
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bRPo1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e569016d63746a22$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $e569016d63746a22$var$baseStyles = null;
const $e569016d63746a22$var$justifyStartStyles = null;
const $e569016d63746a22$var$justifyEndStyles = null; /**
                                * __Tag group__
                                *
                                * A tag group controls the layout and alignment for a collection of tags.
                                *
                                * - [Examples](https://atlassian.design/components/tag-group/examples)
                                * - [Code](https://atlassian.design/components/tag-group/code)
                                * - [Usage](https://atlassian.design/components/tag-group/usage)
                                */ 
const $e569016d63746a22$var$TagGroup = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $e569016d63746a22$export$2e2bcd8739ae039 = $e569016d63746a22$var$TagGroup;

});

parcelRegister("Rk8D3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fc8a07657df7a02$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $ecnYn = parcelRequire("ecnYn");
const $4fc8a07657df7a02$var$baseStyles = (0, $3jLHL.css)({
    boxSizing: 'border-box'
});
const $4fc8a07657df7a02$var$blockBleedMap = {
    'space.025': (0, $3jLHL.css)({
        marginBlock: "var(--ds-space-negative-025, -0.125rem)"
    }),
    'space.050': (0, $3jLHL.css)({
        marginBlock: "var(--ds-space-negative-050, -0.25rem)"
    }),
    'space.100': (0, $3jLHL.css)({
        marginBlock: "var(--ds-space-negative-100, -0.5rem)"
    }),
    'space.150': (0, $3jLHL.css)({
        marginBlock: "var(--ds-space-negative-150, -0.75rem)"
    }),
    'space.200': (0, $3jLHL.css)({
        marginBlock: "var(--ds-space-negative-200, -1rem)"
    })
};
const $4fc8a07657df7a02$var$inlineBleedMap = {
    'space.025': (0, $3jLHL.css)({
        marginInline: "var(--ds-space-negative-025, -0.125rem)"
    }),
    'space.050': (0, $3jLHL.css)({
        marginInline: "var(--ds-space-negative-050, -0.25rem)"
    }),
    'space.100': (0, $3jLHL.css)({
        marginInline: "var(--ds-space-negative-100, -0.5rem)"
    }),
    'space.150': (0, $3jLHL.css)({
        marginInline: "var(--ds-space-negative-150, -0.75rem)"
    }),
    'space.200': (0, $3jLHL.css)({
        marginInline: "var(--ds-space-negative-200, -1rem)"
    })
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $4fc8a07657df7a02$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $4fc8a07657df7a02$var$baseStyles,
            (inline || all) && $4fc8a07657df7a02$var$inlineBleedMap[inline || all],
            (block || all) && $4fc8a07657df7a02$var$blockBleedMap[block || all],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$4fc8a07657df7a02$var$Bleed.displayName = 'Bleed';
var $4fc8a07657df7a02$export$2e2bcd8739ae039 = $4fc8a07657df7a02$var$Bleed;

});

parcelRegister("2Fl4v", function(module, exports) {

$parcel$export(module.exports, "makeModalThreeLOPrompt", () => $65f5939ddad688eb$export$ee02671eeeecd75);
$parcel$export(module.exports, "makeModalThreeLOPromptForCustomUI", () => $65f5939ddad688eb$export$85a504818a81117d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $i35rc = parcelRequire("i35rc");

var $5dK2X = parcelRequire("5dK2X");

const $65f5939ddad688eb$var$AKModalDialog = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9lYhX")));

const $65f5939ddad688eb$var$AKModalTransition = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9lYhX")).then((module)=>({
            default: module.ModalTransition
        })));

const $65f5939ddad688eb$var$AKModalHeader = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("9ot3w"))));

const $65f5939ddad688eb$var$AKModalTitle = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("d8eRd"))));

const $65f5939ddad688eb$var$AKModalBody = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("1DHa6"))));

const $65f5939ddad688eb$var$AKModalFooter = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8o1lj"))));

const $65f5939ddad688eb$var$AKButton = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7CYIQ")));

const $65f5939ddad688eb$var$SectionMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6JSOU")));
const $65f5939ddad688eb$var$ModalThreeLOPrompt = ({ onClose: onClose = ()=>{}, isBlanketHidden: isBlanketHidden, ...props })=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === '';
    const intl = (0, $dBxQj.default)();
    const { modalTitle: modalTitle, modalBody: modalBody } = isAuthUrlEmpty ? {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalErrorTitle),
        modalBody: /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$SectionMessage, {
            appearance: "error",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                as: "p",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$65f5939ddad688eb$var$messages.noAuthURLErrorMessage
                })
            })
        })
    } : {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalAccessRequiredTitle),
        modalBody: promptMessage
    };
    const [isModalOpen, setIsModalOpen] = (0, $gwFzn.useState)(true);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$AKModalTransition, {
        children: isModalOpen && /*#__PURE__*/ (0, $7UHDa.jsxs)($65f5939ddad688eb$var$AKModalDialog, {
            onClose: ()=>{
                setIsModalOpen(false);
                onClose();
            },
            isBlanketHidden: isBlanketHidden,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$AKModalHeader, {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$AKModalTitle, {
                        children: modalTitle
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$AKModalBody, {
                    children: modalBody
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)($65f5939ddad688eb$var$AKModalFooter, {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$AKButton, {
                            appearance: "subtle",
                            onClick: ()=>{
                                setIsModalOpen(false);
                                onClose();
                            },
                            children: "Cancel"
                        }),
                        !isAuthUrlEmpty && /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$AKButton, {
                            appearance: "primary",
                            autoFocus: true,
                            isLoading: loading,
                            onClick: startAuth,
                            children: buttonText
                        })
                    ]
                })
            ]
        })
    });
};
var $65f5939ddad688eb$export$2e2bcd8739ae039 = $65f5939ddad688eb$var$ModalThreeLOPrompt;
const $65f5939ddad688eb$export$ee02671eeeecd75 = ({ onClose: onClose, appName: appName })=>{
    return function modalThreeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: ()=>dispatch({
                    type: 'render',
                    extensionData: {}
                }),
            appName: appName,
            onClose: onClose
        });
    };
};
const $65f5939ddad688eb$export$85a504818a81117d = ({ onClose: onClose, appName: appName, isBlanketHidden: isBlanketHidden = false })=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            ...props,
            appName: appName,
            onClose: onClose,
            isBlanketHidden: isBlanketHidden
        });
    };
};
const $65f5939ddad688eb$var$messages = (0, $2nPZH.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.modal.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    },
    modalErrorTitle: {
        id: "confluence.threeLOPrompt.modal.error.title",
        defaultMessage: "Error"
    },
    modalAccessRequiredTitle: {
        id: "confluence.threeLOPrompt.modal.access.required.title",
        defaultMessage: "Access required"
    }
});

});
parcelRegister("i35rc", function(module, exports) {

$parcel$export(module.exports, "useAuth", () => $cf1792e251a9a919$export$1d39dc5b47e56ff0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fgbwU = parcelRequire("fgbwU");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $dcJ7R = parcelRequire("dcJ7R");

var $6hqEj = parcelRequire("6hqEj");

var $9P47v = parcelRequire("9P47v");
// TODO: We should make appName non-optional later: http://go/j/AUX-570
// appName was made optional because it isn't in already inserted apps prior to the change in http://go/j/AUX-411
const $cf1792e251a9a919$var$defaultPromptMessage = (intl, appName)=>{
    return intl.formatMessage($cf1792e251a9a919$var$messages.defaultPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppLower)
    });
};
const $cf1792e251a9a919$var$externalAuthPromptMessage = (intl, appName)=>{
    return intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppUpper)
    });
};
const $cf1792e251a9a919$export$1d39dc5b47e56ff0 = ({ message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess, metadata: metadata })=>{
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $gwFzn.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $gwFzn.useState)(false);
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    const promptIsForExternalAuth = (0, $fgbwU.isExternalAuth)(authUrl);
    const intl = (0, $dBxQj.default)();
    const startAuth = (0, $gwFzn.useCallback)(()=>{
        setLoading(true);
        setAuthFailureMessage(false);
        (0, $fgbwU.safeAuth)(authUrl).then(()=>{
            onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                setLoading(false);
                setFailedToAuthenticate(false);
                if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === 'function') callbackAfterConsentFlowHasFinished();
            });
        }, (err)=>{
            setLoading(false);
            setFailedToAuthenticate(true);
            if ((0, $9P47v.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
        });
    }, [
        authUrl,
        onSuccess,
        setLoading,
        setFailedToAuthenticate,
        setAuthFailureMessage
    ]);
    const promptMessage = failedToAuthenticate ? authFailureMessage || intl.formatMessage($cf1792e251a9a919$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $cf1792e251a9a919$var$externalAuthPromptMessage(intl, appName) : $cf1792e251a9a919$var$defaultPromptMessage(intl, appName));
    const content = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))), {
                label: intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthWarning),
                color: "var(--ds-icon-warning, #FF8B00)",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            promptMessage
        ]
    });
    const externalAuthButtonText = intl.formatMessage($cf1792e251a9a919$var$messages.configureAccess);
    const buttonText = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($cf1792e251a9a919$var$messages.allowAccess));
    return {
        loading: loading,
        startAuth: startAuth,
        promptMessage: content,
        buttonText: buttonText
    };
};
const $cf1792e251a9a919$var$messages = (0, $2nPZH.defineMessages)({
    defaultPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message",
        defaultMessage: "For {appString} to display, you need to allow the app to access Atlassian products on your behalf."
    },
    externalAuthPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.prompt.message",
        defaultMessage: "{appString} requires additional access to your account."
    },
    thisAppUpper: {
        id: "confluence.threeLOPrompt.use-auth.this.app.upper.message",
        defaultMessage: "This app"
    },
    thisAppLower: {
        id: "confluence.threeLOPrompt.use-auth.this.app.lower.message",
        defaultMessage: "this app"
    },
    defaultFailedToAuthMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.failed.to.auth.message",
        defaultMessage: "Failed to authenticate."
    },
    externalAuthWarning: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.warning.message",
        defaultMessage: "External Auth Warning"
    },
    configureAccess: {
        id: "confluence.threeLOPrompt.use-auth.configure.access.button.text",
        defaultMessage: "Configure access"
    },
    allowAccess: {
        id: "confluence.threeLOPrompt.use-auth.allow.access.button.text",
        defaultMessage: "Allow access"
    }
});

});
parcelRegister("fgbwU", function(module, exports) {

$parcel$export(module.exports, "safeAuth", () => $40dbef35f15607cc$export$5a2d35665f488c3c);
$parcel$export(module.exports, "isExternalAuth", () => $40dbef35f15607cc$export$4211976e157c7ad8);

var $3uVVG = parcelRequire("3uVVG");

var $jLYRk = parcelRequire("jLYRk");
const $40dbef35f15607cc$export$6baf9fc1d877ea76 = 'atlassian-token-service-key';
const $40dbef35f15607cc$export$5a2d35665f488c3c = async (startUrl, windowFeatures)=>{
    return (0, $3uVVG.auth)((0, $jLYRk.sanitizeUrl)(startUrl), windowFeatures);
};
const $40dbef35f15607cc$export$4211976e157c7ad8 = (startUrl)=>{
    const url = new URL(startUrl || '', window.location.href);
    const serviceKey = url.searchParams.get('serviceKey');
    return serviceKey !== $40dbef35f15607cc$export$6baf9fc1d877ea76;
};

});
parcelRegister("jLYRk", function(module, exports) {

$parcel$export(module.exports, "sanitizeUrl", () => $a08eb7c3df84467c$export$300bd6d67c49dbfc);
$parcel$export(module.exports, "EmFn", () => $a08eb7c3df84467c$export$fec26b2d751c6d95);
$parcel$export(module.exports, "LinkFn", () => $a08eb7c3df84467c$export$7c70dc97eeeaf683);
$parcel$export(module.exports, "StrikeFn", () => $a08eb7c3df84467c$export$e9e7c187aef6a83a);
$parcel$export(module.exports, "StringFn", () => $a08eb7c3df84467c$export$11a9c970dcafffc0);
$parcel$export(module.exports, "StrongFn", () => $a08eb7c3df84467c$export$566c617eb72a5976);

var $7UHDa = parcelRequire("7UHDa");

var $2Nwuj = parcelRequire("2Nwuj");

var $dh538 = parcelRequire("dh538");

var $gwFzn = parcelRequire("gwFzn");

var $5dK2X = parcelRequire("5dK2X");

var $gGmck = parcelRequire("gGmck");

var $1nSBE = parcelRequire("1nSBE");
const $a08eb7c3df84467c$var$useDeprecationWarning = (componentName)=>{
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $gGmck.RendererContext));
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        if (forgeEnvironment !== 'PRODUCTION') (0, $1nSBE.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    }, [
        forgeEnvironment,
        componentName
    ]);
};

const $a08eb7c3df84467c$var$AkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmLyj")));
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $a08eb7c3df84467c$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};
function $a08eb7c3df84467c$export$e7bdca014c19fc5c({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Em');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
        as: "em",
        children: children
    });
}
function $a08eb7c3df84467c$export$a6c7ac8248d6e38a({ href: href, children: children, openNewTab: openNewTab, appearance: appearance }) {
    const sanitizedHref = $a08eb7c3df84467c$export$300bd6d67c49dbfc(href);
    if (appearance === 'primary-button' || appearance === 'button') return /*#__PURE__*/ (0, $7UHDa.jsx)($a08eb7c3df84467c$var$AkButton, {
        appearance: appearance === 'primary-button' ? 'primary' : 'default',
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined,
        children: children
    });
    else return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__forge-ui') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined,
        children: children
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined,
        children: children
    });
}
function $a08eb7c3df84467c$export$97176b8d51d2058f({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strike');
    return /*#__PURE__*/ (0, $7UHDa.jsx)("s", {
        children: children
    });
}
function $a08eb7c3df84467c$export$89b8e0fa65f6a914({ text: text }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('String');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: text
    });
}
function $a08eb7c3df84467c$export$f301627d437cff88({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strong');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
        as: "strong",
        children: children
    });
}
function $a08eb7c3df84467c$var$wrap(Component) {
    return function WrappedComponent({ Components: Components, children: children, props: propsAny, render: render, renderChildren: renderChildren, dispatch: dispatch }) {
        const props = propsAny;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            ...props,
            children: renderChildren({
                Components: Components,
                children: children,
                render: render,
                dispatch: dispatch
            })
        });
    };
}
const $a08eb7c3df84467c$export$fec26b2d751c6d95 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$e7bdca014c19fc5c);
const $a08eb7c3df84467c$export$7c70dc97eeeaf683 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$a6c7ac8248d6e38a);
const $a08eb7c3df84467c$export$e9e7c187aef6a83a = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$97176b8d51d2058f);
const $a08eb7c3df84467c$export$11a9c970dcafffc0 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$89b8e0fa65f6a914);
const $a08eb7c3df84467c$export$566c617eb72a5976 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$f301627d437cff88);

});
parcelRegister("gGmck", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6);

var $gwFzn = parcelRequire("gwFzn");
const $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6 = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});

});

parcelRegister("1nSBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $da27ee5222cf5f14$export$2e2bcd8739ae039);
// Displays a warning message only once per message to avoid spamming the console with the same message multiple times.
const $da27ee5222cf5f14$var$messages = new Set();
function $da27ee5222cf5f14$export$2e2bcd8739ae039(message) {
    if ($da27ee5222cf5f14$var$messages.has(message)) return;
    $da27ee5222cf5f14$var$messages.add(message);
    if (typeof window !== 'undefined') // eslint-disable-next-line no-console
    console.warn(message);
}

});

parcelRegister("fmLyj", function(module, exports) {

let $b2fdcc032b5cd0bd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2fdcc032b5cd0bd$var$load("bIwBL").then(()=>parcelRequire('7Cnic'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});






parcelRegister("9lYhX", function(module, exports) {

let $6cf4d7480a8f4a28$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6cf4d7480a8f4a28$var$load("bf0yj").then(()=>parcelRequire('3yfJl'));

});

parcelRegister("7CYIQ", function(module, exports) {

let $58db2f2d571dc6ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $58db2f2d571dc6ae$var$load("eMbal").then(()=>parcelRequire('eAAnv'));

});

parcelRegister("6JSOU", function(module, exports) {

let $4e81782d4f8e8630$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4e81782d4f8e8630$var$load("cjJTJ").then(()=>parcelRequire('iV9t7'));

});


parcelRegister("HEA67", function(module, exports) {

$parcel$export(module.exports, "ForgeUIExtensionAnalyticsContext", () => $5a707b7422677cdc$export$5c431bb5ef7d7900);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");

var $45DA9 = parcelRequire("45DA9");
const $5a707b7422677cdc$export$5c431bb5ef7d7900 = ({ extensionId: extensionId, localId: localId, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
        data: {
            forgeUIAttributes: {
                localId: localId,
                ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extensionId)
            }
        },
        children: children
    });
};

});
parcelRegister("45DA9", function(module, exports) {

$parcel$export(module.exports, "extensionIdToAnalyticsAttributes", () => $4b306a2ad8292411$export$d4650cd03b563908);

var $fRK8K = parcelRequire("fRK8K");
function $4b306a2ad8292411$export$d4650cd03b563908(extensionId) {
    if (!extensionId) return {};
    try {
        const ari = (0, $fRK8K.parse)(extensionId);
        if (!ari.resourceId) return {};
        const [appId, environmentId, groupId, extensionKey] = ari.resourceId.split('/');
        return {
            appId: appId,
            environmentId: environmentId,
            groupId: groupId,
            extensionKey: extensionKey
        };
    } catch  {
        return {};
    }
}

});


parcelRegister("fgm2d", function(module, exports) {

$parcel$export(module.exports, "ForgeUIRenderer", () => $e2fd6b5eb27bb420$export$b89b612df1c715da);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kO2Re = parcelRequire("kO2Re");

var $b1LIt = parcelRequire("b1LIt");

var $4hOVE = parcelRequire("4hOVE");
var $2Fl4v = parcelRequire("2Fl4v");
var $4ZTaE = parcelRequire("4ZTaE");

var $HEA67 = parcelRequire("HEA67");

var $iqcSr = parcelRequire("iqcSr");
const $e2fd6b5eb27bb420$export$b89b612df1c715da = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, hasModalConsentPrompt: hasModalConsentPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, getContextToken: getContextToken, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: modalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onInitialRender: onInitialRender, product: product, timezone: timezone, getModalWidth: getModalWidth, onModalExtensionClose: onModalExtensionClose, onSuccess: onSuccess, onAppError: onAppError } = props;
    let cloudId;
    let workspaceId;
    if ('cloudId' in props) cloudId = props.cloudId;
    else if ('workspaceId' in props) workspaceId = props.workspaceId;
    const cloudOrWorkspaceId = cloudId ? {
        cloudId: cloudId
    } : {
        workspaceId: workspaceId
    };
    (0, $gwFzn.useEffect)(()=>{
        onInitialRender?.();
    }, [
        onInitialRender
    ]);
    const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = extension;
    const coreData = (0, $gwFzn.useMemo)(()=>({
            workspaceId: workspaceId,
            cloudId: cloudId,
            localId: localId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        }), [
        cloudId,
        environmentId,
        environmentType,
        extensionId,
        localId,
        workspaceId
    ]);
    const getThreeLOPrompt = (0, $gwFzn.useCallback)(()=>({
            ThreeLOPrompt: modalExtension || hasModalConsentPrompt ? (0, $2Fl4v.makeModalThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                isBlanketHidden: true,
                onClose: onConsentModalClose
            }) : (0, $4ZTaE.makeThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                onSuccess: onConsentSuccess,
                message: consentMessage,
                onInitialization: onConsentInitialization
            })
        }), [
        extension.properties.title,
        consentMessage,
        hasModalConsentPrompt,
        modalExtension,
        onConsentSuccess,
        onConsentModalClose,
        onConsentInitialization
    ]);
    const customUIProps = {
        accountId: accountId,
        bridge: bridge,
        client: client,
        consentMessage: consentMessage,
        contextIds: contextIds,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        dialogs: dialogs,
        entryPoint: entryPoint,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getThreeLOPrompt: getThreeLOPrompt,
        height: height,
        loadingComponent: loadingComponent,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        onConsentModalClose: onConsentModalClose,
        onConsentSuccess: onConsentSuccess,
        onError: onError,
        onForgeDocUpdated: onForgeDocUpdated,
        onIframeLoad: onIframeLoad,
        product: product,
        timezone: timezone,
        isIframeHidden: isIframeHidden,
        isIframeResizable: isIframeResizable
    };
    const [viewOnClose, setViewOnClose] = (0, $gwFzn.useState)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $HEA67.ForgeUIExtensionAnalyticsContext), {
        extensionId: extension.id,
        localId: localId || extension.id,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                hidden: true,
                id: "forge-ui-renderer"
            }),
            (0, $iqcSr.isCustomUI)(extension, entryPoint) ? modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kO2Re.ModalCustomUIRenderer), {
                ...customUIProps,
                bridge: {
                    onClose: (callback)=>{
                        setViewOnClose(()=>callback.data);
                        // stores the callback for when modal is closed
                        return true;
                    },
                    // spread down here so product can override the default onClose
                    ...customUIProps.bridge
                },
                modalOnClose: onModalExtensionClose,
                viewOnClose: viewOnClose
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kO2Re.CustomUIRenderer), {
                ...customUIProps,
                getModalWidth: getModalWidth,
                width: width
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $b1LIt.UIKitRenderer), {
                coreData: coreData,
                getThreeLOPrompt: getThreeLOPrompt,
                accountId: accountId,
                client: client,
                contextIds: contextIds,
                extension: extension,
                extensionData: extensionData,
                extensionViewData: extensionViewData,
                product: product,
                bridge: bridge,
                customBridgeMethods: customBridgeMethods,
                components: (0, $dh538.fg)('forbid-forge-ui-kit-frame-in-custom-fields-view') ? {
                    Frame: (0, $4hOVE.makeFrame)((inputProps)=>{
                        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kO2Re.CustomUIRenderer), {
                            ...customUIProps,
                            extension: {
                                ...extension,
                                properties: {
                                    ...extension.properties,
                                    ...inputProps
                                }
                            },
                            ...(0, $dh538.fg)('platform_enable_frame_rendering_for_entry_points') && {
                                entryPoint: undefined
                            },
                            // Ensures Frame is always resized to the full height of the content
                            // Required because Jira leaves isIframeResizable as false
                            isIframeResizable: true
                        });
                    }),
                    ...components
                } : {
                    ...components,
                    Frame: (0, $4hOVE.makeFrame)((inputProps)=>{
                        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kO2Re.CustomUIRenderer), {
                            ...customUIProps,
                            extension: {
                                ...extension,
                                properties: {
                                    ...extension.properties,
                                    ...inputProps
                                }
                            },
                            ...(0, $dh538.fg)('platform_enable_frame_rendering_for_entry_points') && {
                                entryPoint: undefined
                            },
                            // Ensures Frame is always resized to the full height of the content
                            // Required because Jira leaves isIframeResizable as false
                            isIframeResizable: true
                        });
                    })
                },
                consentMessage: consentMessage,
                entryPoint: entryPoint,
                getContextToken: getContextToken,
                locale: locale,
                localId: localId,
                mentionProvider: mentionProvider,
                modalExtension: modalExtension,
                onConsentSuccess: onConsentSuccess,
                onForgeDocUpdated: onForgeDocUpdated,
                timezone: timezone,
                onConsentModalClose: onConsentModalClose,
                onError: onError,
                loadingComponent: loadingComponent,
                extensionPayload: extensionPayload,
                onSuccess: onSuccess,
                ...cloudOrWorkspaceId,
                onAppError: onAppError
            })
        ]
    });
};

});
parcelRegister("kO2Re", function(module, exports) {

$parcel$export(module.exports, "CustomUIRenderer", () => $8537409554582c9d$export$17d9f1e4832027c9);
$parcel$export(module.exports, "ModalCustomUIRenderer", () => $8537409554582c9d$export$5d28a207fd7621f6);
/* CustomUIRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6NPDq = parcelRequire("6NPDq");
var $h6bEF = parcelRequire("h6bEF");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $7hpmn = parcelRequire("7hpmn");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $1c598 = parcelRequire("1c598");

var $i9F01 = parcelRequire("i9F01");

var $amyZ5 = parcelRequire("amyZ5");

var $eahkE = parcelRequire("eahkE");
const $8537409554582c9d$var$styles = {
    modalDeprecationMessage: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $8537409554582c9d$export$17d9f1e4832027c9 = ({ accountId: accountId, bridge: bridge, client: client, contextIds: contextIds, coreData: coreData, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, iframeRef: iframeRef, isInModal: isInModal, loadingComponent: loadingComponent, locale: locale, localId: localId, modalStyles: modalStyles, modalProvider: modalProvider, onIframeLoad: onIframeLoad, onModalCustomUIRendererClose: onModalCustomUIRendererClose, product: product, timezone: timezone, getModalWidth: getModalWidth, setIsLoading: setIsLoading })=>{
    const [error, setError] = (0, $gwFzn.useState)(null);
    // modalOptions is null when no modal is open is non null when opened
    const [modalOptions, setModalOptions] = (0, $gwFzn.useState)(null);
    const [viewOnClose, setViewOnClose] = (0, $gwFzn.useState)();
    const onCloseFromModalClass = modalOptions?.onClose;
    const extensionInModal = (0, $gwFzn.useMemo)(()=>({
            ...extension,
            // Pass a type that is not included in the dimensions presets so that it falls back to default
            type: `${extension.type}::dynamic-modal`,
            properties: {
                ...extension.properties,
                resource: modalOptions?.resource ?? extension.properties.resource
            }
        }), [
        extension,
        modalOptions?.resource
    ]);
    const onError = (error)=>{
        error && setError(error);
    };
    const extensionDataInModal = (0, $gwFzn.useMemo)(()=>({
            ...extensionData,
            ...modalOptions?.context ? {
                modal: modalOptions?.context
            } : {},
            // This is to handle an incompatibility issue with Compass and JSM where they are incorrectly currently spreading the context object on the top level instead of in the `modal` object.
            // Remove once Compass apps have been updated https://softwareteams.atlassian.net/browse/COMPASS-22051 and a notice to app developers have been sent out
            ...(product === 'compass' || extension.type.startsWith('jiraServiceManagement')) && modalOptions?.context ? {
                ...modalOptions?.context
            } : {}
        }), [
        extension.type,
        extensionData,
        modalOptions?.context,
        product
    ]);
    const handleModalTearDown = (0, $gwFzn.useCallback)(()=>{
        setModalOptions(null);
    }, [
        setModalOptions
    ]);
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const handleModalClose = (0, $gwFzn.useCallback)(()=>{
        onCloseFromModalClass?.();
        // if reduced motion is enabled, we need to call handleModalTearDown here as it no longer calls `onCloseComplete` in `ModalCustomUIRenderer`
        if (isReducedMotion) handleModalTearDown();
    }, [
        isReducedMotion,
        onCloseFromModalClass,
        handleModalTearDown
    ]);
    // Confluence specific feature
    // Needed to show Forge modals in live pages. dialogs won't be passed in if the page isn't live.
    (0, $gwFzn.useEffect)(()=>{
        if (product !== 'confluence') return;
        if (dialogs && modalOptions) dialogs.showDialog($8537409554582c9d$export$5d28a207fd7621f6, {
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: localId,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            size: modalOptions.size,
            closeOnEscape: modalOptions.closeOnEscape,
            closeOnOverlayClick: modalOptions.closeOnOverlayClick
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modalOptions,
        dialogs
    ]);
    const iframeProps = {
        accountId: accountId,
        apolloClient: client,
        contextIds: contextIds,
        components: getThreeLOPrompt,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        isHidden: isIframeHidden,
        isResizable: isIframeResizable,
        locale: locale,
        timezone: timezone,
        loadingComponent: loadingComponent
    };
    if (error) {
        // Sandbox deprecation error
        if (error === (0, $eahkE.SANDBOX_DEPRECATION_ERROR)) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eahkE.ForgeDeprecationMessage), {
            extension: extension,
            client: client,
            error: error
        });
    // Currently no other error types are handled
    }
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6bEF.Iframe), {
                ...iframeProps,
                entryPoint: entryPoint,
                isResizable: isIframeResizable,
                bridge: {
                    ...bridge,
                    openModal: (opts)=>{
                        setModalOptions(opts.data);
                        return true;
                    },
                    ...onModalCustomUIRendererClose ? {
                        close: (payload)=>{
                            if ((0, $dh538.fg)('forge-ui-on-close-bridge-method')) onModalCustomUIRendererClose().then(()=>{
                                bridge?.close?.(payload);
                            }).finally(()=>{
                                return true;
                            });
                            else {
                                // This bridge.close reference is defined below in ModalCustomUIRenderer.
                                onModalCustomUIRendererClose();
                                bridge?.close?.(payload);
                                return true;
                            }
                        }
                    } : {}
                },
                height: height,
                width: width,
                isInModal: isInModal,
                ref: iframeRef,
                onLoad: onIframeLoad,
                setIsLoading: setIsLoading,
                onError: onError
            }),
            modalOptions ? /*#__PURE__*/ (0, $7UHDa.jsx)($8537409554582c9d$export$5d28a207fd7621f6, {
                ...iframeProps,
                product: product,
                getThreeLOPrompt: getThreeLOPrompt,
                dialogs: dialogs,
                client: client,
                extension: extensionInModal,
                extensionData: extensionDataInModal,
                localId: localId,
                onTearDown: handleModalTearDown,
                bridge: {
                    ...bridge,
                    onClose: (callback)=>{
                        setViewOnClose(()=>callback.data);
                        // stores the callback for when modal is closed
                        return true;
                    },
                    close: (payload)=>{
                        onCloseFromModalClass?.(payload.data);
                        return true;
                    }
                },
                modalOnClose: handleModalClose,
                size: modalOptions.size,
                closeOnEscape: modalOptions.closeOnEscape,
                closeOnOverlayClick: modalOptions.closeOnOverlayClick,
                modalStyles: modalStyles,
                modalProvider: modalProvider,
                getModalWidth: getModalWidth,
                isIframeResizable: isIframeResizable,
                viewOnClose: viewOnClose
            }) : null
        ]
    });
};
const $8537409554582c9d$export$5d28a207fd7621f6 = ({ accountId: accountId, bridge: bridge, coreData: coreData, client: client, closeOnEscape: closeOnEscape, closeOnOverlayClick: closeOnOverlayClick, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, isIframeHidden: isIframeHidden = false, isIframeResizable: isIframeResizable = false, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: ModalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onTearDown: onTearDown, product: product, size: size, timezone: timezone, getModalWidth: getModalWidth, modalOnClose: // onClose from `Modal`
modalOnClose, viewOnClose: // onClose from `view`
viewOnClose })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(true);
    // This is for preventing inline dialog apps from being closed by an esc key press when a
    // modal is open until https://product-fabric.atlassian.net/browse/DSP-3552 is resolved.
    (0, $gwFzn.useEffect)(()=>{
        if (product !== 'confluence' || modalExtension?.type === 'macroConfig') return;
        function dismissEscape(e) {
            if (e.key === 'Escape') {
                e.stopPropagation();
                if (closeOnEscape) {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            }
        }
        if (isOpen) document.addEventListener('keydown', dismissEscape, {
            capture: true
        });
        return ()=>document.removeEventListener('keydown', dismissEscape, {
                capture: true
            });
    }, [
        isOpen,
        closeOnEscape,
        product,
        modalOnClose,
        modalExtension?.type
    ]);
    const modalSize = size ?? extension.properties.viewportSize ?? 'medium';
    const modalWidth = getModalWidth ? getModalWidth(size) : (0, $i9F01.getAtlasKitModalWidth)(modalSize);
    const { height: modalHeight } = (0, $6NPDq.getModalDimensions)(modalSize);
    // If size is defined, iframe modal should not be resizable.
    // In JSM ONLY, iframe modal should ALWAYS be resizable.
    // Iframe should scale to 100% of the modal so that Select drop downs are not cut off
    const isJsmModule = extension.type.startsWith('jiraServiceManagement');
    const isModalResizable = isJsmModule || (size !== undefined ? false : isIframeResizable);
    const shouldShowFCFModalDeprecationMessage = (0, $dh538.fg)('forge_fcf_modal_exp_deprecation_notice') && (extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD || extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD_TYPE);
    const renderModal = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
            width: modalWidth,
            // "max" size modal have a height value of 100%, which needs to be set in this parent component
            // all other modal sizes have height values that do not depend on the parent component
            // therefore their heights should be handled by the `ModalContentsWrapper` below
            height: modalSize === 'max' ? modalHeight : undefined,
            onClose: async ()=>{
                if ((0, $dh538.fg)('forge-ui-on-close-bridge-method')) try {
                    await viewOnClose?.();
                } finally{
                    modalOnClose?.();
                    setIsOpen(false);
                }
                else {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            },
            onCloseComplete: onTearDown,
            testId: "custom-ui-modal-dialog",
            shouldCloseOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick,
            shouldCloseOnEscapePress: modalExtension?.shouldCloseOnEscapePress,
            children: [
                shouldShowFCFModalDeprecationMessage && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $8537409554582c9d$var$styles.modalDeprecationMessage,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $amyZ5.ForgeModalDeprecationMessage), {
                        client: client,
                        extension: extension
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i9F01.ModalContentWrapper), {
                    size: modalSize,
                    styles: modalStyles,
                    isResizable: isIframeResizable,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($8537409554582c9d$export$17d9f1e4832027c9, {
                        product: product,
                        coreData: coreData,
                        getThreeLOPrompt: getThreeLOPrompt,
                        dialogs: dialogs,
                        accountId: accountId,
                        client: client,
                        contextIds: contextIds,
                        extension: extension,
                        extensionData: extensionData,
                        extensionViewData: extensionViewData,
                        bridge: bridge,
                        customBridgeMethods: customBridgeMethods,
                        consentMessage: consentMessage,
                        entryPoint: entryPoint,
                        getContextToken: getContextToken,
                        height: "100%",
                        isIframeHidden: isIframeHidden,
                        isIframeResizable: isModalResizable,
                        locale: locale,
                        localId: localId,
                        mentionProvider: mentionProvider,
                        modalExtension: modalExtension,
                        onConsentSuccess: onConsentSuccess,
                        onForgeDocUpdated: onForgeDocUpdated,
                        timezone: timezone,
                        onConsentModalClose: onConsentModalClose,
                        onError: onError,
                        onIframeLoad: onIframeLoad,
                        loadingComponent: loadingComponent,
                        extensionPayload: extensionPayload,
                        modalStyles: modalStyles,
                        // This is called when `view.close` is called
                        onModalCustomUIRendererClose: async ()=>{
                            if (!(0, $dh538.fg)('forge_ui_onclose_fix')) modalOnClose?.();
                            if (viewOnClose && (0, $dh538.fg)('forge-ui-on-close-bridge-method')) try {
                                await viewOnClose?.();
                            } finally{
                                setIsOpen(false);
                            }
                            else setIsOpen(false);
                        },
                        isInModal: true
                    })
                })
            ]
        });
    if (ModalProvider) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $7UHDa.jsx)(ModalProvider, {
            children: renderModal()
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
        children: isOpen && renderModal()
    });
};

});
parcelRegister("6NPDq", function(module, exports) {

$parcel$export(module.exports, "getModalDimensions", () => $3b6c709f803268e6$export$b3b34c460afe006f);
const $3b6c709f803268e6$var$ModalSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
    MAX: 'max'
};
const $3b6c709f803268e6$var$modalDimensions = {
    [$3b6c709f803268e6$var$ModalSizes.SMALL]: {
        height: '20vh',
        minHeight: '320px'
    },
    [$3b6c709f803268e6$var$ModalSizes.MEDIUM]: {
        height: '40vh',
        minHeight: '520px'
    },
    [$3b6c709f803268e6$var$ModalSizes.LARGE]: {
        height: '70vh',
        minHeight: '720px'
    },
    [$3b6c709f803268e6$var$ModalSizes.XLARGE]: {
        height: '90vh'
    },
    [$3b6c709f803268e6$var$ModalSizes.MAX]: {
        height: '100%'
    }
};
const $3b6c709f803268e6$export$b3b34c460afe006f = (size)=>$3b6c709f803268e6$var$modalDimensions[size];

});

parcelRegister("h6bEF", function(module, exports) {

$parcel$export(module.exports, "Iframe", () => $f2c0519b4a165d40$export$5137ec99f248330b);
/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $a9dFP = parcelRequire("a9dFP");
var $cOrQJ = parcelRequire("cOrQJ");

var $jIiuI = parcelRequire("jIiuI");

var $7mt4M = parcelRequire("7mt4M");

var $ijfiP = parcelRequire("ijfiP");
var $1I2N5 = parcelRequire("1I2N5");

var $71Ozv = parcelRequire("71Ozv");

var $kaOT1 = parcelRequire("kaOT1");

var $5oEbs = parcelRequire("5oEbs");
var $LiNdD = parcelRequire("LiNdD");
var $hcbSV = parcelRequire("hcbSV");
var $6hkBe = parcelRequire("6hkBe");
var $ge8sG = parcelRequire("ge8sG");
var $4jZsH = parcelRequire("4jZsH");
var $UZU5S = parcelRequire("UZU5S");

var $f0Xuq = parcelRequire("f0Xuq");

var $bn0yX = parcelRequire("bn0yX");

var $6oQb1 = parcelRequire("6oQb1");

var $jc2GP = parcelRequire("jc2GP");

var $dh538 = parcelRequire("dh538");

var $jNc4k = parcelRequire("jNc4k");
const $f2c0519b4a165d40$var$styles = {
    hostedResourcesIframeContainer: "_kqswh2mm",
    box: "_1bsb1osq _4t3i1osq"
};
const $f2c0519b4a165d40$var$ReloadOnContextChangeWrapper = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (getCurrentForgeReactMajorVersion && (0, $dh538.fg)('forge-ui-macro-config-update-improvement')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jNc4k.ContextChangeObserverWrapper), {
        context: context,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: children
    }, (0, (/*@__PURE__*/$parcel$interopDefault($71Ozv)))(context));
};
const $f2c0519b4a165d40$export$5137ec99f248330b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, apolloClient: apolloClient, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable = true, entryPoint: entryPoint, extensionPayload: extensionPayload, getContextToken: getContextToken, timezone: timezone, locale: locale, isHidden: isHidden = false, isInModal: isInModal = false, setShouldShowRenderer: setShouldShowRenderer, setIsLoading: setIsLoading, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion, onError: onError }, iframeRef)=>{
    const environment = (0, $gwFzn.useContext)((0, $jIiuI.EnvironmentContext)); // ARKEN-856: useThemeObserver() is a bit noisy, it returns copies of the same theme which breaks useBridge() dependencies
    // We use useMemoizedStateObject() to properly memoize its output doing a deep-equality check
    const theme = (0, $1I2N5.useMemoizedStateObject)((0, $cOrQJ.default)());
    const iframeWrapperRef = (0, $gwFzn.useRef)(null);
    const [surfaceColor, setSurfaceColor] = (0, $gwFzn.useState)(null);
    const { trackExtensionLoaded: trackExtensionLoaded } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $gwFzn.useEffect)(()=>{
        if (!iframeWrapperRef.current) return;
        const nextSurfaceColor = getComputedStyle(iframeWrapperRef.current).getPropertyValue((0, $a9dFP.CURRENT_SURFACE_CSS_VAR));
        setSurfaceColor(nextSurfaceColor);
    }, [
        theme
    ]);
    const { appId: appId, moduleKey: moduleKey } = (0, $ijfiP.parseExtensionId)(extension.id);
    const { environmentId: environmentId, environmentType: environmentType } = extension;
    const extensionEntryPoint = (0, $6hkBe.getExtensionEntryPoint)(extension, entryPoint);
    const defaultSrc = (0, $gwFzn.useMemo)(()=>(0, $5oEbs.createSrcFromExtension)(appId, extension, environment, extensionEntryPoint), [
        appId,
        extension,
        environment,
        extensionEntryPoint
    ]);
    const { tunnels: tunnels, loading: loading } = (0, $7mt4M.useCustomUITunnelsList)({
        client: apolloClient,
        appId: appId,
        environmentId: environmentId,
        environmentType: environmentType
    });
    (0, $gwFzn.useEffect)(()=>{
        if (extension?.properties?.render !== 'native') {
            const extensionType = (0, $jc2GP.getExtensionType)(extension);
            trackExtensionLoaded({
                forgeEnvironment: extension?.environmentType,
                renderType: 'CustomUI',
                extensionType: extensionType,
                isConfiguring: extensionData.macro?.isConfiguring,
                isInserting: extensionData.macro?.isInserting
            });
        } // Adding `extension` itself or `trackExtensionLoaded` will cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        extension?.environmentType,
        extension?.properties?.render,
        extension?.type
    ]);
    const [isThreeLOPromptVisible, setIsThreeLOPromptVisible] = (0, $gwFzn.useState)(false);
    const coreDataInner = {
        ...coreData,
        environmentId: environmentId,
        environmentType: environmentType,
        moduleKey: moduleKey,
        siteUrl: window.location.origin
    };
    const resizingEnabled = isResizable && !extension.properties.viewportSize;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
        ref: iframeWrapperRef,
        testId: "hosted-resources-iframe-container",
        xcss: $f2c0519b4a165d40$var$styles.hostedResourcesIframeContainer,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: isThreeLOPromptVisible || isHidden ? undefined : height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        },
        children: [
            loading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $f2c0519b4a165d40$var$styles.box,
                    children: loading && !isHidden && (0, $bn0yX.getLoadingComponent)(loadingComponent)
                })
            }),
            !loading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kaOT1.TracingProvider), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($f2c0519b4a165d40$var$ReloadOnContextChangeWrapper, {
                    getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
                    context: (0, $UZU5S.getViewContext)({
                        resolverContext: (0, $ge8sG.getResolverContext)(coreDataInner, extensionData),
                        accountId: accountId,
                        extension: extension,
                        timezone: timezone ?? (0, $hcbSV.getBrowserTimezone)(),
                        locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
                        extensionViewData: extensionViewData
                    }),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f0Xuq.InnerIframe), {
                        accountId: accountId,
                        extension: extension,
                        contextIds: contextIds,
                        apolloClient: apolloClient,
                        components: components,
                        coreData: coreDataInner,
                        extensionData: extensionData,
                        extensionViewData: extensionViewData,
                        loadingComponent: loadingComponent,
                        onLoad: onLoad,
                        height: height,
                        width: width,
                        src: (0, $4jZsH.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc),
                        bridge: bridge,
                        customBridgeMethods: customBridgeMethods,
                        isResizable: resizingEnabled,
                        getContextToken: getContextToken,
                        timezone: timezone,
                        locale: locale,
                        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
                        setShouldShowRenderer: setShouldShowRenderer,
                        extensionPayload: extensionPayload,
                        isHidden: isHidden,
                        theme: theme,
                        surfaceColor: surfaceColor,
                        appId: appId,
                        ref: iframeRef,
                        isInModal: isInModal,
                        setIsLoading: setIsLoading,
                        onError: onError
                    })
                })
            })
        ]
    });
});

});
parcelRegister("7mt4M", function(module, exports) {

$parcel$export(module.exports, "useCustomUITunnelsList", () => $783b254f80b9fbef$export$ad717e82ff0f4348);

var $gwFzn = parcelRequire("gwFzn");

var $d2LG0 = parcelRequire("d2LG0");

var $xQxzY = parcelRequire("xQxzY");

var $dh538 = parcelRequire("dh538");

var $1Igmn = parcelRequire("1Igmn");
const $783b254f80b9fbef$export$fe748943fdfd6c6b = ()=>{
    const query = `
  query forge_ui_getActiveTunnels($appId: ID!, $environmentId: ID!) {
    appActiveTunnels(appId: $appId, environmentId: $environmentId) {
      customUI {
        resourceKey
        tunnelUrl
      }
    }
  }
  `;
    return (0, $d2LG0.default)`${query}`;
};
const $783b254f80b9fbef$export$6702f78eaa0e936a = (client, appId, environmentId, queryOptions)=>{
    const headers = {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) headers['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)();
    return {
        variables: {
            appId: appId,
            environmentId: environmentId
        },
        ...queryOptions,
        query: $783b254f80b9fbef$export$fe748943fdfd6c6b(),
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: headers
        }
    };
};
const $783b254f80b9fbef$export$f31e7455041d7e13 = ({ loading: loading, data: data })=>{
    if (!loading) return data?.appActiveTunnels?.customUI;
    return undefined;
};
const $783b254f80b9fbef$export$ad717e82ff0f4348 = (options)=>{
    const { appId: appId, environmentType: environmentType, environmentId: environmentId, client: client, queryOptions: queryOptions } = options;
    const shouldQuery = (0, $gwFzn.useRef)(true);
    if (environmentType !== 'DEVELOPMENT') shouldQuery.current = false;
    const requestOptions = $783b254f80b9fbef$export$6702f78eaa0e936a(client, appId, environmentId, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)(requestOptions.query || $783b254f80b9fbef$export$fe748943fdfd6c6b(), {
        ...requestOptions,
        skip: !shouldQuery.current
    });
    const tunnels = $783b254f80b9fbef$export$f31e7455041d7e13({
        loading: loading,
        data: data
    });
    return {
        error: error,
        tunnels: tunnels || [],
        loading: loading
    };
};

});

parcelRegister("ijfiP", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $e2d7503e18a8780a$export$bae42cbaf7fa3e1b);

var $fRK8K = parcelRequire("fRK8K");
const $e2d7503e18a8780a$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $fRK8K.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});

parcelRegister("1I2N5", function(module, exports) {

$parcel$export(module.exports, "useMemoizedStateObject", () => $fbfcc51dc5b115ca$export$cc725e2aa41de44a);

var $gwFzn = parcelRequire("gwFzn");

var $atveb = parcelRequire("atveb");
const $fbfcc51dc5b115ca$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($atveb))))=>{
    const [memoizedData, setMemoizedData] = (0, $gwFzn.useState)(data);
    (0, $gwFzn.useEffect)(()=>{
        if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
    }, [
        data,
        memoizedData,
        equalityCheck
    ]);
    return memoizedData;
};

});

parcelRegister("kaOT1", function(module, exports) {

$parcel$export(module.exports, "TracingProvider", () => $74f9941a52315579$export$73f470ced5fdc319);
$parcel$export(module.exports, "useTracingContext", () => $74f9941a52315579$export$1bd6b93107e60cf1);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $74f9941a52315579$export$e775b9769343d051 = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $74f9941a52315579$export$73f470ced5fdc319 = (props)=>{
    const breadCrumbs = (0, $gwFzn.useRef)([]);
    const tracingService = (0, $gwFzn.useRef)({
        getBreadcrumbs: ()=>breadCrumbs.current,
        recordBridgeCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `forge.bridge`,
                    message: description,
                    timestamp: new Date().toISOString()
                }
            ],
        recordGqlCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    type: 'http',
                    category: 'gql',
                    timestamp: new Date().toISOString(),
                    data: {
                        url: description
                    }
                }
            ],
        recordConsentFlow: (description, result)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `user.consent`,
                    message: description,
                    timestamp: new Date().toISOString(),
                    ...result ? {
                        data: {
                            result: result
                        }
                    } : {}
                }
            ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($74f9941a52315579$export$e775b9769343d051.Provider, {
        value: tracingService.current,
        children: props.children
    });
};
const $74f9941a52315579$export$1bd6b93107e60cf1 = ()=>{
    const tracingContext = (0, $gwFzn.useContext)($74f9941a52315579$export$e775b9769343d051);
    return tracingContext;
};

});

parcelRegister("5oEbs", function(module, exports) {

$parcel$export(module.exports, "createSrcFromExtension", () => $83c738174c625218$export$158d41afab8f2af8);

var $lzcvT = parcelRequire("lzcvT");

var $1c598 = parcelRequire("1c598");

var $b7qxC = parcelRequire("b7qxC");

var $cqiXo = parcelRequire("cqiXo");
const $83c738174c625218$export$9b5c32eaf7c2ac3d = {
    [(0, $1c598.ProductEnvironment).PRODUCTION]: 'prod',
    [(0, $1c598.ProductEnvironment).STAGING]: 'stg',
    [(0, $1c598.ProductEnvironment).DEVELOPMENT]: 'stg'
};
const $83c738174c625218$export$158d41afab8f2af8 = (appId, extension, environment, entryPoint)=>{
    const cdnEnv = (0, $b7qxC.getCDNEnvironment)(environment);
    // Map the dev environment to staging here for local development. The dev environment is not set up to load Forge apps.
    const urlEnv = cdnEnv === (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT ? (0, $1c598.ForgeCDNEnvironment).STAGING : cdnEnv;
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const secondLevelDomain = (0, $lzcvT.isFedRamp)() ? 'atlassian-dev-us-gov-mod' : 'atlassian-dev';
    const domain = `${$83c738174c625218$export$d4a94ef9062fefbf(installationId)}--${$83c738174c625218$export$d4a94ef9062fefbf(appId)}.cdn.${urlEnv}.${secondLevelDomain}.net`;
    /**
	 * Hostname is added here as a URI segment instead of a query string because the JS and CSS scripts inside of the index.html file need to be aware of the hostname as well.
	 * They are using relative paths that will ignore the appended query string here.
	 *
	 * The appId is also included in the subdomain so that it can be compared against the appId in the
	 * resource path. This comparison is performed by the routing Lambda@ Edge to prevent a malicious
	 * developer from appending their malicious app path to a legitimate installation id.
	 */ const encodedAppContext = (0, $cqiXo.getEncodedAppContext)(extension);
    const urlSafeContext = $83c738174c625218$var$urlSafeB64(encodedAppContext);
    return `https://${domain}/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_hostname_${window.location.hostname}/_ctx_${urlSafeContext}/`;
};
function $83c738174c625218$export$d4a94ef9062fefbf(uuid) {
    const [a, b, c, d, e] = uuid.split('-');
    const combinedUuid = [
        a,
        `${b}${c}${d}`,
        e
    ];
    return combinedUuid.map((s)=>parseInt(s, 16)).map((s)=>s.toString(36)).join('-');
}
function $83c738174c625218$export$824f5b1835a75769(shortenedUuid) {
    const [a, b, c] = shortenedUuid.split('-').map((s)=>parseInt(s, 36)).map((s)=>s.toString(16));
    // expands the middle segment into the original UUID
    // ffffffff-abcdabcdabcd-ffffffffffff ===> ffffffff-abcd-abcd-abcd-ffffffffffff
    const middleExpanded = b.match(/.{1,4}/g) || b;
    return [
        a,
        ...middleExpanded,
        c
    ].join('-');
}
function $83c738174c625218$var$urlSafeB64(str) {
    return str.replace(/\+/g, '-') // Replace '+' with '-'
    .replace(/\//g, '_') // Replace '/' with '_'
    .replace(/=+$/, ''); // Remove padding
}

});
parcelRegister("b7qxC", function(module, exports) {

$parcel$export(module.exports, "getCDNEnvironment", () => $ea538cc77ceb57f0$export$d86e18ec9052db2c);

var $1c598 = parcelRequire("1c598");

var $lzcvT = parcelRequire("lzcvT");
const $ea538cc77ceb57f0$export$d86e18ec9052db2c = (productEnvironment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
        else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
    }
    if (productEnvironment === (0, $1c598.ProductEnvironment).DEVELOPMENT) return (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT;
    else if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
    else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
};

});

parcelRegister("cqiXo", function(module, exports) {

$parcel$export(module.exports, "getEncodedAppContext", () => $11028dbc0e45417b$export$423a62223c29d468);

var $71Ozv = parcelRequire("71Ozv");

var $gDm8X = parcelRequire("gDm8X");
const $11028dbc0e45417b$export$423a62223c29d468 = (extension)=>{
    const { egress: egress = [], installationConfig: installationConfig = [] } = extension;
    return $11028dbc0e45417b$var$gzipAndB64Encode({
        egress: egress,
        installationConfig: installationConfig,
        hostname: window.location.hostname
    });
};
const $11028dbc0e45417b$var$gzipAndB64Encode = (json)=>{
    const jsonString = (0, (/*@__PURE__*/$parcel$interopDefault($71Ozv)))(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic
    try {
        const zippedData = (0, $gDm8X.gzipSync)(new TextEncoder().encode(jsonString), {
            level: 9,
            mtime: 0
        });
        return btoa(String.fromCharCode(...zippedData));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err.message);
    }
    return '';
};

});


parcelRegister("LiNdD", function(module, exports) {

$parcel$export(module.exports, "getBrowserLocale", () => $3ac7139ae0ef30fb$export$563e375d286a76a7);
const $3ac7139ae0ef30fb$export$563e375d286a76a7 = ()=>{
    if (navigator.languages) return navigator.languages[0];
    return navigator.language;
};

});

parcelRegister("hcbSV", function(module, exports) {

$parcel$export(module.exports, "getBrowserTimezone", () => $130ab70bfb5bcaa7$export$9b96caef38763092);

var $5oEbs = parcelRequire("5oEbs");

var $4jZsH = parcelRequire("4jZsH");

var $6hkBe = parcelRequire("6hkBe");

var $LiNdD = parcelRequire("LiNdD");

var $ge8sG = parcelRequire("ge8sG");

var $UZU5S = parcelRequire("UZU5S");
const $130ab70bfb5bcaa7$export$9b96caef38763092 = ()=>{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

});
parcelRegister("4jZsH", function(module, exports) {

$parcel$export(module.exports, "getSrcUrl", () => $f045517dec5f1afb$export$6dd3d030a75d6dba);

var $6SLx1 = parcelRequire("6SLx1");
const $f045517dec5f1afb$export$6dd3d030a75d6dba = (tunnels, extensionResource, defaultUrl)=>{
    const matchTunnel = tunnels.find((tunnel)=>tunnel.resourceKey === extensionResource);
    const platformFeatureFlags = (0, $6SLx1.getPlatformFeatureFlags)();
    const queryParams = new URLSearchParams({
        ...platformFeatureFlags.length > 0 ? {
            platformFeatureFlags: platformFeatureFlags.join(',')
        } : {},
        // when tunnelling, pass hostname into query param to be passed into CSP
        ...matchTunnel ? {
            hostname: window.location.hostname
        } : {}
    }).toString();
    const query = queryParams ? `?${queryParams}` : '';
    if (matchTunnel) return `${matchTunnel.tunnelUrl}${query}`;
    return `${defaultUrl}${query}`;
};

});
parcelRegister("6SLx1", function(module, exports) {

$parcel$export(module.exports, "getPlatformFeatureFlags", () => $337f83d71a1a0efc$export$bd17c6970f4d989e);

var $dh538 = parcelRequire("dh538");
const $337f83d71a1a0efc$export$bd17c6970f4d989e = ()=>{
    const platformFeatureFlags = [];
    // Each feature flag name is required to be an inline string for static analysis
    if ((0, $dh538.fg)('platform-visual-refresh-icons')) platformFeatureFlags.push('platform-visual-refresh-icons');
    return platformFeatureFlags;
};

});


parcelRegister("6hkBe", function(module, exports) {

$parcel$export(module.exports, "getExtensionEntryPoint", () => $79126e23f70deddc$export$5dfdba3e408a8d60);
const $79126e23f70deddc$export$5dfdba3e408a8d60 = (extension, entryPoint)=>{
    const defaultEntryPoint = extension.properties.resource;
    const alternativeEntryPoint = entryPoint && extension.properties[entryPoint]?.resource;
    return alternativeEntryPoint || defaultEntryPoint;
};

});

parcelRegister("ge8sG", function(module, exports) {

$parcel$export(module.exports, "getResolverContext", () => $ac41360860378247$export$c34ac5b863279caa);
const $ac41360860378247$export$c34ac5b863279caa = (coreData, extensionData)=>({
        ...coreData,
        extension: extensionData
    });

});

parcelRegister("UZU5S", function(module, exports) {

$parcel$export(module.exports, "getViewContext", () => $fff5b396b669afc2$export$20af16720c0f9c71);
const $fff5b396b669afc2$export$20af16720c0f9c71 = ({ resolverContext: resolverContext, accountId: accountId, extension: extension, timezone: timezone, locale: locale, location: location, extensionPayload: extensionPayload, extensionViewData: extensionViewData, theme: theme, surfaceColor: surfaceColor })=>{
    // Combine the static macro extension data with the dynamic extension view data (macro body) into a single macro object
    const macro = {
        ...resolverContext.extension?.macro,
        ...extensionViewData?.macro
    };
    /* adding hasAccess separately instead of using userAccess as a whole is to avoid appending __typename in the context */ const userAccess = extension.userAccess ?? {
        enabled: false,
        hasAccess: false
    };
    return {
        ...resolverContext,
        extension: {
            ...resolverContext.extension,
            ...extensionViewData,
            ...extensionPayload,
            ...Object.keys(macro).length > 0 ? {
                macro: macro
            } : {},
            location: location
        },
        accountId: accountId,
        license: extension?.license || null,
        timezone: timezone,
        locale: locale,
        theme: theme,
        surfaceColor: surfaceColor,
        userAccess: userAccess
    };
};

});


parcelRegister("f0Xuq", function(module, exports) {

$parcel$export(module.exports, "InnerIframe", () => $ab5a832ac7acfeff$export$3c4d31cb85fd39c5);
/* InnerIframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $kyKWe = parcelRequire("kyKWe");

var $gdv5Z = parcelRequire("gdv5Z");

var $10PJn = parcelRequire("10PJn");

var $dh538 = parcelRequire("dh538");

var $jIiuI = parcelRequire("jIiuI");

var $dj2Gr = parcelRequire("dj2Gr");
var $jT2lX = parcelRequire("jT2lX");
var $3sdPf = parcelRequire("3sdPf");

var $4ZTaE = parcelRequire("4ZTaE");

var $4LgCj = parcelRequire("4LgCj");
var $9XihO = parcelRequire("9XihO");
var $kxKUs = parcelRequire("kxKUs");
var $kZjf5 = parcelRequire("kZjf5");

var $kaOT1 = parcelRequire("kaOT1");

var $LiNdD = parcelRequire("LiNdD");
var $hcbSV = parcelRequire("hcbSV");
var $ge8sG = parcelRequire("ge8sG");
var $UZU5S = parcelRequire("UZU5S");

var $aGCtG = parcelRequire("aGCtG");

var $bn0yX = parcelRequire("bn0yX");

var $eahkE = parcelRequire("eahkE");
const $ab5a832ac7acfeff$var$styles = {
    threeLOInfo: "_1bsb1osq _4t3i1osq",
    box: "_kqswh2mm"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $ab5a832ac7acfeff$var$modalIframeStyles = null;
const $ab5a832ac7acfeff$var$iframeStyles = null;
const $ab5a832ac7acfeff$var$hiddenIframeStyles = null;
const $ab5a832ac7acfeff$var$nonResizeableIframeStyles = null;
const $ab5a832ac7acfeff$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4ZTaE.default), {
            ...props
        })
}; /**
    * Hook for determining default IFrame React ref, using parent ref when provided
    *
    * @param parentIframeRef parent IFrame React ref
    * @returns default IFrame React ref
    */ 
function $ab5a832ac7acfeff$var$useDefaultIframeRef(parentIframeRef) {
    const localIframeRef = (0, $gwFzn.useRef)(null);
    const mergedRef = (0, $10PJn.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    return mergedRef;
}
const $ab5a832ac7acfeff$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, apolloClient: apolloClient, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', src: src, bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable, getContextToken: getContextToken, timezone: timezone, locale: locale, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, extensionPayload: extensionPayload, isHidden: isHidden, theme: theme, surfaceColor: surfaceColor, appId: appId, isInModal: isInModal, setIsLoading: setIsLoading, onError: onError }, parentIframeRef)=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($ab5a832ac7acfeff$var$defaultComponents) : $ab5a832ac7acfeff$var$defaultComponents;
    const appIsAuthenticated = (0, $aGCtG.isAppConsentedLocally)(appId, accountId);
    const { consentUrl: consentUrl, currentUserConsent: currentUserConsent, requiresUserConsent: requiresUserConsent, properties: { frameId: frameId } } = extension;
    const [userConsentRequired, setUserConsentRequired] = (0, $gwFzn.useState)(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated);
    const productContext = (0, $gwFzn.useMemo)(()=>{
        const resolverContext = (0, $ge8sG.getResolverContext)(coreData, extensionData);
        const viewContext = (0, $UZU5S.getViewContext)({
            resolverContext: resolverContext,
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $hcbSV.getBrowserTimezone)(),
            locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            theme: theme,
            surfaceColor: surfaceColor,
            ...(0, $dh538.fg)('frge-706-include-location-in-forge-context') ? {
                location: window.location.toString()
            } : {}
        });
        return {
            resolverContext: resolverContext,
            viewContext: viewContext
        };
    }, [
        coreData,
        extensionData,
        extensionViewData,
        accountId,
        extension,
        timezone,
        locale,
        extensionPayload,
        theme,
        surfaceColor
    ]);
    const tracing = (0, $kaOT1.useTracingContext)();
    const contextTokenRef = (0, $gwFzn.useRef)(undefined);
    const [threeLOInfo, setThreeLOInfo] = (0, $gwFzn.useState)(null);
    const invokeRetriesRef = (0, $gwFzn.useRef)([]);
    const iframeRef = $ab5a832ac7acfeff$var$useDefaultIframeRef(parentIframeRef);
    (0, $gwFzn.useEffect)(()=>{
        const clearThreeLOInfo = async ()=>setThreeLOInfo(null);
        if (userConsentRequired) {
            tracing?.recordConsentFlow('consent flow - start');
            setThreeLOInfo({
                authUrl: consentUrl,
                onSuccess: async ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'success');
                    setUserConsentRequired(false);
                    setIsThreeLOPromptVisible(false);
                    (0, $aGCtG.setAppConsentLocal)(appId, accountId);
                    return clearThreeLOInfo();
                },
                onReject: ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'rejected');
                    return clearThreeLOInfo();
                }
            });
            setIsThreeLOPromptVisible(true);
            setShouldShowRenderer?.(false);
            if (onLoad) onLoad();
        }
    }, [
        onLoad,
        setIsThreeLOPromptVisible,
        setShouldShowRenderer,
        tracing,
        appId,
        accountId,
        consentUrl,
        userConsentRequired
    ]);
    const navigation = (0, $kZjf5.useNavigation)({
        extension: extension,
        push: bridge?.spaPush
    });
    const invoker = (0, $dj2Gr.useInvokeExtension)(contextIds, extension.id, {
        client: apolloClient
    }); // this hook has no side effect (i.e. does not actively trigger any network calls or actively making any subscription.
    // It is because everything inside this hook is lazily initialized.
    // Importantly:
    // - It only has impact when the subscribeClientEvent is called by the client (i.e. @forge/bridge)
    // - The backend service is feature flagged and is not live in production, hence calling this hook in production or without
    //   enabled falg will have no impact.
    const subscribeClientEvent = (0, $3sdPf.useSubscribeClientEventsBridge)(appId, extension.installationId);
    const publishClientEvent = (0, $jT2lX.usePublishClientEventsBridge)(appId, extension.installationId, {
        client: apolloClient
    });
    const environment = (0, $gwFzn.useContext)((0, $jIiuI.EnvironmentContext));
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const productFetchClient = (0, $9XihO.useProductFetchClient)({
        appId: appId,
        environment: environment,
        contextIds: contextIds,
        cloudId: cloudId,
        workspaceId: workspaceId,
        extensionId: extension.id,
        options: {
            client: apolloClient
        },
        renderThreeLOPrompt: (retry)=>{
            return new Promise((resolve, reject)=>{
                const authUrl = threeLOInfo?.authUrl || consentUrl;
                if (authUrl) {
                    invokeRetriesRef.current.push(retry);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                }
            });
        }
    });
    const { loading: loading, iframeProps: { onLoad: onLoadIframeFromProps } } = (0, $kxKUs.useBridge)({
        theme: theme,
        surfaceColor: surfaceColor,
        origin: new URL(src).origin,
        api: {
            ...(0, $4LgCj.createBridgeApi)(bridge, {
                userConsentRequired: !!userConsentRequired
            }),
            onInvoke: async (payload)=>{
                const newContextToken = getContextToken ? await getContextToken() : contextTokenRef.current?.jwt;
                tracing?.recordGqlCall('invokeExtension - start');
                const { data: data } = await invoker({
                    call: payload,
                    context: {
                        ...productContext.resolverContext
                    },
                    extensionPayload: extensionPayload,
                    contextToken: newContextToken
                });
                const resp = data?.invokeExtension;
                if (!resp?.success) {
                    const error = resp?.errors?.[0];
                    if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                        type: '3lo',
                        authUrl: error?.extensions.fields?.authInfoUrl
                    };
                    if (error?.extensions.errorType === (0, $eahkE.SANDBOX_DEPRECATION_ERROR) && onError && (0, $dh538.fg)('platform_render_sandbox_runtime_error_panel')) onError(error?.extensions.errorType);
                    return {
                        type: 'err',
                        message: error?.message ?? 'An error occurred while trying to invoke.'
                    };
                }
                tracing?.recordGqlCall('invokeExtension - end');
                contextTokenRef.current = resp?.contextToken;
                return {
                    type: 'ok',
                    response: resp?.response?.body
                };
            },
            onNavigate: navigation.onNavigate,
            onThreeLO: async (authUrl, retry)=>{
                return new Promise((resolve, reject)=>{
                    invokeRetriesRef.current.push(retry);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                });
            },
            getContext: async ()=>({
                    ...productContext.viewContext
                }),
            fetchProduct: async ({ restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            getFrameId: ()=>frameId ?? null,
            subscribeClientEvent: subscribeClientEvent,
            publishClientEvent: publishClientEvent
        },
        customBridgeMethods: customBridgeMethods,
        onLoad: onLoad,
        isResizable: isResizable,
        height: height,
        environment: environment,
        extension: extension,
        iframeRef: iframeRef,
        client: apolloClient,
        contextIds: contextIds
    });
    (0, $gwFzn.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
        xcss: $ab5a832ac7acfeff$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || threeLOInfo ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        },
        children: [
            navigation.getModalJsx(),
            (loading || threeLOInfo) && ((0, $dh538.fg)('fix-react-18-concurrent-upgrade-infinite-rendering') ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                xcss: $ab5a832ac7acfeff$var$styles.threeLOInfo,
                children: [
                    loading && !threeLOInfo && !isHidden && (0, $bn0yX.getLoadingComponent)(loadingComponent),
                    threeLOInfo && ThreeLOPrompt({
                        authUrl: threeLOInfo.authUrl,
                        onSuccess: threeLOInfo.onSuccess,
                        metadata: {
                            moduleType: extension.type
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                    xcss: $ab5a832ac7acfeff$var$styles.threeLOInfo,
                    children: [
                        loading && !threeLOInfo && !isHidden && (0, $bn0yX.getLoadingComponent)(loadingComponent),
                        threeLOInfo && ThreeLOPrompt({
                            authUrl: threeLOInfo.authUrl,
                            onSuccess: threeLOInfo.onSuccess,
                            metadata: {
                                moduleType: extension.type
                            }
                        })
                    ]
                })
            })),
            !userConsentRequired && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("iframe", {
                    "data-testid": "hosted-resources-iframe",
                    "data-forge-iframe": true,
                    sandbox: "allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts",
                    allow: "camera; clipboard-write; display-capture; fullscreen; microphone",
                    src: src,
                    ref: iframeRef,
                    onLoad: onLoadIframeFromProps,
                    title: `Iframe ${frameId ?? (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()} from ${appId}`,
                    className: (0, $35pXk.default)([
                        "_19itglyw _1e0c1ule _1bsb1osq",
                        (loading || threeLOInfo || isHidden) && "_1e0cglyw",
                        isInModal && "_2rko1sit _4t3i1osq",
                        !isResizable && "_4t3i1osq"
                    ])
                })
            })
        ]
    });
});

});
parcelRegister("dj2Gr", function(module, exports) {

$parcel$export(module.exports, "useInvokeExtension", () => $7569106fed376473$export$19d283d2f5a7d3c);

var $gwFzn = parcelRequire("gwFzn");

var $76I1K = parcelRequire("76I1K");

var $d2LG0 = parcelRequire("d2LG0");

var $1KmJq = parcelRequire("1KmJq");

var $dh538 = parcelRequire("dh538");

var $1Igmn = parcelRequire("1Igmn");
const $7569106fed376473$export$46af696e5313090f = (0, $d2LG0.default)`mutation forge_ui_invokeExtension($input:InvokeExtensionInput!){invokeExtension(input:$input){success response{body}contextToken{jwt expiresAt}errors{message extensions{errorType statusCode ...on InvokeExtensionPayloadErrorExtension{fields{authInfoUrl}}}}}}`;
const $7569106fed376473$export$19d283d2f5a7d3c = (contextIds, extensionId, options)=>{
    const [mutationFunction] = (0, $1KmJq.useMutation)($7569106fed376473$export$46af696e5313090f, options);
    const headers = (0, $gwFzn.useMemo)(()=>{
        const initHeaders = {};
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) initHeaders['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join());
        return initHeaders;
    }, [
        contextIds
    ]);
    return (0, $76I1K.useCallbackOne)((payload, entryPoint = 'resolver')=>mutationFunction({
            variables: {
                input: {
                    contextIds: contextIds,
                    extensionId: extensionId,
                    payload: payload,
                    entryPoint: entryPoint
                }
            },
            context: {
                headers: headers
            }
        }), [
        contextIds,
        extensionId,
        mutationFunction,
        headers
    ]);
};

});

parcelRegister("jT2lX", function(module, exports) {

$parcel$export(module.exports, "usePublishClientEventsBridge", () => $82bf2731064fa10d$export$b6697de9337e7980);

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $1KmJq = parcelRequire("1KmJq");

var $1Igmn = parcelRequire("1Igmn");
const $82bf2731064fa10d$export$9791cd1b013cd8c8 = (0, $d2LG0.default)`mutation publishAppClientEvent($appId:ID!$contextAri:ID!$channel:String!$eventName:String$payload:String!){ecosystem{publishAppClientEvent(appId:$appId contextAri:$contextAri channel:$channel eventName:$eventName payload:$payload){statusCode}}}`;
const $82bf2731064fa10d$export$b6697de9337e7980 = (appId, contextAri, options)=>{
    const [mutationFunction] = (0, $1KmJq.useMutation)($82bf2731064fa10d$export$9791cd1b013cd8c8, options);
    const headers = (0, $gwFzn.useMemo)(()=>{
        const initHeaders = {};
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) initHeaders['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)();
        return initHeaders;
    }, []);
    return (0, $gwFzn.useCallback)((payload)=>{
        const { channel: channel, eventName: eventName, eventPayload: eventPayload } = payload.data;
        return mutationFunction({
            variables: {
                appId: appId,
                contextAri: contextAri,
                channel: channel,
                eventName: eventName,
                payload: eventPayload
            },
            context: {
                headers: headers
            }
        });
    }, [
        appId,
        contextAri,
        mutationFunction,
        headers
    ]);
};

});

parcelRegister("3sdPf", function(module, exports) {

$parcel$export(module.exports, "useSubscribeClientEventsBridge", () => $f3780db024f27ed2$export$d1ccb298f902fc9c);

var $d2LG0 = parcelRequire("d2LG0");

var $aLaTe = parcelRequire("aLaTe");

var $gwFzn = parcelRequire("gwFzn");

var $kK6dd = parcelRequire("kK6dd");
const $f3780db024f27ed2$var$appClientEventsSubscription = (0, $d2LG0.default)`subscription onAppClientEvent($appId:ID!$channel:String!$contextAri:ID!$eventName:String){ecosystem{onAppClientEvent(appId:$appId channel:$channel contextAri:$contextAri eventName:$eventName){payload}}}`;
const $f3780db024f27ed2$var$getContextKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
const $f3780db024f27ed2$var$unsubscribeAllSubscriptions = (activeSubscriptions)=>{
    activeSubscriptions.forEach((subscription)=>{
        if (!subscription.closed) subscription.unsubscribe();
    });
    activeSubscriptions.clear();
};
const $f3780db024f27ed2$export$d1ccb298f902fc9c = (appId, contextAri)=>{
    const activeSubscriptions = (0, $gwFzn.useRef)(new Map());
    (0, $gwFzn.useEffect)(()=>{
        const currentSubscriptions = activeSubscriptions.current;
        return ()=>{
            $f3780db024f27ed2$var$unsubscribeAllSubscriptions(currentSubscriptions);
        };
    }, []);
    // this is the bridge method that will be called from the extension
    return (0, $gwFzn.useCallback)(async (payload)=>{
        const { channel: channel, eventName: eventName, onClientEvent: onClientEvent } = payload.data;
        const subscription = (0, $kK6dd.subscribe)({
            operationName: 'onAppClientEvent',
            query: (0, $aLaTe.print)($f3780db024f27ed2$var$appClientEventsSubscription),
            variables: {
                appId: appId,
                contextAri: contextAri,
                channel: channel,
                eventName: eventName
            }
        }, {
            next: (result)=>{
                const { payload: payload } = result.data.ecosystem.onAppClientEvent ?? {};
                onClientEvent(payload ?? null);
            },
            error: (err)=>{
                onClientEvent(null, err);
            },
            complete: ()=>{}
        });
        const contextKey = $f3780db024f27ed2$var$getContextKey({
            channel: channel,
            ...eventName !== undefined && {
                eventName: eventName
            }
        });
        const existingSubscription = activeSubscriptions.current.get(contextKey);
        if (existingSubscription && !existingSubscription.closed) existingSubscription.unsubscribe();
        activeSubscriptions.current.set(contextKey, subscription);
        return {
            unsubscribe: ()=>{
                // close the subscription
                if (!subscription.closed) subscription.unsubscribe();
                activeSubscriptions.current.delete(contextKey);
            }
        };
    }, [
        appId,
        contextAri
    ]);
};

});
parcelRegister("kK6dd", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $b7f5501d28b11a4d$export$ec068583843480e7);

var $58grj = parcelRequire("58grj");
const $b7f5501d28b11a4d$var$getAGGWebsocketURI = ()=>{
    return `wss://${window.location.host}/gateway/api/graphql/subscriptions`;
};
const $b7f5501d28b11a4d$var$createAGGSubscriptionClient = ()=>{
    return (0, $58grj.createClient)({
        url: $b7f5501d28b11a4d$var$getAGGWebsocketURI(),
        retryAttempts: 2,
        lazy: true
    });
};
const $b7f5501d28b11a4d$var$getAGGSubscriptionClient = ()=>{
    let client = window.__FORGE_AGG_SUBSCRIPTION_CLIENT__;
    if (!client) {
        client = $b7f5501d28b11a4d$var$createAGGSubscriptionClient();
        window.__FORGE_AGG_SUBSCRIPTION_CLIENT__ = client;
    }
    return client;
};
class $b7f5501d28b11a4d$var$BasicSubscription {
    unsubscribe() {
        if (!this.closed) {
            this.baseUnsubscribe();
            this.closed = true;
        }
    }
    constructor(baseUnsubscribe){
        this.closed = void 0;
        this.baseUnsubscribe = void 0;
        this.closed = false;
        this.baseUnsubscribe = baseUnsubscribe;
    }
}
const $b7f5501d28b11a4d$export$ec068583843480e7 = (payload, sink, client)=>{
    if (!client) client = $b7f5501d28b11a4d$var$getAGGSubscriptionClient();
    const unsubscribe = client.subscribe(payload, sink);
    return new $b7f5501d28b11a4d$var$BasicSubscription(unsubscribe);
};

});


parcelRegister("4ZTaE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24cf88a4f07ee68$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ThreeLOPromptRenderFn", () => $e24cf88a4f07ee68$export$92dadb4ff2941f34);
$parcel$export(module.exports, "makeThreeLOPrompt", () => $e24cf88a4f07ee68$export$388ff2bd3ce4e348);
$parcel$export(module.exports, "makeThreeLOPromptForCustomUI", () => $e24cf88a4f07ee68$export$7519b5f6e74be543);
/* threeLOPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $1GzhS = parcelRequire("1GzhS");

var $gdv5Z = parcelRequire("gdv5Z");

var $aoVih = parcelRequire("aoVih");

var $ccHMk = parcelRequire("ccHMk");

var $dh538 = parcelRequire("dh538");

var $i35rc = parcelRequire("i35rc");

var $jXwV2 = parcelRequire("jXwV2");

const $e24cf88a4f07ee68$var$LegacySectionMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6JSOU")));
const $e24cf88a4f07ee68$var$styles = {
    box: "_1h6dtmh3 _1dqonqa1 _189ejfq9"
};
const $e24cf88a4f07ee68$var$ThreeLOPrompt = (props)=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    (0, $gwFzn.useEffect)(()=>{
        if (onInitialization) onInitialization();
    }, [
        onInitialization
    ]);
    if (!authUrl || authUrl === '') {
        if ((0, $dh538.fg)('fix-react-18-concurrent-upgrade-infinite-rendering')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
            appearance: "error",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...$e24cf88a4f07ee68$var$messages.noAuthURLErrorMessage
            })
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)($e24cf88a4f07ee68$var$LegacySectionMessage, {
            appearance: "error",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...$e24cf88a4f07ee68$var$messages.noAuthURLErrorMessage
            })
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            onClick: (e)=>e.stopPropagation(),
            padding: "space.250",
            xcss: $e24cf88a4f07ee68$var$styles.box,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                alignInline: "start",
                space: "space.250",
                grow: "hug",
                testId: "three-lo-prompt",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        children: promptMessage
                    }),
                    (0, $dh538.fg)('fix-react-18-concurrent-upgrade-infinite-rendering') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        onClick: startAuth,
                        isLoading: loading,
                        children: buttonText
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jXwV2.AkButton), {
                        onClick: startAuth,
                        isLoading: loading,
                        children: buttonText
                    })
                ]
            })
        })
    });
};
var $e24cf88a4f07ee68$export$2e2bcd8739ae039 = $e24cf88a4f07ee68$var$ThreeLOPrompt;
const $e24cf88a4f07ee68$export$92dadb4ff2941f34 = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($e24cf88a4f07ee68$var$ThreeLOPrompt, {
        message: message,
        authUrl: authUrl,
        promptText: promptText,
        onSuccess: ()=>dispatch({
                type: 'render',
                extensionData: {}
            })
    });
};
const $e24cf88a4f07ee68$export$388ff2bd3ce4e348 = ({ appName: appName, onSuccess: onSuccess })=>{
    return function threeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return dispatch({
                    type: 'render',
                    extensionData: {}
                });
            }
        });
    };
};
const $e24cf88a4f07ee68$export$7519b5f6e74be543 = ({ appName: appName, onSuccess: onSuccess, message: message, onInitialization: onInitialization })=>{
    return function threeLOPrompt(props) {
        const { authUrl: authUrl, promptText: promptText, onSuccess: onSuccessFromIframeComponent } = props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return Promise.resolve(onSuccessFromIframeComponent);
            },
            onInitialization: onInitialization
        });
    };
};
const $e24cf88a4f07ee68$var$messages = (0, $2nPZH.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    }
});

});
parcelRegister("jXwV2", function(module, exports) {

$parcel$export(module.exports, "AkButton", () => $a42d48f6837420c9$export$8471a7693ebd6f54);
$parcel$export(module.exports, "useButton", () => $a42d48f6837420c9$export$ea18c227d4417cc3);
$parcel$export(module.exports, "Button", () => $a42d48f6837420c9$export$353f5b6fc5456de1);
$parcel$export(module.exports, "useActionButtons", () => $a42d48f6837420c9$export$fdac0c774aedd7f7);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a2MMO = parcelRequire("a2MMO");

var $i2hng = parcelRequire("i2hng");

var $8qzb0 = parcelRequire("8qzb0");

const $a42d48f6837420c9$export$8471a7693ebd6f54 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("7CYIQ")));
function $a42d48f6837420c9$export$ea18c227d4417cc3({ forgeDoc: forgeDoc, dispatch: dispatch }) {
    const { props: { appearance: appearance = 'default', text: text, disabled: disabled, onClick: onClick, icon: icon, iconPosition: iconPosition = 'before' } = {} } = forgeDoc;
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    const handleClick = async ()=>{
        setLoading(true);
        try {
            await dispatch({
                type: 'event',
                handler: onClick,
                args: [],
                extensionData: {}
            });
        } finally{
            setLoading(false);
        }
    };
    let iconDom;
    if (icon) iconDom = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8qzb0.default), {
        size: "medium",
        glyph: icon
    });
    const iconBefore = iconPosition === 'before' ? iconDom : undefined;
    const iconAfter = iconPosition === 'after' ? iconDom : undefined;
    const width = (0, $gwFzn.useContext)((0, $i2hng.WidthContext));
    let shouldFitContainer = (0, $a2MMO.buttonShouldFitContainer)(width);
    return {
        akButtonProps: {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading,
            isDisabled: disabled,
            appearance: appearance,
            onClick: handleClick,
            children: text
        }
    };
}
function $a42d48f6837420c9$export$353f5b6fc5456de1(props) {
    const { akButtonProps: akButtonProps } = $a42d48f6837420c9$export$ea18c227d4417cc3(props);
    const { shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading, isDisabled: isDisabled, appearance: appearance, onClick: onClick, children: children } = akButtonProps;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a42d48f6837420c9$export$8471a7693ebd6f54, {
        shouldFitContainer: shouldFitContainer,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isLoading: isLoading,
        isDisabled: isDisabled,
        appearance: appearance,
        onClick: onClick,
        children: children
    });
}
function $a42d48f6837420c9$export$fdac0c774aedd7f7({ forgeDoc: forgeDoc, dispatch: dispatch }) {
    const [loading, setLoading] = (0, $gwFzn.useState)(forgeDoc.map(()=>false));
    const width = (0, $gwFzn.useContext)((0, $i2hng.WidthContext));
    const shouldFitContainer = (0, $a2MMO.buttonShouldFitContainer)(width);
    const actionButtons = forgeDoc.map((actionButtonForgeDoc, index)=>{
        const { props: { appearance: appearance = 'subtle', text: text, disabled: disabled, onClick: onClick, icon: icon, iconPosition: iconPosition = 'before' } = {} } = actionButtonForgeDoc;
        const handleClick = async ()=>{
            setLoading(loading.map((l, i)=>{
                if (i === index) return true;
                return l;
            }));
            try {
                await dispatch({
                    type: 'event',
                    handler: onClick,
                    args: [],
                    extensionData: {}
                });
            } finally{
                setLoading(loading.map((l, i)=>{
                    if (i === index) return false;
                    return l;
                }));
            }
        };
        let iconDom;
        if (icon) iconDom = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8qzb0.default), {
            size: "medium",
            glyph: icon
        });
        const iconBefore = iconPosition === 'before' ? iconDom : undefined;
        const iconAfter = iconPosition === 'after' ? iconDom : undefined;
        return {
            shouldFitContainer: shouldFitContainer,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isLoading: loading[index],
            isDisabled: disabled,
            appearance: appearance,
            onClick: handleClick,
            children: text
        };
    });
    return {
        akActionButtonProps: actionButtons
    };
}

});
parcelRegister("a2MMO", function(module, exports) {

$parcel$export(module.exports, "buttonShouldFitContainer", () => $708787c55cfee9c5$export$37ca8ef0f54b556e);
const $708787c55cfee9c5$var$FULL_WIDTH_BUTTONS_BREAKPOINT_PX = 360;
const $708787c55cfee9c5$export$37ca8ef0f54b556e = (width)=>width > 0 && width < $708787c55cfee9c5$var$FULL_WIDTH_BUTTONS_BREAKPOINT_PX;

});

parcelRegister("i2hng", function(module, exports) {

$parcel$export(module.exports, "WidthContext", () => $e15251f056a7fc02$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthProvider", () => $e15251f056a7fc02$export$7921e18173e8c666);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4JDbp = parcelRequire("4JDbp");
const $e15251f056a7fc02$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(0);
const $e15251f056a7fc02$var$SCROLLBAR_WIDTH = 30;
const $e15251f056a7fc02$export$7921e18173e8c666 = ({ children: children })=>{
    const [width, setWidth] = (0, $gwFzn.useState)(0);
    const handleWidthChange = (newWidth)=>{
        // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
        if (!newWidth || Math.abs(width - newWidth) < $e15251f056a7fc02$var$SCROLLBAR_WIDTH) return;
        setWidth(newWidth);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: handleWidthChange
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($e15251f056a7fc02$export$27e39f636459b9f.Provider, {
                value: width,
                children: children
            })
        ]
    });
};
const $e15251f056a7fc02$export$5d8538aa831b6ebb = $e15251f056a7fc02$export$27e39f636459b9f.Consumer;

});

parcelRegister("8qzb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8625d40649a1e3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5LrKE = parcelRequire("5LrKE");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");
const $1b8625d40649a1e3$var$Icon = ({ size: size = 'medium', glyph: glyph })=>{
    const Component = (0, $5LrKE.IconPaths)[glyph];
    const intl = (0, $dBxQj.default)();
    if (!Component) return null;
     // do nothing
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: // @ts-ignore Jira only - TS2322: Type '{ label: string; size: "small" | "medium" | "large"; }' is not assignable to type 'IntrinsicAttributes'.
        /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            label: intl.formatMessage($1b8625d40649a1e3$var$messages.icon),
            size: size
        })
    });
};
var $1b8625d40649a1e3$export$2e2bcd8739ae039 = $1b8625d40649a1e3$var$Icon;
function $1b8625d40649a1e3$export$af44fe23e87e9bd7({ props: props }) {
    const { glyph: glyph, size: size } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($1b8625d40649a1e3$var$Icon, {
        glyph: glyph,
        size: size
    });
}
const $1b8625d40649a1e3$var$messages = (0, $2nPZH.defineMessages)({
    icon: {
        id: "confluence.icon.label",
        defaultMessage: "Icon"
    }
});

});
parcelRegister("5LrKE", function(module, exports) {

$parcel$export(module.exports, "IconPaths", () => $ccc53643ba31c9ca$export$6409a24d2c5a7539);
// *** GENERATED FILE - DO NOT EDIT ***
// WARNING: import needs to be statically analysable to not be problematic [at runtime]

var $gwFzn = parcelRequire("gwFzn");





































































































































































































































































































































































const $ccc53643ba31c9ca$export$6409a24d2c5a7539 = {
    activity: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7uqxq"))),
    add: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("egnkI"))),
    'add-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("69jXZ"))),
    'add-item': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cVLXH"))),
    addon: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lF15K"))),
    'app-access': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3mGTl"))),
    'app-switcher': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7Oixb"))),
    archive: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3XErz"))),
    'arrow-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ikpD8"))),
    'arrow-down-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2u1xT"))),
    'arrow-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2sYAo"))),
    'arrow-left-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cW2cu"))),
    'arrow-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ncbZj"))),
    'arrow-right-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6fThe"))),
    'arrow-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8fdGd"))),
    'arrow-up-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jQYVG"))),
    attachment: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("72epO"))),
    audio: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lPSh9"))),
    'audio-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1XG0j"))),
    backlog: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7N1nT"))),
    billing: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("PrNAI"))),
    'billing-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9wBfw"))),
    'bitbucket-branches': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("48o9a"))),
    'bitbucket-builds': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("al8ek"))),
    'bitbucket-clone': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9NGnm"))),
    'bitbucket-commits': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bSoQ5"))),
    'bitbucket-compare': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ctMmL"))),
    'bitbucket-forks': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("WbN4W"))),
    'bitbucket-output': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i53Wt"))),
    'bitbucket-pipelines': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jVAma"))),
    'bitbucket-pullrequests': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("g3FIx"))),
    'bitbucket-repos': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6YxxM"))),
    'bitbucket-snippets': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a9gIA"))),
    'bitbucket-source': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aT7Al"))),
    board: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1ygEM"))),
    book: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fDU6I"))),
    'bullet-list': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4zIyE"))),
    calendar: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("32wsW")))),
    'calendar-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bSPHX"))),
    camera: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fq6oe"))),
    'camera-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cUWGE"))),
    'camera-rotate': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9i56W"))),
    'camera-take-picture': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("e4iVV"))),
    canvas: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("l3kLa"))),
    check: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("66FuL")))),
    'check-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("eCByP")))),
    'check-circle-outline': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eG3Hu"))),
    checkbox: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cokXW"))),
    'checkbox-indeterminate': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4v2Kt"))),
    'chevron-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("klvaQ")))),
    'chevron-down-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bZnWb"))),
    'chevron-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eEZee"))),
    'chevron-left-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6ade7"))),
    'chevron-left-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("7jrhz")))),
    'chevron-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dBnQj"))),
    'chevron-right-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2TPo8"))),
    'chevron-right-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("dskUg")))),
    'chevron-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aLXfB"))),
    'chevron-up-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7bAx3"))),
    'child-issues': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("g6eqe"))),
    code: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7WiKX"))),
    comment: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lkHKL"))),
    component: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8WE6A"))),
    copy: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("5mdwm")))),
    creditcard: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a3GrC"))),
    'creditcard-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("g3xEK"))),
    cross: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("ge0Ua")))),
    'cross-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5r9xx"))),
    dashboard: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fWz52"))),
    decision: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("flMWY"))),
    department: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hpBnv"))),
    'detail-view': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iMp6B"))),
    discover: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("36wYk"))),
    'discover-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4CLVX"))),
    document: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f4dBg"))),
    'document-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6voFP"))),
    documents: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bI2rr"))),
    download: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7zqtv"))),
    'drag-handler': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6LeCs"))),
    dropbox: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1aijb"))),
    edit: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("50B9p"))),
    'edit-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8k8Tk"))),
    'editor-add': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5iX3H"))),
    'editor-addon': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("58zsy"))),
    'editor-advanced': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2gPzN"))),
    'editor-align-center': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("e8liC"))),
    'editor-align-image-center': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("c3ye6"))),
    'editor-align-image-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fYu2I"))),
    'editor-align-image-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("YnYzy"))),
    'editor-align-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jKmDI"))),
    'editor-align-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cJhMj"))),
    'editor-attachment': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hQC4q"))),
    'editor-background-color': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("e2PWG"))),
    'editor-bold': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("efbV0"))),
    'editor-bullet-list': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3FUpl"))),
    'editor-close': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("d0d2M")))),
    'editor-code': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4udHW"))),
    'editor-collapse': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3iuuL"))),
    'editor-date': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("erQrG"))),
    'editor-decision': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lpsLT"))),
    'editor-divider': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6aCL3"))),
    'editor-done': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("6Eilg")))),
    'editor-edit': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3kNFU"))),
    'editor-emoji': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2Db2S"))),
    'editor-error': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2yLb2"))),
    'editor-expand': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4Z9Qn"))),
    'editor-feedback': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("15iS2"))),
    'editor-file': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lFUZx"))),
    'editor-file-preview': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8KqjS"))),
    'editor-help': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7Or5u"))),
    'editor-hint': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4UsjY"))),
    'editor-horizontal-rule': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("if6iT"))),
    'editor-image': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gAgWa"))),
    'editor-image-border': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aV6ps"))),
    'editor-image-resize': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9AP6y"))),
    'editor-indent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3ihBx"))),
    'editor-info': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4KQjl"))),
    'editor-italic': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("egQsF"))),
    'editor-layout-single': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2ruzy"))),
    'editor-layout-three-equal': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1Wu6x"))),
    'editor-layout-three-with-sidebars': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dKZ4S"))),
    'editor-layout-two-equal': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f7eKx"))),
    'editor-layout-two-left-sidebar': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bArSn"))),
    'editor-layout-two-right-sidebar': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4p15b"))),
    'editor-link': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gnI8L"))),
    'editor-media-center': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3jgZY"))),
    'editor-media-full-width': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6XCSm"))),
    'editor-media-wide': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("axCs4"))),
    'editor-media-wrap-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jiQoJ"))),
    'editor-media-wrap-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("35crK"))),
    'editor-mention': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1llhC"))),
    'editor-more': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("inAmW"))),
    'editor-note': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7Bu96"))),
    'editor-number-list': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aFPUK"))),
    'editor-open': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("h8TC5"))),
    'editor-outdent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gI4Aj"))),
    'editor-panel': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8cvaV"))),
    'editor-photo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("rE76e"))),
    'editor-quote': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eLxw3"))),
    'editor-recent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("NtK10"))),
    'editor-redo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iDNea"))),
    'editor-remove': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aHxWB"))),
    'editor-remove-emoji': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eNmKk"))),
    'editor-search': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("66gZz")))),
    'editor-settings': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iIPUk"))),
    'editor-strikethrough': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1utN2"))),
    'editor-success': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("6alL7")))),
    'editor-table': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("azjDQ"))),
    'editor-table-display-options': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iYJOn"))),
    'editor-task': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iyP5h"))),
    'editor-text-color': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hM3rd"))),
    'editor-text-style': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YrnS"))),
    'editor-underline': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("loBYZ"))),
    'editor-undo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7PgQ0"))),
    'editor-unlink': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hjJeG"))),
    'editor-warning': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dBlHC"))),
    email: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("jc9Cb")))),
    emoji: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("77MmL"))),
    'emoji-add': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cJX52"))),
    'emoji-activity': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fvBna"))),
    'emoji-atlassian': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cY3xj"))),
    'emoji-custom': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2NAdC"))),
    'emoji-emoji': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lNtff"))),
    'emoji-flags': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f4PGy"))),
    'emoji-food': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("19z4B"))),
    'emoji-frequent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8L0KX"))),
    'emoji-keyboard': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1qIMR"))),
    'emoji-nature': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3AtxT"))),
    'emoji-objects': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9rG5j"))),
    'emoji-people': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("h78mi"))),
    'emoji-productivity': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dGWBF"))),
    'emoji-symbols': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bXQHP"))),
    'emoji-travel': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i92HB"))),
    error: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8QILn")))),
    export: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("giJMN"))),
    feedback: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kfusf"))),
    file: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ahsrS"))),
    filter: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bteXK"))),
    'flag-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k6txg"))),
    folder: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cvzpb"))),
    'folder-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kIQda"))),
    followers: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8ygoT"))),
    following: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jdqQu"))),
    googledrive: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fjYpf"))),
    'graph-bar': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("j8dnF"))),
    'graph-line': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lHHv8"))),
    gsuite: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hzr76"))),
    highlights: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4fcqT"))),
    'hipchat-audio-only': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hQXOL"))),
    'hipchat-chevron-double-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lk5Fc"))),
    'hipchat-chevron-double-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cfzPK"))),
    'hipchat-chevron-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("3rvkR")))),
    'hipchat-chevron-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("lj1Sg")))),
    'hipchat-dial-out': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7rPkg"))),
    'hipchat-lobby': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hU5Qa"))),
    'hipchat-media-attachment-count': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gl0Qr"))),
    'hipchat-outgoing-sound': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("af7Xv"))),
    'hipchat-sd-video': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("brt1O"))),
    home: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kUyYW"))),
    'home-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5aKUo"))),
    image: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("16A0u"))),
    'image-border': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lkfjj"))),
    'image-resize': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8P4yv"))),
    info: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("a7lwr")))),
    'invite-team': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iNdiW"))),
    issue: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("69dVB"))),
    'issue-raise': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("LX7JB"))),
    issues: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3vE7v"))),
    'jira-capture': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jUQmM"))),
    'jira-failed-build-status': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("59pum"))),
    'jira-labs': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a6XFF"))),
    'jira-test-session': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("99tIu"))),
    label: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("70mPY"))),
    lightbulb: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gmmth"))),
    'lightbulb-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jqPu5"))),
    like: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8JAhC"))),
    link: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("2D7De")))),
    'link-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dZmch"))),
    list: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1iwJp"))),
    location: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2p0ep"))),
    lock: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("22KZk"))),
    'lock-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3rJTC"))),
    'lock-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("17uVW")))),
    marketplace: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iYWy8"))),
    'media-services-actual-size': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f80K8"))),
    'media-services-add-comment': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4WqiO"))),
    'media-services-annotate': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8E9Ge"))),
    'media-services-arrow': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("betzx"))),
    'media-services-audio': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fNcp7"))),
    'media-services-blur': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("44nbm"))),
    'media-services-brush': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fpv3L"))),
    'media-services-button-option': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YX9t"))),
    'media-services-code': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("496tK"))),
    'media-services-document': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hHq4z"))),
    'media-services-filter': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8sLkZ"))),
    'media-services-fit-to-page': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3IKtH"))),
    'media-services-full-screen': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7QIoe"))),
    'media-services-grid': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iatmb"))),
    'media-services-image': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("b86dE"))),
    'media-services-line': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fily5"))),
    'media-services-line-thickness': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ihSz2"))),
    'media-services-no-image': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("9aBYD")))),
    'media-services-open-mediaviewer': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("b6fyt"))),
    'media-services-oval': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1IzgK"))),
    'media-services-pdf': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("d4eIg"))),
    'media-services-preselected': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k07KP"))),
    'media-services-presentation': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ahUPs"))),
    'media-services-rectangle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4EOqR"))),
    'media-services-scale-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i9ugx"))),
    'media-services-scale-small': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("idhWn"))),
    'media-services-spreadsheet': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1uRHH"))),
    'media-services-text': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3M40A"))),
    'media-services-unknown': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iNq8h"))),
    'media-services-video': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dYWbo"))),
    'media-services-zip': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1czDT"))),
    'media-services-zoom-in': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YJKk"))),
    'media-services-zoom-out': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bqmbd"))),
    mention: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("x61t6"))),
    menu: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lRe88"))),
    'menu-expand': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("85yWV"))),
    mobile: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("c4G0C"))),
    more: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1bR0l"))),
    'more-vertical': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gpNqQ"))),
    notification: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("CrpvX"))),
    'notification-all': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4Eyjd"))),
    'notification-direct': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1FzTW"))),
    'office-building': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gdD5P"))),
    'office-building-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3RtEX"))),
    open: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8MIkL"))),
    overview: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2CkJR"))),
    page: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5laGB"))),
    'page-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cN36Q"))),
    pdf: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("382xi"))),
    people: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("f9sHQ")))),
    'people-group': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("21y3U"))),
    person: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("3Jfdd")))),
    'person-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1ISHG"))),
    'person-with-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eqrmh"))),
    'person-with-cross': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gEAFN"))),
    'person-with-tick': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8FLov"))),
    portfolio: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("j7LPy"))),
    preferences: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("feFIC"))),
    premium: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kK8YU"))),
    'presence-active': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2GhhD"))),
    'presence-busy': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kGbn4"))),
    'presence-unavailable': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fdV0I"))),
    question: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fGCAg"))),
    'question-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8nVd9")))),
    questions: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("366MN"))),
    queues: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hjs2V"))),
    quote: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1gQeO"))),
    radio: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1N7Kn"))),
    recent: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aOH1S"))),
    redo: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lsP6p"))),
    refresh: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4NdrY"))),
    retry: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("casQF"))),
    roadmap: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("clSMY"))),
    'room-menu': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k3cNB"))),
    schedule: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hZbsF"))),
    'schedule-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("60GqC"))),
    screen: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jNySf"))),
    search: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("b6c2L"))),
    'select-clear': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("cPXGO")))),
    send: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1sdDz"))),
    settings: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kJYoC"))),
    share: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4fck8"))),
    ship: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("duwZb")))),
    shortcut: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8bFzt")))),
    'sign-in': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lhMt1"))),
    'sign-out': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ecI61"))),
    sprint: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hxD3l"))),
    star: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2XqOH"))),
    'star-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jzrnI"))),
    'star-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8nvCP"))),
    status: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cv50C"))),
    stopwatch: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jtu9J"))),
    subtask: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YXDD"))),
    suitcase: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("itzNP"))),
    switcher: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("01r0n"))),
    table: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("05bUX"))),
    task: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ieF3h"))),
    teams: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cA4Qt"))),
    trash: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hHuV0"))),
    tray: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4M6PA"))),
    undo: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("czh6T"))),
    unlink: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hTBfz"))),
    unlock: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("h5M9M"))),
    'unlock-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("benCO"))),
    'unlock-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aYBE7"))),
    upload: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1BrLD"))),
    'user-avatar-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k4uJB"))),
    'vid-audio-muted': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8wCoY"))),
    'vid-audio-on': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1WkPL"))),
    'vid-backward': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iqJax"))),
    'vid-camera-off': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iud5O"))),
    'vid-camera-on': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hpJdo"))),
    'vid-connection-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jZvq5"))),
    'vid-forward': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a8skH"))),
    'vid-full-screen-off': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lYjTs"))),
    'vid-full-screen-on': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7lNmN"))),
    'vid-hang-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jQzL4"))),
    'vid-hd-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1PwUL"))),
    'vid-pause': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gxyqD"))),
    'vid-play': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lPrJf"))),
    'vid-raised-hand': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("at2ny"))),
    'vid-share-screen': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ijilz"))),
    'vid-speaking-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hWhAv"))),
    'vid-volume-full': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5iX12"))),
    'vid-volume-half': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4y76w"))),
    'vid-volume-muted': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hvS0Z"))),
    'video-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kXZij"))),
    'video-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aRdQq"))),
    warning: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("5Xi9J")))),
    watch: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gJDRl"))),
    'watch-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9zZ12"))),
    world: /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eyQx7"))),
    'world-small': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9IpRk")))
};

});
parcelRegister("7uqxq", function(module, exports) {

let $573feba7776cf8e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $573feba7776cf8e8$var$load("8JZKd").then(()=>parcelRequire('2V2Ld'));

});

parcelRegister("egnkI", function(module, exports) {

let $a624a8cf0b87c477$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a624a8cf0b87c477$var$load("4yJnq").then(()=>parcelRequire('5Gq9J'));

});

parcelRegister("69jXZ", function(module, exports) {

let $47a3124df9f73455$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47a3124df9f73455$var$load("eoIpr").then(()=>parcelRequire('cUH4k'));

});

parcelRegister("cVLXH", function(module, exports) {

let $96a0032a6c5b4312$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $96a0032a6c5b4312$var$load("j5L0R").then(()=>parcelRequire('daxmT'));

});

parcelRegister("lF15K", function(module, exports) {

let $fc4e461900b2dbf3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fc4e461900b2dbf3$var$load("cqHdp").then(()=>parcelRequire('lcVFI'));

});

parcelRegister("3mGTl", function(module, exports) {

let $2734b28958590f75$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2734b28958590f75$var$load("3nxLJ").then(()=>parcelRequire('blD8v'));

});

parcelRegister("7Oixb", function(module, exports) {

let $5afb94723c7f7ec8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5afb94723c7f7ec8$var$load("8B8z5").then(()=>parcelRequire('cCp8H'));

});

parcelRegister("3XErz", function(module, exports) {

let $2e26410db6fe9309$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2e26410db6fe9309$var$load("dmB8F").then(()=>parcelRequire('lfHMX'));

});

parcelRegister("ikpD8", function(module, exports) {

let $d57df9dc9ed90a52$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d57df9dc9ed90a52$var$load("5iqKu").then(()=>parcelRequire('dxJ1i'));

});

parcelRegister("2u1xT", function(module, exports) {

let $1cef9512a55761a3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1cef9512a55761a3$var$load("9ZnUs").then(()=>parcelRequire('eXoGj'));

});

parcelRegister("2sYAo", function(module, exports) {

let $1cbd316cd9db412d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1cbd316cd9db412d$var$load("hGXAt").then(()=>parcelRequire('fJmzg'));

});

parcelRegister("cW2cu", function(module, exports) {

let $96ac9bc62d4fc49a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $96ac9bc62d4fc49a$var$load("1gkvI").then(()=>parcelRequire('9MOi4'));

});

parcelRegister("ncbZj", function(module, exports) {

let $045b9b3e8eb3b2ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $045b9b3e8eb3b2ec$var$load("iWT4e").then(()=>parcelRequire('eEQFA'));

});

parcelRegister("6fThe", function(module, exports) {

let $48df05a10930a74c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $48df05a10930a74c$var$load("8pEYH").then(()=>parcelRequire('4ewpp'));

});

parcelRegister("8fdGd", function(module, exports) {

let $600a55fc6c3156fb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $600a55fc6c3156fb$var$load("9f4oR").then(()=>parcelRequire('9umf9'));

});

parcelRegister("jQYVG", function(module, exports) {

let $e74222f7361ae923$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e74222f7361ae923$var$load("hNfxp").then(()=>parcelRequire('dZu1d'));

});

parcelRegister("72epO", function(module, exports) {

let $51f3e6e4445d75a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $51f3e6e4445d75a7$var$load("8PsNg").then(()=>parcelRequire('hSAKW'));

});

parcelRegister("lPSh9", function(module, exports) {

let $fe587660fe1160ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fe587660fe1160ce$var$load("ajjlj").then(()=>parcelRequire('g8im1'));

});

parcelRegister("1XG0j", function(module, exports) {

let $16dbe23ea62c61e3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $16dbe23ea62c61e3$var$load("lyb2f").then(()=>parcelRequire('icwjb'));

});

parcelRegister("7N1nT", function(module, exports) {

let $5abe2ee8b953518c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5abe2ee8b953518c$var$load("goutI").then(()=>parcelRequire('8NAUH'));

});

parcelRegister("PrNAI", function(module, exports) {

let $09aa53cf13b9921b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $09aa53cf13b9921b$var$load("81hHt").then(()=>parcelRequire('88gzH'));

});

parcelRegister("9wBfw", function(module, exports) {

let $6ef3ff2a0462e98e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6ef3ff2a0462e98e$var$load("lx3pt").then(()=>parcelRequire('avmB1'));

});

parcelRegister("48o9a", function(module, exports) {

let $302aa3d4345edb4f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $302aa3d4345edb4f$var$load("6KHMO").then(()=>parcelRequire('2jPbz'));

});

parcelRegister("al8ek", function(module, exports) {

let $78723fdd145e859d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $78723fdd145e859d$var$load("dWaZ0").then(()=>parcelRequire('lJWVr'));

});

parcelRegister("9NGnm", function(module, exports) {

let $72298f9a7b703a0b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $72298f9a7b703a0b$var$load("aPj2s").then(()=>parcelRequire('5R8Ny'));

});

parcelRegister("bSoQ5", function(module, exports) {

let $8a58015e818164f6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8a58015e818164f6$var$load("5wlgr").then(()=>parcelRequire('2qpS7'));

});

parcelRegister("ctMmL", function(module, exports) {

let $915db5f5efd2b18f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $915db5f5efd2b18f$var$load("5wgXZ").then(()=>parcelRequire('1RMGH'));

});

parcelRegister("WbN4W", function(module, exports) {

let $0aee9042b5b4d19a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0aee9042b5b4d19a$var$load("lVjUX").then(()=>parcelRequire('43YGL'));

});

parcelRegister("i53Wt", function(module, exports) {

let $d29bc071a86fbe17$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d29bc071a86fbe17$var$load("3DkIJ").then(()=>parcelRequire('5ua7I'));

});

parcelRegister("jVAma", function(module, exports) {

let $e81f8adaa7a7cf17$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e81f8adaa7a7cf17$var$load("8QCIL").then(()=>parcelRequire('7TpM2'));

});

parcelRegister("g3FIx", function(module, exports) {

let $bb0d495c026b94da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bb0d495c026b94da$var$load("cjPyA").then(()=>parcelRequire('gzYtx'));

});

parcelRegister("6YxxM", function(module, exports) {

let $51425dc20cfefab3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $51425dc20cfefab3$var$load("c0FMs").then(()=>parcelRequire('cX5zm'));

});

parcelRegister("a9gIA", function(module, exports) {

let $7637b68940012b83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7637b68940012b83$var$load("1rjER").then(()=>parcelRequire('bx4yP'));

});

parcelRegister("aT7Al", function(module, exports) {

let $7ed4ecb45ffd667f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7ed4ecb45ffd667f$var$load("jjqgH").then(()=>parcelRequire('43JzQ'));

});

parcelRegister("1ygEM", function(module, exports) {

let $1215e31a24d4ac12$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1215e31a24d4ac12$var$load("k1740").then(()=>parcelRequire('bnnuC'));

});

parcelRegister("fDU6I", function(module, exports) {

let $b63605481a894348$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b63605481a894348$var$load("82tlz").then(()=>parcelRequire('6daub'));

});

parcelRegister("4zIyE", function(module, exports) {

let $354cfe915450b1eb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $354cfe915450b1eb$var$load("h2l6C").then(()=>parcelRequire('iPlLr'));

});

parcelRegister("bSPHX", function(module, exports) {

let $8a6cd8ff839f33aa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8a6cd8ff839f33aa$var$load("klKxD").then(()=>parcelRequire('9U9uL'));

});

parcelRegister("fq6oe", function(module, exports) {

let $b39e3d99005ad403$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b39e3d99005ad403$var$load("5MxHU").then(()=>parcelRequire('ayPxh'));

});

parcelRegister("cUWGE", function(module, exports) {

let $96783d00ff62d375$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $96783d00ff62d375$var$load("jPath").then(()=>parcelRequire('8ZNcY'));

});

parcelRegister("9i56W", function(module, exports) {

let $6c39c2738d9bf9a6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6c39c2738d9bf9a6$var$load("ckzIH").then(()=>parcelRequire('ddOgh'));

});

parcelRegister("e4iVV", function(module, exports) {

let $a3e020276a6d689c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a3e020276a6d689c$var$load("8ZN0s").then(()=>parcelRequire('ezGM7'));

});

parcelRegister("l3kLa", function(module, exports) {

let $f539fb448ffc21f5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f539fb448ffc21f5$var$load("9fpGr").then(()=>parcelRequire('HLa04'));

});

parcelRegister("eG3Hu", function(module, exports) {

let $aaf7dbc3be3dbee0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aaf7dbc3be3dbee0$var$load("n3xnn").then(()=>parcelRequire('bJeNZ'));

});

parcelRegister("cokXW", function(module, exports) {

let $9057fd51e5e70fe2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9057fd51e5e70fe2$var$load("2jsRt").then(()=>parcelRequire('huub2'));

});

parcelRegister("4v2Kt", function(module, exports) {

let $346c307fa294a7b1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $346c307fa294a7b1$var$load("4JYZP").then(()=>parcelRequire('feYkj'));

});

parcelRegister("bZnWb", function(module, exports) {

let $8ba7f5b459d3adfa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8ba7f5b459d3adfa$var$load("cLqdU").then(()=>parcelRequire('5uIs5'));

});

parcelRegister("eEZee", function(module, exports) {

let $aac44bd5a3d91a05$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aac44bd5a3d91a05$var$load("avCUM").then(()=>parcelRequire('6jcw2'));

});

parcelRegister("6ade7", function(module, exports) {

let $47cdefd396907cf2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47cdefd396907cf2$var$load("doomh").then(()=>parcelRequire('f0syu'));

});

parcelRegister("dBnQj", function(module, exports) {

let $9e7139b98578c0ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9e7139b98578c0ec$var$load("gQSWJ").then(()=>parcelRequire('k1A8C'));

});

parcelRegister("2TPo8", function(module, exports) {

let $21c89478b89eee2f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21c89478b89eee2f$var$load("lnWRh").then(()=>parcelRequire('eowPm'));

});

parcelRegister("aLXfB", function(module, exports) {

let $7d7c411d47d7cf7d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d7c411d47d7cf7d$var$load("gOlh9").then(()=>parcelRequire('8fhBi'));

});

parcelRegister("7bAx3", function(module, exports) {

let $53b5e601f687d06e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $53b5e601f687d06e$var$load("daGTo").then(()=>parcelRequire('cT2BR'));

});

parcelRegister("g6eqe", function(module, exports) {

let $bb8864cde81d9387$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bb8864cde81d9387$var$load("2w2Fa").then(()=>parcelRequire('fhXcL'));

});

parcelRegister("7WiKX", function(module, exports) {

let $5c7c7fc9807edbab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5c7c7fc9807edbab$var$load("9DPul").then(()=>parcelRequire('9Fe9G'));

});

parcelRegister("lkHKL", function(module, exports) {

let $f87d67b1e6f5dcbf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f87d67b1e6f5dcbf$var$load("2nh75").then(()=>parcelRequire('kOV42'));

});

parcelRegister("8WE6A", function(module, exports) {

let $6832d99804c7ffa0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6832d99804c7ffa0$var$load("aQnhg").then(()=>parcelRequire('1zg3D'));

});

parcelRegister("a3GrC", function(module, exports) {

let $752b1bcd82617854$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $752b1bcd82617854$var$load("7diBI").then(()=>parcelRequire('1DwwI'));

});

parcelRegister("g3xEK", function(module, exports) {

let $bb07089627c9ede0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bb07089627c9ede0$var$load("cC8RD").then(()=>parcelRequire('aRQqo'));

});

parcelRegister("5r9xx", function(module, exports) {

let $3f56dfd2060ea081$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3f56dfd2060ea081$var$load("4aLlP").then(()=>parcelRequire('jJfRl'));

});

parcelRegister("fWz52", function(module, exports) {

let $b9b77bfb1f050391$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b9b77bfb1f050391$var$load("9G6yn").then(()=>parcelRequire('d7cx7'));

});

parcelRegister("flMWY", function(module, exports) {

let $b2cec9a7fd073703$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2cec9a7fd073703$var$load("kIKZl").then(()=>parcelRequire('5RMes'));

});

parcelRegister("hpBnv", function(module, exports) {

let $cad1c3fca5676041$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cad1c3fca5676041$var$load("c7DhJ").then(()=>parcelRequire('ak2ew'));

});

parcelRegister("iMp6B", function(module, exports) {

let $dac02f1fb12c9f3c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dac02f1fb12c9f3c$var$load("kBJjY").then(()=>parcelRequire('5TJ5b'));

});

parcelRegister("36wYk", function(module, exports) {

let $242b8230a144d0e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $242b8230a144d0e9$var$load("e8HfG").then(()=>parcelRequire('aIx48'));

});

parcelRegister("4CLVX", function(module, exports) {

let $35dfe4ae1d16f91b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $35dfe4ae1d16f91b$var$load("8SYzS").then(()=>parcelRequire('bpKQ0'));

});

parcelRegister("f4dBg", function(module, exports) {

let $af81c764c45f2aa5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af81c764c45f2aa5$var$load("gZUCP").then(()=>parcelRequire('hnVTp'));

});

parcelRegister("6voFP", function(module, exports) {

let $4bc8c6fe154e4528$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4bc8c6fe154e4528$var$load("icyPI").then(()=>parcelRequire('1d4Mb'));

});

parcelRegister("bI2rr", function(module, exports) {

let $8865b2a185ef3421$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8865b2a185ef3421$var$load("63hQz").then(()=>parcelRequire('6NyjW'));

});

parcelRegister("7zqtv", function(module, exports) {

let $583056a9fde79c59$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $583056a9fde79c59$var$load("3ooAX").then(()=>parcelRequire('3UCaN'));

});

parcelRegister("6LeCs", function(module, exports) {

let $4ec278f5314806cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4ec278f5314806cf$var$load("3Eu7W").then(()=>parcelRequire('6Dqb4'));

});

parcelRegister("1aijb", function(module, exports) {

let $0d94ed4d2737ccbe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0d94ed4d2737ccbe$var$load("aD89V").then(()=>parcelRequire('7PhkK'));

});

parcelRegister("50B9p", function(module, exports) {

let $3a59c5313256bbd7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a59c5313256bbd7$var$load("4lfDj").then(()=>parcelRequire('1Nklh'));

});

parcelRegister("8k8Tk", function(module, exports) {

let $60f7169d3841089d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $60f7169d3841089d$var$load("7fpGq").then(()=>parcelRequire('Dlgdv'));

});

parcelRegister("5iX3H", function(module, exports) {

let $3dcc7208466a8bac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3dcc7208466a8bac$var$load("dBjkU").then(()=>parcelRequire('ln6ck'));

});

parcelRegister("58zsy", function(module, exports) {

let $3bd934a1abc90bb3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3bd934a1abc90bb3$var$load("at9PL").then(()=>parcelRequire('aKJ2P'));

});

parcelRegister("2gPzN", function(module, exports) {

let $1a7515685569c353$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1a7515685569c353$var$load("fESSO").then(()=>parcelRequire('qgbsm'));

});

parcelRegister("e8liC", function(module, exports) {

let $a4a255a4c99fbbbb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a4a255a4c99fbbbb$var$load("9KwLZ").then(()=>parcelRequire('lkHRD'));

});

parcelRegister("c3ye6", function(module, exports) {

let $8c705081a6072468$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8c705081a6072468$var$load("93PzR").then(()=>parcelRequire('fVPpU'));

});

parcelRegister("fYu2I", function(module, exports) {

let $ba13c37b6a1fb148$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba13c37b6a1fb148$var$load("9jXWv").then(()=>parcelRequire('4z9XK'));

});

parcelRegister("YnYzy", function(module, exports) {

let $0b5833d732c9c00a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b5833d732c9c00a$var$load("jCH24").then(()=>parcelRequire('dm7sF'));

});

parcelRegister("jKmDI", function(module, exports) {

let $e603dfef2cb4f74b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e603dfef2cb4f74b$var$load("4GjQw").then(()=>parcelRequire('iCiYs'));

});

parcelRegister("cJhMj", function(module, exports) {

let $94477a5eccb2a432$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $94477a5eccb2a432$var$load("cLJTa").then(()=>parcelRequire('4EFIZ'));

});

parcelRegister("hQC4q", function(module, exports) {

let $cfe4d2fe915887c1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cfe4d2fe915887c1$var$load("7NttI").then(()=>parcelRequire('fgThH'));

});

parcelRegister("e2PWG", function(module, exports) {

let $a3998bdda9d19eaa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a3998bdda9d19eaa$var$load("1dMfP").then(()=>parcelRequire('3KXjR'));

});

parcelRegister("efbV0", function(module, exports) {

let $a5ebb627ae2dff83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5ebb627ae2dff83$var$load("9jfSP").then(()=>parcelRequire('bX0fK'));

});

parcelRegister("3FUpl", function(module, exports) {

let $2ad0f4d8dcf3917b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2ad0f4d8dcf3917b$var$load("eHVyt").then(()=>parcelRequire('gPkH3'));

});

parcelRegister("4udHW", function(module, exports) {

let $344498db3db288f3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $344498db3db288f3$var$load("aTu7U").then(()=>parcelRequire('kG2Cm'));

});

parcelRegister("3iuuL", function(module, exports) {

let $266ab54469eecb03$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $266ab54469eecb03$var$load("3JJHk").then(()=>parcelRequire('fvYtK'));

});

parcelRegister("erQrG", function(module, exports) {

let $a84c44e6ff09f2cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a84c44e6ff09f2cb$var$load("jYdYm").then(()=>parcelRequire('bmrnl'));

});

parcelRegister("lpsLT", function(module, exports) {

let $f96240303ccbec3d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f96240303ccbec3d$var$load("4hJCH").then(()=>parcelRequire('8JMZ0'));

});

parcelRegister("6aCL3", function(module, exports) {

let $47e1bdc19902c34f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47e1bdc19902c34f$var$load("hOVrV").then(()=>parcelRequire('1Ks4Q'));

});

parcelRegister("3kNFU", function(module, exports) {

let $26d9c5c380b4a3b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $26d9c5c380b4a3b6$var$load("gsg0E").then(()=>parcelRequire('byKJT'));

});

parcelRegister("2Db2S", function(module, exports) {

let $1ea7cab01296a9f1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1ea7cab01296a9f1$var$load("8TJKv").then(()=>parcelRequire('i6rUi'));

});

parcelRegister("2yLb2", function(module, exports) {

let $1dd35a215b7372ab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1dd35a215b7372ab$var$load("1aoDv").then(()=>parcelRequire('dOtw2'));

});

parcelRegister("4Z9Qn", function(module, exports) {

let $3a147eb56289c321$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a147eb56289c321$var$load("iRpFz").then(()=>parcelRequire('inR50'));

});

parcelRegister("15iS2", function(module, exports) {

let $0ca4e55d3a5a7889$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0ca4e55d3a5a7889$var$load("6Nh0d").then(()=>parcelRequire('41bOz'));

});

parcelRegister("lFUZx", function(module, exports) {

let $fc79a29f9fe83b9c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fc79a29f9fe83b9c$var$load("2JlZe").then(()=>parcelRequire('fEmHe'));

});

parcelRegister("8KqjS", function(module, exports) {

let $65e7092504ebf018$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $65e7092504ebf018$var$load("jwq7e").then(()=>parcelRequire('fKEXu'));

});

parcelRegister("7Or5u", function(module, exports) {

let $5b0236ed1efb7fed$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5b0236ed1efb7fed$var$load("7MPP6").then(()=>parcelRequire('8icpB'));

});

parcelRegister("4UsjY", function(module, exports) {

let $39325c5da68c0efd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $39325c5da68c0efd$var$load("95Qae").then(()=>parcelRequire('l4ZyA'));

});

parcelRegister("if6iT", function(module, exports) {

let $d47e847e46f9e2d8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d47e847e46f9e2d8$var$load("8IzJ3").then(()=>parcelRequire('5b9Z9'));

});

parcelRegister("gAgWa", function(module, exports) {

let $c12d258608b86475$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c12d258608b86475$var$load("aerDQ").then(()=>parcelRequire('glU04'));

});

parcelRegister("aV6ps", function(module, exports) {

let $7f3433178b341c11$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7f3433178b341c11$var$load("cAPnh").then(()=>parcelRequire('8j2ZH'));

});

parcelRegister("9AP6y", function(module, exports) {

let $6fbf1e2e528cf46f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6fbf1e2e528cf46f$var$load("eB7Uk"),
    $6fbf1e2e528cf46f$var$load("cAAbj")
]).then(()=>parcelRequire('h4Kkd'));

});

parcelRegister("3ihBx", function(module, exports) {

let $2660b5660653715f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2660b5660653715f$var$load("3oVYt").then(()=>parcelRequire('cDCCl'));

});

parcelRegister("4KQjl", function(module, exports) {

let $3764092ce6acfc1c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3764092ce6acfc1c$var$load("dx9iv").then(()=>parcelRequire('4NIhb'));

});

parcelRegister("egQsF", function(module, exports) {

let $a63b410dfd135583$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a63b410dfd135583$var$load("7JX0n").then(()=>parcelRequire('4AGyV'));

});

parcelRegister("2ruzy", function(module, exports) {

let $1c75d16caa02fd4c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1c75d16caa02fd4c$var$load("brZLs").then(()=>parcelRequire('31Ui6'));

});

parcelRegister("1Wu6x", function(module, exports) {

let $16a28f5d3c1b3f17$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $16a28f5d3c1b3f17$var$load("1HhHN").then(()=>parcelRequire('lS9G7'));

});

parcelRegister("dKZ4S", function(module, exports) {

let $a03ef2fb8a59f884$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a03ef2fb8a59f884$var$load("RA3Jm").then(()=>parcelRequire('i12BE'));

});

parcelRegister("f7eKx", function(module, exports) {

let $b012f36ccff38398$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b012f36ccff38398$var$load("89jKa").then(()=>parcelRequire('9HSvn'));

});

parcelRegister("bArSn", function(module, exports) {

let $86f8ae1a10a08cd2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $86f8ae1a10a08cd2$var$load("awJDd").then(()=>parcelRequire('fBY8v'));

});

parcelRegister("4p15b", function(module, exports) {

let $334a562f3cf8e1a3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $334a562f3cf8e1a3$var$load("bnitc").then(()=>parcelRequire('7sUdD'));

});

parcelRegister("gnI8L", function(module, exports) {

let $bed108ac3b1cc870$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bed108ac3b1cc870$var$load("eruLw").then(()=>parcelRequire('8IxMf'));

});

parcelRegister("3jgZY", function(module, exports) {

let $269054fe7d265358$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $269054fe7d265358$var$load("eB7Uk"),
    $269054fe7d265358$var$load("5yU7b")
]).then(()=>parcelRequire('fecYF'));

});

parcelRegister("6XCSm", function(module, exports) {

let $511668b4ab535380$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $511668b4ab535380$var$load("cAsoy").then(()=>parcelRequire('bWDfG'));

});

parcelRegister("axCs4", function(module, exports) {

let $7acad02caa2ce395$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7acad02caa2ce395$var$load("5lvho").then(()=>parcelRequire('h188A'));

});

parcelRegister("jiQoJ", function(module, exports) {

let $e0d857e47bf8e0f5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e0d857e47bf8e0f5$var$load("6pvRv").then(()=>parcelRequire('5042u'));

});

parcelRegister("35crK", function(module, exports) {

let $23eb7e5f6b0ab7d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $23eb7e5f6b0ab7d6$var$load("5oXE9").then(()=>parcelRequire('gTjFa'));

});

parcelRegister("1llhC", function(module, exports) {

let $0fa842fbb61453cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0fa842fbb61453cf$var$load("6ge9a").then(()=>parcelRequire('aBZC5'));

});

parcelRegister("inAmW", function(module, exports) {

let $d616961720a265e0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d616961720a265e0$var$load("2YtxS").then(()=>parcelRequire('buUDP'));

});

parcelRegister("7Bu96", function(module, exports) {

let $58935f73e2124b51$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $58935f73e2124b51$var$load("kcEOo").then(()=>parcelRequire('4ODVn'));

});

parcelRegister("aFPUK", function(module, exports) {

let $7c5600d04ad991aa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c5600d04ad991aa$var$load("42Txt").then(()=>parcelRequire('dGf3x'));

});

parcelRegister("h8TC5", function(module, exports) {

let $03387d344d3322e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $03387d344d3322e5$var$load("eQEen").then(()=>parcelRequire('8B7Mv'));

});

parcelRegister("gI4Aj", function(module, exports) {

let $c2a44fd530d29e85$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c2a44fd530d29e85$var$load("9aAXz").then(()=>parcelRequire('cSfLu'));

});

parcelRegister("8cvaV", function(module, exports) {

let $5f87a078c6f438f7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5f87a078c6f438f7$var$load("hDCAz").then(()=>parcelRequire('gmTTR'));

});

parcelRegister("rE76e", function(module, exports) {

let $0531a370269af5a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0531a370269af5a9$var$load("f6bts").then(()=>parcelRequire('2Jysk'));

});

parcelRegister("eLxw3", function(module, exports) {

let $abff740f86a667a6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $abff740f86a667a6$var$load("k05kV").then(()=>parcelRequire('hO1ce'));

});

parcelRegister("NtK10", function(module, exports) {

let $094ba5b257100d9d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $094ba5b257100d9d$var$load("gfTcy").then(()=>parcelRequire('dVfWe'));

});

parcelRegister("iDNea", function(module, exports) {

let $d9220e0f5882eec0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d9220e0f5882eec0$var$load("lbMTW").then(()=>parcelRequire('k1LfU'));

});

parcelRegister("aHxWB", function(module, exports) {

let $7ca84024b5fa93c6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7ca84024b5fa93c6$var$load("3NE3l").then(()=>parcelRequire('5bJFE'));

});

parcelRegister("eNmKk", function(module, exports) {

let $ac57493a65d6bc4e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ac57493a65d6bc4e$var$load("bibJh").then(()=>parcelRequire('1hn1F'));

});

parcelRegister("iIPUk", function(module, exports) {

let $da1499cf793fe72c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $da1499cf793fe72c$var$load("grG1M").then(()=>parcelRequire('a6h9M'));

});

parcelRegister("1utN2", function(module, exports) {

let $115fb36c6f6bedd6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $115fb36c6f6bedd6$var$load("d5w2d").then(()=>parcelRequire('bOUpD'));

});

parcelRegister("azjDQ", function(module, exports) {

let $7b1c68af11640718$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7b1c68af11640718$var$load("fZZ7S").then(()=>parcelRequire('7rLeu'));

});

parcelRegister("iYJOn", function(module, exports) {

let $dd115dcb5122ec86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dd115dcb5122ec86$var$load("ipU1p").then(()=>parcelRequire('iSy9M'));

});

parcelRegister("iyP5h", function(module, exports) {

let $d833073c8d2ff351$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d833073c8d2ff351$var$load("80ixL").then(()=>parcelRequire('j0spP'));

});

parcelRegister("hM3rd", function(module, exports) {

let $cf099617e4dc7b41$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cf099617e4dc7b41$var$load("4Np2T").then(()=>parcelRequire('8naep'));

});

parcelRegister("8YrnS", function(module, exports) {

let $68892b3d1a6ea906$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $68892b3d1a6ea906$var$load("1phY7").then(()=>parcelRequire('aNOf2'));

});

parcelRegister("loBYZ", function(module, exports) {

let $f9394d6c4dd2934e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f9394d6c4dd2934e$var$load("ceU3x").then(()=>parcelRequire('iyPh3'));

});

parcelRegister("7PgQ0", function(module, exports) {

let $5b2a5b74046e4262$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5b2a5b74046e4262$var$load("ddz4Z").then(()=>parcelRequire('7Zzmn'));

});

parcelRegister("hjJeG", function(module, exports) {

let $c9b74cecab2a7735$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c9b74cecab2a7735$var$load("5K06i"),
    $c9b74cecab2a7735$var$load("2KkrK")
]).then(()=>parcelRequire('bnpWc'));

});

parcelRegister("dBlHC", function(module, exports) {

let $9e6f90c015ef31a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9e6f90c015ef31a4$var$load("7jeqD").then(()=>parcelRequire('5MbuW'));

});

parcelRegister("77MmL", function(module, exports) {

let $52feb45d611afb30$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $52feb45d611afb30$var$load("5dDgy").then(()=>parcelRequire('6bEAi'));

});

parcelRegister("cJX52", function(module, exports) {

let $94678416bbdf324d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $94678416bbdf324d$var$load("lKaDG"),
    $94678416bbdf324d$var$load("aYGIV")
]).then(()=>parcelRequire('3puEE'));

});

parcelRegister("fvBna", function(module, exports) {

let $b4a6bdb6777b7f17$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b4a6bdb6777b7f17$var$load("etwBB").then(()=>parcelRequire('7x9yK'));

});

parcelRegister("cY3xj", function(module, exports) {

let $970dd4da7f85291c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $970dd4da7f85291c$var$load("7uY3Y").then(()=>parcelRequire('hhOn3'));

});

parcelRegister("2NAdC", function(module, exports) {

let $209c40a1ce901827$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $209c40a1ce901827$var$load("a2rZD").then(()=>parcelRequire('jH3CX'));

});

parcelRegister("lNtff", function(module, exports) {

let $fde4dc01e0d32b8b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fde4dc01e0d32b8b$var$load("9UmSD").then(()=>parcelRequire('9vAtn'));

});

parcelRegister("f4PGy", function(module, exports) {

let $af9f5263e4b308f4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af9f5263e4b308f4$var$load("ePm95").then(()=>parcelRequire('aPaXw'));

});

parcelRegister("19z4B", function(module, exports) {

let $0d71d68998c195ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0d71d68998c195ef$var$load("kJcWg").then(()=>parcelRequire('lLg7I'));

});

parcelRegister("8L0KX", function(module, exports) {

let $66034cbcbdbd12ff$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $66034cbcbdbd12ff$var$load("cUIjD").then(()=>parcelRequire('ltXJB'));

});

parcelRegister("1qIMR", function(module, exports) {

let $10aaf5f4c3f78f38$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $10aaf5f4c3f78f38$var$load("9OCf5").then(()=>parcelRequire('kcmYy'));

});

parcelRegister("3AtxT", function(module, exports) {

let $29cba70707b26538$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29cba70707b26538$var$load("4tIwu").then(()=>parcelRequire('jO8pH'));

});

parcelRegister("9rG5j", function(module, exports) {

let $6e0747ce14f4b29c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6e0747ce14f4b29c$var$load("1sEV4").then(()=>parcelRequire('kxiVw'));

});

parcelRegister("h78mi", function(module, exports) {

let $c75992fc26a2dce2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c75992fc26a2dce2$var$load("6Tafs").then(()=>parcelRequire('eWpan'));

});

parcelRegister("dGWBF", function(module, exports) {

let $9f7ca8a042475305$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9f7ca8a042475305$var$load("36ctu").then(()=>parcelRequire('kQ3RN'));

});

parcelRegister("bXQHP", function(module, exports) {

let $8b5e16b2a85862e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8b5e16b2a85862e8$var$load("l4q1r"),
    $8b5e16b2a85862e8$var$load("6j8nK")
]).then(()=>parcelRequire('dfteC'));

});

parcelRegister("i92HB", function(module, exports) {

let $d35b29e5d7131718$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d35b29e5d7131718$var$load("i1sL7").then(()=>parcelRequire('CggUl'));

});

parcelRegister("giJMN", function(module, exports) {

let $bde1d7ef011b80b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bde1d7ef011b80b8$var$load("380IO").then(()=>parcelRequire('hoxEe'));

});

parcelRegister("kfusf", function(module, exports) {

let $ebdcd5097caa46bd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ebdcd5097caa46bd$var$load("fyS0J").then(()=>parcelRequire('45NuA'));

});

parcelRegister("ahsrS", function(module, exports) {

let $77c18f35e7d2c7e7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $77c18f35e7d2c7e7$var$load("dPdkf").then(()=>parcelRequire('4behf'));

});

parcelRegister("bteXK", function(module, exports) {

let $859e026ed23e6745$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $859e026ed23e6745$var$load("bZWqy").then(()=>parcelRequire('jIcpb'));

});

parcelRegister("k6txg", function(module, exports) {

let $ea2b4758a035bb23$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ea2b4758a035bb23$var$load("jwtoD").then(()=>parcelRequire('15j5l'));

});

parcelRegister("cvzpb", function(module, exports) {

let $91b3d808303d3be9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $91b3d808303d3be9$var$load("awj6q").then(()=>parcelRequire('hCM3u'));

});

parcelRegister("kIQda", function(module, exports) {

let $f1606ad199685c53$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f1606ad199685c53$var$load("fNM8r").then(()=>parcelRequire('5aQLI'));

});

parcelRegister("8ygoT", function(module, exports) {

let $639e3883808a6bdb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $639e3883808a6bdb$var$load("aa9pX").then(()=>parcelRequire('jFo4x'));

});

parcelRegister("jdqQu", function(module, exports) {

let $dfd40e300dc002d0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dfd40e300dc002d0$var$load("gkdtJ").then(()=>parcelRequire('1ygpC'));

});

parcelRegister("fjYpf", function(module, exports) {

let $b2777cc7c53c53dd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2777cc7c53c53dd$var$load("3ZFtq").then(()=>parcelRequire('eNWU9'));

});

parcelRegister("j8dnF", function(module, exports) {

let $ded924d35fb11aab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ded924d35fb11aab$var$load("dpgfu").then(()=>parcelRequire('7Nofo'));

});

parcelRegister("lHHv8", function(module, exports) {

let $fccf5b8b822ae9b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fccf5b8b822ae9b9$var$load("1mqFt").then(()=>parcelRequire('hJjEH'));

});

parcelRegister("hzr76", function(module, exports) {

let $ccaabcb8b170f6e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ccaabcb8b170f6e9$var$load("bD36u").then(()=>parcelRequire('iBmSz'));

});

parcelRegister("4fcqT", function(module, exports) {

let $31723504474027ba$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $31723504474027ba$var$load("9J78C").then(()=>parcelRequire('94DZY'));

});

parcelRegister("hQXOL", function(module, exports) {

let $cff5b18fab70e4ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cff5b18fab70e4ca$var$load("jXE7i"),
    $cff5b18fab70e4ca$var$load("hCK89")
]).then(()=>parcelRequire('61dq6'));

});

parcelRegister("lk5Fc", function(module, exports) {

let $f85fdbe1ce6cd196$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f85fdbe1ce6cd196$var$load("21YhU").then(()=>parcelRequire('cMnm9'));

});

parcelRegister("cfzPK", function(module, exports) {

let $8eb2ae8e5489d87e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8eb2ae8e5489d87e$var$load("d9A3r").then(()=>parcelRequire('k2c1s'));

});

parcelRegister("7rPkg", function(module, exports) {

let $56c2de43cfb51d24$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $56c2de43cfb51d24$var$load("itvKG").then(()=>parcelRequire('8RrFV'));

});

parcelRegister("hU5Qa", function(module, exports) {

let $d08c32677d765f16$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d08c32677d765f16$var$load("afbg4").then(()=>parcelRequire('4ZJrP'));

});

parcelRegister("gl0Qr", function(module, exports) {

let $be4f434a6a076954$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $be4f434a6a076954$var$load("4YvOn").then(()=>parcelRequire('dCvxM'));

});

parcelRegister("af7Xv", function(module, exports) {

let $77517a8b9d767b05$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $77517a8b9d767b05$var$load("7ylp3"),
    $77517a8b9d767b05$var$load("kIPUL"),
    $77517a8b9d767b05$var$load("6dDCB")
]).then(()=>parcelRequire('37m2U'));

});

parcelRegister("brt1O", function(module, exports) {

let $8548bbbcc8b55a43$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8548bbbcc8b55a43$var$load("5l2C3").then(()=>parcelRequire('3Ba1h'));

});

parcelRegister("kUyYW", function(module, exports) {

let $f3942c4f683ac7dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f3942c4f683ac7dc$var$load("edP6u").then(()=>parcelRequire('djWMf'));

});

parcelRegister("5aKUo", function(module, exports) {

let $3c4245f9d000b2b0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c4245f9d000b2b0$var$load("4fw7s").then(()=>parcelRequire('2fH53'));

});

parcelRegister("16A0u", function(module, exports) {

let $0ce2482e63c45155$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0ce2482e63c45155$var$load("6tlHd").then(()=>parcelRequire('12opN'));

});

parcelRegister("lkfjj", function(module, exports) {

let $f867578d27fd36d7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f867578d27fd36d7$var$load("86Mbi").then(()=>parcelRequire('9HIUE'));

});

parcelRegister("8P4yv", function(module, exports) {

let $66c69ecd1be75ccd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $66c69ecd1be75ccd$var$load("eB7Uk"),
    $66c69ecd1be75ccd$var$load("jMcpk")
]).then(()=>parcelRequire('bYWX4'));

});

parcelRegister("iNdiW", function(module, exports) {

let $dae71f9b41c2efd0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dae71f9b41c2efd0$var$load("hcsg0").then(()=>parcelRequire('lmzTx'));

});

parcelRegister("69dVB", function(module, exports) {

let $0127b746d43c9539$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0127b746d43c9539$var$load("ktmsN").then(()=>parcelRequire('dHCVo'));

});

parcelRegister("LX7JB", function(module, exports) {

let $090240a5599e92b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $090240a5599e92b9$var$load("kkycx").then(()=>parcelRequire('6ul0c'));

});

parcelRegister("3vE7v", function(module, exports) {

let $28e3635af8b92a4d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $28e3635af8b92a4d$var$load("8HTC7").then(()=>parcelRequire('lYh3a'));

});

parcelRegister("jUQmM", function(module, exports) {

let $e7fbde309deee94b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e7fbde309deee94b$var$load("bxgNi"),
    $e7fbde309deee94b$var$load("4j2De")
]).then(()=>parcelRequire('fqv9g'));

});

parcelRegister("59pum", function(module, exports) {

let $3c01908c9ab58c8a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c01908c9ab58c8a$var$load("ho4wM").then(()=>parcelRequire('lzIWk'));

});

parcelRegister("a6XFF", function(module, exports) {

let $75c8c058cee094cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75c8c058cee094cb$var$load("aPnlt").then(()=>parcelRequire('28QRh'));

});

parcelRegister("99tIu", function(module, exports) {

let $6a9c01642882bddd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6a9c01642882bddd$var$load("lDcy8").then(()=>parcelRequire('2JrrX'));

});

parcelRegister("70mPY", function(module, exports) {

let $519a3f7b2cf76a69$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $519a3f7b2cf76a69$var$load("5K06i"),
    $519a3f7b2cf76a69$var$load("amAvE")
]).then(()=>parcelRequire('eiQQV'));

});

parcelRegister("gmmth", function(module, exports) {

let $be9021bb053b9296$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $be9021bb053b9296$var$load("7LJ3q").then(()=>parcelRequire('kNFe8'));

});

parcelRegister("jqPu5", function(module, exports) {

let $e25861bfcda38f76$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e25861bfcda38f76$var$load("aHbYg").then(()=>parcelRequire('6egTz'));

});

parcelRegister("8JAhC", function(module, exports) {

let $65beabc1b883c507$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $65beabc1b883c507$var$load("dkV2T").then(()=>parcelRequire('jgpZe'));

});

parcelRegister("dZmch", function(module, exports) {

let $a2f230bad6f30b9a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a2f230bad6f30b9a$var$load("dIuhJ").then(()=>parcelRequire('jzipv'));

});

parcelRegister("1iwJp", function(module, exports) {

let $0f20dca96c543ad3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0f20dca96c543ad3$var$load("9IgsX").then(()=>parcelRequire('AHo5e'));

});

parcelRegister("2p0ep", function(module, exports) {

let $1bfe18876726a401$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1bfe18876726a401$var$load("dUEf9").then(()=>parcelRequire('3Ry19'));

});

parcelRegister("22KZk", function(module, exports) {

let $17d0378b9eecb054$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $17d0378b9eecb054$var$load("i8IR3").then(()=>parcelRequire('kfDgS'));

});

parcelRegister("3rJTC", function(module, exports) {

let $28277eb1d34b3766$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $28277eb1d34b3766$var$load("bL008").then(()=>parcelRequire('l1U4U'));

});

parcelRegister("iYWy8", function(module, exports) {

let $dd1b3f518784cf75$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dd1b3f518784cf75$var$load("awBbb").then(()=>parcelRequire('cPPcH'));

});

parcelRegister("f80K8", function(module, exports) {

let $b0382df65a2580ed$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b0382df65a2580ed$var$load("9QvHa").then(()=>parcelRequire('bJViO'));

});

parcelRegister("4WqiO", function(module, exports) {

let $3990fb4b0f3d76ed$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3990fb4b0f3d76ed$var$load("lKaDG"),
    $3990fb4b0f3d76ed$var$load("aBPqh")
]).then(()=>parcelRequire('6Kkwl'));

});

parcelRegister("8E9Ge", function(module, exports) {

let $64b9916953f0c8e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $64b9916953f0c8e6$var$load("hWQdg").then(()=>parcelRequire('8YzrV'));

});

parcelRegister("betzx", function(module, exports) {

let $82d7f0f475242f56$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $82d7f0f475242f56$var$load("d9I6H").then(()=>parcelRequire('9mwm7'));

});

parcelRegister("fNcp7", function(module, exports) {

let $b7f50dd643d6d263$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b7f50dd643d6d263$var$load("9vSeI").then(()=>parcelRequire('GDUgu'));

});

parcelRegister("44nbm", function(module, exports) {

let $2f6984a8964620a3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2f6984a8964620a3$var$load("dgQWQ").then(()=>parcelRequire('bDl1z'));

});

parcelRegister("fpv3L", function(module, exports) {

let $b38148a53f937786$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b38148a53f937786$var$load("lSNP3").then(()=>parcelRequire('5EKtz'));

});

parcelRegister("8YX9t", function(module, exports) {

let $68a1cfa2964c5e96$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $68a1cfa2964c5e96$var$load("jlidQ").then(()=>parcelRequire('ei5Sx'));

});

parcelRegister("496tK", function(module, exports) {

let $304d0740ffe54e43$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $304d0740ffe54e43$var$load("e3Tty").then(()=>parcelRequire('f4aeC'));

});

parcelRegister("hHq4z", function(module, exports) {

let $ce2aad4bd1421964$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ce2aad4bd1421964$var$load("2dcZB").then(()=>parcelRequire('kn29b'));

});

parcelRegister("8sLkZ", function(module, exports) {

let $6295a882d0480c54$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6295a882d0480c54$var$load("ltkYf").then(()=>parcelRequire('2ao8s'));

});

parcelRegister("3IKtH", function(module, exports) {

let $2b5988bcd4f9b1c3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b5988bcd4f9b1c3$var$load("aiceI").then(()=>parcelRequire('01szy'));

});

parcelRegister("7QIoe", function(module, exports) {

let $5b6fd29e15c19434$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5b6fd29e15c19434$var$load("imB10").then(()=>parcelRequire('in7zw'));

});

parcelRegister("iatmb", function(module, exports) {

let $d39feecb38726479$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d39feecb38726479$var$load("8oWxD"),
    $d39feecb38726479$var$load("lPkt3")
]).then(()=>parcelRequire('krYSF'));

});

parcelRegister("b86dE", function(module, exports) {

let $81a544135f5b8313$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $81a544135f5b8313$var$load("O17sz").then(()=>parcelRequire('e2mYq'));

});

parcelRegister("fily5", function(module, exports) {

let $b2294098d4cf89a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b2294098d4cf89a4$var$load("eB7Uk"),
    $b2294098d4cf89a4$var$load("8Y1Y3")
]).then(()=>parcelRequire('gOItI'));

});

parcelRegister("ihSz2", function(module, exports) {

let $d50423d225a1cbcb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d50423d225a1cbcb$var$load("4cIR5").then(()=>parcelRequire('aOUdU'));

});

parcelRegister("9aBYD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ad281a7e2d796cd$var$_react = $6ad281a7e2d796cd$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");
function $6ad281a7e2d796cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ad281a7e2d796cd$var$MediaServicesNoImageIcon = (props)=>/*#__PURE__*/ $6ad281a7e2d796cd$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m19.41 3.041.72-.72a1.095 1.095 0 1 1 1.55 1.548L3.87 21.68a1.095 1.095 0 1 1-1.55-1.55l.72-.72a2 2 0 0 1-.04-.405V4.995C3 3.893 3.893 3 4.995 3h14.01q.209 0 .405.041M21 7.531v11.474A1.995 1.995 0 0 1 19.005 21H7.53l3-3H18v-2.7l-2.271-2.498zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$6ad281a7e2d796cd$var$MediaServicesNoImageIcon.displayName = 'MediaServicesNoImageIcon';
var $6ad281a7e2d796cd$var$_default = module.exports.default = $6ad281a7e2d796cd$var$MediaServicesNoImageIcon;

});

parcelRegister("b6fyt", function(module, exports) {

let $814c5222c2c7ccdd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $814c5222c2c7ccdd$var$load("eHInC").then(()=>parcelRequire('iEc3v'));

});

parcelRegister("1IzgK", function(module, exports) {

let $140542380c79c8ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $140542380c79c8ef$var$load("20N8v").then(()=>parcelRequire('aVpt4'));

});

parcelRegister("d4eIg", function(module, exports) {

let $98370fc5599e98c8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $98370fc5599e98c8$var$load("33hok").then(()=>parcelRequire('gcdUq'));

});

parcelRegister("k07KP", function(module, exports) {

let $e8f9d290dd00a4f4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e8f9d290dd00a4f4$var$load("dMQ95").then(()=>parcelRequire('1hOxD'));

});

parcelRegister("ahUPs", function(module, exports) {

let $77d792f2e841897d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $77d792f2e841897d$var$load("4biGc").then(()=>parcelRequire('99IS5'));

});

parcelRegister("4EOqR", function(module, exports) {

let $364204a4108b98ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $364204a4108b98ea$var$load("kfezh").then(()=>parcelRequire('er7lB'));

});

parcelRegister("i9ugx", function(module, exports) {

let $d3708b62d7fbe193$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d3708b62d7fbe193$var$load("8tSgw").then(()=>parcelRequire('i2GOL'));

});

parcelRegister("idhWn", function(module, exports) {

let $d4275b893a375f1a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d4275b893a375f1a$var$load("3BAxY").then(()=>parcelRequire('gyvV1'));

});

parcelRegister("1uRHH", function(module, exports) {

let $11724042437e667e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $11724042437e667e$var$load("34msg").then(()=>parcelRequire('nnywf'));

});

parcelRegister("3M40A", function(module, exports) {

let $2bf8f6c977f30e2d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2bf8f6c977f30e2d$var$load("fNx04").then(()=>parcelRequire('9o9gx'));

});

parcelRegister("iNq8h", function(module, exports) {

let $daf112fa2521e79d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $daf112fa2521e79d$var$load("kdgMq").then(()=>parcelRequire('h0iV6'));

});

parcelRegister("dYWbo", function(module, exports) {

let $a2de02dc6ad5f55a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a2de02dc6ad5f55a$var$load("dsbZs").then(()=>parcelRequire('4i9CF'));

});

parcelRegister("1czDT", function(module, exports) {

let $0e028f470f485f33$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0e028f470f485f33$var$load("81dS6").then(()=>parcelRequire('aheLq'));

});

parcelRegister("8YJKk", function(module, exports) {

let $68976998b8350241$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $68976998b8350241$var$load("4uhcp").then(()=>parcelRequire('jA3Z9'));

});

parcelRegister("bqmbd", function(module, exports) {

let $851353e725cfad64$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $851353e725cfad64$var$load("gFHfi").then(()=>parcelRequire('27bo9'));

});

parcelRegister("x61t6", function(module, exports) {

let $0637c12952a24d68$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0637c12952a24d68$var$load("jB6NT").then(()=>parcelRequire('7aMFL'));

});

parcelRegister("lRe88", function(module, exports) {

let $fe9982319830b956$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fe9982319830b956$var$load("hB5eh").then(()=>parcelRequire('kBnhd'));

});

parcelRegister("85yWV", function(module, exports) {

let $5e39e6995763e268$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e39e6995763e268$var$load("bJVPM").then(()=>parcelRequire('6ZEj6'));

});

parcelRegister("c4G0C", function(module, exports) {

let $8ca671d7499df15c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8ca671d7499df15c$var$load("lijQ3").then(()=>parcelRequire('jQfjq'));

});

parcelRegister("1bR0l", function(module, exports) {

let $0ddfef2391868240$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0ddfef2391868240$var$load("kUAIU").then(()=>parcelRequire('8j0Ak'));

});

parcelRegister("gpNqQ", function(module, exports) {

let $bf3553516175cef6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bf3553516175cef6$var$load("jYASR").then(()=>parcelRequire('alzqi'));

});

parcelRegister("CrpvX", function(module, exports) {

let $0738cfe214982581$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0738cfe214982581$var$load("7TRGL").then(()=>parcelRequire('jOLOx'));

});

parcelRegister("4Eyjd", function(module, exports) {

let $363582de1cf8334b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $363582de1cf8334b$var$load("kxlgv").then(()=>parcelRequire('4OQXl'));

});

parcelRegister("1FzTW", function(module, exports) {

let $13757804e9433025$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13757804e9433025$var$load("dRALU").then(()=>parcelRequire('3PK42'));

});

parcelRegister("gdD5P", function(module, exports) {

let $bcec2f4ff1c8cbdf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bcec2f4ff1c8cbdf$var$load("ekztv").then(()=>parcelRequire('eVv9d'));

});

parcelRegister("3RtEX", function(module, exports) {

let $2cfd541794cb65a3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2cfd541794cb65a3$var$load("9Si4N").then(()=>parcelRequire('h3njx'));

});

parcelRegister("8MIkL", function(module, exports) {

let $66553234c2b5b0b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $66553234c2b5b0b9$var$load("hYWtF").then(()=>parcelRequire('5JtnX'));

});

parcelRegister("2CkJR", function(module, exports) {

let $1e7f37ab36b0487c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1e7f37ab36b0487c$var$load("2KbAD").then(()=>parcelRequire('bfgbA'));

});

parcelRegister("5laGB", function(module, exports) {

let $3e3733f65e4c976f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3e3733f65e4c976f$var$load("esvqD").then(()=>parcelRequire('7Lcpq'));

});

parcelRegister("cN36Q", function(module, exports) {

let $94fc791d7e8792b1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $94fc791d7e8792b1$var$load("gR1Yg").then(()=>parcelRequire('ld96b'));

});

parcelRegister("382xi", function(module, exports) {

let $2474160d37c56dac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2474160d37c56dac$var$load("clrQb").then(()=>parcelRequire('9GCsh'));

});

parcelRegister("21y3U", function(module, exports) {

let $179618cc05aa22fb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $179618cc05aa22fb$var$load("bZO0a").then(()=>parcelRequire('duHPY'));

});

parcelRegister("1ISHG", function(module, exports) {

let $1414558550246257$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1414558550246257$var$load("1g8hM").then(()=>parcelRequire('2OqZy'));

});

parcelRegister("eqrmh", function(module, exports) {

let $a808b73604579e5e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a808b73604579e5e$var$load("hVJdX").then(()=>parcelRequire('lW5j9'));

});

parcelRegister("gEAFN", function(module, exports) {

let $c1fcd4440e171995$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c1fcd4440e171995$var$load("3sraF").then(()=>parcelRequire('bq6BP'));

});

parcelRegister("8FLov", function(module, exports) {

let $6506ea9393a7cf38$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6506ea9393a7cf38$var$load("esjMx").then(()=>parcelRequire('9dLgx'));

});

parcelRegister("j7LPy", function(module, exports) {

let $dec3c5eaf00a40b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dec3c5eaf00a40b6$var$load("eH7OB").then(()=>parcelRequire('74dfH'));

});

parcelRegister("feFIC", function(module, exports) {

let $b1788649fd753ae8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1788649fd753ae8$var$load("iabhK").then(()=>parcelRequire('jPIdX'));

});

parcelRegister("kK8YU", function(module, exports) {

let $f19f12109ee26f62$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f19f12109ee26f62$var$load("jle6Z"),
    $f19f12109ee26f62$var$load("gixIb")
]).then(()=>parcelRequire('6X2vu'));

});

parcelRegister("2GhhD", function(module, exports) {

let $1f3ce9292c06b96f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1f3ce9292c06b96f$var$load("fMfL2").then(()=>parcelRequire('6xEso'));

});

parcelRegister("kGbn4", function(module, exports) {

let $f0e08cf83f2141ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f0e08cf83f2141ca$var$load("aBLGF").then(()=>parcelRequire('eWJYw'));

});

parcelRegister("fdV0I", function(module, exports) {

let $b1544b00cb8a9078$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1544b00cb8a9078$var$load("a40p8").then(()=>parcelRequire('koTfG'));

});

parcelRegister("fGCAg", function(module, exports) {

let $b6b8b539ca2a7384$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b6b8b539ca2a7384$var$load("eWzXf").then(()=>parcelRequire('5sFnD'));

});

parcelRegister("366MN", function(module, exports) {

let $24173238f2cb9c81$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $24173238f2cb9c81$var$load("8LUW6").then(()=>parcelRequire('1uqxU'));

});

parcelRegister("hjs2V", function(module, exports) {

let $c9a9f76a9c9180e7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c9a9f76a9c9180e7$var$load("a6X4y").then(()=>parcelRequire('4JTpJ'));

});

parcelRegister("1gQeO", function(module, exports) {

let $0ecfce71ddc9f0a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0ecfce71ddc9f0a4$var$load("3zuUe").then(()=>parcelRequire('h0sHG'));

});

parcelRegister("1N7Kn", function(module, exports) {

let $14e0606d9242e372$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $14e0606d9242e372$var$load("aQp8v").then(()=>parcelRequire('eJPDm'));

});

parcelRegister("aOH1S", function(module, exports) {

let $7dfff39bd4349861$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7dfff39bd4349861$var$load("lvR1M").then(()=>parcelRequire('loik3'));

});

parcelRegister("lsP6p", function(module, exports) {

let $fa03da59a92e14af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fa03da59a92e14af$var$load("e65TP").then(()=>parcelRequire('RZ5dr'));

});

parcelRegister("4NdrY", function(module, exports) {

let $37d62beec663f0e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $37d62beec663f0e6$var$load("91C8u").then(()=>parcelRequire('1Ce5i'));

});

parcelRegister("casQF", function(module, exports) {

let $8dbccbe8f5358a89$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8dbccbe8f5358a89$var$load("hMDX9"),
    $8dbccbe8f5358a89$var$load("gGGz0")
]).then(()=>parcelRequire('fiSL0'));

});

parcelRegister("clSMY", function(module, exports) {

let $0252188cf9a8700e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0252188cf9a8700e$var$load("6fzNV").then(()=>parcelRequire('c5Qhh'));

});

parcelRegister("k3cNB", function(module, exports) {

let $e98e041390e90d6a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e98e041390e90d6a$var$load("4hwCy").then(()=>parcelRequire('gC1BV'));

});

parcelRegister("hZbsF", function(module, exports) {

let $d181062c203aa9a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d181062c203aa9a4$var$load("cDj36").then(()=>parcelRequire('21Xtm'));

});

parcelRegister("60GqC", function(module, exports) {

let $4603a790807c8bf5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4603a790807c8bf5$var$load("fR1sL").then(()=>parcelRequire('cegX4'));

});

parcelRegister("jNySf", function(module, exports) {

let $e69da53131814136$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e69da53131814136$var$load("8h7gn").then(()=>parcelRequire('5RvEg'));

});

parcelRegister("b6c2L", function(module, exports) {

let $814998df8c59156e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $814998df8c59156e$var$load("3xznI").then(()=>parcelRequire('5NBJG'));

});

parcelRegister("1sdDz", function(module, exports) {

let $10f2fc0d8dcc6f35$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $10f2fc0d8dcc6f35$var$load("g6X6x").then(()=>parcelRequire('eCzgA'));

});

parcelRegister("kJYoC", function(module, exports) {

let $f196dc05a4f43ad5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f196dc05a4f43ad5$var$load("c5krk").then(()=>parcelRequire('b0kd3'));

});

parcelRegister("4fck8", function(module, exports) {

let $31721f5da140c7c9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $31721f5da140c7c9$var$load("k9kY4").then(()=>parcelRequire('hycEC'));

});

parcelRegister("lhMt1", function(module, exports) {

let $f7f0c80c4173933f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7f0c80c4173933f$var$load("bkOZu").then(()=>parcelRequire('iRXVy'));

});

parcelRegister("ecI61", function(module, exports) {

let $a5746440ac80d94f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5746440ac80d94f$var$load("kvYmC").then(()=>parcelRequire('eszxl'));

});

parcelRegister("hxD3l", function(module, exports) {

let $cc53cfdc9ee7ee2a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cc53cfdc9ee7ee2a$var$load("5bLmk").then(()=>parcelRequire('dmAzn'));

});

parcelRegister("2XqOH", function(module, exports) {

let $2275e4b4cc375326$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2275e4b4cc375326$var$load("6FSEq").then(()=>parcelRequire('h09kj'));

});

parcelRegister("jzrnI", function(module, exports) {

let $e3f6869655baa379$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3f6869655baa379$var$load("erM4f").then(()=>parcelRequire('fEvxc'));

});

parcelRegister("8nvCP", function(module, exports) {

let $619900da050d0210$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $619900da050d0210$var$load("gekGO").then(()=>parcelRequire('aHroS'));

});

parcelRegister("cv50C", function(module, exports) {

let $919c43f2ba7bcfb3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $919c43f2ba7bcfb3$var$load("hsIlp").then(()=>parcelRequire('53aPg'));

});

parcelRegister("jtu9J", function(module, exports) {

let $e2d81e13f09bd133$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e2d81e13f09bd133$var$load("iMW3l").then(()=>parcelRequire('fXTeH'));

});

parcelRegister("8YXDD", function(module, exports) {

let $68a23041cee7bb25$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $68a23041cee7bb25$var$load("hl2oi").then(()=>parcelRequire('kLgX2'));

});

parcelRegister("itzNP", function(module, exports) {

let $d736b51d7d9bb926$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d736b51d7d9bb926$var$load("g7pmM").then(()=>parcelRequire('fe39K'));

});

parcelRegister("01r0n", function(module, exports) {

let $00450abc3a328862$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00450abc3a328862$var$load("1Jqoz").then(()=>parcelRequire('5u94T'));

});

parcelRegister("05bUX", function(module, exports) {

let $00f9b65cb50e2f85$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $00f9b65cb50e2f85$var$load("8oWxD"),
    $00f9b65cb50e2f85$var$load("gbDYP")
]).then(()=>parcelRequire('kYJU9'));

});

parcelRegister("ieF3h", function(module, exports) {

let $d46960da258a6aba$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d46960da258a6aba$var$load("d1W0Z").then(()=>parcelRequire('4CMZN'));

});

parcelRegister("cA4Qt", function(module, exports) {

let $928c9afd215906a5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $928c9afd215906a5$var$load("eWtnO").then(()=>parcelRequire('28sfx'));

});

parcelRegister("hHuV0", function(module, exports) {

let $ce2e6f900ab436a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ce2e6f900ab436a1$var$load("eZF0Q").then(()=>parcelRequire('8z6iG'));

});

parcelRegister("4M6PA", function(module, exports) {

let $37a0f1a39607e979$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $37a0f1a39607e979$var$load("7dXmm").then(()=>parcelRequire('bfvre'));

});

parcelRegister("czh6T", function(module, exports) {

let $926606a8cd173741$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $926606a8cd173741$var$load("hWdy3").then(()=>parcelRequire('a73CT'));

});

parcelRegister("hTBfz", function(module, exports) {

let $d07477d6931000c2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d07477d6931000c2$var$load("5K06i"),
    $d07477d6931000c2$var$load("dFNh6")
]).then(()=>parcelRequire('8g9bp'));

});

parcelRegister("h5M9M", function(module, exports) {

let $c7184236d72d7162$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c7184236d72d7162$var$load("56GYP").then(()=>parcelRequire('1J0Iy'));

});

parcelRegister("benCO", function(module, exports) {

let $82d353f5bad9f589$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $82d353f5bad9f589$var$load("dDCdM").then(()=>parcelRequire('3x0ud'));

});

parcelRegister("aYBE7", function(module, exports) {

let $7fdcb5b6e350d39d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7fdcb5b6e350d39d$var$load("9SQ85").then(()=>parcelRequire('hdhNx'));

});

parcelRegister("1BrLD", function(module, exports) {

let $12aec927a4438444$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $12aec927a4438444$var$load("1Xmqp").then(()=>parcelRequire('kLlX5'));

});

parcelRegister("k4uJB", function(module, exports) {

let $e9cc059ab21553e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e9cc059ab21553e9$var$load("HLeeR").then(()=>parcelRequire('im18V'));

});

parcelRegister("8wCoY", function(module, exports) {

let $634f19aebea3cf86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $634f19aebea3cf86$var$load("bQOCT").then(()=>parcelRequire('1V9Sw'));

});

parcelRegister("1WkPL", function(module, exports) {

let $169b5e6367d899e2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $169b5e6367d899e2$var$load("l4q1r"),
    $169b5e6367d899e2$var$load("h4u0O")
]).then(()=>parcelRequire('95zUF'));

});

parcelRegister("iqJax", function(module, exports) {

let $d6adb153a88aacea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d6adb153a88aacea$var$load("gRpzx").then(()=>parcelRequire('apyf6'));

});

parcelRegister("iud5O", function(module, exports) {

let $d7552f4328433d13$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d7552f4328433d13$var$load("SQnmN").then(()=>parcelRequire('7KUlu'));

});

parcelRegister("hpJdo", function(module, exports) {

let $cad7d83becc5765a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cad7d83becc5765a$var$load("wlKjJ").then(()=>parcelRequire('lAkuy'));

});

parcelRegister("jZvq5", function(module, exports) {

let $e8dc16248468b5e7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e8dc16248468b5e7$var$load("8yMmB").then(()=>parcelRequire('gfxP2'));

});

parcelRegister("a8skH", function(module, exports) {

let $7610a10c23eb2855$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7610a10c23eb2855$var$load("fvLpy").then(()=>parcelRequire('2azQc'));

});

parcelRegister("lYjTs", function(module, exports) {

let $ffeea20173262078$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ffeea20173262078$var$load("iiqDR").then(()=>parcelRequire('if0JX'));

});

parcelRegister("7lNmN", function(module, exports) {

let $55a0c9c6077596b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $55a0c9c6077596b3$var$load("dUKeO").then(()=>parcelRequire('aE3qX'));

});

parcelRegister("jQzL4", function(module, exports) {

let $e72e9c7f36d6a29d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e72e9c7f36d6a29d$var$load("i2kjI").then(()=>parcelRequire('cnE20'));

});

parcelRegister("1PwUL", function(module, exports) {

let $155415ffda1d9f84$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $155415ffda1d9f84$var$load("2lQzq").then(()=>parcelRequire('jSqTP'));

});

parcelRegister("gxyqD", function(module, exports) {

let $c0aa6f3c8916d53d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c0aa6f3c8916d53d$var$load("jPg5M"),
    $c0aa6f3c8916d53d$var$load("5rLJa")
]).then(()=>parcelRequire('hNHih'));

});

parcelRegister("lPrJf", function(module, exports) {

let $fe43dec1f1cffc9e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fe43dec1f1cffc9e$var$load("e53Dv").then(()=>parcelRequire('bFn0v'));

});

parcelRegister("at2ny", function(module, exports) {

let $79ee75348ff31ced$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $79ee75348ff31ced$var$load("jqU8W").then(()=>parcelRequire('ijw8O'));

});

parcelRegister("ijilz", function(module, exports) {

let $d5483bac26ede3e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d5483bac26ede3e8$var$load("dLaKS").then(()=>parcelRequire('cZ3Is'));

});

parcelRegister("hWhAv", function(module, exports) {

let $d0f57efed7eb1eb7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d0f57efed7eb1eb7$var$load("56PYd").then(()=>parcelRequire('8gVta'));

});

parcelRegister("5iX12", function(module, exports) {

let $3dcc6979731f6e07$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3dcc6979731f6e07$var$load("7ylp3"),
    $3dcc6979731f6e07$var$load("kIPUL"),
    $3dcc6979731f6e07$var$load("7YoSv")
]).then(()=>parcelRequire('3MgcY'));

});

parcelRegister("4y76w", function(module, exports) {

let $34ffd92924adabfe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $34ffd92924adabfe$var$load("diDkp").then(()=>parcelRequire('lbx4H'));

});

parcelRegister("hvS0Z", function(module, exports) {

let $cbff3b2bf3d5b735$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cbff3b2bf3d5b735$var$load("641zn").then(()=>parcelRequire('dHx1n'));

});

parcelRegister("kXZij", function(module, exports) {

let $f438dd24c7022fde$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f438dd24c7022fde$var$load("cyG00").then(()=>parcelRequire('8eWoD'));

});

parcelRegister("aRdQq", function(module, exports) {

let $7e7997e10b972eb1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7e7997e10b972eb1$var$load("gzPRe").then(()=>parcelRequire('g5Ogf'));

});

parcelRegister("gJDRl", function(module, exports) {

let $c2efc48a63d14a3c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c2efc48a63d14a3c$var$load("jaTPo").then(()=>parcelRequire('j6o0p'));

});

parcelRegister("9zZ12", function(module, exports) {

let $6f96b6630c118f16$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6f96b6630c118f16$var$load("jXE7i"),
    $6f96b6630c118f16$var$load("fJU8y")
]).then(()=>parcelRequire('5I6Jc'));

});

parcelRegister("eyQx7", function(module, exports) {

let $a99cfdab1ab13df1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a99cfdab1ab13df1$var$load("h2576").then(()=>parcelRequire('a6Kaz'));

});

parcelRegister("9IpRk", function(module, exports) {

let $712c4831dd127ff7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $712c4831dd127ff7$var$load("hG56j").then(()=>parcelRequire('emmAW'));

});





parcelRegister("4LgCj", function(module, exports) {

$parcel$export(module.exports, "createBridgeApi", () => $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6);

var $hvvoj = parcelRequire("hvvoj");
const $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6 = (bridge, args)=>{
    const { userConsentRequired: userConsentRequired } = args;
    return {
        refresh: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.refresh),
        submit: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.submit),
        close: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.close),
        onClose: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.onClose),
        openModal: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.openModal, {
            requiresUserConsent: userConsentRequired
        }),
        showFlag: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.showFlag),
        closeFlag: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.closeFlag),
        reconcile: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.reconcile),
        onError: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.onError),
        createHistory: ()=>(0, $hvvoj.createHistory)({
                history: bridge?.history,
                extensionBasePath: bridge?.extensionBasePath
            }),
        changeWindowTitle: $53fbfe482eb8d8a0$var$createBridgeMethod(bridge?.changeWindowTitle)
    };
};
const $53fbfe482eb8d8a0$var$createBridgeMethod = (method, ...args)=>{
    return async (payload)=>{
        if (method) return method(payload, ...args) ?? true;
        return false;
    };
};

});
parcelRegister("hvvoj", function(module, exports) {

$parcel$export(module.exports, "createHistory", () => $2a01424001f37a1e$export$4178d7ac16e6cf7c);

var $kxKUs = parcelRequire("kxKUs");
const $2a01424001f37a1e$export$21f63b78155c2049 = (extensionBasePath)=>{
    return {
        extensionRouteToFullPath: (extensionRoute)=>`${extensionBasePath}${extensionRoute ?? ''}`,
        fullPathToExtensionRoute: (fullLocation)=>{
            const extensionRoute = fullLocation.split(extensionBasePath).pop();
            return extensionRoute ? extensionRoute : '/';
        }
    };
};
const $2a01424001f37a1e$export$4178d7ac16e6cf7c = ({ history: history, extensionBasePath: extensionBasePath })=>{
    if (!history || !extensionBasePath) throw new (0, $kxKUs.BridgeClientError)('History API is not available within this module.');
    const { extensionRouteToFullPath: extensionRouteToFullPath, fullPathToExtensionRoute: fullPathToExtensionRoute } = $2a01424001f37a1e$export$21f63b78155c2049(extensionBasePath);
    const parseLocation = (location, parser)=>({
            ...location,
            pathname: parser(location.pathname)
        });
    const setNewHistoryLocation = (type, pathOrLocation, state)=>{
        const setHistory = type === 'push' ? history.push : history.replace;
        if (typeof pathOrLocation === 'string') return setHistory(extensionRouteToFullPath(pathOrLocation), state);
        return setHistory(parseLocation({
            state: state,
            ...pathOrLocation
        }, extensionRouteToFullPath));
    };
    return {
        ...history,
        location: parseLocation(history.location, fullPathToExtensionRoute),
        push (pathOrLocation, state) {
            setNewHistoryLocation('push', pathOrLocation, state);
        },
        replace (pathOrLocation, state) {
            setNewHistoryLocation('replace', pathOrLocation, state);
        },
        listen (listener) {
            const unlisten = history.listen((location, action)=>{
                listener(parseLocation(location, fullPathToExtensionRoute), action);
            });
            return unlisten;
        }
    };
};

});
parcelRegister("kxKUs", function(module, exports) {

$parcel$export(module.exports, "BridgeClientError", () => $2472ed5b4088eda9$export$d86296fe47e644cc);
$parcel$export(module.exports, "useBridge", () => $2472ed5b4088eda9$export$23a7a1286dcfa590);

var $gwFzn = parcelRequire("gwFzn");

var $eH9u1 = parcelRequire("eH9u1");

var $iBV33 = parcelRequire("iBV33");

var $inPa6 = parcelRequire("inPa6");

var $lzcvT = parcelRequire("lzcvT");

var $8z9j5 = parcelRequire("8z9j5");

var $dWSaf = parcelRequire("dWSaf");

var $4c2yb = parcelRequire("4c2yb");

var $luNHV = parcelRequire("luNHV");

var $7KMPr = parcelRequire("7KMPr");
var $kaOT1 = parcelRequire("kaOT1");

var $7TH2w = parcelRequire("7TH2w");

var $3Spjc = parcelRequire("3Spjc");

var $5U2YR = parcelRequire("5U2YR");

var $jIEsy = parcelRequire("jIEsy");

var $ijfiP = parcelRequire("ijfiP");

var $1JDPF = parcelRequire("1JDPF");

var $dh538 = parcelRequire("dh538");
let $2472ed5b4088eda9$var$createIframeBridge = null;

// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') $2472ed5b4088eda9$var$createIframeBridge = (parcelRequire("9icEp")).createIframeBridge;
const $2472ed5b4088eda9$var$mapCustomBridgeMethods = (customBridgeMethods)=>{
    if (!customBridgeMethods) return {};
    return Object.keys(customBridgeMethods).reduce((acc, key)=>{
        return {
            ...acc,
            [key]: (payload)=>{
                return customBridgeMethods[key](payload?.data);
            }
        };
    }, {});
};
class $2472ed5b4088eda9$export$d86296fe47e644cc extends Error {
    constructor(cause){
        super(cause);
    }
}
const $2472ed5b4088eda9$export$23a7a1286dcfa590 = ({ theme: theme, surfaceColor: surfaceColor, origin: origin, api: api, customBridgeMethods: customBridgeMethods, onLoad: onLoad, isResizable: isResizable, height: height, environment: environment, extension: extension, iframeRef: iframeRef, client: client, contextIds: contextIds })=>{
    const [loading, setLoading] = (0, $gwFzn.useState)(true);
    const [loadedAt, setLoadedAt] = (0, $gwFzn.useState)(null);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    // This ref avoids the api object ending up in the dep array
    // of the effect that calls createIframeBridge. It means that
    // people can pass anonymous functions as the api without the
    // bridge being re-created every render.
    const apiRef = (0, $gwFzn.useRef)(api);
    (0, $gwFzn.useEffect)(()=>{
        apiRef.current = api;
    }, [
        api
    ]);
    const enableThemingRef = (0, $gwFzn.useRef)();
    const setThemeRef = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        if (!setThemeRef.current) return;
        setThemeRef.current(theme, surfaceColor, environment);
    }, [
        theme,
        surfaceColor,
        loading,
        environment
    ]);
    // same as above, but for customBridgeMethods
    const customBridgeMethodsRef = (0, $gwFzn.useRef)(customBridgeMethods);
    (0, $gwFzn.useEffect)(()=>{
        customBridgeMethodsRef.current = customBridgeMethods;
    }, [
        customBridgeMethods
    ]);
    const [errorExtensionDetails, setErrorExtensionDetails] = (0, $gwFzn.useState)({
        id: extension.id,
        properties: extension.properties,
        type: extension.type,
        environmentType: extension.environmentType,
        appOwnerAccountId: extension.appOwner?.accountId
    });
    const tracing = (0, $kaOT1.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        const { type: type, environmentType: environmentType, properties: properties, appOwnerAccountId: appOwnerAccountId, id: id } = errorExtensionDetails;
        if (extension.id !== id || extension.type !== type || extension.environmentType !== environmentType || extension.appOwner?.accountId !== appOwnerAccountId || !(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(extension.properties, properties)) setErrorExtensionDetails({
            id: extension.id,
            properties: extension.properties,
            type: extension.type,
            environmentType: extension.environmentType,
            appOwnerAccountId: extension.appOwner?.accountId
        });
    }, [
        extension,
        errorExtensionDetails
    ]);
    const { id: id, installationId: installationId } = extension;
    // Need to retrieve appId here because extension.appId could be undefined in certain products. For example, Jira extensions do not provide the appId.
    const appId = extension.appId ?? (0, $ijfiP.parseExtensionId)(extension.id).appId;
    const getAppForgeUIExtensions = (0, $1JDPF.useGetAppForgeUIExtensions)({
        client: client,
        appId: appId,
        environmentId: extension.environmentId,
        contextIds: contextIds
    });
    (0, $gwFzn.useEffect)(()=>{
        //this should never happen on client side
        if (!$2472ed5b4088eda9$var$createIframeBridge) return;
        const iframeEl = iframeRef.current;
        if (iframeEl?.contentWindow && !loading && typeof loadedAt === 'number') {
            const eventCallbacks = [];
            const extensionDetails = {
                id: id.split('/').slice(0, 3).join('/'),
                installationId: installationId
            };
            const sendHandshakeMetric = (page)=>{
                return (success, error)=>{
                    if (success) createAnalyticsEvent({
                        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                        data: {
                            action: 'succeeded',
                            actionSubject: 'forge.ui.bridge',
                            attributes: {
                                target: 'handshake'
                            },
                            source: page,
                            tags: [
                                'forge'
                            ]
                        }
                    }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                    else {
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                            data: {
                                action: 'failed',
                                actionSubject: 'forge.ui.bridge',
                                attributes: {
                                    target: 'handshake'
                                },
                                source: page,
                                tags: [
                                    'forge'
                                ]
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
                        (0, $7KMPr.captureAndReportError)({
                            error: handshakeError,
                            environment: environment,
                            errorExtensionDetails: errorExtensionDetails,
                            page: page,
                            tracing: tracing
                        });
                    }
                };
            };
            const { open: open } = $2472ed5b4088eda9$var$createIframeBridge({
                theme: theme,
                surfaceColor: surfaceColor,
                withDomain: origin,
                withWindow: iframeEl.contentWindow,
                metadata: {
                    env: environment,
                    module: extension.type,
                    product: extension.type.split(':')[0],
                    isFedRamp: (0, $lzcvT.isFedRamp)()
                },
                features: (0, $dWSaf.withMetricsAndAnalytics)({
                    features: {
                        invoke: async ({ data: data })=>{
                            const { onInvoke: onInvoke, onThreeLO: onThreeLO } = apiRef.current;
                            const result = await onInvoke(data);
                            if (result.type === '3lo') return new Promise((resolve, reject)=>{
                                onThreeLO(result.authUrl, ()=>onInvoke(data).then((res)=>{
                                        if (res.type === 'ok') resolve(res.response);
                                        // Unexpected case where 3LO consent requested again after consenting
                                        reject();
                                    }, reject));
                            });
                            if (result.type === 'err') throw new Error(result.message);
                            return result.response;
                        },
                        navigate: async ({ data: data })=>{
                            if ('target' in data && data.target && getAppForgeUIExtensions && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                            (0, $dh538.fg)('forge-ui-navigation')) {
                                const url = await (0, $jIEsy.createNavigateTargetUrl)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!url) return;
                                return apiRef.current.onNavigate({
                                    type: data.type,
                                    url: url
                                });
                            }
                            return apiRef.current.onNavigate(data);
                        },
                        reconcile: async ({ data: data })=>{
                            return apiRef.current.reconcile(data);
                        },
                        onError: async ({ data: data })=>{
                            return apiRef.current.onError(data);
                        },
                        reload: async ()=>{
                            (0, $4c2yb.reload)();
                        },
                        refresh: async ()=>{
                            return apiRef.current.refresh();
                        },
                        submit: async (payload)=>{
                            return apiRef.current.submit(payload);
                        },
                        onClose: async (payload)=>{
                            return apiRef.current.onClose(payload);
                        },
                        close: async (payload)=>{
                            return apiRef.current.close(payload);
                        },
                        getContext: ()=>{
                            return apiRef.current.getContext();
                        },
                        openModal: async (payload)=>{
                            return apiRef.current.openModal(payload);
                        },
                        createHistory: async ()=>{
                            return apiRef.current.createHistory();
                        },
                        fetchProduct: async ({ data: data })=>{
                            return apiRef.current.fetchProduct(data);
                        },
                        showFlag: async ({ data: data })=>{
                            const flagActions = data.actions?.map((action)=>{
                                const { onClick: onClick } = action;
                                return {
                                    ...action,
                                    onClick: onClick ? ()=>onClick() : ()=>{}
                                };
                            });
                            return apiRef.current.showFlag({
                                ...data,
                                actions: flagActions
                            });
                        },
                        closeFlag: async ({ data: data })=>{
                            return apiRef.current.closeFlag(data);
                        },
                        on: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $luNHV.on)(event, callback, extensionDetails);
                            eventCallbacks.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacks.splice(eventCallbacks.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        emit: async (payload)=>{
                            return (0, $luNHV.emit)(payload.data.event, payload.data.payload, extensionDetails);
                        },
                        enableTheming: async ()=>{
                            await enableThemingRef.current?.();
                            const currentTheme = (0, $8z9j5.default)();
                            const surfaceColor = null;
                            setThemeRef.current?.(currentTheme, surfaceColor, environment);
                        },
                        changeWindowTitle: async ({ data: data })=>{
                            apiRef.current.changeWindowTitle(data);
                        },
                        getFrameId: async ()=>{
                            return apiRef.current.getFrameId();
                        },
                        subscribeClientEvent: async (payload)=>{
                            return (0, $dh538.fg)('forge-ui-enable-websocket-support') ? apiRef.current.subscribeClientEvent?.(payload) : undefined;
                        },
                        publishClientEvent: async (payload)=>{
                            return (0, $dh538.fg)('forge-ui-enable-websocket-support') ? apiRef.current.publishClientEvent?.(payload) : undefined;
                        },
                        ...$2472ed5b4088eda9$var$mapCustomBridgeMethods(customBridgeMethodsRef.current)
                    },
                    page: page,
                    environment: environment,
                    forgeEnvironment: extension.environmentType,
                    errorExtensionDetails: errorExtensionDetails,
                    createAnalyticsEvent: createAnalyticsEvent,
                    tracing: tracing
                }),
                sendHandshakeMetric: sendHandshakeMetric(page)
            });
            if (isResizable) (0, $iBV33.iframeResizer)({
                heightCalculationMethod: 'bodyScroll',
                widthCalculationMethod: 'bodyScroll',
                scrolling: true,
                // @ts-ignore minHeight can be a string
                minHeight: height,
                sizeWidth: extension.properties.layout === 'inline' && extension.type === 'xen:macro',
                // sizeWidth is enabled for resizing only for inline macros
                initCallback: (iframe)=>{
                    iframe?.iFrameResizer?.resize();
                }
            }, iframeEl);
            const { close: close, enableTheming: enableTheming, setTheme: setTheme } = open();
            setThemeRef.current = setTheme;
            enableThemingRef.current = enableTheming;
            return ()=>{
                close?.(); // close may be undefined here if createIframeBridge call fails
                for (const subscription of eventCallbacks)subscription.unsubscribe();
                iframeEl?.iFrameResizer && iframeEl?.iFrameResizer.removeListeners();
            };
        }
    }, [
        iframeRef,
        origin,
        loading,
        page,
        isResizable,
        height,
        environment,
        errorExtensionDetails,
        id,
        extension.properties.layout,
        extension.type,
        extension.environmentType,
        installationId,
        tracing,
        theme,
        surfaceColor,
        createAnalyticsEvent,
        loadedAt,
        getAppForgeUIExtensions
    ]);
    return {
        loading: loading,
        iframeProps: {
            ref: iframeRef,
            onLoad: ()=>{
                onLoad && onLoad();
                setLoading(false);
                setLoadedAt(Date.now());
            }
        }
    };
};

});
parcelRegister("dWSaf", function(module, exports) {

$parcel$export(module.exports, "withMetricsAndAnalytics", () => $053a3977db87c15f$export$68a362b9cb2811d7);

var $7TH2w = parcelRequire("7TH2w");

var $7KMPr = parcelRequire("7KMPr");

var $kxKUs = parcelRequire("kxKUs");

var $fSMLG = parcelRequire("fSMLG");

var $3Spjc = parcelRequire("3Spjc");

var $6oQb1 = parcelRequire("6oQb1");

var $dh538 = parcelRequire("dh538");
const $053a3977db87c15f$var$prepareBridgeEventAttributes = (bridgeMethod, payload, isSucceed)=>{
    if (bridgeMethod === 'submit' && isSucceed) {
        const payloadFields = Array.from(Object.entries(payload?.data ?? {})).filter(([, value])=>value).map(([key])=>key);
        return {
            payloadFields: payloadFields
        };
    }
    if ((0, $dh538.fg)('forge-ui-navigation')) {
        if (bridgeMethod === 'navigate') {
            const { target: target, url: url, type: type } = payload?.data ?? {};
            const navigationContext = {
                target: 'trusted',
                type: type
            };
            if (url && typeof url === 'string') try {
                if ([
                    'https:',
                    'http:'
                ].includes(new URL(url).protocol)) navigationContext.target = 'external';
            } catch (e) {}
            else if (target && typeof target === 'string') navigationContext.target = target;
            return navigationContext;
        }
    }
    return {};
};
const $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics = ({ feature: feature, createAnalyticsEvent: createAnalyticsEvent, page: page, bridgeMethod: bridgeMethod, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>async (payload)=>{
        try {
            tracing?.recordBridgeCall(`${bridgeMethod}() - start`);
            const result = await feature(payload);
            tracing?.recordBridgeCall(`${bridgeMethod}() - end`);
            if (bridgeMethod === 'on') createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'subscribed',
                    actionSubject: 'bridgeEvent',
                    attributes: {
                        // TODO: remove the condition (and related test) once Developer UGC spec is ready
                        event: payload.data.event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
                    },
                    source: page,
                    tags: [
                        'forge'
                    ]
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
            // this replaces the BRIDGE_REQUEST_RECEIVED metal client event
            (0, $6oQb1.trackBridgeSucceed)(createAnalyticsEvent, {
                source: page,
                method: bridgeMethod,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: $053a3977db87c15f$var$prepareBridgeEventAttributes(bridgeMethod, payload, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $kxKUs.BridgeClientError))) {
                if (!(0, $fSMLG.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    (0, $6oQb1.trackBridgeFailed)(createAnalyticsEvent, {
                        source: page,
                        errorName: error.name,
                        method: bridgeMethod,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: $053a3977db87c15f$var$prepareBridgeEventAttributes(bridgeMethod, payload, false)
                    });
                    (0, $7KMPr.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: errorExtensionDetails,
                        page: page,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
const $053a3977db87c15f$export$68a362b9cb2811d7 = ({ features: features, createAnalyticsEvent: createAnalyticsEvent, page: page, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>Object.entries(features).reduce((acc, [key, feature])=>({
            ...acc,
            [key]: $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics({
                feature: feature,
                createAnalyticsEvent: createAnalyticsEvent,
                page: page,
                bridgeMethod: key,
                environment: environment,
                forgeEnvironment: forgeEnvironment,
                errorExtensionDetails: errorExtensionDetails,
                tracing: tracing
            })
        }), {});

});
parcelRegister("7KMPr", function(module, exports) {

$parcel$export(module.exports, "captureAndReportError", () => $9de26c8889125530$export$faf06bc0661c564c);

var $lzcvT = parcelRequire("lzcvT");

var $ijfiP = parcelRequire("ijfiP");

var $kaOT1 = parcelRequire("kaOT1");
const $9de26c8889125530$var$packageVersion = "0.0.0-use.local";
const $9de26c8889125530$export$bb9823fd3fb51f9c = 'https://1210cfc4338849588134f2c80b99f75c@o55978.ingest.sentry.io/5988824';
const $9de26c8889125530$export$b7f7efe8cd791eed = 'https://a377d38318350e08236b26b7b13c8016@sentry.atlassian-us-gov-mod.com/23';

const $9de26c8889125530$export$faf06bc0661c564c = async ({ error: error, environment: environment, errorExtensionDetails: errorExtensionDetails, page: page, errorInfo: errorInfo, tracing: tracing })=>{
    try {
        const module = await (parcelRequire("jrilp"));
        const { BrowserClient: BrowserClient, Hub: Hub } = module;
        // From https://sentry.io/settings/atlassian-2y/projects/forge-ui/keys/ and https://sentry.prod.services.kitt-inf-us-gov-mod.net/settings/sentry/projects/forge-ui/keys
        const dsn = (0, $lzcvT.isFedRamp)() ? $9de26c8889125530$export$b7f7efe8cd791eed : $9de26c8889125530$export$bb9823fd3fb51f9c;
        const client = new BrowserClient({
            environment: environment,
            dsn: dsn,
            release: `forge-ui@${$9de26c8889125530$var$packageVersion}`
        });
        const hub = new Hub(client);
        hub.withScope(async (scope)=>{
            if (tracing) {
                const breadcrumbs = tracing.getBreadcrumbs();
                breadcrumbs.forEach((bc)=>scope.addBreadcrumb(bc, 20));
            }
            if (errorInfo) scope.setExtra('componentTrace', {
                errorInfo: errorInfo,
                componentStack: errorInfo?.componentStack?.substring(0, 1000)
            });
            scope.setTag('extensionPoint', page);
            if (errorExtensionDetails) {
                scope.setExtra('extensionProperties', errorExtensionDetails.properties);
                try {
                    const appIdFromId = (0, $ijfiP.parseExtensionId)(errorExtensionDetails.id ?? '').appId;
                    if (appIdFromId) scope.setTag('appId', appIdFromId);
                } catch (e) {
                // parseExtensionId() uses parse() form @atlassian/cs-ari, which throws an error if the ID is not valid
                }
                if (errorExtensionDetails.environmentType) scope.setTag('forgeEnvironment', errorExtensionDetails.environmentType);
                if (errorExtensionDetails.type) scope.setTag('extensionType', errorExtensionDetails.type);
                if (errorExtensionDetails.appOwnerAccountId) scope.setTag('appOwner', errorExtensionDetails.appOwnerAccountId);
            }
            hub.captureException(error);
        });
        return client.close();
    } catch (e) {
    // Error reporting failed, we don't want to cause a unhandledrejection event
    }
};

});
parcelRegister("jrilp", function(module, exports) {

let $e26ec4bc5ba22a81$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e26ec4bc5ba22a81$var$load("dUXgJ"),
    $e26ec4bc5ba22a81$var$load("8RcKV")
]).then(()=>parcelRequire('4JAbX'));

});


parcelRegister("fSMLG", function(module, exports) {

$parcel$export(module.exports, "blocklistedErrorMessagePatterns", () => $796443ed50933d56$export$5458688a52e32026);
const $796443ed50933d56$export$5458688a52e32026 = [
    // Error in user code
    /^There was an error invoking the function/,
    // User code returned non-JSON value, so XIS threw an InvalidInvocationPayloadError.
    /^Invalid response body, data must be JSON or undefined$/,
    // Networking errors
    /^Failed to fetch$/,
    /^Network error: Failed to fetch$/,
    /^Network error: Network failure: TypeError: Failed to fetch$/,
    /^NetworkError when attempting to fetch resource.$/,
    /^Network error: Received status 504$/,
    /^GraphQL error: The underlying service call timed out$/,
    // Unauthenticated requests made from public confluence content
    /^GraphQL error: Auth category: UNAUTHENTICATED is not allowed in service xen_invocation_service$/
];

});

parcelRegister("6oQb1", function(module, exports) {

$parcel$export(module.exports, "trackBridgeSucceed", () => $eccfed1aa8771b08$export$f4ca3aaa7a36404);
$parcel$export(module.exports, "trackBridgeFailed", () => $eccfed1aa8771b08$export$5c425ded9b0e7602);
$parcel$export(module.exports, "trackComponentUsageRendered", () => $eccfed1aa8771b08$export$d84d2f0ce1c82c0);
$parcel$export(module.exports, "trackRendererRendered", () => $eccfed1aa8771b08$export$7e97f0f47f75f097);
$parcel$export(module.exports, "useForgeUiAnalyticsEvent", () => $eccfed1aa8771b08$export$4b165c4db6e19dc5);

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $5U2YR = parcelRequire("5U2YR");

var $3Spjc = parcelRequire("3Spjc");

var $76I1K = parcelRequire("76I1K");

var $dh538 = parcelRequire("dh538");
const $eccfed1aa8771b08$var$fireEvent = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, source: source, attributes: attributes })=>createAnalyticsEvent({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes,
            source: source,
            tags: [
                'forge'
            ]
        }
    }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
const $eccfed1aa8771b08$export$f4ca3aaa7a36404 = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$fireEvent(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $eccfed1aa8771b08$export$5c425ded9b0e7602 = (createAnalyticsEvent, { source: source, errorName: errorName, method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$var$fireEvent(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            error: errorName,
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $eccfed1aa8771b08$export$d84d2f0ce1c82c0 = (createAnalyticsEvent, { source: source, isLegacyUiKit: isLegacyUiKit, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$var$fireEvent(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.analytics.component_usage',
        source: source,
        attributes: {
            appType: `UIKit${isLegacyUiKit ? '1' : ''}`,
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        }
    });
const $eccfed1aa8771b08$export$7e97f0f47f75f097 = (createAnalyticsEvent, { source: source, target: target })=>$eccfed1aa8771b08$var$fireEvent(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.renderer',
        source: source,
        attributes: {
            target: target
        }
    });
const $eccfed1aa8771b08$export$4e96f3067ed7def4 = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting })=>$eccfed1aa8771b08$var$fireEvent(createAnalyticsEvent, {
        action: 'loaded',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            renderType: renderType,
            extensionType: extensionType,
            isConfiguring: isConfiguring,
            isInserting: isInserting
        }
    });
const $eccfed1aa8771b08$export$45fdee56ce66a2e2 = (createAnalyticsEvent, { source: source, mountCount: mountCount })=>$eccfed1aa8771b08$var$fireEvent(createAnalyticsEvent, {
        action: 'remounted',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            mountCount: mountCount
        }
    });
const $eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers = ({ createAnalyticsEvent: createAnalyticsEvent, source: source })=>{
    return {
        trackComponentUsageRendered: ({ isLegacyUiKit: isLegacyUiKit, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$export$d84d2f0ce1c82c0(createAnalyticsEvent, {
                source: source,
                isLegacyUiKit: isLegacyUiKit,
                forgeEnvironment: forgeEnvironment,
                components: components,
                forgeReactMajorVersion: forgeReactMajorVersion
            }),
        trackRendererRendered: ({ target: target })=>$eccfed1aa8771b08$export$7e97f0f47f75f097(createAnalyticsEvent, {
                source: source,
                target: target
            }),
        trackExtensionLoaded: ({ forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting })=>$eccfed1aa8771b08$export$4e96f3067ed7def4(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                renderType: renderType,
                extensionType: extensionType,
                isConfiguring: isConfiguring,
                isInserting: isInserting
            }),
        trackExtensionRemounted: ({ mountCount: mountCount })=>$eccfed1aa8771b08$export$45fdee56ce66a2e2(createAnalyticsEvent, {
                source: source,
                mountCount: mountCount
            }),
        trackBridgeSucceed: ({ method: method, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$f4ca3aaa7a36404(createAnalyticsEvent, {
                source: source,
                method: method,
                forgeEnvironment: forgeEnvironment
            }),
        trackBridgeFailed: ({ method: method, errorName: errorName, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$5c425ded9b0e7602(createAnalyticsEvent, {
                source: source,
                errorName: errorName,
                method: method,
                forgeEnvironment: forgeEnvironment
            })
    };
};
const $eccfed1aa8771b08$export$4b165c4db6e19dc5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const cachedTrackers = (0, $76I1K.useMemoOne)(()=>$eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers({
            createAnalyticsEvent: createAnalyticsEvent,
            source: source
        }), [
        createAnalyticsEvent,
        source
    ]);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return (0, $dh538.fg)('forge-ui-macro-config-update-improvement') ? cachedTrackers : $eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers({
        createAnalyticsEvent: createAnalyticsEvent,
        source: source
    });
};

});


parcelRegister("4c2yb", function(module, exports) {

$parcel$export(module.exports, "reload", () => $3a24103e0164297d$export$32da5b5043dcd88c);
function $3a24103e0164297d$export$32da5b5043dcd88c() {
    window.location.reload();
}

});

parcelRegister("luNHV", function(module, exports) {

$parcel$export(module.exports, "on", () => $6d065658f7ab57e8$export$af631764ddc44097);
$parcel$export(module.exports, "emit", () => $6d065658f7ab57e8$export$8f35fbd5db0f3634);
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $6d065658f7ab57e8$var$EVENT_PREFIX = 'forge.bridge.';
function $6d065658f7ab57e8$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $6d065658f7ab57e8$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}

});

parcelRegister("jIEsy", function(module, exports) {

$parcel$export(module.exports, "createNavigateTargetUrl", () => $9d659de96bd747dc$export$a2022158d4c03066);

var $faCvF = parcelRequire("faCvF");

var $6usda = parcelRequire("6usda");

var $6wbTo = parcelRequire("6wbTo");

var $j4W8T = parcelRequire("j4W8T");
const $9d659de96bd747dc$var$extensionURLHelpers = {
    ...(0, $faCvF.confluenceExtensionURLHelpers),
    ...(0, $6wbTo.jiraExtensionURLHelpers)
};
const $9d659de96bd747dc$var$navigationTargetHandlers = {
    ...(0, $6wbTo.jiraNavigationTargetHandlers),
    ...(0, $faCvF.confluenceNavigationTargetURLHelpers),
    userProfile: async ({ accountId: accountId })=>(0, $j4W8T.ensureURLPath)(`/people/${accountId}`),
    module: async ({ moduleKey: moduleKey, ...params }, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        if (!moduleKey) throw (0, $6usda.NavigationError).MissingProperty('moduleKey');
        const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
        if (!module || !module.appId || !module.environmentId) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
        const moduleUrlHelper = $9d659de96bd747dc$var$extensionURLHelpers[module.type];
        if (!moduleUrlHelper) throw (0, $6usda.NavigationError).NotSupportedExtensionType(module.type);
        return moduleUrlHelper(module, params);
    }
};
const $9d659de96bd747dc$export$a2022158d4c03066 = async (targetInfo, utils)=>{
    const { target: target, ...payload } = targetInfo;
    const handler = $9d659de96bd747dc$var$navigationTargetHandlers[target];
    if (!handler) return null;
    try {
        return await handler(payload, utils);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message);
        return null;
    }
};

});
parcelRegister("faCvF", function(module, exports) {

$parcel$export(module.exports, "confluenceExtensionURLHelpers", () => $04ed449cb34fa9a4$export$68f051c1b56c060f);
$parcel$export(module.exports, "confluenceNavigationTargetURLHelpers", () => $04ed449cb34fa9a4$export$f91bdc214ca5389d);

var $1c598 = parcelRequire("1c598");

var $j4W8T = parcelRequire("j4W8T");

var $6usda = parcelRequire("6usda");
const $04ed449cb34fa9a4$var$makeConfluenceURLPath = (0, $j4W8T.createMakeProductURLPath)('/wiki');
const $04ed449cb34fa9a4$var$isCustomContentType = (contentType)=>contentType.startsWith('forge:');
const $04ed449cb34fa9a4$export$68f051c1b56c060f = {
    [(0, $1c598.ConfluenceExtension).GLOBAL_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId })=>{
        const { route: route } = properties;
        if (appId && environmentId && route) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).GLOBAL_SETTINGS]: ({ id: id })=>$04ed449cb34fa9a4$var$makeConfluenceURLPath('/admin/forge', {
            id: id
        }),
    [(0, $1c598.ConfluenceExtension).SPACE_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).SPACE_SETTINGS]: ({ properties: properties, appId: appId, environmentId: environmentId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (!spaceKey) throw (0, $6usda.NavigationError).MissingProperty('spaceKey');
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/settings/apps/${appId}/${environmentId}/${route}`);
        return null;
    }
};
const $04ed449cb34fa9a4$export$f91bdc214ca5389d = {
    contentView: async ({ contentId: contentId, version: version })=>{
        if (!contentId) throw (0, $6usda.NavigationError).MissingProperty('contentId');
        let resp = null;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { id: id, type: type, _links: { webui: webui } } = await resp.json();
        // if version is provided, we should use it, however, it only works for none-custom content type
        if (version && version >= 0) {
            if ($04ed449cb34fa9a4$var$isCustomContentType(type)) throw new Error('Version is not supported for custom content type');
            return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/pages/viewpage.action', {
                pageId: id,
                pageVersion: `${version}`
            });
        } else if (webui) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(webui);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    contentEdit: async ({ contentId: contentId })=>{
        let resp;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { _links: { edituiv2: edituiv2 } } = await resp.json();
        // content with custom content type doesn't have edit link
        if (edituiv2) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(edituiv2);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    spaceView: async ({ spaceKey: spaceKey })=>{
        return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}`);
    },
    contentList: async (params, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        const { contentType: contentType } = params;
        if (!contentType) throw (0, $6usda.NavigationError).MissingProperty('contentType');
        if (contentType === 'customContent' && params.moduleKey) {
            const { moduleKey: moduleKey } = params;
            const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
            if (!module) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
            const { appId: appId, environmentId: environmentId } = module;
            if (appId && environmentId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/search', {
                type: `forge:${appId}:${environmentId}:${moduleKey}`
            });
        } else if (contentType === 'page' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/pages`);
        else if (contentType === 'blogpost' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/blogs`);
        throw (0, $6usda.NavigationError).InvalidValueForProperty('contentType', contentType);
    }
};

});
parcelRegister("j4W8T", function(module, exports) {

$parcel$export(module.exports, "ensureURLPath", () => $ae891dc783a5dbcf$export$26e2379e0018d084);
$parcel$export(module.exports, "createMakeProductURLPath", () => $ae891dc783a5dbcf$export$ab31bc7dd6e328ce);
// Ensures that the path structured correctly and adds provided parameters to the path
const $ae891dc783a5dbcf$export$26e2379e0018d084 = (path, parameters)=>{
    let encodedPath = (path ?? '').split('/').map(encodeURIComponent).join('/');
    if (parameters && Object.keys(parameters).length > 0) encodedPath += '?' + new URLSearchParams(parameters).toString();
    return encodedPath;
};
const $ae891dc783a5dbcf$export$ab31bc7dd6e328ce = (productPathPrefix)=>(path, parameters)=>{
        return $ae891dc783a5dbcf$export$26e2379e0018d084(path ? productPathPrefix + path : productPathPrefix, parameters);
    };

});

parcelRegister("6usda", function(module, exports) {

$parcel$export(module.exports, "getModuleByKey", () => $9406182ad5621a53$export$c1f2bec49c0b084d);
$parcel$export(module.exports, "NavigationError", () => $9406182ad5621a53$export$c53ed1333d39ada3);
$parcel$export(module.exports, "ensurePropertyExists", () => $9406182ad5621a53$export$ae701e18d3b38cae);
const $9406182ad5621a53$export$c1f2bec49c0b084d = async (getAppForgeUIExtensions, moduleKey)=>{
    const { extensions: extensions } = await getAppForgeUIExtensions({
        expandAppOwner: false
    });
    const module = extensions?.find(({ key: key })=>key === moduleKey);
    return module?.type ? module : null;
};
const $9406182ad5621a53$export$c53ed1333d39ada3 = {
    ModuleNotFound: (moduleKey)=>{
        return new Error(`Navigation failed: Module with moduleKey ${moduleKey} was not found`);
    },
    MissingProperty: (property)=>{
        return new Error(`Navigation failed: ${property} not provided`);
    },
    FailedToFetchContentInfo: (contentId)=>{
        return new Error(`Navigation failed: Failed to fetch content information with id ${contentId}. Please check if the ID provided is correct`);
    },
    NotSupportedExtensionType: (moduleType)=>{
        return new Error(`Navigation failed: Module type ${moduleType} is not supported`);
    },
    InvalidValueForProperty: (property, value)=>{
        return new Error(`Navigation failed: ${value} is not a valid value for ${property}`);
    },
    LinkForContentNotFound: (contentId)=>{
        return new Error(`Navigation failed: Link for content with id ${contentId} was not found`);
    }
};
const $9406182ad5621a53$export$ae701e18d3b38cae = (propertyName, propertyValue)=>{
    if (propertyValue === undefined || propertyValue === null) throw $9406182ad5621a53$export$c53ed1333d39ada3.MissingProperty(propertyName);
    return propertyValue;
};

});


parcelRegister("6wbTo", function(module, exports) {

$parcel$export(module.exports, "jiraExtensionURLHelpers", () => $d3b8e1134d73790d$export$47842863b73e9046);
$parcel$export(module.exports, "jiraNavigationTargetHandlers", () => $d3b8e1134d73790d$export$ca7043166c283e6d);

var $1c598 = parcelRequire("1c598");

var $j4W8T = parcelRequire("j4W8T");

var $6usda = parcelRequire("6usda");
const $d3b8e1134d73790d$var$makeJiraURLPath = (0, $j4W8T.createMakeProductURLPath)('/jira');
const $d3b8e1134d73790d$export$47842863b73e9046 = {
    [(0, $1c598.JiraExtension).ADMIN_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).GLOBAL_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PERSONAL_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/personal/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${(0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_PAGE]: ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${(0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/apps/${appId}/${environmentId}`);
    }
};
const $d3b8e1134d73790d$export$ca7043166c283e6d = {
    dashboard: async ({ dashboardId: dashboardId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/dashboards/${(0, $6usda.ensurePropertyExists)('dashboardId', dashboardId)}`);
    },
    issue: async ({ issueKey: issueKey })=>{
        return `/browse/${(0, $6usda.ensurePropertyExists)('issueKey', issueKey)}`;
    },
    // equivalent to Connects projectAdminSummary target
    projectSettingsDetails: async ({ projectKey: projectKey })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${(0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase()}/settings/details`);
    }
};

});


parcelRegister("1JDPF", function(module, exports) {

$parcel$export(module.exports, "useGetAppForgeUIExtensions", () => $a32dcdb2dcf56aee$export$10dcd63d9a8843c4);

var $gwFzn = parcelRequire("gwFzn");

var $fYGGr = parcelRequire("fYGGr");

var $grQpA = parcelRequire("grQpA");

var $atveb = parcelRequire("atveb");

var $dh538 = parcelRequire("dh538");
const $a32dcdb2dcf56aee$var$useCustomCompareMemo = (factory, dependency, isEqual)=>{
    const dependencyRef = (0, $gwFzn.useRef)(dependency);
    const valueRef = (0, $gwFzn.useRef)(factory());
    if (!isEqual(dependency, dependencyRef.current)) {
        dependencyRef.current = dependency;
        valueRef.current = factory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $gwFzn.useMemo)(()=>valueRef.current, [
        dependencyRef.current
    ]);
};
const $a32dcdb2dcf56aee$var$isSameDeps = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const [clientA, appIdA, environmentIdA, contextIdsA] = a;
    const [clientB, appIdB, environmentIdB, contextIdsB] = b;
    return clientA === clientB && appIdA === appIdB && environmentIdA === environmentIdB && (0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(contextIdsA.sort(), contextIdsB.sort());
};
const $a32dcdb2dcf56aee$export$eafa2a08bf8a8e04 = ({ client: client, appId: appId, environmentId: environmentId, contextIds: contextIds })=>{
    return $a32dcdb2dcf56aee$var$useCustomCompareMemo(()=>{
        return async (params)=>{
            return await (0, $fYGGr.getForgeUIExtensionsAsync)({
                client: client,
                contextIds: contextIds,
                extensionsFilter: [
                    {
                        type: (0, $grQpA.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                        value: `${appId}:${environmentId}`
                    }
                ],
                ...params
            });
        };
    }, [
        client,
        appId,
        environmentId,
        contextIds
    ], $a32dcdb2dcf56aee$var$isSameDeps);
};
const $a32dcdb2dcf56aee$export$10dcd63d9a8843c4 = (params)=>{
    const getAppForgeUIExtensions = $a32dcdb2dcf56aee$export$eafa2a08bf8a8e04(params);
    return (0, $dh538.fg)('forge-ui-navigation') ? getAppForgeUIExtensions : null;
};

});
parcelRegister("fYGGr", function(module, exports) {

$parcel$export(module.exports, "getForgeUIExtensionsAsync", () => $cf16612a3c00cd2e$export$f276dc1a7d0b17c5);

var $bsX2q = parcelRequire("bsX2q");
const $cf16612a3c00cd2e$export$f276dc1a7d0b17c5 = async ({ client: client, contextIds: contextIds, moduleType: moduleType, queryOptions: queryOptions, expandAppOwner: expandAppOwner, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = (0, $bsX2q.createExtensionListQueryOptions)(client, contextIds, queryOptions, expandAppOwner, extensionsFilter, moduleType, dataClassificationTagIds, locale);
    const queryResult = await client.query(requestOptions);
    return {
        extensions: (0, $bsX2q.getExtensionsFromGQLResult)(queryResult),
        errors: queryResult.errors
    };
};

});





parcelRegister("9XihO", function(module, exports) {

$parcel$export(module.exports, "isBinaryContentType", () => $d04645d643f36821$export$da8d8c42bfb20907);
$parcel$export(module.exports, "useProductFetchClient", () => $d04645d643f36821$export$2f041121bdb61a5);

var $1KmJq = parcelRequire("1KmJq");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $lzcvT = parcelRequire("lzcvT");

var $kaOT1 = parcelRequire("kaOT1");

var $JsJ4Y = parcelRequire("JsJ4Y");
var $1Igmn = parcelRequire("1Igmn");
var $b7qxC = parcelRequire("b7qxC");

var $dh538 = parcelRequire("dh538");

var $fRK8K = parcelRequire("fRK8K");
const $d04645d643f36821$export$ed8186c9e5e5ba23 = (0, $d2LG0.default)`mutation forge_ui_userAuthTokenForExtension($input:UserAuthTokenForExtensionInput!){userAuthTokenForExtension(input:$input){success errors{message}authToken{token ttl}}}`;
const $d04645d643f36821$var$validProducts = [
    'confluence',
    'jira',
    'bitbucket'
];
const $d04645d643f36821$var$apiGatewayUrlMap = {
    dev: 'api.stg.atlassian.com',
    stg: 'api.stg.atlassian.com',
    prod: 'api.atlassian.com'
};
const $d04645d643f36821$var$getApiGatewayUrl = (environment)=>{
    const apiBase = $d04645d643f36821$var$apiGatewayUrlMap[environment];
    const url = (0, $lzcvT.isFedRamp)() ? apiBase.replace('atlassian.com', 'atlassian-us-gov-mod.com') : apiBase;
    if (!url) throw new Error(`Invalid environment: ${environment}`);
    return url;
};
function $d04645d643f36821$var$getBaseUrl(environment, product, cloudId) {
    if (product === 'bitbucket') return environment === 'prod' ? 'https://api.bitbucket.org' : 'https://api.integration.bb-inf.net';
    const apiBase = $d04645d643f36821$var$getApiGatewayUrl(environment);
    return `https://${apiBase}/ex/${product}/${cloudId}`;
}
function $d04645d643f36821$var$createProductUrl(environment, product, restPath, cloudId) {
    const baseUrl = $d04645d643f36821$var$getBaseUrl(environment, product, cloudId);
    const fullUrl = // bitbucket requests could be made with absolute URLs
    // e.g. when following href links in API responses
    product === 'bitbucket' && restPath.startsWith(`${baseUrl}/`) ? restPath : `${baseUrl}${restPath}`;
    const productUrl = new URL(fullUrl).toString();
    if (!productUrl.startsWith(`${baseUrl}/`)) throw new Error('Invalid product URL');
    return productUrl;
}
function $d04645d643f36821$var$isTokenValid(token) {
    return !!(token && token.expiry > Date.now());
}
function $d04645d643f36821$var$isProduct(product) {
    return $d04645d643f36821$var$validProducts.includes(product);
}
function $d04645d643f36821$export$da8d8c42bfb20907(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
function $d04645d643f36821$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key === 'file') {
        const fileName = formLike['__fileName'];
        const mimeType = formLike['__fileType'];
        // convert back from base64 to File (Blob)
        const blob = (0, $JsJ4Y.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append('file', file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
const $d04645d643f36821$var$MILLIS_IN_SECOND = 1000;
const $d04645d643f36821$export$8ec4f55608742960 = async (url, init)=>{
    const response = await fetch(url, init);
    const isAttachment = $d04645d643f36821$export$da8d8c42bfb20907(response.headers.get('content-type'));
    if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
        const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
        return new Response(b64Content, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    return response;
};
function $d04645d643f36821$export$2f041121bdb61a5({ appId: appId, extensionId: extensionId, accountType: accountType, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, options: options, contextIds: contextIds = [] }) {
    const [mutationFunction] = (0, $1KmJq.useMutation)($d04645d643f36821$export$ed8186c9e5e5ba23, options);
    const authTokenRef = (0, $gwFzn.useRef)(undefined);
    const tracing = (0, $kaOT1.useTracingContext)();
    /**
   * Workspace based products like Trello and Bitbucket will not pass in cloudId,
   * they will pass in workspaceId instead.
   */ if (!cloudId && !workspaceId) return async ()=>{
        throw new Error('Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.');
    };
    const headers = {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) headers['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join());
    const fetchOAuthToken = async (extensionId, contextIds)=>{
        tracing?.recordGqlCall('userAuthTokenForExtension - start');
        const { data: data } = await mutationFunction({
            variables: {
                input: {
                    extensionId: extensionId,
                    contextIds: contextIds
                }
            },
            context: {
                headers: headers
            }
        });
        if (data?.userAuthTokenForExtension) {
            const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
            tracing?.recordGqlCall('userAuthTokenForExtension - end');
            if (!success && errors && errors[0].message.includes('No Atlassian OAuth token found for this user and extension')) return new Promise((resolve)=>{
                renderThreeLOPrompt(async ()=>{
                    const token = await fetchOAuthToken(extensionId, contextIds);
                    resolve(token);
                });
            });
            if (success && authToken) {
                const { token: token, ttl: ttl } = authToken;
                return {
                    token: token,
                    expiry: Date.now() + ttl * $d04645d643f36821$var$MILLIS_IN_SECOND
                };
            }
        }
        throw new Error('An unexpected error occurred when fetching an auth token');
    };
    const cdnEnvironment = (0, $b7qxC.getCDNEnvironment)(environment);
    return async (restPath, product, init, isMultipartFormData)=>{
        if (!$d04645d643f36821$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
        const atlassianAccount = !accountType || accountType === 'atlassian';
        if (!$d04645d643f36821$var$isTokenValid(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${authTokenRef?.current?.token}`);
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $dh538.fg)('forge-ui-add-x-ecosystem-user-agent-header')) {
            // this header is used to identify requests made by Forge, based on:
            // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
            const appAri = (0, $fRK8K.createAppAri)({
                appId: appId
            }).toString();
            headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        }
        const body = isMultipartFormData ? $d04645d643f36821$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        return $d04645d643f36821$export$8ec4f55608742960($d04645d643f36821$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
            ...init,
            body: body,
            headers: headers
        });
    };
}

});
parcelRegister("JsJ4Y", function(module, exports) {

$parcel$export(module.exports, "base64ToBlob", () => $d09011ff2196b597$export$b3fb17ae4345ac8f);
$parcel$export(module.exports, "blobToBase64", () => $d09011ff2196b597$export$47a328b4cabd57cc);
const $d09011ff2196b597$export$b3fb17ae4345ac8f = (b64string, mimeType)=>{
    const base64Data = b64string.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for(let i = 0; i < byteCharacters.length; i++)byteNumbers[i] = byteCharacters.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([
        byteArray
    ], {
        type: mimeType
    });
};
const $d09011ff2196b597$export$47a328b4cabd57cc = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

});


parcelRegister("kZjf5", function(module, exports) {

$parcel$export(module.exports, "useNavigation", () => $c92260a0208e3eb8$export$d0fd4b7106de2769);
/* useNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $inPa6 = parcelRequire("inPa6");

var $7TH2w = parcelRequire("7TH2w");

var $eEA8O = parcelRequire("eEA8O");

var $5dK2X = parcelRequire("5dK2X");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");
var $6xdDU = parcelRequire("6xdDU");

var $3Spjc = parcelRequire("3Spjc");

var $kxKUs = parcelRequire("kxKUs");

var $i5CVI = parcelRequire("i5CVI");

var $2kGKp = parcelRequire("2kGKp");

var $lMJg3 = parcelRequire("lMJg3");

var $kTcrU = parcelRequire("kTcrU");

var $dh538 = parcelRequire("dh538");
const $c92260a0208e3eb8$var$cssActionItem = null;
function $c92260a0208e3eb8$export$d0fd4b7106de2769({ extension: extension, push: push }) {
    const [modalState, setModalState] = (0, $gwFzn.useState)({
        state: 'closed'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const egressService = (0, $lMJg3.useEgressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    return {
        onNavigate: async ({ type: type, url: urlString })=>{
            const url = (0, $kTcrU.makeUrl)(urlString);
            const linkType = $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService);
            if (linkType === 'invalid' || !url) throw new (0, $kxKUs.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === 'trusted') {
                (0, $i5CVI.navigate)(url.href, type, push);
                return;
            }
            const analyticsAttributes = $c92260a0208e3eb8$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.UI_EVENT_TYPE),
                    data: {
                        action: 'viewed',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: 'open',
                    url: url,
                    onConfirm: ()=>{
                        (0, $i5CVI.navigate)(url.href, type, push); // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'approved',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'cancelled',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $kxKUs.BridgeClientError)('cancelled'));
                    }
                });
            });
        },
        getModalJsx: ()=>{
            if (modalState.state === 'closed') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {});
            const ModalFooter = ()=>{
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8o1lj.default), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- to avoid import of css module from @compiled/react
                    , {
                        className: (0, $35pXk.default)([
                            "_1e0c1txw _1bah1yb4 _1bsb1osq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                                href: "https://go.atlassian.com/forge-help-app-security",
                                appearance: "subtle-link",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: (0, $35pXk.default)([
                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf"
                                ]),
                                children: "Learn more about app security"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsxs)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            , {
                                className: (0, $35pXk.default)([
                                    "_1e0c116y _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                        className: (0, $35pXk.default)([
                                            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                                            appearance: "subtle",
                                            onClick: ()=>{
                                                setModalState({
                                                    state: 'closed'
                                                });
                                                modalState.onCancel();
                                            },
                                            children: "Cancel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                        className: (0, $35pXk.default)([
                                            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                                            appearance: "warning",
                                            onClick: ()=>{
                                                modalState.onConfirm();
                                                setModalState({
                                                    state: 'closed'
                                                });
                                            },
                                            children: "Continue"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            };
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
                    onClose: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        modalState.onCancel();
                    },
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                                appearance: "warning",
                                children: `Opening external page on ${modalState.url.hostname}`
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1DHa6.default), {
                            children: [
                                extension.properties?.title ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5dK2X.default), {
                                    as: "p",
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                            as: "strong",
                                            children: extension.properties.title
                                        }),
                                        " is sending you to an external page. Ensure you trust that page before you continue."
                                    ]
                                }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5dK2X.default), {
                                    as: "p",
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                            as: "strong",
                                            children: "This app"
                                        }),
                                        " is sending you to an external page. Ensure you trust that page before you continue."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                    as: "p",
                                    maxLines: 1,
                                    children: modalState.url.href
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)(ModalFooter, {})
                    ]
                })
            });
        }
    };
}
const $c92260a0208e3eb8$var$getRootDomain = (url)=>{
    const hostnameParts = url.hostname.split('.'); // Root domain consists of the last two parts of the hostname
    if (hostnameParts.length > 1) return hostnameParts.slice(-2).join('.');
    else // If there's only one part, return it (e.g., 'localhost')
    return url.hostname;
}; // domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $c92260a0208e3eb8$var$TRUSTED_ROOT_DOMAINS = [
    'atl-paas.net',
    'atlassian.com',
    'atlassian.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net'
]; // Exported for testing only
function $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService) {
    if (!url) return 'invalid';
    if (url.protocol === 'mailto:') return 'trusted';
    if (url.protocol === 'tel:' && (0, $dh538.fg)('forge_ui_allow_tel_links')) return 'trusted';
    try {
        // URL is listed under permissions in manifest
        if (egressService.isValidUrl(url.href)) return 'trusted';
         // URL is from same origin
        if (url.origin === (0, $2kGKp.getOrigin)()) return 'trusted';
         // URL is under a trusted atlassian domain
        const rootDomain = $c92260a0208e3eb8$var$getRootDomain(url);
        if ($c92260a0208e3eb8$var$TRUSTED_ROOT_DOMAINS.includes(rootDomain)) return 'trusted';
        if ([
            'https:',
            'http:'
        ].includes(url.protocol)) return 'external';
    } catch  {}
    return 'invalid';
} // Exported for testing only
function $c92260a0208e3eb8$export$e748b6351ba5f204(url) {
    // Don't count the initial `?` in the query string length.
    const queryStringSize = url.search.length > 1 ? url.search.length - 1 : 0;
    return {
        url: url.href,
        queryStringSize: queryStringSize
    };
}

});
parcelRegister("i5CVI", function(module, exports) {

$parcel$export(module.exports, "navigate", () => $6828e685c7239bdd$export$ff7962acd6052c28);
function $6828e685c7239bdd$export$ff7962acd6052c28(url, type, push) {
    switch(type){
        case 'new-tab':
            window.open(url, '_blank', 'noopener noreferrer');
            break;
        case 'same-tab':
            if (push) push(url);
            else window.location.href = url;
            break;
    }
}

});

parcelRegister("2kGKp", function(module, exports) {

$parcel$export(module.exports, "getOrigin", () => $676d2d098e4ba6be$export$5a759dc7a1cfb72a);
const $676d2d098e4ba6be$export$5a759dc7a1cfb72a = ()=>{
    return window.location.origin;
};

});

parcelRegister("lMJg3", function(module, exports) {

$parcel$export(module.exports, "useEgressPermissionService", () => $462f7dce88626787$export$8a0b6b45ac3015d5);

var $gwFzn = parcelRequire("gwFzn");

var $3uTSB = parcelRequire("3uTSB");
const $462f7dce88626787$export$8a0b6b45ac3015d5 = (permissionType, egress)=>{
    return (0, $gwFzn.useMemo)(()=>{
        const egressUrls = (egress || []).find((permission)=>permission.type === permissionType);
        const allowedUrls = egressUrls ? egressUrls.addresses : [];
        return new (0, $3uTSB.EgressFilteringService)(allowedUrls);
    }, [
        permissionType,
        egress
    ]);
};

});

parcelRegister("kTcrU", function(module, exports) {

$parcel$export(module.exports, "makeUrl", () => $3716a239e20d61f7$export$e98ca45c96b2aafe);

var $dh538 = parcelRequire("dh538");

var $2kGKp = parcelRequire("2kGKp");
const $3716a239e20d61f7$var$emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Filters out all parameters that may be used for malicious purposes such as attaching local files or adding bcc recipients
// Only subject and body are allowed
const $3716a239e20d61f7$var$filterMailtoParams = (mailtoLink)=>{
    try {
        const url = new URL(mailtoLink);
        const params = url.searchParams;
        const email = url.pathname;
        let newParams = '';
        if (!$3716a239e20d61f7$var$emailRegex.test(email)) // throw empty error for makeUrl to catch
        throw new Error();
        if (params.has('subject')) newParams += 'subject=' + encodeURIComponent(params.get('subject') || '');
        if (params.has('body')) {
            newParams += newParams ? '&body=' : 'body=';
            newParams += encodeURIComponent(params.get('body') || '');
        }
        return `${url.protocol}${email}` + (newParams ? '?' + newParams : '');
    } catch (error) {
        // throw empty error for makeUrl to catch
        throw new Error();
    }
};
function $3716a239e20d61f7$export$e98ca45c96b2aafe(urlString) {
    try {
        if (urlString.startsWith('mailto:')) return new URL($3716a239e20d61f7$var$filterMailtoParams(urlString));
        if (urlString.startsWith('tel:') && (0, $dh538.fg)('forge_ui_allow_tel_links')) // For telephone links, we just return the URL as is
        return new URL(urlString);
        // We decode the URL string to handle cases where a malicious app might pass in a URL with encoded characters to bypass our egress checks
        const decodedUrlString = decodeURIComponent(urlString);
        const fullUrl = decodedUrlString.startsWith('/') ? `${(0, $2kGKp.getOrigin)()}${urlString}` : urlString;
        // Checks if `fullUrl` has a protocol(eg. http://, https://, etc), if not, add the `https://` protocol
        const protocolRegex = /^(.*?:\/\/)/;
        const urlWithProtocol = protocolRegex.test(fullUrl) ? fullUrl : `https://${fullUrl}`;
        // We use the URL constructor to validate the URL
        const url = new URL(urlWithProtocol);
        return url;
    } catch  {
        return undefined;
    }
}

});


parcelRegister("aGCtG", function(module, exports) {

$parcel$export(module.exports, "isAppConsentedLocally", () => $dd25f80afb746bb3$export$c58c2ef6cd7b14a1);
$parcel$export(module.exports, "setAppConsentLocal", () => $dd25f80afb746bb3$export$8d4e05c53de89926);
const $dd25f80afb746bb3$export$c58c2ef6cd7b14a1 = (appId, accountId)=>!!window['__consentedApps']?.[`${appId}:${accountId}`];
const $dd25f80afb746bb3$export$8d4e05c53de89926 = (appId, accountId)=>{
    window.__consentedApps = window.__consentedApps || {};
    window.__consentedApps[`${appId}:${accountId}`] = true;
};

});

parcelRegister("bn0yX", function(module, exports) {

$parcel$export(module.exports, "getLoadingComponent", () => $13104cd2bb06c6a7$export$aee5524fcec014ce);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $CMcde = parcelRequire("CMcde");
const $13104cd2bb06c6a7$export$aee5524fcec014ce = (loadingComponent)=>{
    if (loadingComponent) return typeof loadingComponent === 'function' ? loadingComponent() : loadingComponent;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $CMcde.Loader), {});
};

});
parcelRegister("CMcde", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $a7bb558f45760cd7$export$3b0d6d7590275603);
/* loader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $9hlns = parcelRequire("9hlns");
const $a7bb558f45760cd7$export$3b0d6d7590275603 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
            testId: "forge-app-loading-spinner",
            size: "large"
        })
    });
};

});


parcelRegister("eahkE", function(module, exports) {

$parcel$export(module.exports, "SANDBOX_DEPRECATION_ERROR", () => $83b849164997a777$export$22d69806bfc9e8c1);
$parcel$export(module.exports, "ForgeDeprecationMessage", () => $83b849164997a777$export$e812f4e5298c004d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $aoVih = parcelRequire("aoVih");

var $lp6ii = parcelRequire("lp6ii");

var $1Igmn = parcelRequire("1Igmn");
const $83b849164997a777$export$22d69806bfc9e8c1 = 'INVALID_INVOCATION_RUNTIME_ERROR';
const $83b849164997a777$var$buildMessage = (title, error)=>{
    if (error === $83b849164997a777$export$22d69806bfc9e8c1) return `Your app ${title} is no longer working as it uses a deprecated platform feature. Please check if an update for this app is available through Atlassian Administration, or ask the app developer to upgrade the app.\nIf the app is listed on the marketplace, contact the developer using the Support tab.`;
    return `${title} version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
};
const $83b849164997a777$export$e812f4e5298c004d = (props)=>{
    const { client: client, extension: extension, error: error } = props;
    const [appName, setAppName] = (0, $gwFzn.useState)(undefined);
    const headers = (0, $gwFzn.useMemo)(()=>{
        const initHeaders = {};
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) initHeaders['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)();
        return initHeaders;
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (client) {
            const response = client.query({
                query: (0, $lp6ii.GET_APP_NAME),
                variables: {
                    id: extension.id
                },
                context: {
                    headers: headers
                }
            });
            response.then((data)=>{
                const appName = data.data?.app.name;
                setAppName(appName);
            });
        }
    }, [
        client,
        extension.id,
        headers
    ]);
    const title = appName ? appName : extension.properties.title;
    const message = $83b849164997a777$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
        title: "App update required",
        appearance: "error",
        children: message
    });
};

});
parcelRegister("lp6ii", function(module, exports) {

$parcel$export(module.exports, "GET_APP_NAME", () => $8d90d7c7a35ed227$export$d55d1cb9c5e0f267);

var $d2LG0 = parcelRequire("d2LG0");
const $8d90d7c7a35ed227$export$d55d1cb9c5e0f267 = (0, $d2LG0.default)`query app($id:ID!){app(id:$id){name}}`;

});



parcelRegister("jc2GP", function(module, exports) {

$parcel$export(module.exports, "getExtensionType", () => $45b69e870d2a465f$export$45b306f42e1402e5);
const $45b69e870d2a465f$export$45b306f42e1402e5 = (extension)=>{
    const { properties: properties } = extension;
    if (properties?.layout === 'bodied') return 'bodiedExtension';
    else if (properties?.layout === 'inline') return 'inlineExtension';
    return 'extension';
};

});

parcelRegister("jNc4k", function(module, exports) {

$parcel$export(module.exports, "ContextChangeObserverWrapper", () => $81f81791d185e0cc$export$5585193a0b9bb43d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $luNHV = parcelRequire("luNHV");

var $71Ozv = parcelRequire("71Ozv");

var $76I1K = parcelRequire("76I1K");

var $6oQb1 = parcelRequire("6oQb1");
const $81f81791d185e0cc$export$5585193a0b9bb43d = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    const forgeReactMajorVersion = (0, $gwFzn.useRef)(null);
    const initialConfigKey = (0, $gwFzn.useRef)(null);
    const { config: config, ...extensionWithoutConfig } = context.extension ?? {};
    const currentConfigKey = (0, (/*@__PURE__*/$parcel$interopDefault($71Ozv)))(config);
    const baseContextKey = (0, (/*@__PURE__*/$parcel$interopDefault($71Ozv)))({
        ...context,
        extension: extensionWithoutConfig
    });
    const trackWrappedComponentMounted = $81f81791d185e0cc$var$useWrappedComponentMountTracker();
    (0, $gwFzn.useEffect)(()=>{
        (0, $luNHV.emit)('FORGE_CORE_MACRO_CONFIG_CHANGED', {
            config: config
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentConfigKey
    ]);
    if (forgeReactMajorVersion.current === null) forgeReactMajorVersion.current = getCurrentForgeReactMajorVersion();
    if (initialConfigKey.current === null) initialConfigKey.current = currentConfigKey;
    // for existing apps we need to ensure backwards compatibility
    const shouldContextKeyChangeOnConfigChange = forgeReactMajorVersion.current === null || forgeReactMajorVersion.current < 11;
    // if the app is using the new version of Forge react, we always uses the initial config key
    const key = baseContextKey + (shouldContextKeyChangeOnConfigChange ? currentConfigKey : initialConfigKey.current);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($81f81791d185e0cc$var$WrappedComponent, {
        onMounted: trackWrappedComponentMounted,
        children: children
    }, key);
};
const $81f81791d185e0cc$var$useWrappedComponentMountTracker = ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $gwFzn.useRef)(0);
    const trackWrappedComponentMounted = (0, $76I1K.useCallbackOne)(()=>{
        mountedCount.current += 1;
        if (mountedCount.current > 1) trackExtensionRemounted({
            mountCount: mountedCount.current
        });
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackWrappedComponentMounted;
};
const $81f81791d185e0cc$var$WrappedComponent = ({ children: children, onMounted: onMounted })=>{
    (0, $gwFzn.useEffect)(()=>{
        onMounted();
    }, [
        onMounted
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("i9F01", function(module, exports) {

$parcel$export(module.exports, "ModalContentWrapper", () => $dc67d857f203b917$export$a6d6b74199964ee4);
$parcel$export(module.exports, "getAtlasKitModalWidth", () => $dc67d857f203b917$export$ca177c112881662a);
/* custom-ui-modal-utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $1DHa6 = parcelRequire("1DHa6");
const $dc67d857f203b917$var$smallModalStyles = null;
const $dc67d857f203b917$var$mediumModalStyles = null;
const $dc67d857f203b917$var$largeModalStyles = null;
const $dc67d857f203b917$var$xlargeModalStyles = null;
const $dc67d857f203b917$var$maxModalStyles = null;
const $dc67d857f203b917$var$resizableModalStyles = null; // TODO: Fix below styles once we move to compiled/react
const $dc67d857f203b917$export$a6d6b74199964ee4 = ({ children: children, size: size, styles: styles, isResizable: isResizable })=>{
    switch(size){
        case 'small':
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                style: styles,
                className: (0, $35pXk.default)([
                    "_2rko1sit _4t3i1tmh _1tkenklw _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'medium':
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                style: styles,
                className: (0, $35pXk.default)([
                    "_2rko1sit _4t3ivzbd _1tke1lk4 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'large':
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                style: styles,
                className: (0, $35pXk.default)([
                    "_2rko1sit _4t3i1rxh _1tke1yw0 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'xlarge':
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                style: styles,
                className: (0, $35pXk.default)([
                    "_2rko1sit _4t3i10fc _1tkezwhf _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ]),
                children: children
            });
        case 'max':
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                style: styles,
                className: (0, $35pXk.default)([
                    "_2rko1sit _4t3i1osq _bfhk1bhr"
                ]),
                children: children
            });
        default:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                children: children
            });
    }
};
const $dc67d857f203b917$export$ca177c112881662a = (modalSize)=>{
    if (modalSize === 'xlarge') return 'x-large';
    if (modalSize === 'max') return '100%';
    return modalSize;
};

});

parcelRegister("amyZ5", function(module, exports) {

$parcel$export(module.exports, "ForgeModalDeprecationMessage", () => $3ed8ce0b7cea2643$export$5b67d59ebd4f147c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $aoVih = parcelRequire("aoVih");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $lp6ii = parcelRequire("lp6ii");

var $1Igmn = parcelRequire("1Igmn");
function $3ed8ce0b7cea2643$export$5b67d59ebd4f147c(props) {
    const { client: client, extension: extension } = props;
    const [appName, setAppName] = (0, $gwFzn.useState)(undefined);
    const headers = (0, $gwFzn.useMemo)(()=>{
        const initHeaders = {};
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) initHeaders['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)();
        return initHeaders;
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (client && extension) {
            const response = client.query({
                query: (0, $lp6ii.GET_APP_NAME),
                variables: {
                    id: extension.id
                },
                context: {
                    headers: headers
                }
            });
            response.then((data)=>{
                const appName = data.data?.app.name;
                setAppName(appName);
            });
        }
    }, [
        client,
        extension,
        headers
    ]);
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
        title: intl.formatMessage($3ed8ce0b7cea2643$var$messages.title),
        appearance: "error",
        children: intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
            appName: appName
        })
    });
}
const $3ed8ce0b7cea2643$var$messages = (0, $2nPZH.defineMessages)({
    title: {
        id: "forge.modal.deprecation.title",
        defaultMessage: "Update your app"
    },
    message: {
        id: "forge.modal.deprecation.message",
        defaultMessage: "Your app {appName} uses the deprecated modal editing experience for custom fields, which is being phased out. Please have your system admin update the app to use inline editing instead. If issues remain, contact the app developer."
    }
});

});


parcelRegister("b1LIt", function(module, exports) {

$parcel$export(module.exports, "UIKitRenderer", () => $e892f186f061f3fc$export$9ca39743052e068e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $jed12 = parcelRequire("jed12");

var $hEvav = parcelRequire("hEvav");
var $cAcwV = parcelRequire("cAcwV");
var $durRy = parcelRequire("durRy");

var $d0USC = parcelRequire("d0USC");

var $gwUcI = parcelRequire("gwUcI");
const $e892f186f061f3fc$export$9ca39743052e068e = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, coreData: coreData, contextIds: contextIds, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $gwFzn.useState)(undefined);
    const [error, setError] = (0, $gwFzn.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $gwFzn.useState)(true);
    const wiredComponents = (0, $gwFzn.useMemo)(()=>({
            Avatar: (0, $hEvav.makeUser)({
                client: client
            }),
            AvatarStack: (0, $cAcwV.makeUserGroup)({
                client: client
            }),
            UserPicker: (0, $durRy.makeNativeUserPicker)({
                client: client,
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $gwUcI.uncurlyUuid)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            })
        }), [
        accountId,
        client,
        cloudId,
        mentionProvider,
        product,
        workspaceId
    ]);
    const getComponents = (0, $gwFzn.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...components
        }), [
        components,
        wiredComponents
    ]);
    const handleError = (0, $gwFzn.useCallback)((error)=>{
        if (onError) onError(error.message);
        if (onAppError) onAppError(error.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            shouldShowRenderer && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jed12.default), {
                isNative: true,
                forgeDoc: forgeDoc,
                extension: extension,
                error: error?.message,
                components: getComponents,
                modalExtension: modalExtension,
                extensionData: extensionData,
                extensionType: extensionData.type,
                loading: true,
                loadingComponent: loadingComponent,
                onError: handleError,
                client: client,
                onSuccess: onSuccess
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d0USC.WebRuntime), {
                accountId: accountId,
                setForgeDoc: (forgeDoc)=>{
                    if (forgeDoc.type !== 'MacroConfig') setForgeDoc(forgeDoc);
                    onForgeDocUpdated?.(forgeDoc);
                },
                setError: setError,
                apolloClient: client,
                components: getThreeLOPrompt,
                contextIds: contextIds,
                extension: extension,
                coreData: coreData,
                extensionData: extensionData,
                extensionPayload: extensionPayload,
                extensionViewData: extensionViewData,
                locale: locale,
                bridge: bridge,
                getContextToken: getContextToken,
                entryPoint: entryPoint,
                customBridgeMethods: customBridgeMethods,
                setShouldShowRenderer: setShouldShowRenderer
            })
        ]
    });
};

});
parcelRegister("jed12", function(module, exports) {

$parcel$export(module.exports, "default", () => $9248c53ed364f1d5$export$2e2bcd8739ae039);
/* eslint-disable import/dynamic-import-chunkname */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");

var $dh538 = parcelRequire("dh538");

var $hWJfj = parcelRequire("hWJfj");
var $1qp4n = parcelRequire("1qp4n");
var $3EkSF = parcelRequire("3EkSF");

var $JmaBh = parcelRequire("JmaBh");

var $jIiuI = parcelRequire("jIiuI");
var $gGmck = parcelRequire("gGmck");
var $i2hng = parcelRequire("i2hng");

var $CMcde = parcelRequire("CMcde");

var $gzd7F = parcelRequire("gzd7F");

var $2Jivw = parcelRequire("2Jivw");

var $69400 = parcelRequire("69400");

var $jc2GP = parcelRequire("jc2GP");
var $ijfiP = parcelRequire("ijfiP");

var $5oEbs = parcelRequire("5oEbs");

var $6oQb1 = parcelRequire("6oQb1");

var $eahkE = parcelRequire("eahkE");

var $iGprk = parcelRequire("iGprk");

var $hoVr8 = parcelRequire("hoVr8");

var $ahOA5 = parcelRequire("ahOA5");
const $9248c53ed364f1d5$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) // Wrapping loadingComponent in a valid react element (fragment) for change `fix-react-18-concurrent-upgrade-infinite-rendering`
    // ReactNode type is not necessarily a valid React element, unable to change this type as different extension points pass in various loadingComponent types
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: loadingComponent
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $CMcde.Loader), {});
};
const $9248c53ed364f1d5$var$getAppDomainName = (extension, environment)=>{
    const parsedExtension = extension && extension?.id ? (0, $ijfiP.parseExtensionId)(extension.id) : undefined;
    if (parsedExtension) {
        const iframeSrc = (0, $5oEbs.createSrcFromExtension)(parsedExtension.appId, extension, environment, '');
        const iframeUrl = new URL(iframeSrc);
        return iframeUrl.host;
    }
    return;
};

const $9248c53ed364f1d5$var$RendererNextLatest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>/* webpackChunkName: "forge-ui-renderer-with-components" */ Promise.resolve((parcelRequire("2Jivw"))).then((module)=>({
            default: module.RendererNextLatest
        })));
const $9248c53ed364f1d5$var$shouldRenderDeprecationErrorMessage = (appId, isNative, forgeReactMajorVersion, error)=>{
    if (error === (0, $eahkE.SANDBOX_DEPRECATION_ERROR)) return true;
    // Currently supported - UI Kit 2 and @forge/react >=10
    if (isNative && forgeReactMajorVersion) return false;
    // Deprecated - UI Kit 2 @forge/react < 10.
    if (isNative && !forgeReactMajorVersion) return true;
    // Deprecated - UI Kit 1
    if (!(0, $dh538.fg)('platform_disable_ui_kit_1')) return false;
    const uiKit1AppHasExtension = appId ? appId in (0, $iGprk.privateAppExtensionList) : false;
    // Excluded from deprecation UI Kit 1 apps
    if (uiKit1AppHasExtension && (0, $dh538.fg)('platform_enable_ui_kit_1_extension_list')) return false;
    // Non excluded UI Kit 1 apps
    return true;
};
// This extra component exists so errors from the "render" function are caught in the an error boundary
// Also the error boundary requires a suspense fallback
const $9248c53ed364f1d5$var$RendererNextWithProviders = (props)=>{
    const { extension: extension, extensionData: extensionData, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, client: client, error: error } = props;
    const defaultDispatch = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback(async ()=>{}, []);
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $gwFzn.useContext)((0, $jIiuI.EnvironmentContext));
    const domainName = $9248c53ed364f1d5$var$getAppDomainName(extension, environment);
    const { trackExtensionLoaded: trackExtensionLoaded } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $gwFzn.useEffect)(()=>{
        trackExtensionLoaded({
            renderType: props.isNative ? 'UIKit' : 'UIKit1',
            forgeEnvironment: extension?.environmentType,
            extensionType: (0, $jc2GP.getExtensionType)(extension),
            isConfiguring: extensionData?.macro?.isConfiguring,
            isInserting: extensionData?.macro?.isInserting
        });
    // Adding the dependencies, including trackExtensionLoaded, causes this effect to fire too often
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (forgeDoc && $9248c53ed364f1d5$var$shouldRenderDeprecationErrorMessage(extension.appId, props.isNative, forgeReactMajorVersion, error)) return props.modalExtension ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ahOA5.ForgeExtensionPointModal), {
        modalExtension: props.modalExtension,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eahkE.ForgeDeprecationMessage), {
            client: client,
            extension: extension,
            error: error
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eahkE.ForgeDeprecationMessage), {
        client: client,
        extension: extension,
        error: error
    });
    // true while fetching initial forgeDoc
    if ((0, $dh538.fg)('fix-react-18-concurrent-upgrade-infinite-rendering')) {
        if (props.loading && !forgeDoc) return $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent);
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qp4n.default), {
            dispatch: dispatch,
            extension: extension,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hWJfj.default), {
                dispatch: dispatch,
                extension: extension,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gzd7F.default), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3EkSF.default), {
                        onError: props.onError,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i2hng.WidthProvider), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
                                locale: locale ?? 'en',
                                defaultLocale: "en",
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $JmaBh.PortalProvider), {
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gGmck.RendererContext).Provider, {
                                        value: {
                                            egress: extension?.egress,
                                            properties: extension?.properties,
                                            forgeEnvironment: extension?.environmentType,
                                            forgeReactMajorVersion: forgeReactMajorVersion,
                                            appDomainName: domainName,
                                            extensionType: extension?.type
                                        },
                                        children: props.isNative && forgeReactMajorVersion && forgeReactMajorVersion >= 10 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $69400.default), {
                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)($9248c53ed364f1d5$var$RenderTrackingWrapper, {
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)($9248c53ed364f1d5$var$RendererNextLatest, {
                                                    ...props,
                                                    dispatch: dispatch ?? defaultDispatch
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Jivw.RendererNextLegacy), {
                                            ...props,
                                            dispatch: dispatch ?? defaultDispatch
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
const $9248c53ed364f1d5$var$RenderTrackingWrapper = ({ children: children })=>{
    if ((0, $dh538.fg)('forge-ui-track-ui-kit-renderer-rendered-event')) return /*#__PURE__*/ (0, $7UHDa.jsx)($9248c53ed364f1d5$var$RenderTrackingWrapperActual, {
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
const $9248c53ed364f1d5$var$RenderTrackingWrapperActual = ({ children: children })=>{
    (0, $hoVr8.useSendRendererRenderedAnalytics)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
var $9248c53ed364f1d5$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($9248c53ed364f1d5$var$RendererNextWithProviders, {
        ...props
    });
};

});
parcelRegister("hWJfj", function(module, exports) {

$parcel$export(module.exports, "ComponentError", () => $2104b77b1f0c0326$export$925737f92c0570a1);
$parcel$export(module.exports, "default", () => $2104b77b1f0c0326$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1c598 = parcelRequire("1c598");

var $gvvHu = parcelRequire("gvvHu");

var $7KMPr = parcelRequire("7KMPr");

var $inPa6 = parcelRequire("inPa6");

var $7TH2w = parcelRequire("7TH2w");

var $3Spjc = parcelRequire("3Spjc");

var $5U2YR = parcelRequire("5U2YR");
class $2104b77b1f0c0326$export$925737f92c0570a1 extends Error {
    constructor(message, component){
        super(message);
        this.component = void 0;
        this.component = component;
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2104b77b1f0c0326$export$925737f92c0570a1.prototype);
    }
}
class $2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent extends (0, $gwFzn.Component) {
    componentDidCatch(error, errorInfo) {
        // Filters out reporting errors for components that are not valid e.g. <Buton/>
        if (!(error instanceof $2104b77b1f0c0326$export$925737f92c0570a1)) throw error;
        const { extension: extension } = this.props;
        const { page: page, environment: environment } = this.context;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment ?? (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        this.props.createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: 'componentError',
                    component: error.component
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $2104b77b1f0c0326$var$ComponentErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)($2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $2104b77b1f0c0326$export$2e2bcd8739ae039 = $2104b77b1f0c0326$var$ComponentErrorBoundary;

});
parcelRegister("gvvHu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3044cb8be034d2df$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ErrorPanelRenderFn", () => $3044cb8be034d2df$export$1fe699079d0f690f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");

var $CMcde = parcelRequire("CMcde");

const $3044cb8be034d2df$var$AKSectionMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6JSOU")));

const $3044cb8be034d2df$var$SectionMessageAction = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("pJdIK")));
const $3044cb8be034d2df$var$textWrapCss = (0, $3jLHL.css)({
    whiteSpace: 'pre-wrap'
});
const $3044cb8be034d2df$var$ErrorPanel = ({ error: error, dispatch: dispatch, isReloadPage: isReloadPage })=>{
    const { message: message, errorDetails: errorDetails, errorMessage: errorMessage } = error;
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const intl = (0, $dBxQj.default)();
    const reinitializeApp = async ()=>{
        if (isReloadPage) window.location.reload();
        setIsLoading(true);
        try {
            if (dispatch) await dispatch({
                type: 'render',
                extensionData: {}
            });
        } finally{
            setIsLoading(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $CMcde.Loader), null);
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)({
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ul: {
                paddingLeft: 0
            }
        })
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($3044cb8be034d2df$var$AKSectionMessage, {
        appearance: "error",
        title: message,
        actions: [
            {
                key: 'refresh',
                text: intl.formatMessage(isReloadPage ? $3044cb8be034d2df$var$messages.reloadPage : $3044cb8be034d2df$var$messages.refreshApp),
                onClick: reinitializeApp
            }
        ].map(({ text: text, key: key, onClick: onClick })=>/*#__PURE__*/ (0, $3jLHL.jsx)($3044cb8be034d2df$var$SectionMessageAction, {
                key: key,
                onClick: onClick
            }, text))
    }, errorMessage && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        xcss: $3044cb8be034d2df$var$textWrapCss
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5dK2X.default), {
        as: "p"
    }, errorMessage)), errorDetails && /*#__PURE__*/ (0, $3jLHL.jsx)("pre", {
        css: $3044cb8be034d2df$var$textWrapCss
    }, errorDetails)));
};
var $3044cb8be034d2df$export$2e2bcd8739ae039 = $3044cb8be034d2df$var$ErrorPanel;
const $3044cb8be034d2df$export$1fe699079d0f690f = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { error: error } = forgeDoc.props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)($3044cb8be034d2df$var$ErrorPanel, {
        key: "error",
        error: error,
        dispatch: dispatch
    });
};
const $3044cb8be034d2df$var$messages = (0, $2nPZH.defineMessages)({
    refreshApp: {
        id: "confluence.error.panel.refresh.app",
        defaultMessage: "Refresh app"
    },
    reloadPage: {
        id: "confluence.error.panel.reload.page",
        defaultMessage: "Reload page"
    }
});

});
parcelRegister("pJdIK", function(module, exports) {

let $04d569b96d98d2ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $04d569b96d98d2ea$var$load("jbqJf").then(()=>parcelRequire('hkbHJ'));

});



parcelRegister("1qp4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a7e2bde20e8f4eb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1c598 = parcelRequire("1c598");

var $gvvHu = parcelRequire("gvvHu");

var $5U2YR = parcelRequire("5U2YR");

var $7KMPr = parcelRequire("7KMPr");

var $inPa6 = parcelRequire("inPa6");

var $7TH2w = parcelRequire("7TH2w");

var $3Spjc = parcelRequire("3Spjc");
class $3a7e2bde20e8f4eb$export$a707936a384f62f9 extends Error {
    constructor(error){
        super(error.logMessage);
        this.logMessage = void 0;
        this.errorTitle = void 0;
        this.errorBody = void 0;
        this.errorTitle = error.errorTitle;
        this.logMessage = error.logMessage;
        this.errorBody = error.errorBody;
    }
}
class $3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent extends (0, $gwFzn.Component) {
    componentDidCatch(error, errorInfo) {
        const { page: page, environment: environment } = this.context;
        const { createAnalyticsEvent: createAnalyticsEvent, extension: extension } = this.props;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment || (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        if (error instanceof $3a7e2bde20e8f4eb$export$a707936a384f62f9) this.setState({
            thrownError: {
                error: {
                    name: 'error',
                    message: error.errorTitle,
                    errorMessage: error.errorBody
                },
                errorInfo: errorInfo
            }
        });
        else this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $3a7e2bde20e8f4eb$var$GenericErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)($3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $3a7e2bde20e8f4eb$export$2e2bcd8739ae039 = $3a7e2bde20e8f4eb$var$GenericErrorBoundary;

});

parcelRegister("3EkSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e1d4758686470f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
class $49e1d4758686470f$var$IntegrationErrorHandlerBoundary extends (0, $gwFzn.Component) {
    componentDidCatch(error) {
        if (this.props.onError) this.props.onError(error);
        throw error;
    }
    render() {
        return this.props.children;
    }
}
var $49e1d4758686470f$export$2e2bcd8739ae039 = $49e1d4758686470f$var$IntegrationErrorHandlerBoundary;

});

parcelRegister("JmaBh", function(module, exports) {

$parcel$export(module.exports, "PortalConsumer", () => $f76408e65cd851d4$export$7d41556b227a95c9);
$parcel$export(module.exports, "PortalProvider", () => $f76408e65cd851d4$export$6df4068a17305b10);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $caX7N = parcelRequire("caX7N");

var $dTk3A = parcelRequire("dTk3A");
const { Provider: $f76408e65cd851d4$var$Provider, Consumer: $f76408e65cd851d4$export$7d41556b227a95c9 } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(undefined);
const $f76408e65cd851d4$export$6df4068a17305b10 = ({ children: children })=>{
    const [portal, setPortal] = (0, $gwFzn.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (portal !== null) setIsPortalReady(true);
    }, [
        portal
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            isPortalReady && /*#__PURE__*/ (0, $7UHDa.jsx)($f76408e65cd851d4$var$Provider, {
                value: portal,
                children: children
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
                zIndex: (0, $dTk3A.layers).modal() + 1,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    "data-testid": "forge-ui-portal",
                    ref: setPortal
                })
            })
        ]
    });
};

});

parcelRegister("gzd7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $cec67f48175aa836$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gvvHu = parcelRequire("gvvHu");
class $cec67f48175aa836$export$51ac3312edef55d7 extends Error {
    get issue() {
        return this._issue;
    }
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    constructor({ issue: issue, message: message }){
        super(message);
        this._issue = void 0;
        this._property = void 0;
        this._issue = issue;
        this._property = '';
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $cec67f48175aa836$export$51ac3312edef55d7.prototype);
    }
}
class $cec67f48175aa836$var$StyleErrorBoundary extends (0, $gwFzn.Component) {
    componentDidCatch(error) {
        if (!(error instanceof $cec67f48175aa836$export$51ac3312edef55d7)) throw error;
        this.setState({
            error: error
        });
    }
    render() {
        const { error: error } = this.state;
        if (!error) return this.props.children;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gvvHu.default), {
            error: {
                name: 'style-error',
                message: `Error was thrown on style property: ${error.property}`,
                errorMessage: `${error.issue}\n${error.message}`
            },
            isReloadPage: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: null
        };
    }
}
var $cec67f48175aa836$export$2e2bcd8739ae039 = $cec67f48175aa836$var$StyleErrorBoundary;

});

parcelRegister("2Jivw", function(module, exports) {

$parcel$export(module.exports, "RendererNextLatest", () => $31a02a62a2ca9c46$export$593275278a807c58);
$parcel$export(module.exports, "RendererNextLegacy", () => $31a02a62a2ca9c46$export$6d81a7348fccd2a2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $glh1I = parcelRequire("glh1I");

var $7PBQ9 = parcelRequire("7PBQ9");

var $2x8cJ = parcelRequire("2x8cJ");

var $dY90P = parcelRequire("dY90P");

var $3tbBB = parcelRequire("3tbBB");

var $4ZTaE = parcelRequire("4ZTaE");

var $hWJfj = parcelRequire("hWJfj");

var $acZWu = parcelRequire("acZWu");

var $dh538 = parcelRequire("dh538");
const $31a02a62a2ca9c46$export$a200b9d079640a1 = new Set([
    'Badge',
    'Bleed',
    'Box',
    'Button',
    'ButtonGroup',
    'Calendar',
    'Checkbox',
    'CheckboxGroup',
    'Code',
    'CodeBlock',
    'Comment',
    'DatePicker',
    'DynamicTable',
    'EmptyState',
    'ErrorMessage',
    'Flex',
    'Form',
    'FormFooter',
    'FormHeader',
    'FormSection',
    'Grid',
    'Heading',
    'HelperMessage',
    'Icon',
    'Inline',
    'InlineEdit',
    'Label',
    'LinkButton',
    'List',
    'ListItem',
    'LoadingButton',
    'Lozenge',
    'Modal',
    'ModalBody',
    'ModalFooter',
    'ModalHeader',
    'ModalTitle',
    'ModalTransition',
    'Popup',
    'Pressable',
    'ProgressBar',
    'ProgressTracker',
    'Radio',
    'RadioGroup',
    'Range',
    'RequiredAsterisk',
    'SectionMessage',
    'SectionMessageAction',
    'Select',
    'Spinner',
    'Stack',
    'Tab',
    'TabList',
    'TabPanel',
    'Tabs',
    'Tag',
    'TagGroup',
    'TextArea',
    'Textfield',
    'TimePicker',
    'Toggle',
    'Tooltip',
    'ValidMessage',
    'AdfRenderer',
    'Image',
    'Link',
    'Text',
    'Strong',
    'BarChart',
    'StackBarChart',
    'HorizontalStackBarChart',
    'HorizontalBarChart',
    'LineChart',
    'PieChart',
    'DonutChart',
    'String',
    'Em',
    'Strike',
    'Root',
    'Fragment',
    'ThreeLOPrompt',
    'User',
    'UserGroup',
    'UserPicker',
    'Frame',
    'ContentWrapper',
    'ValidationMessage',
    'ButtonSet',
    'DateLozenge',
    'ErrorPanel',
    'FormCondition',
    'InlineDialog',
    'ModalDialog',
    'StatusLozenge',
    'Table',
    'TextField',
    'View'
]);
const $31a02a62a2ca9c46$var$rendererNextComponents = {
    ThreeLOPrompt: (0, $4ZTaE.ThreeLOPromptRenderFn)
};
// This was extracted from RendererNext Component due to UnknownComponent Error being
// incompatible with running in a server-side context.
const $31a02a62a2ca9c46$var$customRenderErrorFn = (forgeDocType)=>{
    // Buckets errors into two kinds, ComponentError - component errors we want to report on e.g. <Button/> vs ones we don't e.g. <Buton/> which will only show up in the users console
    if ($31a02a62a2ca9c46$export$a200b9d079640a1.has(forgeDocType)) throw new (0, $hWJfj.ComponentError)(`Error rendering app - component ${forgeDocType}.`, forgeDocType);
    else throw new Error(`Error rendering app - encountered unknown component ${forgeDocType}.`);
};
const $31a02a62a2ca9c46$export$593275278a807c58 = (props)=>{
    const uiKitComponents = Object.keys((0, $dY90P.importMapMemo)).reduce((acc, key)=>{
        const Component = (0, $dY90P.importMapMemo)[key];
        return {
            ...acc,
            [key]: (args)=>/*#__PURE__*/ (0, $gwFzn.createElement)(Component, {
                    ...args,
                    key: args.forgeDoc.key
                })
        };
    }, {});
    const uiKitChartsComponents = Object.keys((0, $3tbBB.importMapChartsMemo)).reduce((acc, key)=>{
        const Component = (0, $3tbBB.importMapChartsMemo)[key];
        return {
            ...acc,
            [key]: (args)=>/*#__PURE__*/ (0, $gwFzn.createElement)(Component, {
                    ...args,
                    key: args.forgeDoc.key
                })
        };
    }, {});
    const components = {
        ...uiKitComponents,
        ...uiKitChartsComponents,
        String: (0, $glh1I.uiKit1Components).String,
        Em: (0, $glh1I.uiKit1Components).Em,
        Strong: (0, $dh538.fg)('forge-ui-kit-fix-strong-element-size-for-macro') ? (0, $acZWu.Strong) : (0, $glh1I.uiKit1Components).Strong,
        Strike: (0, $glh1I.uiKit1Components).Strike,
        Root: $7PBQ9.Root,
        Fragment: $7PBQ9.Fragment
    };
    const combinedComponents = {
        ...components,
        ...$31a02a62a2ca9c46$var$rendererNextComponents
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2x8cJ.RendererNext), {
        ...props,
        components: props.components ? props.components(combinedComponents) : combinedComponents,
        customRenderErrorFn: $31a02a62a2ca9c46$var$customRenderErrorFn
    });
};
const $31a02a62a2ca9c46$export$6d81a7348fccd2a2 = (props)=>{
    const combinedComponents = {
        ...(0, $glh1I.uiKit1Components),
        ...$31a02a62a2ca9c46$var$rendererNextComponents
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2x8cJ.RendererNext), {
        ...props,
        components: props.components ? props.components(combinedComponents) : combinedComponents,
        customRenderErrorFn: $31a02a62a2ca9c46$var$customRenderErrorFn
    });
};

});
parcelRegister("glh1I", function(module, exports) {

$parcel$export(module.exports, "uiKit1Components", () => $ab8fc5e500e17686$export$65fce8c2f2babb3e);

var $gwFzn = parcelRequire("gwFzn");

var $7KAkr = parcelRequire("7KAkr");

var $jXwV2 = parcelRequire("jXwV2");

var $6JQq2 = parcelRequire("6JQq2");

var $i3nfp = parcelRequire("i3nfp");

var $bX26R = parcelRequire("bX26R");

var $guPRT = parcelRequire("guPRT");

var $9gIfM = parcelRequire("9gIfM");

var $gvvHu = parcelRequire("gvvHu");

var $2Hm46 = parcelRequire("2Hm46");

var $dVLdn = parcelRequire("dVLdn");

var $eDXfq = parcelRequire("eDXfq");

var $t7asT = parcelRequire("t7asT");

var $8uh2I = parcelRequire("8uh2I");

var $7CvHT = parcelRequire("7CvHT");

var $crMC7 = parcelRequire("crMC7");

var $e5sc0 = parcelRequire("e5sc0");

var $lj4NV = parcelRequire("lj4NV");

var $1SnA0 = parcelRequire("1SnA0");

var $avcIc = parcelRequire("avcIc");

var $1G5pk = parcelRequire("1G5pk");

var $hslt5 = parcelRequire("hslt5");
var $aYIpJ = parcelRequire("aYIpJ");

var $iBL5y = parcelRequire("iBL5y");

var $1KTym = parcelRequire("1KTym");

var $bmkqA = parcelRequire("bmkqA");

var $cxqzX = parcelRequire("cxqzX");

var $SiAOO = parcelRequire("SiAOO");

var $4eiUW = parcelRequire("4eiUW");

var $kgtKy = parcelRequire("kgtKy");

var $jLYRk = parcelRequire("jLYRk");

var $7Ncdf = parcelRequire("7Ncdf");
const $ab8fc5e500e17686$export$65fce8c2f2babb3e = {
    Badge: (0, $7Ncdf.upgradeComponent)((0, $7KAkr.BadgeFn)),
    Button: (args)=>/*#__PURE__*/ (0, $gwFzn.createElement)((0, $jXwV2.Button), {
            ...args,
            key: args.forgeDoc.key
        }),
    ButtonSet: (0, $7Ncdf.upgradeComponent)((0, $6JQq2.ButtonSetFn)),
    CheckboxGroup: (0, $7Ncdf.upgradeComponent)((0, $i3nfp.CheckboxGroupFn)),
    Code: (0, $7Ncdf.upgradeComponent)((0, $bX26R.CodeFn)),
    DateLozenge: (0, $7Ncdf.upgradeComponent)((0, $guPRT.DateLozengeFn)),
    DatePicker: (0, $7Ncdf.upgradeComponent)((0, $9gIfM.DatePickerFn)),
    Em: (0, $7Ncdf.upgradeComponent)((0, $jLYRk.EmFn)),
    ErrorPanel: (0, $gvvHu.ErrorPanelRenderFn),
    Form: (args)=>/*#__PURE__*/ (0, $gwFzn.createElement)((0, $2Hm46.Form), {
            ...args,
            key: args.forgeDoc.key
        }),
    FormCondition: (0, $7Ncdf.upgradeComponent)((0, $dVLdn.FormConditionFn)),
    Heading: (0, $7Ncdf.upgradeComponent)((0, $kgtKy.HeadingFn)),
    Image: (0, $7Ncdf.upgradeComponent)((0, $eDXfq.ImageFn)),
    InlineDialog: (args)=>/*#__PURE__*/ (0, $gwFzn.createElement)((0, $t7asT.InlineDialog), {
            ...args,
            key: args.forgeDoc.key
        }),
    Link: (0, $7Ncdf.upgradeComponent)((0, $jLYRk.LinkFn)),
    ModalDialog: (args)=>/*#__PURE__*/ (0, $gwFzn.createElement)((0, $8uh2I.ModalDialog), {
            ...args,
            key: args.forgeDoc.key
        }),
    RadioGroup: (0, $7Ncdf.upgradeComponent)((0, $7CvHT.RadioGroupFn)),
    Range: (0, $7Ncdf.upgradeComponent)((0, $crMC7.RangeFn)),
    SectionMessage: (0, $7Ncdf.upgradeComponent)((0, $e5sc0.SectionMessageFn)),
    Select: (0, $7Ncdf.upgradeComponent)((0, $lj4NV.SelectFn)),
    StatusLozenge: (0, $7Ncdf.upgradeComponent)((0, $1SnA0.StatusLozengeFn)),
    Strike: (0, $7Ncdf.upgradeComponent)((0, $jLYRk.StrikeFn)),
    String: (0, $7Ncdf.upgradeComponent)((0, $jLYRk.StringFn)),
    Strong: (0, $7Ncdf.upgradeComponent)((0, $jLYRk.StrongFn)),
    Table: (0, $7Ncdf.upgradeComponent)((0, $1G5pk.TableFn)),
    Tabs: (0, $7Ncdf.upgradeComponent)((0, $avcIc.TabsFn)),
    Tag: (0, $7Ncdf.upgradeComponent)((0, $hslt5.TagFn)),
    TagGroup: (0, $7Ncdf.upgradeComponent)((0, $aYIpJ.TagGroupFn)),
    Text: (0, $7Ncdf.upgradeComponent)((0, $iBL5y.TextFn)),
    TextArea: (0, $7Ncdf.upgradeComponent)((0, $1KTym.TextAreaFn)),
    TextField: (0, $7Ncdf.upgradeComponent)((0, $bmkqA.TextFieldFn)),
    Toggle: (0, $7Ncdf.upgradeComponent)((0, $cxqzX.ToggleFn)),
    Tooltip: (0, $7Ncdf.upgradeComponent)((0, $SiAOO.TooltipFn)),
    View: (0, $7Ncdf.upgradeComponent)((0, $4eiUW.ViewFn))
};

});
parcelRegister("7KAkr", function(module, exports) {

$parcel$export(module.exports, "BadgeFn", () => $1dc316a623d24040$export$c07d87ab1594bff4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $1dc316a623d24040$var$AKBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("1htSM")));
function $1dc316a623d24040$var$Badge({ appearance: appearance = 'default', text: text }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)($1dc316a623d24040$var$AKBadge, {
        appearance: appearance,
        children: text
    });
}
var $1dc316a623d24040$export$2e2bcd8739ae039 = $1dc316a623d24040$var$Badge;
function $1dc316a623d24040$export$c07d87ab1594bff4({ props: props }) {
    const { appearance: appearance, text: text } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($1dc316a623d24040$var$Badge, {
        appearance: appearance,
        text: text
    });
}

});
parcelRegister("1htSM", function(module, exports) {

let $0eee8f037535b0df$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0eee8f037535b0df$var$load("2lpnu").then(()=>parcelRequire('byMHr'));

});


parcelRegister("6JQq2", function(module, exports) {

$parcel$export(module.exports, "ButtonSet", () => $5ff27bb82b284c52$export$87e672a75327e04b);
$parcel$export(module.exports, "ButtonSetFn", () => $5ff27bb82b284c52$export$1ff560ec9540c1a9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
parcelRequire("gwFzn");
const $5ff27bb82b284c52$export$87e672a75327e04b = ({ children: children })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)({
            display: 'flex',
            flexWrap: 'wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '> *': {
                marginTop: "var(--ds-space-100, 8px)",
                marginRight: "var(--ds-space-100, 8px)"
            },
            marginTop: "var(--ds-space-negative-100, -8px)",
            marginRight: "var(--ds-space-negative-100, -8px)"
        })
    }, children);
const $5ff27bb82b284c52$export$1ff560ec9540c1a9 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>/*#__PURE__*/ (0, $3jLHL.jsx)($5ff27bb82b284c52$export$87e672a75327e04b, null, renderChildren({
        children: children,
        dispatch: dispatch,
        Components: Components,
        render: render
    }));

});

parcelRegister("i3nfp", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupFn", () => $7d448eb063ac9d6b$export$b78851756f45833b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $2Hm46 = parcelRequire("2Hm46");
const $7d448eb063ac9d6b$var$styles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});

const $7d448eb063ac9d6b$var$AKCheckbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("g0Fzr")).then((module)=>({
            default: module.Checkbox
        })));

const $7d448eb063ac9d6b$var$AKCheckboxField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.CheckboxField
        })));

const $7d448eb063ac9d6b$var$Fieldset = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Fieldset
        })));

const $7d448eb063ac9d6b$var$AKHelperMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.HelperMessage
        })));
const $7d448eb063ac9d6b$export$4aa08d5625cb8ead = ({ options: options, label: label, name: name, description: description })=>{
    const defaultValues = [];
    options.forEach((option)=>{
        if (option.defaultChecked) defaultValues.push(option.value);
    });
    const [checkboxFieldValues, setCheckboxFieldValues] = (0, $gwFzn.useState)(defaultValues);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($7d448eb063ac9d6b$var$Fieldset, {
        legend: label
    }, description && /*#__PURE__*/ (0, $3jLHL.jsx)($7d448eb063ac9d6b$var$AKHelperMessage, null, description), options.map((option)=>{
        const { key: key, label: label, value: value, defaultChecked: defaultChecked, isRequired: isRequired } = option;
        return /*#__PURE__*/ (0, $3jLHL.jsx)($7d448eb063ac9d6b$var$AKCheckboxField, {
            key: key,
            value: value,
            defaultIsChecked: defaultChecked,
            name: name
        }, ({ fieldProps: fieldProps })=>{
            const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, name: name, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledBy, isChecked: isChecked } = fieldProps;
            return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
                css: $7d448eb063ac9d6b$var$styles
            }, /*#__PURE__*/ (0, $3jLHL.jsx)($7d448eb063ac9d6b$var$AKCheckbox, {
                id: id,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isRequired: isRequired,
                onBlur: onBlur,
                onFocus: onFocus,
                value: value,
                name: name,
                label: label,
                onChange: (e)=>{
                    if (e.target.checked) setCheckboxFieldValues((prevState)=>[
                            ...prevState,
                            value
                        ]);
                    else setCheckboxFieldValues(checkboxFieldValues.filter((e)=>e !== value));
                    return onChange(e);
                },
                "aria-invalid": ariaInvalid,
                "aria-labelledby": ariaLabelledBy
            }));
        });
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
        name: name,
        value: checkboxFieldValues
    }));
};
const $7d448eb063ac9d6b$export$b78851756f45833b = ({ props: propsAny, children: children })=>{
    const { name: name, description: description } = propsAny;
    const props = propsAny;
    // NOTE: legend is deprecated
    const label = 'legend' in props ? props.legend : props.label;
    const options = children.filter(({ type: type })=>type === 'Checkbox').map((child)=>{
        const { key: key, props: props } = child;
        const { label: label, value: value, defaultChecked: defaultChecked, isRequired: isRequired } = props;
        return {
            key: key,
            label: label,
            value: value,
            defaultChecked: defaultChecked,
            isRequired: isRequired
        };
    });
    return /*#__PURE__*/ (0, $3jLHL.jsx)($7d448eb063ac9d6b$export$4aa08d5625cb8ead, {
        label: label,
        name: name,
        options: options,
        description: description
    });
};

});
parcelRegister("2Hm46", function(module, exports) {

$parcel$export(module.exports, "AkForm", () => $051f12b2e6795f2a$export$117438e17b246db9);
$parcel$export(module.exports, "AkFormFooter", () => $051f12b2e6795f2a$export$bbe730ec239dd31a);
$parcel$export(module.exports, "isActionButton", () => $051f12b2e6795f2a$export$2127b0e8511224d0);
$parcel$export(module.exports, "useForm", () => $051f12b2e6795f2a$export$87c0cf8eb5a167e0);
$parcel$export(module.exports, "FormContext", () => $051f12b2e6795f2a$export$c24727297075ec6a);
$parcel$export(module.exports, "FormStateChangeNotifier", () => $051f12b2e6795f2a$export$56c425463976216f);
$parcel$export(module.exports, "Form", () => $051f12b2e6795f2a$export$a7fed597f4b8afd8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $jXwV2 = parcelRequire("jXwV2");
var $6JQq2 = parcelRequire("6JQq2");

var $5yOga = parcelRequire("5yOga");

var $cxeYl = parcelRequire("cxeYl");

const $051f12b2e6795f2a$export$117438e17b246db9 = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.default
        })));

const $051f12b2e6795f2a$export$bbe730ec239dd31a = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.FormFooter
        })));

const $051f12b2e6795f2a$export$c0511946385c3887 = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Field
        })));
const $051f12b2e6795f2a$export$2127b0e8511224d0 = (auxElement)=>auxElement.key && auxElement.key.startsWith('actionButton');
function $051f12b2e6795f2a$export$87c0cf8eb5a167e0({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { props: { submitButtonText: submitButtonText = formatMessage($051f12b2e6795f2a$export$defe85febe8b728c.forgeFormSubmitButtonText), onSubmit: onSubmit, submitButtonAppearance: submitButtonAppearance = 'default' } = {} } = forgeDoc;
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    /**
   * Toggle the Form's React key to remount the component for clearing fields
   * Using the formProps' reset() would trigger our custom form validation for isRequired on some fields
   */ const [formKey, setFormKey] = (0, $gwFzn.useState)(0);
    const onSubmitHandler = async (formData)=>{
        setLoading(true);
        try {
            await dispatch({
                type: 'event',
                extensionData: {},
                handler: onSubmit,
                args: [
                    (0, $5yOga.transformFormData)(formData)
                ]
            });
            setFormKey(Number(!formKey));
        } finally{
            setLoading(false);
        }
    };
    const akSubmitButtonProps = {
        ...(0, $jXwV2.useButton)({
            forgeDoc: {
                type: 'Button',
                props: {
                    text: submitButtonText,
                    appearance: submitButtonAppearance
                },
                children: []
            },
            dispatch: dispatch,
            render: render
        }).akButtonProps,
        onClick: undefined,
        type: 'submit',
        isLoading: loading
    };
    const children = forgeDoc.children.filter((x)=>!$051f12b2e6795f2a$export$2127b0e8511224d0(x));
    const actions = forgeDoc.children.filter($051f12b2e6795f2a$export$2127b0e8511224d0).map((actionButton)=>({
            ...actionButton,
            props: {
                ...actionButton.props,
                appearance: 'subtle'
            }
        }));
    return {
        akFormProps: {
            key: formKey,
            onSubmit: onSubmitHandler,
            children: ()=>{
                throw Error('@atlassian/forge-ui: Invalid composition of UI Kit useForm and Atlaskit Form');
            }
        },
        akSubmitButtonProps: akSubmitButtonProps,
        htmlFormProps: {
            // @ts-ignore
            'data-testid': 'form',
            className: (0, $cxeYl.emotionInstance).css`
        width: 100%;
        margin-top: 0;
        > *:not(footer) {
          margin-top: 0;
        }
        > *:not(:last-child) {
          margin-bottom: ${"var(--ds-space-100, 8px)"};
        }
        ${children.length === 0 ? `
            > footer {
              margin-top: 0;
            }
            ` : ''}
      `
        },
        akFormFooterProps: {
            align: 'start'
        },
        children: children.map(render),
        actions: actions.length > 0 ? actions.map(render) : null
    };
}
const $051f12b2e6795f2a$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(null);
const $051f12b2e6795f2a$export$56c425463976216f = ({ name: name, value: value })=>{
    const formContext = (0, $gwFzn.useContext)($051f12b2e6795f2a$export$c24727297075ec6a);
    (0, $gwFzn.useEffect)(()=>{
        formContext?.setFormValue(name, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        name,
        Array.isArray(value) ? value.join() : value
    ]);
    return null;
};
function $051f12b2e6795f2a$export$a7fed597f4b8afd8(props) {
    const { actions: actions, akFormFooterProps: akFormFooterProps, akFormProps: akFormProps, akSubmitButtonProps: akSubmitButtonProps, children: children, htmlFormProps: htmlFormProps } = $051f12b2e6795f2a$export$87c0cf8eb5a167e0(props);
    const { shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: loading, isDisabled: disabled, appearance: appearance, onClick: onClick, type: type, children: buttonChildren } = akSubmitButtonProps;
    const { align: align } = akFormFooterProps;
    const { key: key, onSubmit: onSubmit } = akFormProps;
    // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
    const { className: className, 'data-testid': dataTestId } = htmlFormProps;
    const [formValues, setFormValues] = (0, $gwFzn.useState)({});
    const setFormValue = (name, value)=>{
        setFormValues((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)($051f12b2e6795f2a$export$117438e17b246db9, {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>{
            const { onSubmit: onSubmit, onKeyDown: onKeyDown, ref: ref } = formProps;
            return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            /*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                onSubmit: onSubmit,
                onKeyDown: onKeyDown,
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                "data-testid": dataTestId,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)($051f12b2e6795f2a$export$c24727297075ec6a.Provider, {
                        value: {
                            formValues: formValues,
                            setFormValue: setFormValue
                        },
                        children: children
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)($051f12b2e6795f2a$export$bbe730ec239dd31a, {
                        align: align,
                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6JQq2.ButtonSet), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jXwV2.AkButton), {
                                    shouldFitContainer: shouldFitContainer,
                                    iconBefore: iconBefore,
                                    iconAfter: iconAfter,
                                    isLoading: loading,
                                    isDisabled: disabled,
                                    appearance: appearance,
                                    onClick: onClick,
                                    type: type,
                                    children: buttonChildren
                                }),
                                actions
                            ]
                        })
                    })
                ]
            }));
        }
    }, key);
}
const $051f12b2e6795f2a$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    forgeFormSubmitButtonText: {
        id: "forge-ui.form.submit-button.text",
        defaultMessage: "Submit"
    }
});

});
parcelRegister("5yOga", function(module, exports) {

$parcel$export(module.exports, "transformFormValue", () => $8718f926ed0b80e1$export$1a3c135ac4585aa9);
$parcel$export(module.exports, "transformFormData", () => $8718f926ed0b80e1$export$d1360584b6d92fb7);
const $8718f926ed0b80e1$var$isOptionData = (value)=>typeof value === 'object' && value.hasOwnProperty('value');
const $8718f926ed0b80e1$var$isUserData = (value)=>typeof value === 'object' && value.hasOwnProperty('id') && value.hasOwnProperty('name') && value.hasOwnProperty('avatarUrl');
const $8718f926ed0b80e1$export$1a3c135ac4585aa9 = (value)=>{
    if ($8718f926ed0b80e1$var$isOptionData(value)) return value.value;
    else if ($8718f926ed0b80e1$var$isUserData(value) && value.type === 'user') return value.id;
    return value;
};
const $8718f926ed0b80e1$export$d1360584b6d92fb7 = (formData)=>Object.entries(formData).reduce((transformedData, [key, value])=>{
        return {
            ...transformedData,
            [key]: Array.isArray(value) ? value.map($8718f926ed0b80e1$export$1a3c135ac4585aa9) : $8718f926ed0b80e1$export$1a3c135ac4585aa9(value)
        };
    }, {});

});

parcelRegister("cxeYl", function(module, exports) {

$parcel$export(module.exports, "emotionInstance", () => $0496a86bf4ff1a05$export$6a54433420868a45);

var $g5ku5 = parcelRequire("g5ku5");
const $0496a86bf4ff1a05$export$6a54433420868a45 = (0, $g5ku5.default)({
    key: 'ui-kit-css'
});

});

parcelRegister("fmuWr", function(module, exports) {

let $b2f0e975958ab7e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2f0e975958ab7e6$var$load("2BKk9").then(()=>parcelRequire('aDVvJ'));

});


parcelRegister("g0Fzr", function(module, exports) {

let $ba7ce47768729649$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba7ce47768729649$var$load("bnZwG").then(()=>parcelRequire('oZKrL'));

});


parcelRegister("bX26R", function(module, exports) {

$parcel$export(module.exports, "CodeFn", () => $16e3655ad2cab112$export$9f067e9ed3ed058);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $9UyM5 = parcelRequire("9UyM5");
const $16e3655ad2cab112$var$styles = (0, $3jLHL.css)({
    width: "'100%'"
});

const $16e3655ad2cab112$var$AKCodeBlock = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("93huM")).then((module)=>({
            AkCode: module.Code,
            AkCodeBlock: module.CodeBlock
        })).then((module)=>({
            default: module.AkCodeBlock
        })));

const $16e3655ad2cab112$var$AKCodeInline = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("93huM")).then((module)=>({
            AkCode: module.Code,
            AkCodeBlock: module.CodeBlock
        })).then((module)=>({
            default: module.AkCode
        })));
const $16e3655ad2cab112$var$Code = ({ text: text, language: language = 'text', showLineNumbers: showLineNumbers = true })=>{
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    return inline ? /*#__PURE__*/ (0, $3jLHL.jsx)($16e3655ad2cab112$var$AKCodeInline, null, text) : /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $16e3655ad2cab112$var$styles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($16e3655ad2cab112$var$AKCodeBlock, {
        text: text,
        language: language,
        showLineNumbers: showLineNumbers
    }));
};
var $16e3655ad2cab112$export$2e2bcd8739ae039 = $16e3655ad2cab112$var$Code;
const $16e3655ad2cab112$export$9f067e9ed3ed058 = ({ props: props })=>{
    const { text: text, language: language, showLineNumbers: showLineNumbers } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)($16e3655ad2cab112$var$Code, {
        text: text,
        language: language,
        showLineNumbers: showLineNumbers
    });
};

});
parcelRegister("9UyM5", function(module, exports) {

$parcel$export(module.exports, "InlineContext", () => $d399cb7128821634$export$75ab56226e2d3efd);
$parcel$export(module.exports, "useInlineContext", () => $d399cb7128821634$export$3828d4e780bd54a);

var $gwFzn = parcelRequire("gwFzn");
const $d399cb7128821634$export$75ab56226e2d3efd = /*#__PURE__*/ (0, $gwFzn.createContext)({
    inline: false
});
const $d399cb7128821634$export$3828d4e780bd54a = ()=>(0, $gwFzn.useContext)($d399cb7128821634$export$75ab56226e2d3efd);

});

parcelRegister("93huM", function(module, exports) {

let $6971f71586de3f85$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6971f71586de3f85$var$load("fhI6j").then(()=>parcelRequire('a58PP'));

});


parcelRegister("guPRT", function(module, exports) {

$parcel$export(module.exports, "DateLozengeFn", () => $b3d700e86f5ab7b3$export$607d2293d1fe73f9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $b3d700e86f5ab7b3$var$AkDateLozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("51pFm")).then((module)=>({
            default: module.Date
        })));
const $b3d700e86f5ab7b3$var$DateLozenge = ({ value: value })=>/*#__PURE__*/ (0, $7UHDa.jsx)($b3d700e86f5ab7b3$var$AkDateLozenge, {
        value: value
    });
var $b3d700e86f5ab7b3$export$2e2bcd8739ae039 = $b3d700e86f5ab7b3$var$DateLozenge;
const $b3d700e86f5ab7b3$export$607d2293d1fe73f9 = ({ props: props })=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($b3d700e86f5ab7b3$var$DateLozenge, {
        value: value
    });
};

});
parcelRegister("51pFm", function(module, exports) {

let $3a80f4799fa64f7c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a80f4799fa64f7c$var$load("4kAUE").then(()=>parcelRequire('1JGUg'));

});


parcelRegister("9gIfM", function(module, exports) {

$parcel$export(module.exports, "DatePickerFn", () => $a50e7fe929d36a1e$export$946840bece97c37);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $2Hm46 = parcelRequire("2Hm46");

var $jBXb2 = parcelRequire("jBXb2");

const $a50e7fe929d36a1e$var$AKDatePicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("hMYa1")).then((module)=>({
            default: module.DatePicker
        })));

const $a50e7fe929d36a1e$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Field
        })));

const $a50e7fe929d36a1e$var$AKHelperMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.HelperMessage
        })));

const $a50e7fe929d36a1e$var$AKErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.ErrorMessage
        })));
const $a50e7fe929d36a1e$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $a50e7fe929d36a1e$export$fa96065c64444af6 = (locale)=>{
    const formatObj = new Intl.DateTimeFormat(locale).formatToParts(new Date());
    return formatObj.map((obj)=>{
        switch(obj.type){
            case 'day':
                return 'DD';
            case 'month':
                return 'MM';
            case 'year':
                return 'YYYY';
            default:
                return obj.value;
        }
    }).join('');
};
const $a50e7fe929d36a1e$var$DatePicker = ({ name: name, label: label, description: description, placeholder: placeholder, defaultValue: defaultValue, isRequired: isRequired })=>{
    const [locale, setLocale] = (0, $gwFzn.useState)('en-US');
    (0, $gwFzn.useEffect)(()=>{
        if (window.navigator.languages && locale !== window.navigator.languages[0]) setLocale(window.navigator.languages[0]);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $jBXb2.FieldContainer), null, /*#__PURE__*/ (0, $3jLHL.jsx)($a50e7fe929d36a1e$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        validate: isRequired ? $a50e7fe929d36a1e$var$validate : undefined
    }, ({ fieldProps: fieldProps, error: error })=>{
        const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onChange: onChange, onFocus: onFocus, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
            name: name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $3jLHL.jsx)($a50e7fe929d36a1e$var$AKDatePicker, {
            id: id,
            isDisabled: isDisabled,
            onBlur: onBlur,
            onFocus: onFocus,
            onChange: onChange,
            value: fieldProps.value || '',
            placeholder: placeholder,
            dateFormat: $a50e7fe929d36a1e$export$fa96065c64444af6(locale),
            isInvalid: isInvalid || Boolean(error),
            "aria-invalid": ariaInvalid,
            "aria-labelledby": ariaLabelledBy
        }), error === 'EMPTY' && /*#__PURE__*/ (0, $3jLHL.jsx)($a50e7fe929d36a1e$var$AKErrorMessage, null, "This field is required."), description && /*#__PURE__*/ (0, $3jLHL.jsx)($a50e7fe929d36a1e$var$AKHelperMessage, null, description));
    }));
};
var $a50e7fe929d36a1e$export$2e2bcd8739ae039 = $a50e7fe929d36a1e$var$DatePicker;
const $a50e7fe929d36a1e$export$946840bece97c37 = ({ props: props })=>{
    const { name: name, label: label, defaultValue: defaultValue, description: description, placeholder: placeholder, isRequired: isRequired } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)($a50e7fe929d36a1e$var$DatePicker, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        description: description,
        placeholder: placeholder,
        isRequired: isRequired
    });
};

});
parcelRegister("jBXb2", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $3d18012f6ad4f2f5$var$boxStyles = (0, $ecnYn.xcss)({
    maxWidth: '100%',
    width: '320px'
});
const $3d18012f6ad4f2f5$export$b5c4b0e7cd7f148b = (props)=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        xcss: $3d18012f6ad4f2f5$var$boxStyles
    }, props.children);
};

});

parcelRegister("hMYa1", function(module, exports) {

let $cf359604bb1605d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cf359604bb1605d5$var$load("hvGeE"),
    $cf359604bb1605d5$var$load("jHT17")
]).then(()=>parcelRequire('8ctJl'));

});


parcelRegister("dVLdn", function(module, exports) {

$parcel$export(module.exports, "FormConditionFn", () => $32b8fbcc01788bcc$export$5063d3d804b7f0da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $5yOga = parcelRequire("5yOga");

var $2Hm46 = parcelRequire("2Hm46");
const $32b8fbcc01788bcc$var$isEqual = (first, second)=>{
    if (first === second) return true;
    if (Array.isArray(first) && Array.isArray(second)) return first.sort().toString() === second.sort().toString();
    return false;
};
const $32b8fbcc01788bcc$var$FormCondition = ({ when: when, is: is, areChildrenPersisted: areChildrenPersisted = false, children: children })=>{
    const formContext = (0, $gwFzn.useContext)((0, $2Hm46.FormContext));
    const shouldShowChildren = $32b8fbcc01788bcc$var$isEqual((0, $5yOga.transformFormValue)(formContext?.formValues[when]), is);
    if (areChildrenPersisted) return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: shouldShowChildren ? 'block' : 'none'
        })
    }, children);
    else return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, shouldShowChildren ? children : null);
};
var $32b8fbcc01788bcc$export$2e2bcd8739ae039 = $32b8fbcc01788bcc$var$FormCondition;
const $32b8fbcc01788bcc$export$5063d3d804b7f0da = ({ props: props, children: children, Components: Components, dispatch: dispatch, render: render, renderChildren: renderChildren })=>{
    const { when: when, is: is, areChildrenPersisted: areChildrenPersisted } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)($32b8fbcc01788bcc$var$FormCondition, {
        when: when,
        is: is,
        areChildrenPersisted: areChildrenPersisted
    }, renderChildren({
        children: children,
        render: render,
        dispatch: dispatch,
        Components: Components
    }));
};

});

parcelRegister("eDXfq", function(module, exports) {

$parcel$export(module.exports, "ImageFn", () => $8f85478b37fe897b$export$f62f254e0954ca34);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $er4dw = parcelRequire("er4dw");

var $kS0x0 = parcelRequire("kS0x0");
const $8f85478b37fe897b$export$baab7c95ad93ac5a = {
    xsmall: '25%',
    small: '37.5%',
    medium: '50%',
    large: '75%',
    xlarge: '100%'
};
function $8f85478b37fe897b$export$2e2bcd8739ae039({ src: src, alt: alt, size: size = 'xlarge' }) {
    const maxWidth = $8f85478b37fe897b$export$baab7c95ad93ac5a[size] || '100%';
    return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 'auto',
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textAlign: 'center'
        },
        src: src,
        alt: alt
    });
}
const $8f85478b37fe897b$export$f62f254e0954ca34 = ({ props: props })=>{
    const { src: src, alt: alt, size: size } = props;
    const isValidUrl = (0, $kS0x0.useIsValidImageUrl)(src);
    if (isValidUrl) return /*#__PURE__*/ (0, $7UHDa.jsx)($8f85478b37fe897b$export$2e2bcd8739ae039, {
        src: src,
        alt: alt,
        size: size
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $er4dw.EgressErrorMessage), {
        url: src
    });
};

});
parcelRegister("er4dw", function(module, exports) {

$parcel$export(module.exports, "EgressErrorMessage", () => $4da241c59eddfab6$export$5cfbc54f19d7d1a4);
/* egressErrorMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gGmck = parcelRequire("gGmck");

var $9aBYD = parcelRequire("9aBYD");

var $5L38b = parcelRequire("5L38b");

var $bP2lm = parcelRequire("bP2lm");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");

const $4da241c59eddfab6$var$AKButton = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3Elmt")));
const $4da241c59eddfab6$var$LinkWithIcon = ({ href: href, text: text })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($4da241c59eddfab6$var$AKButton, {
        iconAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bP2lm))), {
            color: "currentColor",
            label: ""
        }),
        appearance: "link",
        href: href,
        target: "_blank",
        spacing: "none",
        children: text
    });
};
const $4da241c59eddfab6$export$5cfbc54f19d7d1a4 = ({ url: url })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $gwFzn.useContext)((0, $gGmck.RendererContext));
    const dataUriRegex = /^data/;
    const isDataUri = dataUriRegex.test(url);
    if (forgeEnvironment === 'DEVELOPMENT') return /*#__PURE__*/ (0, $7UHDa.jsxs)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        "data-testid": "egress-error-message",
        className: (0, $35pXk.default)([
            "_1e0c1txw _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $35pXk.default)([
                    "_1wpz1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9aBYD))), {
                    label: "",
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $35pXk.default)([
                    "_1reo15vq _18m915vq _1e0c1txw _19bvutpp _syaz9lu1"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        paddingInlineStart: "space.050",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            as: "p",
                            color: "color.text.danger",
                            children: isDataUri ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                                children: [
                                    "Please use the ",
                                    /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
                                        children: "data:image"
                                    }),
                                    " scheme for an image source."
                                ]
                            }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                                children: [
                                    "Egress permissions for ",
                                    /*#__PURE__*/ (0, $7UHDa.jsx)($4da241c59eddfab6$var$LinkWithIcon, {
                                        href: url,
                                        text: url
                                    }),
                                    " missing in the manifest. For more information",
                                    ' ',
                                    /*#__PURE__*/ (0, $7UHDa.jsx)($4da241c59eddfab6$var$LinkWithIcon, {
                                        href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
                                        text: "see reference docs"
                                    }),
                                    "."
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        title: `Unable to display due to an image link issue.`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9aBYD))), {
            label: ""
        })
    });
};

});
parcelRegister("3Elmt", function(module, exports) {

let $2a85ad76e1ee6b4b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2a85ad76e1ee6b4b$var$load("c734x").then(()=>parcelRequire('3z0Mu'));

});


parcelRegister("kS0x0", function(module, exports) {

$parcel$export(module.exports, "useIsValidImageUrl", () => $576cfccaadb64755$export$3a08b61b3ed9a4da);
$parcel$export(module.exports, "isValidImageUrl", () => $576cfccaadb64755$export$6e0a24fd7459483a);

var $gwFzn = parcelRequire("gwFzn");

var $lzcvT = parcelRequire("lzcvT");

var $1c598 = parcelRequire("1c598");

var $lMJg3 = parcelRequire("lMJg3");

var $jIiuI = parcelRequire("jIiuI");
var $gGmck = parcelRequire("gGmck");

var $b7qxC = parcelRequire("b7qxC");
// --------------------------------------------------------------------------------------------------------------------
//
// NOTE: any changes to these hosts MUST BE applied to the Forge Monorepo -- and vice versa.
// See packages/forge-csp/src/csp/csp-injection-service.ts for the original source code.
//
// --------------------------------------------------------------------------------------------------------------------
/**
 * Media API is used to store product attachments.
 * URLs are defined here: https://developer.atlassian.com/platform/media/support/faq/#which-environment-should-i-use-
 */ const $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST = {
    dev: 'https://api.dev.atlassian.com',
    stg: 'https://api.stg.atlassian.com',
    prod: 'https://api.atlassian.com',
    'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST = {
    dev: 'https://media.dev.atl-paas.net',
    stg: 'https://media.staging.atl-paas.net',
    prod: 'https://api.media.atlassian.com',
    'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST = {
    dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
    'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST = {
    dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
    stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
    prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
    'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST = {
    dev: 'https://ptc-directory-sited-static.us-east-1.staging.public.atl-paas.net/gradients/',
    stg: 'https://ptc-directory-sited-static.us-east-1.staging.public.atl-paas.net/gradients/',
    prod: 'https://ptc-directory-sited-static.us-east-1.prod.public.atl-paas.net/gradients/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
/**
 * Atlassian products use Wordpress as a proxy to serve avatar images in certain conditions.
 * Not allowing them by default forces developers to add the `*.wp.com` domain to the CSP image policy.
 * See: https://hello.atlassian.net/wiki/x/XJpuCgE
 */ const $576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS = {
    dev: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['dev']
    ],
    stg: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['stg']
    ],
    prod: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['prod']
    ],
    'fedramp-stg': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-stg']
    ],
    'fedramp-prod': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-prod']
    ]
};
// --------------------------------------------------------------------------------------------------------------------
/**
 * Gravatar is still used internally to serve legacy Atlassian avatars.
 * Unsplash is integrated by default in Confluence to the header image picker functionality.
 */ const $576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
const $576cfccaadb64755$export$189ea7794c50ff15 = (url, iframeDomainName)=>{
    if (!iframeDomainName) return false;
    let imageSrcUrl;
    try {
        imageSrcUrl = new URL(url);
        // Image is valid if it comes from the same domain as the iframe OR if it's being served from localhost (when using forge tunnel)
        return iframeDomainName === imageSrcUrl.host || imageSrcUrl.hostname === 'localhost';
    } catch (e) {
        return false;
    }
};
const $576cfccaadb64755$var$getImageHostsEnvironment = (environment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (environment === (0, $1c598.ProductEnvironment).STAGING) return 'fedramp-stg';
        return 'fedramp-prod';
    }
    return (0, $b7qxC.getCDNEnvironment)(environment);
};
const $576cfccaadb64755$export$3a08b61b3ed9a4da = (url)=>{
    const { egress: egress, appDomainName: appDomainName } = (0, $gwFzn.useContext)((0, $gGmck.RendererContext));
    const environment = (0, $gwFzn.useContext)((0, $jIiuI.EnvironmentContext));
    const imageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironment(environment);
    const allowListedImageHosts = [
        ...$576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS[imageHostsEnvironment],
        ...$576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
    ];
    const egressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', [
        ...egress || [],
        {
            type: 'IMAGES',
            addresses: allowListedImageHosts
        }
    ]);
    return $576cfccaadb64755$export$6e0a24fd7459483a(url, egressService, appDomainName);
};
const $576cfccaadb64755$export$6e0a24fd7459483a = (url, egressService, appDomainName)=>{
    const dataImageUrlRegex = /^data:image/;
    try {
        const isValidUrl = $576cfccaadb64755$export$189ea7794c50ff15(url, appDomainName) || dataImageUrlRegex.test(url) || egressService.isValidUrl(url);
        return isValidUrl;
    } catch (e) {
        return false;
    }
};

});


parcelRegister("t7asT", function(module, exports) {

$parcel$export(module.exports, "InlineDialog", () => $b7e8ee93f9359bd7$export$c7313f750e9cbc9d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2Hm46 = parcelRequire("2Hm46");

var $jXwV2 = parcelRequire("jXwV2");
var $6JQq2 = parcelRequire("6JQq2");
function $b7e8ee93f9359bd7$var$Form(props) {
    const { actions: actions, akFormProps: akFormProps, akSubmitButtonProps: akSubmitButtonProps, children: children, htmlFormProps: htmlFormProps } = (0, $2Hm46.useForm)(props);
    const { key: key, onSubmit: onSubmit } = akFormProps;
    const { children: submitButtonChildren, shouldFitContainer: shouldFitContainer, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: loading, isDisabled: disabled, onClick: onClick, type: type } = akSubmitButtonProps;
    // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
    const { className: className, 'data-testid': dataTestId } = htmlFormProps;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Hm46.AkForm), {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>{
            const { onSubmit: onSubmit, onKeyDown: onKeyDown, ref: ref } = formProps;
            return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            /*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                onSubmit: onSubmit,
                onKeyDown: onKeyDown,
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                "data-testid": dataTestId,
                children: [
                    children,
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Hm46.AkFormFooter), {
                        align: "end",
                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6JQq2.ButtonSet), {
                            children: [
                                actions,
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jXwV2.AkButton), {
                                    shouldFitContainer: shouldFitContainer,
                                    iconBefore: iconBefore,
                                    iconAfter: iconAfter,
                                    isLoading: loading,
                                    isDisabled: disabled,
                                    onClick: onClick,
                                    type: type,
                                    appearance: "primary",
                                    children: submitButtonChildren
                                })
                            ]
                        })
                    })
                ]
            }));
        }
    }, key);
}
function $b7e8ee93f9359bd7$export$a06b1ef8e65f6918({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    if (forgeDoc.children.length === 0) return {
        children: []
    };
    return {
        children: forgeDoc.children[0].type === 'Form' ? /*#__PURE__*/ (0, $7UHDa.jsx)($b7e8ee93f9359bd7$var$Form, {
            forgeDoc: forgeDoc.children[0],
            dispatch: dispatch,
            render: render
        }) : forgeDoc.children.map(render)
    };
}
const $b7e8ee93f9359bd7$export$c7313f750e9cbc9d = (props)=>{
    const { children: children } = $b7e8ee93f9359bd7$export$a06b1ef8e65f6918(props);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: children
    });
};

});

parcelRegister("8uh2I", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $30d941e03f46872c$export$1fa217be60c2f188);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2Hm46 = parcelRequire("2Hm46");

var $jXwV2 = parcelRequire("jXwV2");

var $dh538 = parcelRequire("dh538");

const $30d941e03f46872c$export$d84e15b05040c98 = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9lYhX")));

const $30d941e03f46872c$var$AKModalHeader = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("9ot3w"))));

const $30d941e03f46872c$var$AKModalTitle = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("d8eRd"))));

const $30d941e03f46872c$var$AKModalBody = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("1DHa6"))));

const $30d941e03f46872c$var$AKModalFooter = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8o1lj"))));

const $30d941e03f46872c$var$AKButton = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7CYIQ")));
const $30d941e03f46872c$var$COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
function $30d941e03f46872c$var$applyTopMargin(element) {
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)({
            marginTop: $30d941e03f46872c$var$COMPONENT_TOP_MARGIN
        })
    }, element);
}
function $30d941e03f46872c$export$1e9ab8114847a87d({ forgeDoc: forgeDoc, dispatch: dispatch, render: render }) {
    const intl = (0, $dBxQj.default)();
    const { appearance: appearance, header: header, onClose: onClose, closeButtonText: closeButtonText = intl.formatMessage($30d941e03f46872c$var$messages.closeModalButton), width: width = 'medium' } = forgeDoc.props || {};
    const formForgeDoc = forgeDoc.children.length === 1 && forgeDoc.children[0]?.type === 'Form' ? forgeDoc.children[0] : undefined;
    const [isSubmitting, setIsSubmitting] = (0, $gwFzn.useState)(false);
    const [isClosing, setIsClosing] = (0, $gwFzn.useState)(false);
    const [formValues, setFormValues] = (0, $gwFzn.useState)({});
    const setFormValue = (name, value)=>{
        setFormValues((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const { children: children, akFormProps: akFormProps, htmlFormProps: htmlFormProps, akSubmitButtonProps: akFormSubmitButtonProps } = (0, $2Hm46.useForm)({
        // This is awkward because we only use values if formForgeDoc exists
        // I want to conditionally call this hook but I can't
        forgeDoc: formForgeDoc || {
            type: 'Form',
            children: []
        },
        dispatch: dispatch,
        render: render
    });
    const akFormPropsWithOnSubmit = {
        ...akFormProps,
        onSubmit: async (...args)=>{
            setIsSubmitting(true);
            try {
                await akFormProps.onSubmit(...args);
            } finally{
                setIsSubmitting(false);
            }
        }
    };
    const formId = (0, $gwFzn.useRef)(`modal-form-id-${Date.now()}`);
    const akSubmitButtonProps = {
        ...akFormSubmitButtonProps,
        appearance: appearance || 'primary',
        isLoading: isSubmitting,
        form: formId.current
    };
    const handleClose = async ()=>{
        setIsClosing(true);
        try {
            await dispatch({
                type: 'event',
                handler: onClose,
                args: [],
                extensionData: {}
            });
        } finally{
            setIsClosing(false);
        }
    };
    const actions = formForgeDoc ? formForgeDoc.children.filter((0, $2Hm46.isActionButton)) : [];
    const { akActionButtonProps: akActionButtonProps } = (0, $jXwV2.useActionButtons)({
        forgeDoc: actions,
        dispatch: dispatch,
        render: render
    });
    const { akButtonProps: closeButtonProps } = (0, $jXwV2.useButton)({
        forgeDoc: {
            type: 'Button',
            props: {
                appearance: 'subtle',
                text: closeButtonText,
                onClick: onClose
            },
            children: []
        },
        dispatch: dispatch,
        render: render
    });
    const akCloseButtonProps = {
        ...closeButtonProps,
        isLoading: isClosing || closeButtonProps.isLoading
    };
    return {
        akModalDialogProps: {
            onClose: handleClose,
            width: width
        },
        akModalTitleProps: {
            appearance: appearance,
            children: header
        },
        akModalBodyProps: {
            children: formForgeDoc ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.AkForm), akFormPropsWithOnSubmit, ({ formProps: formProps })=>/*#__PURE__*/ (0, $3jLHL.jsx)("form", {
                    ...formProps,
                    ...htmlFormProps,
                    id: formId.current
                }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormContext).Provider, {
                    value: {
                        formValues: formValues,
                        setFormValue: setFormValue
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child, index)=>index === 0 ? child : $30d941e03f46872c$var$applyTopMargin(child))))) : (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(forgeDoc.children.map(render), (child, index)=>index === 0 ? child : $30d941e03f46872c$var$applyTopMargin(child))
        },
        actions: formForgeDoc ? [
            ...akActionButtonProps,
            akCloseButtonProps,
            akSubmitButtonProps
        ] : [
            akCloseButtonProps
        ]
    };
}
function $30d941e03f46872c$export$1fa217be60c2f188(props) {
    const { akModalDialogProps: akModalDialogProps, akModalTitleProps: akModalTitleProps, akModalBodyProps: akModalBodyProps, actions: actions } = $30d941e03f46872c$export$1e9ab8114847a87d(props);
    const ConditionalSuspense = (0, $dh538.fg)('concurrent-rendering-fix-forge-issue-actions') ? $30d941e03f46872c$var$SuspenseWithNullFallback : (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($30d941e03f46872c$export$d84e15b05040c98, akModalDialogProps, /*#__PURE__*/ (0, $3jLHL.jsx)(ConditionalSuspense, null, /*#__PURE__*/ (0, $3jLHL.jsx)($30d941e03f46872c$var$AKModalHeader, null, /*#__PURE__*/ (0, $3jLHL.jsx)($30d941e03f46872c$var$AKModalTitle, akModalTitleProps)), /*#__PURE__*/ (0, $3jLHL.jsx)($30d941e03f46872c$var$AKModalBody, akModalBodyProps), /*#__PURE__*/ (0, $3jLHL.jsx)($30d941e03f46872c$var$AKModalFooter, null, actions.map((akButtonProps, index)=>/*#__PURE__*/ (0, $3jLHL.jsx)($30d941e03f46872c$var$AKButton, {
            ...akButtonProps,
            key: index
        }))))));
}
// Cleanup when concurrent-rendering-fix-forge-issue-actions is removed
function $30d941e03f46872c$var$SuspenseWithNullFallback({ children: children }) {
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Suspense), {
        fallback: null
    }, children);
}
const $30d941e03f46872c$var$messages = (0, $2nPZH.defineMessages)({
    closeModalButton: {
        id: "confluence.modal.dialog.close.modal.button",
        defaultMessage: "Cancel"
    }
});

});

parcelRegister("7CvHT", function(module, exports) {

$parcel$export(module.exports, "RadioGroupFn", () => $3dee357baf0d8c03$export$306cd3e63a0f2f51);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $2Hm46 = parcelRequire("2Hm46");
const $3dee357baf0d8c03$var$styles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});

const $3dee357baf0d8c03$var$Field = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Field
        })));

const $3dee357baf0d8c03$var$AkRadioGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>Promise.resolve((parcelRequire("lBvGi"))));

const $3dee357baf0d8c03$var$AKHelperMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.HelperMessage
        })));
const $3dee357baf0d8c03$export$a98f0dcb43a68a25 = ({ options: options, defaultValue: defaultValue, isRequired: isRequired, label: label, description: description, name: name })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)($3dee357baf0d8c03$var$Field, {
        defaultValue: defaultValue,
        isRequired: isRequired,
        label: label,
        name: name
    }, ({ fieldProps: fieldProps })=>{
        const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
            name: name,
            value: fieldProps.value
        }), description && /*#__PURE__*/ (0, $3jLHL.jsx)($3dee357baf0d8c03$var$AKHelperMessage, null, description), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: $3dee357baf0d8c03$var$styles
        }, /*#__PURE__*/ (0, $3jLHL.jsx)($3dee357baf0d8c03$var$AkRadioGroup, {
            "test-id": id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            onChange: onChange,
            value: value,
            "aria-labelledby": ariaLabelledBy,
            options: options
        })));
    });
};
const $3dee357baf0d8c03$export$306cd3e63a0f2f51 = ({ props: props, children: children })=>{
    const { label: label, name: name, isRequired: isRequired, description: description } = props;
    let defaultValue;
    const options = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Radio') {
            const { label: label, value: value, defaultChecked: defaultChecked } = props;
            if (defaultChecked) defaultValue = value;
            return {
                name: name,
                label: label,
                value: value
            };
        }
    }).filter((option)=>typeof option !== 'undefined');
    return /*#__PURE__*/ (0, $3jLHL.jsx)($3dee357baf0d8c03$export$a98f0dcb43a68a25, {
        label: label,
        name: name,
        options: options,
        defaultValue: defaultValue,
        description: description,
        isRequired: isRequired
    });
};

});
parcelRegister("lBvGi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56c2dc0faf44f7eb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");

var $c0qxy = parcelRequire("c0qxy");

var $kZ5GD = parcelRequire("kZ5GD");
const $56c2dc0faf44f7eb$var$noOptions = [];
function $56c2dc0faf44f7eb$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $56c2dc0faf44f7eb$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $ee7An.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $c0qxy.useId)();
    const [selectedValue, setSelectedValue] = (0, $gwFzn.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $gwFzn.createElement)((0, $kZ5GD.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("kZ5GD", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d63ff022409480$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $dh538 = parcelRequire("dh538");
const $56d63ff022409480$var$packageName = "platform-pkg";
const $56d63ff022409480$var$packageVersion = "0.0.0-use.local";
const $56d63ff022409480$var$noop = (0, $ee7An.default);
const $56d63ff022409480$var$labelPaddingStyles = null;
const $56d63ff022409480$var$labelStyles = null;
const $56d63ff022409480$var$radioStyles = null;
const $56d63ff022409480$var$newRadioStyles = null;
const $56d63ff022409480$var$InnerRadio = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $56d63ff022409480$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $56d63ff022409480$var$packageName,
        packageVersion: $56d63ff022409480$var$packageVersion
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $35pXk.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syaz1fxt _mqf81lh4 _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $35pXk.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _11511elr _1s6w5w2r _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosi1fvw _11jy1fvw _f3ett94y _19ybs4qr _1d7ps4qr _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4ryasyzs _o1bdsyzs _nxi6syzs _neoesyzs _1el2syzs _lekr13gt _11v713gt _1f8c13gt _s2ft13gt _17a113gt _x48a1lg7 _1ib21lg7 _1yk91lg7 _gdmb1lg7 _pmm41lg7 _y2mv15mc _1bg4jfq9 _6tjk15mc _awqnjfq9 _1rvq1d5g _1p9j1elr _x2tz18hz _1iwz18hz _sj8yr01l _jckogr1v _1dvd1elr _60ak5w2r",
                    (0, $dh538.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $56d63ff022409480$var$Radio = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)($56d63ff022409480$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $56d63ff022409480$export$2e2bcd8739ae039 = $56d63ff022409480$var$Radio;

});



parcelRegister("crMC7", function(module, exports) {

$parcel$export(module.exports, "RangeFn", () => $a39f1476ebe09a75$export$da0b73f16fbcfd59);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $2Hm46 = parcelRequire("2Hm46");

var $jBXb2 = parcelRequire("jBXb2");

const $a39f1476ebe09a75$var$AKRange = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("kBMqU")));

const $a39f1476ebe09a75$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Field
        })));
const $a39f1476ebe09a75$var$Range = ({ defaultValue: defaultValue, min: min = 0, max: max = 100, step: step = 1, label: label, name: name, testId: testId })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $jBXb2.FieldContainer), null, /*#__PURE__*/ (0, $3jLHL.jsx)($a39f1476ebe09a75$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue || min
    }, ({ fieldProps: fieldProps })=>{
        const { isDisabled: isDisabled, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
            name: name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $3jLHL.jsx)($a39f1476ebe09a75$var$AKRange, {
            min: min,
            max: max,
            step: step,
            testId: testId,
            isDisabled: isDisabled,
            value: value,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            "aria-labelledby": ariaLabelledBy
        }));
    }));
};
var $a39f1476ebe09a75$export$2e2bcd8739ae039 = $a39f1476ebe09a75$var$Range;
const $a39f1476ebe09a75$export$da0b73f16fbcfd59 = ({ props: props })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)($a39f1476ebe09a75$var$Range, props);
};

});
parcelRegister("kBMqU", function(module, exports) {

let $f00cd5217a9dce6c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f00cd5217a9dce6c$var$load("iOQWp").then(()=>parcelRequire('liy3y'));

});


parcelRegister("e5sc0", function(module, exports) {

$parcel$export(module.exports, "SectionMessageFn", () => $c0aa0bb1af76a24d$export$8376ed98c8f93829);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $c0aa0bb1af76a24d$var$AKSectionMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6JSOU")));
const $c0aa0bb1af76a24d$export$e06a8392284a8d09 = {
    info: 'information',
    confirmation: 'success',
    change: 'discovery',
    warning: 'warning',
    error: 'error'
};
const $c0aa0bb1af76a24d$var$SectionMessage = ({ title: title, appearance: appearance = 'info', children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c0aa0bb1af76a24d$var$AKSectionMessage, {
        title: title,
        //TODO: Remove this mapping once the forge-ui package is updated to accomodate section-message appearance changes
        appearance: $c0aa0bb1af76a24d$export$e06a8392284a8d09[appearance],
        children: children
    });
};
var $c0aa0bb1af76a24d$export$2e2bcd8739ae039 = $c0aa0bb1af76a24d$var$SectionMessage;
const $c0aa0bb1af76a24d$export$8376ed98c8f93829 = ({ props: props, children: children, Components: Components, render: render, renderChildren: renderChildren, dispatch: dispatch })=>{
    const { title: title, appearance: appearance } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c0aa0bb1af76a24d$var$SectionMessage, {
        title: title,
        appearance: appearance,
        children: renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        })
    });
};

});

parcelRegister("lj4NV", function(module, exports) {

$parcel$export(module.exports, "SelectFn", () => $22effabcab7a648e$export$747c8c62a73d26b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $jBXb2 = parcelRequire("jBXb2");

var $JmaBh = parcelRequire("JmaBh");

var $2Hm46 = parcelRequire("2Hm46");

const $22effabcab7a648e$var$AKFormField = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aJB4a")));

const $22effabcab7a648e$var$AKSelect = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3tmpL")));

const $22effabcab7a648e$var$AKErrorMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.ErrorMessage
        })));

const $22effabcab7a648e$var$AKHelperMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.HelperMessage
        })));
const $22effabcab7a648e$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $22effabcab7a648e$export$ef9b1a59e592288f = ({ options: options, isMulti: isMulti, defaultValue: defaultValue, label: label, name: name, description: description, isRequired: isRequired, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $JmaBh.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $jBXb2.FieldContainer), null, /*#__PURE__*/ (0, $3jLHL.jsx)($22effabcab7a648e$var$AKFormField, {
            defaultValue: defaultValue,
            label: label,
            name: name,
            isRequired: isRequired,
            validate: isRequired ? $22effabcab7a648e$var$validate : undefined
        }, ({ fieldProps: fieldProps, error: error })=>{
            const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
            return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
                name: name,
                value: fieldProps.value
            }), /*#__PURE__*/ (0, $3jLHL.jsx)($22effabcab7a648e$var$AKSelect, {
                id: id,
                isRequired: isRequired,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                value: value,
                "aria-labelledby": ariaLabelledBy,
                isMulti: isMulti,
                menuPortalTarget: portal,
                options: options,
                placeholder: placeholder,
                validationState: error ? 'error' : 'default'
            }), error === 'EMPTY' && /*#__PURE__*/ (0, $3jLHL.jsx)($22effabcab7a648e$var$AKErrorMessage, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), $22effabcab7a648e$var$messages.requiredFieldMessage)), description && /*#__PURE__*/ (0, $3jLHL.jsx)($22effabcab7a648e$var$AKHelperMessage, null, description));
        })));
};
const $22effabcab7a648e$export$747c8c62a73d26b4 = ({ props: props, children: children })=>{
    const { description: description, label: label, name: name, isMulti: isMulti, placeholder: placeholder, isRequired: isRequired } = props;
    let defaultValue = [];
    const options = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Option') {
            const { defaultSelected: defaultSelected, label: label, value: value } = props;
            const option = {
                label: label,
                value: value
            };
            if (defaultSelected) {
                if (isMulti) defaultValue.push(option);
                else defaultValue = [
                    option
                ];
            }
            return option;
        }
    }).filter((option)=>typeof option !== 'undefined');
    const formattedDefaultValue = isMulti ? defaultValue : defaultValue[0];
    return /*#__PURE__*/ (0, $3jLHL.jsx)($22effabcab7a648e$export$ef9b1a59e592288f, {
        label: label,
        name: name,
        options: options,
        isMulti: isMulti,
        isRequired: isRequired,
        defaultValue: formattedDefaultValue,
        description: description,
        placeholder: placeholder
    });
};
const $22effabcab7a648e$var$messages = (0, $2nPZH.defineMessages)({
    requiredFieldMessage: {
        id: "confluence.select.required.field.message",
        defaultMessage: "This field is required."
    }
});

});
parcelRegister("aJB4a", function(module, exports) {

let $7d0adbf33851a492$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d0adbf33851a492$var$load("kGeFl").then(()=>parcelRequire('9IQWX'));

});

parcelRegister("3tmpL", function(module, exports) {

let $28757791d909c81f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $28757791d909c81f$var$load("aQp8v"),
    $28757791d909c81f$var$load("2jsRt"),
    $28757791d909c81f$var$load("69F1b")
]).then(()=>parcelRequire('2QizT'));

});


parcelRegister("1SnA0", function(module, exports) {

$parcel$export(module.exports, "StatusLozengeFn", () => $a9fcfda387e3540d$export$3cc3ebecc7f239e9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $a9fcfda387e3540d$var$AkStatusLozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>Promise.resolve((parcelRequire("aIk0I"))));
const $a9fcfda387e3540d$var$StatusLozenge = ({ appearance: appearance, text: text })=>/*#__PURE__*/ (0, $7UHDa.jsx)($a9fcfda387e3540d$var$AkStatusLozenge, {
        appearance: appearance,
        children: text
    });
var $a9fcfda387e3540d$export$2e2bcd8739ae039 = $a9fcfda387e3540d$var$StatusLozenge;
const $a9fcfda387e3540d$export$3cc3ebecc7f239e9 = ({ props: props })=>{
    const { appearance: appearance, text: text } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a9fcfda387e3540d$var$StatusLozenge, {
        appearance: appearance,
        text: text
    });
};

});

parcelRegister("avcIc", function(module, exports) {

$parcel$export(module.exports, "TabsFn", () => $d6f185b59b4c46eb$export$79714c2052a995e9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4eiUW = parcelRequire("4eiUW");

var $3jLHL = parcelRequire("3jLHL");

var $kRbf2 = parcelRequire("kRbf2");

const $d6f185b59b4c46eb$var$AKTabs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fQ4sN")).then((module)=>({
            default: module.default
        })));

const $d6f185b59b4c46eb$var$AKTab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fQ4sN")).then((module)=>({
            default: module.Tab
        })));

const $d6f185b59b4c46eb$var$AKTabList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fQ4sN")).then((module)=>({
            default: module.TabList
        })));

const $d6f185b59b4c46eb$var$AKTabPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fQ4sN")).then((module)=>({
            default: module.TabPanel
        })));
// Tabs must be stateful so we don't reset to the first tab on re-renders
const $d6f185b59b4c46eb$var$Tabs = ({ tabs: tabs })=>{
    const [selectedIndex, setSelectedIndex] = (0, $gwFzn.useState)(0);
    const id = (0, $gwFzn.useRef)((0, $kRbf2.useUID)());
    return /*#__PURE__*/ (0, $3jLHL.jsx)($d6f185b59b4c46eb$var$AKTabs, {
        selected: selectedIndex,
        onChange: setSelectedIndex,
        id: id.current,
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($d6f185b59b4c46eb$var$AKTabList, null, tabs.map((tab, index)=>/*#__PURE__*/ (0, $3jLHL.jsx)($d6f185b59b4c46eb$var$AKTab, {
            key: index
        }, tab.label))), tabs.map((tab, index)=>/*#__PURE__*/ (0, $3jLHL.jsx)($d6f185b59b4c46eb$var$AKTabPanel, {
            key: index
        }, tab.content)));
};
var $d6f185b59b4c46eb$export$2e2bcd8739ae039 = $d6f185b59b4c46eb$var$Tabs;
const $d6f185b59b4c46eb$export$79714c2052a995e9 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    const tabData = children.map((child)=>{
        const { props: props, type: type } = child;
        if (type === 'Tab') return {
            label: props?.label,
            content: /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4eiUW.default), {
                nonVisibleChildren: null
            }, renderChildren({
                children: child.children,
                dispatch: dispatch,
                Components: Components,
                render: render
            }))
        };
    }).filter((child)=>child != null);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($d6f185b59b4c46eb$var$Tabs, {
        tabs: tabData
    });
};

});
parcelRegister("4eiUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e557af5bc1407d1c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ViewFn", () => $e557af5bc1407d1c$export$9dd2b28001e5a44e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");
const $e557af5bc1407d1c$var$styles = (0, $3jLHL.css)({
    width: 'inherit'
});
const $e557af5bc1407d1c$var$COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
function $e557af5bc1407d1c$var$applyTopMargin(element) {
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)({
            marginTop: $e557af5bc1407d1c$var$COMPONENT_TOP_MARGIN,
            width: 'inherit'
        })
    }, element);
}
const $e557af5bc1407d1c$var$View = ({ children: children, nonVisibleChildren: nonVisibleChildren })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)({
            display: 'flex',
            background: 'transparent',
            flexDirection: 'column',
            padding: 0,
            position: 'relative',
            overflow: 'hidden',
            alignItems: 'flex-start',
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '> *': {
                marginBottom: 0
            }
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child, index)=>index ? $e557af5bc1407d1c$var$applyTopMargin(child) : /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: $e557af5bc1407d1c$var$styles
        }, child)), nonVisibleChildren);
};
var $e557af5bc1407d1c$export$2e2bcd8739ae039 = $e557af5bc1407d1c$var$View;
const $e557af5bc1407d1c$export$9dd2b28001e5a44e = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    const isChildVisible = (type)=>![
            'ModalDialog'
        ].includes(type);
    const nonVisibleChildren = children.filter(({ type: type })=>!isChildVisible(type));
    const visibleChildren = children.filter(({ type: type })=>isChildVisible(type));
    return /*#__PURE__*/ (0, $3jLHL.jsx)($e557af5bc1407d1c$var$View, {
        nonVisibleChildren: renderChildren({
            children: nonVisibleChildren,
            dispatch: dispatch,
            Components: Components,
            render: render
        })
    }, renderChildren({
        children: visibleChildren,
        dispatch: dispatch,
        Components: Components,
        render: render
    }));
};

});

parcelRegister("fQ4sN", function(module, exports) {

let $b87f2cb3cda01fcf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b87f2cb3cda01fcf$var$load("fLGVd").then(()=>parcelRequire('3fhoV'));

});


parcelRegister("1G5pk", function(module, exports) {

$parcel$export(module.exports, "TableFn", () => $f42d8d47d2541350$export$d1aa90943bebe2eb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $10FyV = parcelRequire("10FyV");
const $f42d8d47d2541350$var$styles = (0, $3jLHL.css)({
    alignSelf: 'normal',
    marginBottom: '0px',
    wordBreak: 'initial'
});
const $f42d8d47d2541350$export$54ec01a60f47d33d = ({ head: head, rows: rows, rowsPerPage: rowsPerPage = 15 })=>{
    const [currentPage, setCurrentPage] = (0, $gwFzn.useState)(1);
    // rowsPerPage of 0 is a sentinel value for a fixed size Table
    const isFixedSize = rowsPerPage === 0 || rows.length <= rowsPerPage;
    rowsPerPage = isFixedSize ? Infinity : rowsPerPage;
    function onChange(i) {
        setCurrentPage(i);
    }
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $f42d8d47d2541350$var$styles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $10FyV.default), {
        isFixedSize: isFixedSize,
        rowsPerPage: rowsPerPage,
        page: currentPage,
        onSetPage: onChange,
        head: head,
        rows: rows
    }));
};
const $f42d8d47d2541350$export$d1aa90943bebe2eb = ({ props: props, children: children, dispatch: dispatch, render: render, Components: Components })=>{
    const { rowsPerPage: rowsPerPage } = props;
    const convertRow = (row)=>{
        const cells = row.children.filter((child)=>child.type === 'Cell').map((cell)=>{
            const content = cell.children.map((child)=>{
                return render({
                    aux: child,
                    dispatch: dispatch,
                    Components: Components
                });
            });
            return {
                content: content
            };
        });
        return {
            cells: cells
        };
    };
    const head = children.filter((child)=>child.type === 'Head');
    const headData = head.length > 0 ? convertRow(head[0]) : {
        cells: []
    };
    const rows = children.filter((child)=>child.type === 'Row').map((row)=>convertRow(row));
    return /*#__PURE__*/ (0, $3jLHL.jsx)($f42d8d47d2541350$export$54ec01a60f47d33d, {
        head: headData,
        rows: rows,
        rowsPerPage: rowsPerPage
    });
};

});
parcelRegister("10FyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $061808f38ff72f63$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $061808f38ff72f63$var$AKDynamicTable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("3GbBg")).then((module)=>({
            default: module.DynamicTableStateless
        })));
class $061808f38ff72f63$export$e6dfd72ab29f8598 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    /**
   * There's a bug with Suspense and findDOMNode https://github.com/facebook/react/issues/14188
   * We've opted to catch and ignore the error temporarily while we address the issue in Atlaskit
   * See http:/go/j/FUI-870
   */ componentDidCatch(error) {
        if (error && error.message && (error.message === 'Unable to find node on an unmounted component.' || error.message.startsWith('Minified React error #188;')) && !this.state.retried) this.setState({
            retried: true
        }, ()=>this.setState({
                retried: false
            }));
        else throw error;
    }
    render() {
        const { Component: Component, head: head, isFixedSize: isFixedSize, onSetPage: onSetPage, page: page, rows: rows, rowsPerPage: rowsPerPage } = this.props;
        if (Component) return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            head: head,
            isFixedSize: isFixedSize,
            onSetPage: onSetPage,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage
        });
        else return null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            retried: false
        };
    }
}
const $061808f38ff72f63$var$LazyLoadedTable = (props)=>{
    const { head: head, isFixedSize: isFixedSize, onSetPage: onSetPage, page: page, rows: rows, rowsPerPage: rowsPerPage } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($061808f38ff72f63$export$e6dfd72ab29f8598, {
        Component: $061808f38ff72f63$var$AKDynamicTable,
        head: head,
        isFixedSize: isFixedSize,
        onSetPage: onSetPage,
        page: page,
        rows: rows,
        rowsPerPage: rowsPerPage
    });
};
var $061808f38ff72f63$export$2e2bcd8739ae039 = $061808f38ff72f63$var$LazyLoadedTable;

});
parcelRegister("3GbBg", function(module, exports) {

let $2ade4ad8dde9531b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2ade4ad8dde9531b$var$load("b2tMY").then(()=>parcelRequire('cUOL6'));

});



parcelRegister("hslt5", function(module, exports) {

$parcel$export(module.exports, "TagFn", () => $a07ec5c4d0f3df05$export$3ee92cd923c64da4);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $a07ec5c4d0f3df05$var$AKTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("kXROd")).then((module)=>({
            default: module.SimpleTag
        })));
const $a07ec5c4d0f3df05$var$colorDict = {
    default: 'standard',
    green: 'green',
    blue: 'blue',
    red: 'red',
    purple: 'purple',
    grey: 'grey',
    teal: 'teal',
    yellow: 'yellow',
    'green-light': 'greenLight',
    'blue-light': 'blueLight',
    'red-light': 'redLight',
    'purple-light': 'purpleLight',
    'grey-light': 'greyLight',
    'teal-light': 'tealLight',
    'yellow-light': 'yellowLight'
};
const $a07ec5c4d0f3df05$var$mapColorToAK = (color)=>{
    return $a07ec5c4d0f3df05$var$colorDict[color];
};
const $a07ec5c4d0f3df05$var$Tag = ({ color: color = 'default', text: text })=>{
    const akColor = $a07ec5c4d0f3df05$var$mapColorToAK(color);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a07ec5c4d0f3df05$var$AKTag, {
        color: akColor,
        text: text
    });
};
const $a07ec5c4d0f3df05$export$3ee92cd923c64da4 = ({ props: props })=>{
    const { color: color, text: text } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a07ec5c4d0f3df05$var$Tag, {
        color: color,
        text: text
    });
};
var $a07ec5c4d0f3df05$export$2e2bcd8739ae039 = $a07ec5c4d0f3df05$var$Tag;

});
parcelRegister("kXROd", function(module, exports) {

let $f4330eae683161e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f4330eae683161e8$var$load("6Ue6S").then(()=>parcelRequire('A6kZA'));

});


parcelRegister("aYIpJ", function(module, exports) {

$parcel$export(module.exports, "TagGroupFn", () => $3d126440aa917d8a$export$95fa80966968aa57);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $3d126440aa917d8a$var$AKTagGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("iP7Jf")));
const $3d126440aa917d8a$var$TagGroup = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($3d126440aa917d8a$var$AKTagGroup, {
        children: children
    });
};
var $3d126440aa917d8a$export$2e2bcd8739ae039 = $3d126440aa917d8a$var$TagGroup;
const $3d126440aa917d8a$export$95fa80966968aa57 = ({ children: children, dispatch: dispatch, Components: Components, render: render, renderChildren: renderChildren })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($3d126440aa917d8a$var$TagGroup, {
        children: renderChildren({
            children: children,
            dispatch: dispatch,
            Components: Components,
            render: render
        })
    });
};

});
parcelRegister("iP7Jf", function(module, exports) {

let $db42fc2e68fec836$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $db42fc2e68fec836$var$load("hBcQv").then(()=>parcelRequire('kDUfG'));

});


parcelRegister("iBL5y", function(module, exports) {

$parcel$export(module.exports, "TextFn", () => $a832f0cd6ed31fad$export$c703e634d6a416c6);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $1c598 = parcelRequire("1c598");

var $9UyM5 = parcelRequire("9UyM5");

var $5dK2X = parcelRequire("5dK2X");
function $a832f0cd6ed31fad$export$e56c262d45d65d3f(text) {
    return text.split(/\s*\n\s*\n[\n\s]*/).filter((str)=>str.length > 0);
}
function $a832f0cd6ed31fad$export$cc54e21c3860db3d({ content: content }) {
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", null, $a832f0cd6ed31fad$export$e56c262d45d65d3f(content).map((paragraph, i)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $5dK2X.default), {
            as: "p",
            key: i
        }, paragraph)));
}
const $a832f0cd6ed31fad$var$ALIGN_ALLOWLIST = [
    'start',
    'center',
    'end'
];
const $a832f0cd6ed31fad$var$isTextAlign = (align)=>{
    return $a832f0cd6ed31fad$var$ALIGN_ALLOWLIST.includes(align);
};
function $a832f0cd6ed31fad$export$8af001e2d8bdb181(align) {
    if ($a832f0cd6ed31fad$var$isTextAlign(align)) return align;
    else return 'start';
}
function $a832f0cd6ed31fad$export$a4f87e7f51175d99({ children: children, align: align }) {
    const sanitizedAlign = $a832f0cd6ed31fad$export$8af001e2d8bdb181(align);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9UyM5.InlineContext).Provider, {
        value: {
            inline: true
        }
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            textAlign: sanitizedAlign
        })
    }, children));
}
function $a832f0cd6ed31fad$var$filterMarkup(children, nested) {
    const isNestable = (child)=>(0, $1c598.MarkupRecursiveList).some((x)=>child.type === x);
    const isInline = (child)=>(0, $1c598.MarkupList).some((x)=>child.type === x);
    return children.map((child)=>{
        if (nested) {
            if (!isNestable(child)) return null;
        } else {
            if (!isInline(child)) return null;
        }
        return {
            ...child,
            children: $a832f0cd6ed31fad$var$filterMarkup(child.children, true)
        };
    }).filter((x)=>x !== null);
}
function $a832f0cd6ed31fad$export$e64c089f4186fe76({ Components: Components, children: children, align: align, dispatch: dispatch, render: render, renderChildren: renderChildren }) {
    // filter non Markup components
    children = $a832f0cd6ed31fad$var$filterMarkup(children, false);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($a832f0cd6ed31fad$export$a4f87e7f51175d99, {
        align: align
    }, renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    }));
}
function $a832f0cd6ed31fad$export$c703e634d6a416c6({ props: props, children: children, type: type, dispatch: dispatch, render: render, renderChildren: renderChildren, Components: Components }) {
    const { content: content, format: format } = props;
    if (typeof content === 'string') return /*#__PURE__*/ (0, $3jLHL.jsx)($a832f0cd6ed31fad$export$cc54e21c3860db3d, {
        content: content
    });
    if (format === 'markup') {
        const { align: align } = props;
        return $a832f0cd6ed31fad$export$e64c089f4186fe76({
            children: children,
            align: align,
            type: type,
            dispatch: dispatch,
            render: render,
            renderChildren: renderChildren,
            Components: Components
        });
    }
    // otherwise, do nothing
    return null;
}

});

parcelRegister("1KTym", function(module, exports) {

$parcel$export(module.exports, "TextAreaFn", () => $e6aaecc72491f49a$export$7c39c70ba43929a0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $jBXb2 = parcelRequire("jBXb2");

var $2Hm46 = parcelRequire("2Hm46");

const $e6aaecc72491f49a$var$AkFormField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Field
        })));

const $e6aaecc72491f49a$var$AKTextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("ijA12")));

const $e6aaecc72491f49a$var$AKErrorMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.ErrorMessage
        })));

const $e6aaecc72491f49a$var$AKHelperMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.HelperMessage
        })));
const $e6aaecc72491f49a$var$validate = (value)=>!value ? 'EMPTY' : undefined;
const $e6aaecc72491f49a$var$TextArea = (props)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $jBXb2.FieldContainer), null, /*#__PURE__*/ (0, $3jLHL.jsx)($e6aaecc72491f49a$var$AkFormField, {
        name: props.name,
        label: props.label,
        defaultValue: props.defaultValue,
        isRequired: props.isRequired,
        validate: props.isRequired ? $e6aaecc72491f49a$var$validate : undefined
    }, ({ fieldProps: fieldProps, error: error })=>{
        const { id: id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
            name: props.name,
            value: fieldProps.value
        }), /*#__PURE__*/ (0, $3jLHL.jsx)($e6aaecc72491f49a$var$AKTextArea, {
            id: id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            value: value,
            "aria-labelledby": ariaLabelledBy,
            appearance: "standard",
            resize: "smart",
            minimumRows: 2,
            isMonospaced: props.isMonospaced,
            placeholder: props.placeholder,
            spellCheck: props.spellCheck
        }), error === 'EMPTY' && /*#__PURE__*/ (0, $3jLHL.jsx)($e6aaecc72491f49a$var$AKErrorMessage, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), $e6aaecc72491f49a$var$messages.requiredFieldMessage)), props.description && /*#__PURE__*/ (0, $3jLHL.jsx)($e6aaecc72491f49a$var$AKHelperMessage, null, props.description));
    }));
var $e6aaecc72491f49a$export$2e2bcd8739ae039 = $e6aaecc72491f49a$var$TextArea;
const $e6aaecc72491f49a$export$7c39c70ba43929a0 = ({ props: props })=>{
    const { name: name, label: label, defaultValue: defaultValue, isMonospaced: isMonospaced, isRequired: isRequired, description: description, placeholder: placeholder, spellCheck: spellCheck } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)($e6aaecc72491f49a$var$TextArea, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isMonospaced: isMonospaced,
        isRequired: isRequired,
        placeholder: placeholder,
        description: description,
        spellCheck: spellCheck
    });
};
const $e6aaecc72491f49a$var$messages = (0, $2nPZH.defineMessages)({
    requiredFieldMessage: {
        id: "confluence.text.area.required.field.message",
        defaultMessage: "This field is required."
    }
});

});
parcelRegister("ijA12", function(module, exports) {

let $d555f0540a84275c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d555f0540a84275c$var$load("32YGB").then(()=>parcelRequire('jQy0H'));

});


parcelRegister("bmkqA", function(module, exports) {

$parcel$export(module.exports, "TextFieldFn", () => $fc4f6995b570b23c$export$13e56753353ca8c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $4gNgx = parcelRequire("4gNgx");

var $2Hm46 = parcelRequire("2Hm46");

var $jBXb2 = parcelRequire("jBXb2");

const $fc4f6995b570b23c$var$AKTextField = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("c5Tad")));

const $fc4f6995b570b23c$var$AKErrorMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.ErrorMessage
        })));

const $fc4f6995b570b23c$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Field
        })));

const $fc4f6995b570b23c$var$AKHelperMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.HelperMessage
        })));
const $fc4f6995b570b23c$var$isValidType = (type)=>{
    return [
        'text',
        'number',
        'email',
        'tel',
        'password'
    ].includes(type);
};
function $fc4f6995b570b23c$var$TextField({ type: type = 'text', name: name, label: label, description: description, placeholder: // description about the field
placeholder, isRequired: isRequired = false, defaultValue: defaultValue = '', testId: testId, autoComplete: autoComplete }) {
    const validate = (0, $4gNgx.makeValidate)(isRequired, type);
    // WARNING: for <input type=number> and React, native validation is strange, use type text
    const fieldType = !$fc4f6995b570b23c$var$isValidType(type) || type === 'number' ? 'text' : type;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $jBXb2.FieldContainer), null, /*#__PURE__*/ (0, $3jLHL.jsx)($fc4f6995b570b23c$var$AKField, {
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        validate: validate
    }, ({ fieldProps: fieldProps })=>{
        const { id: id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, value: value, onChange: onChange, 'aria-labelledby': ariaLabelledBy } = fieldProps;
        const error = isInvalid ? validate(value) : null;
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
            name: name,
            value: value
        }), /*#__PURE__*/ (0, $3jLHL.jsx)($fc4f6995b570b23c$var$AKTextField, {
            type: fieldType,
            testId: testId,
            placeholder: placeholder,
            autoComplete: autoComplete,
            onFocus: onFocus,
            onBlur: onBlur,
            isDisabled: isDisabled,
            id: id,
            isInvalid: isInvalid,
            "aria-labelledby": ariaLabelledBy,
            defaultValue: defaultValue,
            onChange: onChange
        }), error ? /*#__PURE__*/ (0, $3jLHL.jsx)($fc4f6995b570b23c$var$AKErrorMessage, null, error) : null, description ? /*#__PURE__*/ (0, $3jLHL.jsx)($fc4f6995b570b23c$var$AKHelperMessage, null, description) : null);
    }));
}
var $fc4f6995b570b23c$export$2e2bcd8739ae039 = $fc4f6995b570b23c$var$TextField;
const $fc4f6995b570b23c$export$13e56753353ca8c = ({ props: props })=>{
    const { name: name, label: label, type: type, description: description, defaultValue: defaultValue, isRequired: isRequired, placeholder: placeholder, autoComplete: autoComplete } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)($fc4f6995b570b23c$var$TextField, {
        type: type,
        name: name,
        label: label,
        defaultValue: defaultValue,
        isRequired: isRequired,
        description: description,
        placeholder: placeholder,
        autoComplete: autoComplete
    });
};

});
parcelRegister("4gNgx", function(module, exports) {

$parcel$export(module.exports, "makeValidate", () => $160238b3cd7f3114$export$175ffc4a72fd9f6d);
// eslint-disable-next-line import/no-extraneous-dependencies

var $5vllt = parcelRequire("5vllt");

var $hlhtG = parcelRequire("hlhtG");
var $jaEJa = parcelRequire("jaEJa");
var $2nPZH = parcelRequire("2nPZH");
const $160238b3cd7f3114$var$cache = (0, $jaEJa.createIntlCache)();
const $160238b3cd7f3114$var$defaultIntl = (0, $hlhtG.createIntl)({
    locale: 'en'
}, $160238b3cd7f3114$var$cache);
function $160238b3cd7f3114$export$7e4aa119212bc614(value, propIntl) {
    const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5vllt)))(value) ? undefined : formatMessage($160238b3cd7f3114$var$messages.validNumber);
}
function $160238b3cd7f3114$export$7fbbfbca30081d0(value, propIntl) {
    const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    if (typeof value === 'string' && /@/.test(value)) return;
    // return 'Enter a valid email.';
    return formatMessage($160238b3cd7f3114$var$messages.validEmail);
}
function $160238b3cd7f3114$export$d7aad9be675cc63d(value, propIntl) {
    const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
    const { formatMessage: formatMessage } = intl;
    if (typeof value === 'string' && /[0-9]/.test(value)) return;
    // return 'Enter a valid telephone.';
    return formatMessage($160238b3cd7f3114$var$messages.validTelephone);
}
const $160238b3cd7f3114$var$Validators = {
    email: $160238b3cd7f3114$export$7fbbfbca30081d0,
    number: $160238b3cd7f3114$export$7e4aa119212bc614,
    tel: $160238b3cd7f3114$export$d7aad9be675cc63d
};
function $160238b3cd7f3114$export$175ffc4a72fd9f6d(isRequired, type, propIntl) {
    return function Validate(value) {
        const intl = propIntl ? propIntl : $160238b3cd7f3114$var$defaultIntl;
        const { formatMessage: formatMessage } = intl;
        const isEmpty = typeof value === 'string' && value.length === 0;
        if (isRequired && isEmpty) // return 'This field is required.';
        return formatMessage($160238b3cd7f3114$var$messages.requiredFieldMessage);
        if (isEmpty) return;
        const isType = type in $160238b3cd7f3114$var$Validators ? $160238b3cd7f3114$var$Validators[type] : undefined;
        return isType ? isType(value, propIntl) : undefined;
    };
}
const $160238b3cd7f3114$var$messages = (0, $2nPZH.defineMessages)({
    validNumber: {
        id: "confluence.textfield.validator.number",
        defaultMessage: "Enter a valid number"
    },
    validEmail: {
        id: "confluence.textfield.validator.email",
        defaultMessage: "Enter a valid email."
    },
    validTelephone: {
        id: "confluence.textfield.validator.telephone",
        defaultMessage: "Enter a valid telephone."
    },
    requiredFieldMessage: {
        id: "confluence.textfield.validator.required.field.message",
        defaultMessage: "This field is required."
    }
});

});

parcelRegister("c5Tad", function(module, exports) {

let $8ce0be06e523ace8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8ce0be06e523ace8$var$load("1zUjn").then(()=>parcelRequire('7ycLr'));

});


parcelRegister("cxqzX", function(module, exports) {

$parcel$export(module.exports, "ToggleFn", () => $b7e773ce945c54b2$export$65f25b46bc78faae);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $2Hm46 = parcelRequire("2Hm46");

const $b7e773ce945c54b2$var$AKToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("89IVP")).then((module)=>({
            default: module.default
        })));

const $b7e773ce945c54b2$var$AKField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Field
        })));
const $b7e773ce945c54b2$var$wrapperStyles = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'center'
});
const $b7e773ce945c54b2$var$labelStyles = (0, $3jLHL.css)({
    cursor: 'pointer'
});
const $b7e773ce945c54b2$var$Toggle = ({ name: name, defaultChecked: defaultChecked, testId: testId, label: label })=>/*#__PURE__*/ (0, $3jLHL.jsx)($b7e773ce945c54b2$var$AKField, {
        defaultValue: defaultChecked,
        name: name
    }, ({ fieldProps: fieldProps })=>{
        const { onChange: onChange, value: value, id: id, isDisabled: isDisabled, onBlur: onBlur, onFocus: onFocus, name: toggleName } = fieldProps;
        return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: $b7e773ce945c54b2$var$wrapperStyles
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Hm46.FormStateChangeNotifier), {
            name: name,
            value: value
        }), /*#__PURE__*/ (0, $3jLHL.jsx)($b7e773ce945c54b2$var$AKToggle, {
            onChange: onChange,
            isChecked: value,
            size: "large",
            label: label,
            testId: testId,
            id: id,
            isDisabled: isDisabled,
            onBlur: onBlur,
            onFocus: onFocus,
            name: toggleName
        }), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
            css: $b7e773ce945c54b2$var$labelStyles,
            onClick: ()=>onChange(!value)
        }, label));
    });
var $b7e773ce945c54b2$export$2e2bcd8739ae039 = $b7e773ce945c54b2$var$Toggle;
const $b7e773ce945c54b2$export$65f25b46bc78faae = ({ props: props })=>{
    const { name: name, label: label, defaultChecked: defaultChecked } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)($b7e773ce945c54b2$var$Toggle, {
        name: name,
        label: label,
        defaultChecked: defaultChecked
    });
};

});
parcelRegister("89IVP", function(module, exports) {

let $5f0204790ae7140b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5f0204790ae7140b$var$load("iXv73").then(()=>parcelRequire('ju5RD'));

});


parcelRegister("SiAOO", function(module, exports) {

$parcel$export(module.exports, "TooltipFn", () => $32a10de568a6c426$export$243693318987dcde);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $32a10de568a6c426$var$AKTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("ll9v3")));
const $32a10de568a6c426$var$Tooltip = ({ text: text, children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)($32a10de568a6c426$var$AKTooltip, {
        content: text,
        children: children
    });
var $32a10de568a6c426$export$2e2bcd8739ae039 = $32a10de568a6c426$var$Tooltip;
const $32a10de568a6c426$export$243693318987dcde = ({ props: props, children: children, Components: Components, render: render, renderChildren: renderChildren, dispatch: dispatch })=>{
    const { text: text } = props;
    const renderedChildren = renderChildren({
        Components: Components,
        children: children,
        render: render,
        dispatch: dispatch
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($32a10de568a6c426$var$Tooltip, {
        text: text,
        children: Array.isArray(renderedChildren) ? renderedChildren[0] : renderedChildren
    });
};

});
parcelRegister("ll9v3", function(module, exports) {

let $f892eda0b8a90910$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f892eda0b8a90910$var$load("1UoOL").then(()=>parcelRequire('3iYvl'));

});


parcelRegister("kgtKy", function(module, exports) {

$parcel$export(module.exports, "HeadingFn", () => $c7292c6d1b431c1a$export$fad8cd1e3bc5cd8a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7hXDW = parcelRequire("7hXDW");
function $c7292c6d1b431c1a$export$a8a3e93435678ff9({ size: size = 'medium', children: children }) {
    if (size === 'large') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        size: "xlarge",
        children: children
    });
    if (size === 'small') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        size: "xsmall",
        children: children
    });
    // size === 'medium'
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        size: "medium",
        children: children
    });
}
var $c7292c6d1b431c1a$export$2e2bcd8739ae039 = $c7292c6d1b431c1a$export$a8a3e93435678ff9;
function $c7292c6d1b431c1a$export$fad8cd1e3bc5cd8a({ Components: Components, props: props, children: children, renderChildren: renderChildren, dispatch: dispatch, render: render }) {
    const { size: size } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c7292c6d1b431c1a$export$a8a3e93435678ff9, {
        size: size,
        children: renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        })
    });
}

});

parcelRegister("7Ncdf", function(module, exports) {

$parcel$export(module.exports, "upgradeComponent", () => $b88d3552b5359800$export$d3f7e791718dec1c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");
const $b88d3552b5359800$export$56cc4e6ad1676196 = (0, $csnse.default)((dispatch)=>(legacyEffects)=>{
        return Promise.all((Array.isArray(legacyEffects) ? legacyEffects : [
            legacyEffects
        ]).map((legacyEffect)=>{
            switch(legacyEffect.type){
                case 'initialize':
                    return dispatch({
                        type: 'render',
                        extensionData: {}
                    });
                case 'event':
                    return dispatch({
                        type: 'event',
                        handler: legacyEffect.handler,
                        args: legacyEffect.args,
                        extensionData: {}
                    });
                default:
                    throw Error(`Cannot dispatch "${legacyEffect.type}" effect`);
            }
        })).then(()=>{});
    });
const $b88d3552b5359800$export$d3f7e791718dec1c = (Comp)=>({ forgeDoc: forgeDoc, render: render, dispatch: dispatch })=>{
        const { children: children, key: key, props: props, type: type } = forgeDoc;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Comp, {
            type: type,
            props: props,
            dispatch: $b88d3552b5359800$export$56cc4e6ad1676196(dispatch),
            children: children,
            Components: {} /* no components actually use this component map */ ,
            render: (props)=>render(props.aux),
            renderChildren: (props)=>props.children.map(render)
        }, key);
    };

});


parcelRegister("7PBQ9", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7d5c5ef067e646f8$export$ffb0004e005737fa);
$parcel$export(module.exports, "Root", () => $7d5c5ef067e646f8$export$be92b6f5f03c0fe9);
/* internalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $7d5c5ef067e646f8$export$ffb0004e005737fa = ({ forgeDoc: forgeDoc, render: render })=>/*#__PURE__*/ (0, $7UHDa.jsx)($gwFzn.Fragment, {
        children: forgeDoc.children.map(render)
    });
const $7d5c5ef067e646f8$export$be92b6f5f03c0fe9 = ({ forgeDoc: forgeDoc, render: render })=>{
    const { children: children } = forgeDoc;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_1qhqze3t _1jzaze3t _1bgsze3t _9b1aze3t _cog4ze3t _1gbhze3t"
        ]),
        children: children.map(render)
    });
};

});

parcelRegister("2x8cJ", function(module, exports) {

$parcel$export(module.exports, "RendererNext", () => $6c27856e6e241b8f$export$c18f98553e983d72);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1c598 = parcelRequire("1c598");

var $67L2Z = parcelRequire("67L2Z");

var $dh538 = parcelRequire("dh538");

var $5dK2X = parcelRequire("5dK2X");

var $6dtqn = parcelRequire("6dtqn");

var $gmD98 = parcelRequire("gmD98");

var $gGmck = parcelRequire("gGmck");

var $aoVih = parcelRequire("aoVih");

var $1nSBE = parcelRequire("1nSBE");

var $ahOA5 = parcelRequire("ahOA5");
const $6c27856e6e241b8f$export$2ab0bd25ebac8996 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>{
    return new Promise(()=>{});
});
const $6c27856e6e241b8f$export$7a0a827f8287b06d = (componentType, forgeEnvironment)=>{
    if (forgeEnvironment === 'PRODUCTION') return;
    if (componentType === 'Heading') (0, $1nSBE.default)(`[@forge/react: Heading] Warning: The functionality of the "as" prop is being updated and should no longer be used to determine heading sizes. To avoid breaking changes, migrate to using the "size" prop. For more details, visit: https://atlassian.design/components/heading`);
};
const $6c27856e6e241b8f$export$21a8719ce41a1de2 = (componentMap, componentType)=>{
    if (componentType === 'User' || componentType === 'Avatar') return componentMap['User'] || componentMap['Avatar'];
    if (componentType === 'UserGroup' || componentType === 'AvatarStack') return componentMap['UserGroup'] || componentMap['AvatarStack'];
    return componentMap[componentType];
};
const $6c27856e6e241b8f$var$isAlignFormButtonsEnd = (extensionType, forgeDoc)=>{
    // Confluence Byline and ContextMenu Forge apps with a Form component as
    // there only child shifts the form buttons to the end in the footer
    return (extensionType === (0, $1c598.ConfluenceExtension).BYLINE || extensionType === (0, $1c598.ConfluenceExtension).CONTEXT_MENU) && forgeDoc.children[0]?.type === 'Form';
};
const $6c27856e6e241b8f$var$forgeDocWithModalComponent = (forgeDoc, modalExtension)=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalWidth, onSubmitSuccess: onSubmitSuccess } = modalExtension;
    // ModalDialog component sets the default width to `medium`
    const akModalWidth = modalWidth ? (0, $6dtqn.getAkModalWidth)(modalWidth) : undefined;
    const forgeDocWithModal = {
        ...forgeDoc,
        children: [
            {
                type: 'ModalDialog',
                props: {
                    onClose: closeModalExtension,
                    header: title,
                    width: akModalWidth,
                    onSubmitSuccess: onSubmitSuccess
                },
                children: forgeDoc.children
            }
        ]
    };
    return forgeDocWithModal;
};
const $6c27856e6e241b8f$var$forgeDocWithFormEndButtons = (forgeDoc)=>{
    if (forgeDoc.children.length === 0) return forgeDoc;
    return {
        ...forgeDoc,
        children: [
            {
                ...forgeDoc.children[0],
                props: {
                    ...forgeDoc.children[0].props,
                    alignFooterButtons: 'end'
                }
            }
        ]
    };
};
const $6c27856e6e241b8f$export$c18f98553e983d72 = ({ forgeDoc: forgeDoc, loading: loading = false, error: error, customRenderErrorFn: customRenderErrorFn, components: components, dispatch: dispatch, modalExtension: modalExtension, extensionType: extensionType, isNative: isNative, onSuccess: onSuccess, client: client, extension: extension })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $gwFzn.useContext)((0, $gGmck.RendererContext));
    (0, $gmD98.useSendNodeCountAnalytics)({
        forgeDoc: forgeDoc,
        forgeEnvironment: forgeEnvironment ?? 'DEVELOPMENT',
        UIKitVersion: isNative ? '2' : '1'
    });
    const render = (forgeDoc)=>{
        $6c27856e6e241b8f$export$7a0a827f8287b06d(forgeDoc.type, forgeEnvironment ?? 'DEVELOPMENT');
        const renderFn = $6c27856e6e241b8f$export$21a8719ce41a1de2(components, forgeDoc.type);
        if (!renderFn) {
            if (customRenderErrorFn) customRenderErrorFn(forgeDoc.type);
            else throw new Error(`Error rendering app - encountered unknown component ${forgeDoc.type}.`);
        }
        onSuccess && onSuccess();
        return renderFn({
            forgeDoc: forgeDoc,
            dispatch: dispatch,
            render: render
        });
    };
    // true while fetching initial forgeDoc
    if (!(0, $dh538.fg)('fix-react-18-concurrent-upgrade-infinite-rendering')) {
        if (loading && !forgeDoc) return /*#__PURE__*/ (0, $7UHDa.jsx)($6c27856e6e241b8f$export$2ab0bd25ebac8996, {});
    }
    if (error) return modalExtension ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ahOA5.ForgeExtensionPointModal), {
        modalExtension: modalExtension,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
            title: "Something went wrong",
            appearance: "error",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                children: error
            })
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
        title: "Something went wrong",
        appearance: "error",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            children: error
        })
    });
    if (!forgeDoc) return null;
    // Extensions rendered in a modal for version 10 and onwards are handled here.
    // This is the default behavior for handles model extensions across product modules.
    // When the modelExtension prop is present, and the forgeReactMajorVersion is 10 or higher,
    // the provided foreDoc is rendered within a Modal component with the provided modalExtension props.
    // This setup is to ensure that the modal extension is rendered correctly across all product modules,
    // and is the resolution for the HOT described in: https://ops.internal.atlassian.com/jira/browse/HOT-108146
    if (forgeDoc.forgeReactMajorVersion && forgeDoc.forgeReactMajorVersion >= 10 && modalExtension) {
        const isFirstChildAForm = forgeDoc.children[0]?.type === 'Form';
        const { onSubmitSuccess: onSubmitSuccess } = modalExtension;
        // injects onSubmitSuccess to into the Form component submit handler
        if (isFirstChildAForm) {
            // doing a deep clone here to make a copy of onSubmit
            const formPropsCopy = (0, (/*@__PURE__*/$parcel$interopDefault($67L2Z)))(forgeDoc.children[0].props);
            forgeDoc.children[0].props = {
                ...formPropsCopy,
                onSubmit: async ()=>{
                    const isSuccess = await formPropsCopy.onSubmit();
                    if (onSubmitSuccess && (isSuccess === true || isSuccess === undefined)) onSubmitSuccess();
                }
            };
        }
        const shouldShowFCFModalDeprecationMessage = (0, $dh538.fg)('forge_fcf_modal_exp_deprecation_notice') && (extensionType === (0, $1c598.JiraExtension).CUSTOM_FIELD || extensionType === (0, $1c598.JiraExtension).CUSTOM_FIELD_TYPE);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ahOA5.ForgeExtensionPointModal), {
            modalExtension: modalExtension,
            shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage,
            client: client,
            extension: extension,
            children: render(forgeDoc)
        });
    }
    const newForgeDoc = extensionType && $6c27856e6e241b8f$var$isAlignFormButtonsEnd(extensionType, forgeDoc) ? $6c27856e6e241b8f$var$forgeDocWithFormEndButtons(forgeDoc) : forgeDoc;
    const extensionForgeDoc = modalExtension ? $6c27856e6e241b8f$var$forgeDocWithModalComponent(newForgeDoc, modalExtension) : newForgeDoc;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: render(extensionForgeDoc)
    });
};

});
parcelRegister("6dtqn", function(module, exports) {

$parcel$export(module.exports, "getAkModalWidth", () => $45525d017f0a28c8$export$6349e632801bcc0c);
const $45525d017f0a28c8$export$6349e632801bcc0c = (modalSize)=>{
    switch(modalSize){
        case 'xlarge':
            return 'x-large';
        case 'max':
            return '100%';
        default:
            return modalSize;
    }
};

});

parcelRegister("gmD98", function(module, exports) {

$parcel$export(module.exports, "useSendNodeCountAnalytics", () => $19eebf227db1d91e$export$a0feef3ec4af33b4);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $6oQb1 = parcelRequire("6oQb1");

var $5U2YR = parcelRequire("5U2YR");

var $dh538 = parcelRequire("dh538");
const $19eebf227db1d91e$export$5f39eab89195003c = (doc, componentCountMap)=>{
    if (!doc.props) return;
    Object.keys(doc.props).forEach((propName)=>{
        if (propName === 'children') return;
        const componentName = doc.type;
        if (componentCountMap[componentName].propCount[propName] !== undefined) componentCountMap[componentName].propCount[propName] += 1;
        else componentCountMap[componentName].propCount[propName] = 1;
    });
};
const $19eebf227db1d91e$var$getIconInformation = (doc, componentCountMap)=>{
    if (doc.type !== 'Icon' || !doc.props) return;
    const { glyph: glyph, primaryColor: primaryColor, secondaryColor: secondaryColor } = doc.props;
    if (!componentCountMap.Icon.uniqueGlyphs) componentCountMap.Icon.uniqueGlyphs = new Set();
    if (glyph) componentCountMap.Icon.uniqueGlyphs.add(glyph);
    // TODO: Stop tracking these props once they have been removed from the code base
    // https://ecosystem-platform.atlassian.net/browse/EXT-3350
    if (!componentCountMap.Icon.deprecatedPropsList) componentCountMap.Icon.deprecatedPropsList = new Set();
    if (primaryColor) componentCountMap.Icon.deprecatedPropsList.add('primaryColor');
    if (secondaryColor) componentCountMap.Icon.deprecatedPropsList.add('secondaryColor');
};
// Recursive function to get the total number of components and total number of props on a component
const $19eebf227db1d91e$var$getCountAnalytics = (forgeDoc, componentCountMap = {}, visitors = [])=>{
    const componentName = forgeDoc.type;
    // Type String is not a component
    if (componentName === 'String') return componentCountMap;
    // Don't send Root count as it's always one
    if (componentName !== 'Root') {
        const hasComponentEncountered = componentCountMap[componentName] !== undefined;
        if (hasComponentEncountered) componentCountMap[componentName].componentCount += 1;
        else componentCountMap[componentName] = {
            componentCount: 1,
            propCount: {}
        };
        // Call all visitor functions
        visitors.forEach((visitor)=>{
            visitor(forgeDoc, componentCountMap);
        });
    }
    forgeDoc.children.forEach((forgeDocChild)=>{
        $19eebf227db1d91e$var$getCountAnalytics(forgeDocChild, componentCountMap, visitors);
    });
    return componentCountMap;
};
const $19eebf227db1d91e$var$createKey = (countMap)=>{
    let key = '';
    Object.keys(countMap).sort().forEach((componentName)=>{
        key += `${componentName}${countMap[componentName].componentCount}`;
    });
    return key;
};
const $19eebf227db1d91e$export$a0feef3ec4af33b4 = ({ forgeDoc: forgeDoc, forgeEnvironment: forgeEnvironment, UIKitVersion: UIKitVersion })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const prevCountMap = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef({});
    if (forgeDoc === undefined) return;
    const componentCount = $19eebf227db1d91e$var$getCountAnalytics(forgeDoc, {}, (0, $dh538.fg)('track-icon-glyph-deprecated-props-usage') ? [
        $19eebf227db1d91e$export$5f39eab89195003c,
        $19eebf227db1d91e$var$getIconInformation
    ] : [
        $19eebf227db1d91e$export$5f39eab89195003c
    ]);
    const componentCountAsKey = $19eebf227db1d91e$var$createKey(componentCount);
    // converting to a string here as a safety measure against mutations to the original forgeDoc object
    const forgeReactMajorVersion = forgeDoc.forgeReactMajorVersion?.toString() ?? null;
    // compare if a previous count has already been sent for analytics
    if (!prevCountMap.current.hasOwnProperty(componentCountAsKey)) {
        prevCountMap.current = {
            ...prevCountMap.current,
            [componentCountAsKey]: true
        };
        // NOTE: createAnalyticsEvent has a side effect of potentially mutating objects that are passed into it
        // Any objects passed in should not be reused or must be deep cloned first
        const components = {};
        for(let componentName in componentCount)if (componentName === 'Icon' && (0, $dh538.fg)('track-icon-glyph-deprecated-props-usage')) components[componentName] = {
            count: componentCount[componentName].componentCount,
            propCount: componentCount[componentName].propCount,
            uniqueGlyphs: Array.from(componentCount[componentName].uniqueGlyphs ?? []),
            deprecatedPropsList: Array.from(componentCount[componentName].deprecatedPropsList ?? [])
        };
        else components[componentName] = {
            count: componentCount[componentName].componentCount,
            propCount: componentCount[componentName].propCount
        };
        (0, $6oQb1.trackComponentUsageRendered)(createAnalyticsEvent, {
            source: source,
            isLegacyUiKit: UIKitVersion === '1',
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        });
    }
};

});

parcelRegister("ahOA5", function(module, exports) {

$parcel$export(module.exports, "ForgeExtensionPointModal", () => $10efe874cdee2bbf$export$bf4fcca1fb0dca1e);
/* ForgeExtensionPointModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1qfLF = parcelRequire("1qfLF");

var $1jfCH = parcelRequire("1jfCH");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $amyZ5 = parcelRequire("amyZ5");

var $6dtqn = parcelRequire("6dtqn");
const $10efe874cdee2bbf$var$styles = {
    modalWrapper: "_n3td1ejb"
};
const $10efe874cdee2bbf$export$bf4fcca1fb0dca1e = ({ children: children, modalExtension: modalExtension, shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage, client: client, extension: extension })=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalWidth, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = modalExtension;
    const akModalWidth = modalWidth ? (0, $6dtqn.getAkModalWidth)(modalWidth) : undefined;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension,
        width: akModalWidth,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $9ot3w.default), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jfCH))),
                        label: "Close Modal",
                        onClick: closeModalExtension
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                children: shouldShowFCFModalDeprecationMessage && extension && client ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $amyZ5.ForgeModalDeprecationMessage), {
                            client: client,
                            extension: extension
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            xcss: $10efe874cdee2bbf$var$styles.modalWrapper,
                            children: children
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $10efe874cdee2bbf$var$styles.modalWrapper,
                    children: children
                })
            })
        ]
    });
};

});


parcelRegister("dY90P", function(module, exports) {

$parcel$export(module.exports, "importMapMemo", () => $83671bb8769a0504$export$954661e84fee40f6);

var $gwFzn = parcelRequire("gwFzn");

var $dx0OV = parcelRequire("dx0OV");
var $j9fhT = parcelRequire("j9fhT");
var $jUBYR = parcelRequire("jUBYR");
var $kImA4 = parcelRequire("kImA4");
var $7DHRY = parcelRequire("7DHRY");
var $cCMs9 = parcelRequire("cCMs9");
var $i2C3n = parcelRequire("i2C3n");
var $BATWu = parcelRequire("BATWu");
var $hqLEh = parcelRequire("hqLEh");
var $hmPue = parcelRequire("hmPue");
var $iULMp = parcelRequire("iULMp");
var $gU1fc = parcelRequire("gU1fc");
var $9dr2W = parcelRequire("9dr2W");
var $bua6O = parcelRequire("bua6O");
var $cAQ31 = parcelRequire("cAQ31");
var $2Z8T6 = parcelRequire("2Z8T6");
var $5JZv6 = parcelRequire("5JZv6");
var $8a4Jc = parcelRequire("8a4Jc");
var $48Sur = parcelRequire("48Sur");
var $3VqTP = parcelRequire("3VqTP");
var $khMWP = parcelRequire("khMWP");
var $99RJG = parcelRequire("99RJG");
var $6u5lR = parcelRequire("6u5lR");
var $8Tqzl = parcelRequire("8Tqzl");
var $eG3F5 = parcelRequire("eG3F5");
var $64TIr = parcelRequire("64TIr");
var $cjUe4 = parcelRequire("cjUe4");
var $fMaYs = parcelRequire("fMaYs");
var $bVZ7M = parcelRequire("bVZ7M");
var $g1GtN = parcelRequire("g1GtN");
var $gyKm3 = parcelRequire("gyKm3");
var $cNdyU = parcelRequire("cNdyU");
var $8tpmm = parcelRequire("8tpmm");
var $7i4Hu = parcelRequire("7i4Hu");
var $evykB = parcelRequire("evykB");
var $gYSxw = parcelRequire("gYSxw");
var $fUUXd = parcelRequire("fUUXd");
var $1TJ7p = parcelRequire("1TJ7p");
var $FPPvd = parcelRequire("FPPvd");
var $fiQfD = parcelRequire("fiQfD");
var $bKcia = parcelRequire("bKcia");
var $aEqpx = parcelRequire("aEqpx");
var $oCFvm = parcelRequire("oCFvm");
var $ll1X4 = parcelRequire("ll1X4");
var $81Klo = parcelRequire("81Klo");
var $alvzu = parcelRequire("alvzu");
var $8XUwU = parcelRequire("8XUwU");
var $aMl5L = parcelRequire("aMl5L");
var $kresT = parcelRequire("kresT");
var $fOllR = parcelRequire("fOllR");
var $e98jd = parcelRequire("e98jd");
var $8zt10 = parcelRequire("8zt10");
var $5wUBa = parcelRequire("5wUBa");
var $hC1RA = parcelRequire("hC1RA");
var $acZWu = parcelRequire("acZWu");
var $aW047 = parcelRequire("aW047");
var $cpYZp = parcelRequire("cpYZp");
var $1sb1z = parcelRequire("1sb1z");
var $4keNh = parcelRequire("4keNh");
var $6ewzK = parcelRequire("6ewzK");
var $dgnRd = parcelRequire("dgnRd");
var $bUkSd = parcelRequire("bUkSd");
var $3foWe = parcelRequire("3foWe");
var $2FspE = parcelRequire("2FspE");
var $17tPP = parcelRequire("17tPP");
var $avzTi = parcelRequire("avzTi");
var $hBDWA = parcelRequire("hBDWA");
var $5u7Ds = parcelRequire("5u7Ds");

var $g7rOD = parcelRequire("g7rOD");
const $83671bb8769a0504$export$7cbf6225478f6479 = {
    Badge: $j9fhT.Badge,
    Bleed: $jUBYR.Bleed,
    Box: $kImA4.Box,
    Button: $7DHRY.Button,
    ButtonGroup: $cCMs9.ButtonGroup,
    Calendar: $i2C3n.Calendar,
    Checkbox: $BATWu.Checkbox,
    CheckboxGroup: $hqLEh.CheckboxGroup,
    Code: $hmPue.Code,
    CodeBlock: $iULMp.CodeBlock,
    Comment: $gU1fc.Comment,
    DatePicker: $9dr2W.DatePicker,
    DynamicTable: $bua6O.DynamicTable,
    EmptyState: $cAQ31.EmptyState,
    ErrorMessage: $2Z8T6.ErrorMessage,
    Flex: $5JZv6.Flex,
    Form: $8a4Jc.Form,
    FormFooter: $48Sur.FormFooter,
    FormHeader: $3VqTP.FormHeader,
    FormSection: $khMWP.FormSection,
    Grid: $99RJG.Grid,
    Heading: $6u5lR.Heading,
    HelperMessage: $8Tqzl.HelperMessage,
    Icon: $eG3F5.Icon,
    Inline: $cjUe4.Inline,
    InlineEdit: $fMaYs.InlineEdit,
    Label: $bVZ7M.Label,
    LinkButton: $gyKm3.LinkButton,
    List: $cNdyU.List,
    ListItem: $8tpmm.ListItem,
    LoadingButton: $7i4Hu.LoadingButton,
    Lozenge: $evykB.Lozenge,
    Modal: $gYSxw.Modal,
    ModalBody: $fUUXd.ModalBody,
    ModalFooter: $1TJ7p.ModalFooter,
    ModalHeader: $FPPvd.ModalHeader,
    ModalTitle: $fiQfD.ModalTitle,
    ModalTransition: $bKcia.ModalTransition,
    Popup: $aEqpx.Popup,
    Pressable: $oCFvm.Pressable,
    ProgressBar: $ll1X4.ProgressBar,
    ProgressTracker: $81Klo.ProgressTracker,
    Radio: $alvzu.Radio,
    RadioGroup: $8XUwU.RadioGroup,
    Range: $aMl5L.Range,
    RequiredAsterisk: $kresT.RequiredAsterisk,
    SectionMessage: $fOllR.SectionMessage,
    SectionMessageAction: $e98jd.SectionMessageAction,
    Select: $8zt10.Select,
    Spinner: $5wUBa.Spinner,
    Stack: $hC1RA.Stack,
    Tab: $aW047.Tab,
    TabList: $cpYZp.TabList,
    TabPanel: $1sb1z.TabPanel,
    Tabs: $4keNh.Tabs,
    Tag: $6ewzK.SimpleTag,
    TagGroup: $dgnRd.TagGroup,
    TextArea: $3foWe.TextArea,
    Textfield: $2FspE.Textfield,
    TimePicker: $17tPP.TimePicker,
    Toggle: $avzTi.Toggle,
    Tooltip: $hBDWA.Tooltip,
    ValidMessage: $5u7Ds.ValidMessage,
    AdfRenderer: $dx0OV.AdfRenderer,
    Image: $64TIr.Image,
    Link: $g1GtN.Link,
    Text: $bUkSd.PatchedText,
    Strong: $acZWu.Strong
};
const $83671bb8769a0504$export$954661e84fee40f6 = Object.entries($83671bb8769a0504$export$7cbf6225478f6479).reduce((agg, [key, Component])=>{
    agg[key] = (0, $gwFzn.memo)(Component, (0, $g7rOD.forgePropsAreEqual));
    return agg;
}, {});

});
parcelRegister("dx0OV", function(module, exports) {

$parcel$export(module.exports, "AdfRenderer", () => $d2c1e8bb42c60a10$export$c334f442ba514f7d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $67O0h = parcelRequire("67O0h");

var $6jPem = parcelRequire("6jPem");

var $dh538 = parcelRequire("dh538");

var $lspPP = parcelRequire("lspPP");

var $jRNsq = parcelRequire("jRNsq");

var $er4dw = parcelRequire("er4dw");

var $gGmck = parcelRequire("gGmck");

var $lMJg3 = parcelRequire("lMJg3");

var $kS0x0 = parcelRequire("kS0x0");

var $kZjf5 = parcelRequire("kZjf5");

var $clpPd = parcelRequire("clpPd");
const $d2c1e8bb42c60a10$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $kS0x0.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $6jPem.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $d2c1e8bb42c60a10$var$useSupportsMedia = ()=>{
    try {
        (0, $jRNsq.useMediaClient)();
        return true;
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $d2c1e8bb42c60a10$export$490266e683362ab4 = (props)=>{
    const supportsMedia = $d2c1e8bb42c60a10$var$useSupportsMedia();
    const { egress: egress, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $gwFzn.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $d2c1e8bb42c60a10$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $er4dw.EgressErrorMessage), {
                    url: url
                }, url)),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lspPP.RendererActionsContext), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $67O0h.default), {
                    ...adfRendererProps,
                    document: filteredDocument
                })
            })
        ]
    });
};
const $d2c1e8bb42c60a10$export$1a10af3b9f86d556 = (props)=>{
    const supportsMedia = $d2c1e8bb42c60a10$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $gwFzn.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $d2c1e8bb42c60a10$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $er4dw.EgressErrorMessage), {
                    url: url
                }, url)),
            getModalJsx(),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lspPP.RendererActionsContext), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $67O0h.default), {
                    ...adfRendererProps,
                    eventHandlers: {
                        link: {
                            onClick: (e)=>{
                                e.preventDefault();
                                adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                                onNavigate({
                                    type: 'same-tab',
                                    url: (0, $clpPd.sanitizeUrl)(e.currentTarget.href)
                                });
                            }
                        }
                    },
                    document: filteredDocument
                })
            })
        ]
    });
};
const $d2c1e8bb42c60a10$export$c334f442ba514f7d = (props)=>{
    return (0, $dh538.fg)('ui-kit-link-egress-patch') ? /*#__PURE__*/ (0, $7UHDa.jsx)($d2c1e8bb42c60a10$export$1a10af3b9f86d556, {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($d2c1e8bb42c60a10$export$490266e683362ab4, {
        ...props
    });
};

});
parcelRegister("clpPd", function(module, exports) {

$parcel$export(module.exports, "sanitizeUrl", () => $1501019f8cb42aef$export$300bd6d67c49dbfc);
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $1501019f8cb42aef$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $1501019f8cb42aef$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($1501019f8cb42aef$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};

});


parcelRegister("j9fhT", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $637faf3c7a4c907e$export$37acb3580601e69a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $c4sKh = parcelRequire("c4sKh");
// Convert child to number if possible
// Badge `max` prop will only work if the child is a number
const $637faf3c7a4c907e$var$getBadgeChildren = (forgeDoc)=>{
    const child = forgeDoc.children?.[0]?.props?.text;
    if (child && !isNaN(Number(child))) return Number(child);
    return child;
};
const $637faf3c7a4c907e$export$bf0162d825d6e13 = {
    appearance: true,
    /**
	 * The value displayed within the badge. A badge should only be used in cases where you want to represent a number. Use a lozenge for non-numeric information.
	 *
	 * @type string | number
	 */ children: {
        value: 'getBadgeChildren(props.forgeDoc)'
    },
    max: true,
    testId: true
};
const $637faf3c7a4c907e$export$37acb3580601e69a = (props)=>{
    const { appearance: appearance, max: max, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
        appearance: appearance,
        children: $637faf3c7a4c907e$var$getBadgeChildren(props.forgeDoc),
        max: max,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("jUBYR", function(module, exports) {

$parcel$export(module.exports, "Bleed", () => $151faf8edae1f251$export$a8307195dd50fcbf);
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::41ed5648927b0201af124d118c20fda5>>
 * @codegenId #bleed
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen bleed
 * @codegenParams { "props": { "children": true, "all": true, "inline": true, "block": true, "testId": true, "data-testid": false, "xcss": false, "role": true } }
 * @codegenDependency ../../../../../../../design-system/primitives/src/components/bleed.tsx <<SignedSource::15adb710ca9761627c48e41e1555dc16>>
 * @codegenDependency ../../../../../../../design-system/primitives/src/components/types.tsx <<SignedSource::2f4848af544e0f64968f7c28012cf0f0>>
 * @codegenDependency ../../../../../../../design-system/primitives/src/xcss/xcss.tsx <<SignedSource::a91bf7842593d9052c045e4a40d7ab3b>>
 */ /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $Rk8D3 = parcelRequire("Rk8D3");
const $151faf8edae1f251$export$a8307195dd50fcbf = (props)=>{
    const { all: all, inline: inline, block: block, testId: testId, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Rk8D3.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        all: all,
        inline: inline,
        block: block,
        testId: testId,
        role: role
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("kImA4", function(module, exports) {

$parcel$export(module.exports, "Box", () => $dc33743d43b89b9b$export$e71c4d32a2263218);
// The below lint rules are disabled because Box relies on building styles at runtime from in Forge apps
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ 
var $7UHDa = parcelRequire("7UHDa");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $7Ytfp = parcelRequire("7Ytfp");

var $gwFzn = parcelRequire("gwFzn");
const $dc33743d43b89b9b$export$bf0162d825d6e13 = {
    as: false,
    padding: true,
    paddingBlock: true,
    paddingBlockStart: true,
    paddingBlockEnd: true,
    paddingInline: true,
    paddingInlineStart: true,
    paddingInlineEnd: true,
    backgroundColor: true,
    children: true,
    ref: true,
    testId: true,
    'data-testid': false,
    xcss: {
        value: 'xcss && platformXCSS(xcssValidator(xcss) as PlatformXCSSParam)'
    },
    role: true,
    style: false
};
const $dc33743d43b89b9b$export$e71c4d32a2263218 = (props)=>{
    const { padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, backgroundColor: backgroundColor, ref: ref, testId: testId, xcss: xcss, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        backgroundColor: backgroundColor,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        ref: ref,
        testId: testId,
        xcss: xcss && (0, $ecnYn.xcss)((0, $7Ytfp.xcssValidator)(xcss)),
        role: role
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("7Ytfp", function(module, exports) {

$parcel$export(module.exports, "xcssValidator", () => $18a557183f782deb$export$aa422b2708209a80);

var $7wZJg = parcelRequire("7wZJg");
const $18a557183f782deb$export$aa422b2708209a80 = (0, $7wZJg.makeXCSSValidator)({
    // color related props
    color: true,
    boxShadow: true,
    opacity: true,
    backgroundColor: true,
    borderColor: true,
    borderBlockColor: true,
    borderBlockEndColor: true,
    borderBlockStartColor: true,
    borderBottomColor: true,
    borderInlineColor: true,
    borderInlineEndColor: true,
    borderInlineStartColor: true,
    borderLeftColor: true,
    borderRightColor: true,
    borderTopColor: true,
    overflow: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    overflowX: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    overflowY: {
        supportedValues: [
            'hidden',
            'visible',
            'scroll',
            'auto'
        ]
    },
    // layout and space related props
    display: {
        supportedValues: [
            'block',
            'inline-block',
            'inline',
            'none'
        ]
    },
    flexGrow: {
        allowCSS: true
    },
    width: {
        allowCSS: true
    },
    height: {
        allowCSS: true
    },
    minWidth: {
        allowCSS: true
    },
    maxWidth: {
        allowCSS: true
    },
    minHeight: {
        allowCSS: true
    },
    maxHeight: {
        allowCSS: true
    },
    margin: true,
    marginBlock: true,
    marginBlockEnd: true,
    marginBlockStart: true,
    marginBottom: true,
    marginInline: true,
    marginInlineEnd: true,
    marginInlineStart: true,
    marginLeft: true,
    marginRight: true,
    marginTop: true,
    padding: true,
    paddingBlock: true,
    paddingBlockEnd: true,
    paddingBlockStart: true,
    paddingBottom: true,
    paddingInline: true,
    paddingInlineEnd: true,
    paddingInlineStart: true,
    paddingLeft: true,
    paddingRight: true,
    paddingTop: true,
    // other box related props
    borderRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderBottomLeftRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderBottomRightRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderTopLeftRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderTopRightRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderEndEndRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderEndStartRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderStartEndRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderStartStartRadius: {
        supportedValues: [
            'border.radius'
        ]
    },
    borderWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBlockWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBlockEndWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBlockStartWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderBottomWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderInlineWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderInlineEndWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderInlineStartWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderLeftWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderRightWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    borderTopWidth: {
        supportedValues: [
            'border.width'
        ]
    },
    // other props not in tokens based props
    borderTopStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderBottomStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderRightStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderLeftStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    borderStyle: {
        supportedValues: [
            'dotted',
            'dashed',
            'solid',
            'none',
            'hidden'
        ]
    },
    position: {
        supportedValues: [
            'relative',
            'static'
        ]
    }
});

});
parcelRegister("7wZJg", function(module, exports) {

$parcel$export(module.exports, "makeXCSSValidator", () => $5c1031de888776bc$export$4b24853998c191ec);

var $ecnYn = parcelRequire("ecnYn");
const $5c1031de888776bc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $5c1031de888776bc$var$REX_CSS_SIMPLE_STRING_PROP_VALUE = /^[a-zA-Z-]+$/;
const $5c1031de888776bc$var$REX_CSS_WIDTH_PROP_VALUE = /^-?\d+(\.\d+)?(px|em|rem|%)?$/;
// Note: we currently support only free formed size related props (e.g. width).
//       the validation logic should be extended to support other props in the future.
const $5c1031de888776bc$var$defaultPropValidator = (rawValue)=>{
    const value = `${rawValue ?? ''}`.trim();
    return $5c1031de888776bc$var$REX_CSS_SIMPLE_STRING_PROP_VALUE.test(value) || $5c1031de888776bc$var$REX_CSS_WIDTH_PROP_VALUE.test(value);
};
const $5c1031de888776bc$var$xcssValidateAndCleanup = (styleObj, supportedXCSSPropsSpec, isRoot = true)=>{
    return Object.entries(styleObj).reduce((targetStyleObj, [key, value])=>{
        if (typeof value === 'object' && $5c1031de888776bc$var$safeSelectors.test(key) && isRoot) {
            // handle the case where the value is a media query or pseudo selector
            const cleanedValue = $5c1031de888776bc$var$xcssValidateAndCleanup(value, supportedXCSSPropsSpec, false);
            if (cleanedValue && Object.keys(cleanedValue).length > 0) targetStyleObj[key] = cleanedValue;
        } else if (value) {
            if (supportedXCSSPropsSpec[key]?.(value)) // handle the case where the value is a design token value of a token prop
            // or a string value of a standard css prop that passes the validator function
            // if defined.
            targetStyleObj[key] = value;
            else // eslint-disable-next-line no-console
            console.warn(`Unexpected XCSS property provided: ${key}: ${value}`);
        } else // in case the prop is not supported.
        // eslint-disable-next-line no-console
        console.warn(`Unsupported XCSS property provided: ${key}: ${value}`);
        return targetStyleObj;
    }, {});
};
const $5c1031de888776bc$var$isSupportedValuesConfig = (config)=>{
    return config !== true && 'supportedValues' in config && Array.isArray(config.supportedValues);
};
/**
 *
 * @param supportedXCSSProps - the list of css props to be supported for the intended component.
 *    If not provided, all the props will be supported. The props could be either standard css props
 *    or design token based props. If the prop is a design token based prop, the value of the prop
 *    will be validated against the design tokens map to ensure the value is a valid design token string.
 * @returns a function that takes a style object and returns a style object with only the supported props
 *    as specified in the supportedXCSSProps list. The props that are not supported will be removed from the
 *    returned style object and a warning will be logged in the console.
 */ const $5c1031de888776bc$export$4b24853998c191ec = (supportedXCSSProps)=>{
    const supportedXCSSPropsSpec = Object.entries(supportedXCSSProps).reduce((acc, [prop, config])=>{
        let validator;
        if (config === true) {
            const tokensMapStyle = (0, $ecnYn.tokensMap)[prop];
            if (tokensMapStyle) {
                const tokenSet = new Set(Object.keys(tokensMapStyle));
                validator = (value)=>tokenSet.has(value);
            } else throw new Error('invalid validation config applied to token only props');
        } else if ($5c1031de888776bc$var$isSupportedValuesConfig(config)) {
            const supportedValues = new Set(config.supportedValues);
            validator = (value)=>supportedValues.has(value);
        } else if (config?.allowCSS === true) validator = $5c1031de888776bc$var$defaultPropValidator;
        if (validator) acc[prop] = validator;
        return acc;
    }, {});
    return (styleObj)=>$5c1031de888776bc$var$xcssValidateAndCleanup(styleObj, supportedXCSSPropsSpec);
};

});



parcelRegister("7DHRY", function(module, exports) {

$parcel$export(module.exports, "Button", () => $c4f64c3b581f478a$export$353f5b6fc5456de1);

var $7UHDa = parcelRequire("7UHDa");

var $9PmQV = parcelRequire("9PmQV");

var $eG3F5 = parcelRequire("eG3F5");

var $gwFzn = parcelRequire("gwFzn");

var $ccHMk = parcelRequire("ccHMk");
const $c4f64c3b581f478a$export$bf0162d825d6e13 = {
    children: true,
    autoFocus: true,
    overlay: false,
    isDisabled: true,
    isSelected: true,
    onBlur: {
        value: 'adaptEventHandler(onBlur)'
    },
    onClick: {
        value: 'adaptEventHandler(onClick)'
    },
    onFocus: {
        value: 'adaptEventHandler(onFocus)'
    },
    spacing: {
        value: 'mapDeprecatedSpacing(spacing)'
    },
    testId: true,
    shouldFitContainer: true,
    appearance: true,
    type: true,
    iconAfter: {
        value: 'iconAfter && createIconComponent(iconAfter)'
    },
    iconBefore: {
        value: 'iconBefore && createIconComponent(iconBefore)'
    }
};
const $c4f64c3b581f478a$var$createIconComponent = (icon)=>{
    const Component = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eG3F5.IconComponent), {
            glyph: icon,
            label: icon
        });
    return Component;
};
/**
 * Mapping the deprecated 'none' spacing to 'compact'
 */ const $c4f64c3b581f478a$var$mapDeprecatedSpacing = (spacing)=>spacing === 'none' ? 'compact' : spacing;
const $c4f64c3b581f478a$export$353f5b6fc5456de1 = (props)=>{
    const { autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance, type: type, iconAfter: iconAfter, iconBefore: iconBefore } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onClick: (0, $9PmQV.adaptEventHandler)(onClick),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        spacing: $c4f64c3b581f478a$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: appearance,
        type: type,
        iconAfter: iconAfter && $c4f64c3b581f478a$var$createIconComponent(iconAfter),
        iconBefore: iconBefore && $c4f64c3b581f478a$var$createIconComponent(iconBefore)
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("9PmQV", function(module, exports) {

$parcel$export(module.exports, "adaptEventHandler", () => $a61a7775f4548bb7$export$f956703109d01f6a);
/** The SyntheticEvent object is not serialisable and cannot be passed to the runtime/backend as is.
 * This function filters out all non serialisable arguments and maintains important properties of the event object.
 */ const $a61a7775f4548bb7$var$getSerialisableEventObject = (syntheticEvent)=>{
    /** syntheticEvent.persist() is called to remove the synthetic event from React's event pool.
	 * Without this call, the properties of the event would be nullified after the event callback has been invoked,
	 * due to React's event pooling.
	 * By calling persist(), we ensure that the event properties remain available for the serialization process.
	 */ syntheticEvent?.persist?.();
    const target = syntheticEvent.target;
    const serialisableEvent = {
        bubbles: syntheticEvent.bubbles,
        cancelable: syntheticEvent.cancelable,
        defaultPrevented: syntheticEvent.defaultPrevented,
        eventPhase: syntheticEvent.eventPhase,
        isTrusted: syntheticEvent.isTrusted,
        target: {
            selectionStart: target?.selectionStart,
            selectionEnd: target?.selectionEnd,
            value: target?.value,
            checked: target?.checked,
            name: target?.name,
            id: target?.id,
            tagName: target?.tagName,
            type: target?.type
        },
        timeStamp: syntheticEvent.timeStamp,
        type: syntheticEvent.type
    };
    return serialisableEvent;
};
/**
 * Default handler args transformer that extract react synthetic event from
 * the handler args and creates a serialisable object so that it can be passed into the runtime.
 */ const $a61a7775f4548bb7$var$nativeEventHandlerArgsTransformer = (...args)=>{
    const [event, ...rest] = args;
    return [
        $a61a7775f4548bb7$var$getSerialisableEventObject(event),
        ...rest
    ];
};
const $a61a7775f4548bb7$export$f956703109d01f6a = (sourceEventHandler)=>{
    if (!sourceEventHandler) return sourceEventHandler;
    return (...args)=>{
        sourceEventHandler(...$a61a7775f4548bb7$var$nativeEventHandlerArgsTransformer(...args));
    };
};

});

parcelRegister("eG3F5", function(module, exports) {

$parcel$export(module.exports, "IconComponent", () => $04d28833aacd5f6d$export$f508444e7933c2b1);
$parcel$export(module.exports, "Icon", () => $04d28833aacd5f6d$export$f04a61298a47a40f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1vDIt = parcelRequire("1vDIt");

var $7AZ3I = parcelRequire("7AZ3I");
/**
 * The validateColor function and its helper functions could not be
 * moved to a seperate file because it could potentitally cause cyclic
 * dependencies since type IconColor must be defined here in order for
 * forge-react-types to recognise it.
 */ const $04d28833aacd5f6d$var$iconTokenSet = new Set(Object.keys((0, $1vDIt.default)).filter((token)=>token.startsWith('color.icon')));
const $04d28833aacd5f6d$var$isInTokenSet = (color)=>$04d28833aacd5f6d$var$iconTokenSet.has(color);
const $04d28833aacd5f6d$export$69378c11ed599796 = (color)=>{
    if (!color) return undefined;
    if (!$04d28833aacd5f6d$var$isInTokenSet(color)) {
        // eslint-disable-next-line no-console
        console.warn(`${color} is not a valid icon color design token`);
        return undefined;
    }
    return `var(${(0, $1vDIt.default)[color]})`;
};
const $04d28833aacd5f6d$export$f508444e7933c2b1 = ({ glyph: glyph, size: size, label: label, primaryColor: primaryColor, secondaryColor: secondaryColor })=>{
    const Component = (0, $7AZ3I.IconGlyphs)[glyph];
    if (!Component) {
        // eslint-disable-next-line no-console
        console.warn(`Icon component ${glyph} not found`);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            // @ts-ignore: Jira only - TS2322: Type '{ label: string; size: "small" | "medium" | "large" | undefined; glyph: Icon; primaryColor: string | undefined; secondaryColor: string | undefined; }' is not assignable to type 'IntrinsicAttributes'.
            label: label,
            size: size,
            glyph: glyph,
            primaryColor: $04d28833aacd5f6d$export$69378c11ed599796(primaryColor),
            secondaryColor: $04d28833aacd5f6d$export$69378c11ed599796(secondaryColor)
        })
    });
};
const $04d28833aacd5f6d$export$f04a61298a47a40f = (props)=>{
    const { size: size, glyph: glyph, label: label, primaryColor: primaryColor, secondaryColor: secondaryColor } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($04d28833aacd5f6d$export$f508444e7933c2b1, {
        label: label,
        size: size,
        glyph: glyph,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
};

});
parcelRegister("7AZ3I", function(module, exports) {

$parcel$export(module.exports, "IconGlyphs", () => $900dde9a5d418d97$export$f7b1faa91259ef9d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * lazy imports for all icons in @atlaskit/icon/glyph that are used in UI Kit 2 components
 *
 * @codegen <<SignedSource::7460a808e082bf5bbeca4eface2aab9b>>
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen icon
 * @codegenDependency ../../../../../../../design-system/icon/src/metadata.tsx <<SignedSource::bf9b18623ae5b5bcf2b218de92253dda>>
 */ /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 
var $gwFzn = parcelRequire("gwFzn");





































































































































































































































































































































































const $900dde9a5d418d97$export$f7b1faa91259ef9d = {
    'activity': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7uqxq"))),
    'add': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("egnkI"))),
    'add-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("69jXZ"))),
    'add-item': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cVLXH"))),
    'addon': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lF15K"))),
    'app-access': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3mGTl"))),
    'app-switcher': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7Oixb"))),
    'archive': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3XErz"))),
    'arrow-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ikpD8"))),
    'arrow-down-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2u1xT"))),
    'arrow-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2sYAo"))),
    'arrow-left-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cW2cu"))),
    'arrow-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ncbZj"))),
    'arrow-right-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6fThe"))),
    'arrow-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8fdGd"))),
    'arrow-up-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jQYVG"))),
    'attachment': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("72epO"))),
    'audio': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lPSh9"))),
    'audio-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1XG0j"))),
    'backlog': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7N1nT"))),
    'billing': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("PrNAI"))),
    'billing-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9wBfw"))),
    'bitbucket-branches': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("48o9a"))),
    'bitbucket-builds': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("al8ek"))),
    'bitbucket-clone': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9NGnm"))),
    'bitbucket-commits': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bSoQ5"))),
    'bitbucket-compare': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ctMmL"))),
    'bitbucket-forks': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("WbN4W"))),
    'bitbucket-output': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i53Wt"))),
    'bitbucket-pipelines': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jVAma"))),
    'bitbucket-pullrequests': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("g3FIx"))),
    'bitbucket-repos': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6YxxM"))),
    'bitbucket-snippets': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a9gIA"))),
    'bitbucket-source': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aT7Al"))),
    'board': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1ygEM"))),
    'book': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fDU6I"))),
    'bullet-list': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4zIyE"))),
    'calendar': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("32wsW")))),
    'calendar-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bSPHX"))),
    'camera': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fq6oe"))),
    'camera-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cUWGE"))),
    'camera-rotate': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9i56W"))),
    'camera-take-picture': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("e4iVV"))),
    'canvas': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("l3kLa"))),
    'check': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("66FuL")))),
    'check-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("eCByP")))),
    'check-circle-outline': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eG3Hu"))),
    'checkbox': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cokXW"))),
    'checkbox-indeterminate': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4v2Kt"))),
    'chevron-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("klvaQ")))),
    'chevron-down-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bZnWb"))),
    'chevron-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eEZee"))),
    'chevron-left-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6ade7"))),
    'chevron-left-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("7jrhz")))),
    'chevron-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dBnQj"))),
    'chevron-right-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2TPo8"))),
    'chevron-right-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("dskUg")))),
    'chevron-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aLXfB"))),
    'chevron-up-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7bAx3"))),
    'child-issues': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("g6eqe"))),
    'code': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7WiKX"))),
    'comment': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lkHKL"))),
    'component': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8WE6A"))),
    'copy': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("5mdwm")))),
    'creditcard': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a3GrC"))),
    'creditcard-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("g3xEK"))),
    'cross': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("ge0Ua")))),
    'cross-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5r9xx"))),
    'dashboard': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fWz52"))),
    'decision': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("flMWY"))),
    'department': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hpBnv"))),
    'detail-view': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iMp6B"))),
    'discover': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("36wYk"))),
    'discover-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4CLVX"))),
    'document': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f4dBg"))),
    'document-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6voFP"))),
    'documents': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bI2rr"))),
    'download': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7zqtv"))),
    'drag-handler': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6LeCs"))),
    'dropbox': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1aijb"))),
    'edit': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("50B9p"))),
    'edit-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8k8Tk"))),
    'editor-add': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5iX3H"))),
    'editor-addon': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("58zsy"))),
    'editor-advanced': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2gPzN"))),
    'editor-align-center': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("e8liC"))),
    'editor-align-image-center': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("c3ye6"))),
    'editor-align-image-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fYu2I"))),
    'editor-align-image-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("YnYzy"))),
    'editor-align-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jKmDI"))),
    'editor-align-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cJhMj"))),
    'editor-attachment': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hQC4q"))),
    'editor-background-color': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("e2PWG"))),
    'editor-bold': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("efbV0"))),
    'editor-bullet-list': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3FUpl"))),
    'editor-close': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("d0d2M")))),
    'editor-code': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4udHW"))),
    'editor-collapse': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3iuuL"))),
    'editor-date': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("erQrG"))),
    'editor-decision': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lpsLT"))),
    'editor-divider': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6aCL3"))),
    'editor-done': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("6Eilg")))),
    'editor-edit': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3kNFU"))),
    'editor-emoji': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2Db2S"))),
    'editor-error': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2yLb2"))),
    'editor-expand': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4Z9Qn"))),
    'editor-feedback': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("15iS2"))),
    'editor-file': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lFUZx"))),
    'editor-file-preview': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8KqjS"))),
    'editor-help': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7Or5u"))),
    'editor-hint': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4UsjY"))),
    'editor-horizontal-rule': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("if6iT"))),
    'editor-image': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gAgWa"))),
    'editor-image-border': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aV6ps"))),
    'editor-image-resize': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9AP6y"))),
    'editor-indent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3ihBx"))),
    'editor-info': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4KQjl"))),
    'editor-italic': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("egQsF"))),
    'editor-layout-single': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2ruzy"))),
    'editor-layout-three-equal': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1Wu6x"))),
    'editor-layout-three-with-sidebars': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dKZ4S"))),
    'editor-layout-two-equal': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f7eKx"))),
    'editor-layout-two-left-sidebar': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bArSn"))),
    'editor-layout-two-right-sidebar': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4p15b"))),
    'editor-link': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gnI8L"))),
    'editor-media-center': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3jgZY"))),
    'editor-media-full-width': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6XCSm"))),
    'editor-media-wide': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("axCs4"))),
    'editor-media-wrap-left': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jiQoJ"))),
    'editor-media-wrap-right': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("35crK"))),
    'editor-mention': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1llhC"))),
    'editor-more': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("inAmW"))),
    'editor-note': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7Bu96"))),
    'editor-number-list': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aFPUK"))),
    'editor-open': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("h8TC5"))),
    'editor-outdent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gI4Aj"))),
    'editor-panel': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8cvaV"))),
    'editor-photo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("rE76e"))),
    'editor-quote': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eLxw3"))),
    'editor-recent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("NtK10"))),
    'editor-redo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iDNea"))),
    'editor-remove': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aHxWB"))),
    'editor-remove-emoji': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eNmKk"))),
    'editor-search': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("66gZz")))),
    'editor-settings': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iIPUk"))),
    'editor-strikethrough': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1utN2"))),
    'editor-success': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("6alL7")))),
    'editor-table': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("azjDQ"))),
    'editor-table-display-options': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iYJOn"))),
    'editor-task': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iyP5h"))),
    'editor-text-color': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hM3rd"))),
    'editor-text-style': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YrnS"))),
    'editor-underline': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("loBYZ"))),
    'editor-undo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7PgQ0"))),
    'editor-unlink': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hjJeG"))),
    'editor-warning': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dBlHC"))),
    'email': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("jc9Cb")))),
    'emoji': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("77MmL"))),
    'emoji-add': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cJX52"))),
    'emoji-activity': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fvBna"))),
    'emoji-atlassian': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cY3xj"))),
    'emoji-custom': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2NAdC"))),
    'emoji-emoji': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lNtff"))),
    'emoji-flags': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f4PGy"))),
    'emoji-food': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("19z4B"))),
    'emoji-frequent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8L0KX"))),
    'emoji-keyboard': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1qIMR"))),
    'emoji-nature': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3AtxT"))),
    'emoji-objects': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9rG5j"))),
    'emoji-people': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("h78mi"))),
    'emoji-productivity': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dGWBF"))),
    'emoji-symbols': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bXQHP"))),
    'emoji-travel': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i92HB"))),
    'error': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8QILn")))),
    'export': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("giJMN"))),
    'feedback': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kfusf"))),
    'file': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ahsrS"))),
    'filter': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bteXK"))),
    'flag-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k6txg"))),
    'folder': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cvzpb"))),
    'folder-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kIQda"))),
    'followers': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8ygoT"))),
    'following': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jdqQu"))),
    'googledrive': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fjYpf"))),
    'graph-bar': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("j8dnF"))),
    'graph-line': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lHHv8"))),
    'gsuite': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hzr76"))),
    'highlights': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4fcqT"))),
    'hipchat-audio-only': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hQXOL"))),
    'hipchat-chevron-double-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lk5Fc"))),
    'hipchat-chevron-double-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cfzPK"))),
    'hipchat-chevron-down': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("3rvkR")))),
    'hipchat-chevron-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("lj1Sg")))),
    'hipchat-dial-out': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7rPkg"))),
    'hipchat-lobby': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hU5Qa"))),
    'hipchat-media-attachment-count': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gl0Qr"))),
    'hipchat-outgoing-sound': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("af7Xv"))),
    'hipchat-sd-video': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("brt1O"))),
    'home': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kUyYW"))),
    'home-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5aKUo"))),
    'image': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("16A0u"))),
    'image-border': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lkfjj"))),
    'image-resize': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8P4yv"))),
    'info': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("a7lwr")))),
    'invite-team': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iNdiW"))),
    'issue': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("69dVB"))),
    'issue-raise': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("LX7JB"))),
    'issues': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3vE7v"))),
    'jira-capture': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jUQmM"))),
    'jira-failed-build-status': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("59pum"))),
    'jira-labs': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a6XFF"))),
    'jira-test-session': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("99tIu"))),
    'label': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("70mPY"))),
    'lightbulb': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gmmth"))),
    'lightbulb-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jqPu5"))),
    'like': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8JAhC"))),
    'link': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("2D7De")))),
    'link-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dZmch"))),
    'list': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1iwJp"))),
    'location': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2p0ep"))),
    'lock': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("22KZk"))),
    'lock-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3rJTC"))),
    'lock-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("17uVW")))),
    'marketplace': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iYWy8"))),
    'media-services-actual-size': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f80K8"))),
    'media-services-add-comment': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4WqiO"))),
    'media-services-annotate': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8E9Ge"))),
    'media-services-arrow': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("betzx"))),
    'media-services-audio': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fNcp7"))),
    'media-services-blur': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("44nbm"))),
    'media-services-brush': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fpv3L"))),
    'media-services-button-option': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YX9t"))),
    'media-services-code': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("496tK"))),
    'media-services-document': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hHq4z"))),
    'media-services-filter': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8sLkZ"))),
    'media-services-fit-to-page': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3IKtH"))),
    'media-services-full-screen': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7QIoe"))),
    'media-services-grid': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iatmb"))),
    'media-services-image': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("b86dE"))),
    'media-services-line': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fily5"))),
    'media-services-line-thickness': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ihSz2"))),
    'media-services-no-image': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("9aBYD")))),
    'media-services-open-mediaviewer': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("b6fyt"))),
    'media-services-oval': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1IzgK"))),
    'media-services-pdf': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("d4eIg"))),
    'media-services-preselected': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k07KP"))),
    'media-services-presentation': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ahUPs"))),
    'media-services-rectangle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4EOqR"))),
    'media-services-scale-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i9ugx"))),
    'media-services-scale-small': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("idhWn"))),
    'media-services-spreadsheet': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1uRHH"))),
    'media-services-text': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3M40A"))),
    'media-services-unknown': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iNq8h"))),
    'media-services-video': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dYWbo"))),
    'media-services-zip': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1czDT"))),
    'media-services-zoom-in': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YJKk"))),
    'media-services-zoom-out': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bqmbd"))),
    'mention': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("x61t6"))),
    'menu': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lRe88"))),
    'menu-expand': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("85yWV"))),
    'mobile': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("c4G0C"))),
    'more': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1bR0l"))),
    'more-vertical': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gpNqQ"))),
    'notification': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("CrpvX"))),
    'notification-all': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4Eyjd"))),
    'notification-direct': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1FzTW"))),
    'office-building': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gdD5P"))),
    'office-building-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3RtEX"))),
    'open': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8MIkL"))),
    'overview': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2CkJR"))),
    'page': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5laGB"))),
    'page-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cN36Q"))),
    'pdf': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("382xi"))),
    'people': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("f9sHQ")))),
    'people-group': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("21y3U"))),
    'person': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("3Jfdd")))),
    'person-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1ISHG"))),
    'person-with-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eqrmh"))),
    'person-with-cross': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gEAFN"))),
    'person-with-tick': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8FLov"))),
    'portfolio': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("j7LPy"))),
    'preferences': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("feFIC"))),
    'premium': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kK8YU"))),
    'presence-active': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2GhhD"))),
    'presence-busy': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kGbn4"))),
    'presence-unavailable': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fdV0I"))),
    'question': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fGCAg"))),
    'question-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8nVd9")))),
    'questions': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("366MN"))),
    'queues': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hjs2V"))),
    'quote': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1gQeO"))),
    'radio': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1N7Kn"))),
    'recent': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aOH1S"))),
    'redo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lsP6p"))),
    'refresh': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4NdrY"))),
    'retry': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("casQF"))),
    'roadmap': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("clSMY"))),
    'room-menu': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k3cNB"))),
    'schedule': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hZbsF"))),
    'schedule-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("60GqC"))),
    'screen': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jNySf"))),
    'search': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("b6c2L"))),
    'select-clear': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("cPXGO")))),
    'send': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1sdDz"))),
    'settings': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kJYoC"))),
    'share': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4fck8"))),
    'ship': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("duwZb")))),
    'shortcut': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("8bFzt")))),
    'sign-in': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lhMt1"))),
    'sign-out': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ecI61"))),
    'sprint': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hxD3l"))),
    'star': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2XqOH"))),
    'star-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jzrnI"))),
    'star-large': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8nvCP"))),
    'status': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cv50C"))),
    'stopwatch': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jtu9J"))),
    'subtask': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8YXDD"))),
    'suitcase': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("itzNP"))),
    'switcher': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("01r0n"))),
    'table': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("05bUX"))),
    'task': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ieF3h"))),
    'teams': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cA4Qt"))),
    'trash': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hHuV0"))),
    'tray': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4M6PA"))),
    'undo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("czh6T"))),
    'unlink': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hTBfz"))),
    'unlock': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("h5M9M"))),
    'unlock-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("benCO"))),
    'unlock-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aYBE7"))),
    'upload': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1BrLD"))),
    'user-avatar-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k4uJB"))),
    'vid-audio-muted': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8wCoY"))),
    'vid-audio-on': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1WkPL"))),
    'vid-backward': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iqJax"))),
    'vid-camera-off': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("iud5O"))),
    'vid-camera-on': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hpJdo"))),
    'vid-connection-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jZvq5"))),
    'vid-forward': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("a8skH"))),
    'vid-full-screen-off': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lYjTs"))),
    'vid-full-screen-on': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7lNmN"))),
    'vid-hang-up': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jQzL4"))),
    'vid-hd-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1PwUL"))),
    'vid-pause': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gxyqD"))),
    'vid-play': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lPrJf"))),
    'vid-raised-hand': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("at2ny"))),
    'vid-share-screen': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ijilz"))),
    'vid-speaking-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hWhAv"))),
    'vid-volume-full': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5iX12"))),
    'vid-volume-half': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4y76w"))),
    'vid-volume-muted': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hvS0Z"))),
    'video-circle': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kXZij"))),
    'video-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aRdQq"))),
    'warning': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>Promise.resolve((parcelRequire("5Xi9J")))),
    'watch': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gJDRl"))),
    'watch-filled': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9zZ12"))),
    'world': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eyQx7"))),
    'world-small': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9IpRk")))
};

});



parcelRegister("cCMs9", function(module, exports) {

$parcel$export(module.exports, "ButtonGroup", () => $e4393c0a53b02aba$export$69b1032f2ecdf404);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $hArLp = parcelRequire("hArLp");
const $e4393c0a53b02aba$export$bf0162d825d6e13 = {
    children: {
        value: "applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance)",
        comment: "apply consistent appearance to children elements"
    },
    testId: true,
    label: true,
    titleId: true
};
/**
 * Applying the appearance prop directly to the children forgedocs.
 * It is because the logic for applying appearance to the children components
 * through React.cloneComponent can only be applied to the Forge component wrapper,
 * and not to the actual Button element.
 */ const $e4393c0a53b02aba$var$applyAppearanceToChildren = (children, render, appearance)=>{
    if (!appearance) return children.map(render);
    return children.map((child)=>{
        if (child.type !== 'String') return render({
            ...child,
            props: {
                appearance: appearance,
                ...child.props
            }
        });
        return render(child);
    });
};
const $e4393c0a53b02aba$export$69b1032f2ecdf404 = (props)=>{
    const { testId: testId, label: label, titleId: titleId, appearance: appearance } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hArLp.default), {
        // apply consistent appearance to children elements
        children: $e4393c0a53b02aba$var$applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance),
        testId: testId,
        label: label,
        titleId: titleId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("i2C3n", function(module, exports) {

$parcel$export(module.exports, "Calendar", () => $9b97a2db8a6b7ad3$export$e1aef45b828286de);

var $7UHDa = parcelRequire("7UHDa");

var $9PmQV = parcelRequire("9PmQV");
parcelRequire("gwFzn");

var $91bEl = parcelRequire("91bEl");
const $9b97a2db8a6b7ad3$export$bf0162d825d6e13 = {
    day: true,
    defaultDay: true,
    defaultMonth: true,
    defaultYear: true,
    defaultPreviouslySelected: true,
    defaultSelected: true,
    disabled: true,
    disabledDateFilter: false,
    maxDate: true,
    minDate: true,
    nextMonthLabel: true,
    onBlur: {
        value: "adaptEventHandler(onBlur)"
    },
    onChange: true,
    onFocus: {
        value: "adaptEventHandler(onFocus)"
    },
    onSelect: true,
    previouslySelected: true,
    previousMonthLabel: true,
    selected: true,
    today: true,
    year: true,
    locale: true,
    testId: true,
    weekStartDay: true,
    tabIndex: true
};
const $9b97a2db8a6b7ad3$export$e1aef45b828286de = (props)=>{
    const { day: day, defaultDay: defaultDay, defaultMonth: defaultMonth, defaultYear: defaultYear, defaultPreviouslySelected: defaultPreviouslySelected, defaultSelected: defaultSelected, disabled: disabled, maxDate: maxDate, minDate: minDate, nextMonthLabel: nextMonthLabel, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onSelect: onSelect, previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, today: today, year: year, locale: locale, testId: testId, weekStartDay: weekStartDay, tabIndex: tabIndex } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $91bEl.default), {
        day: day,
        defaultDay: defaultDay,
        defaultMonth: defaultMonth,
        defaultYear: defaultYear,
        defaultPreviouslySelected: defaultPreviouslySelected,
        defaultSelected: defaultSelected,
        disabled: disabled,
        maxDate: maxDate,
        minDate: minDate,
        nextMonthLabel: nextMonthLabel,
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onChange: onChange,
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        onSelect: onSelect,
        previouslySelected: previouslySelected,
        previousMonthLabel: previousMonthLabel,
        selected: selected,
        today: today,
        year: year,
        locale: locale,
        testId: testId,
        weekStartDay: weekStartDay,
        tabIndex: tabIndex
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("BATWu", function(module, exports) {

$parcel$export(module.exports, "Checkbox", () => $7cc3ee78c78f7f2c$export$48513f6b9f8ce62d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7gpC4 = parcelRequire("7gpC4");

var $9PmQV = parcelRequire("9PmQV");
const $7cc3ee78c78f7f2c$export$bf0162d825d6e13 = {
    testId: true,
    defaultChecked: true,
    isChecked: true,
    isIndeterminate: true,
    label: true,
    size: false
};
const $7cc3ee78c78f7f2c$export$48513f6b9f8ce62d = (props)=>{
    const { testId: testId, defaultChecked: defaultChecked, isChecked: isChecked, isIndeterminate: isIndeterminate, label: label, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
        testId: testId,
        defaultChecked: defaultChecked,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        label: label,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $9PmQV.adaptEventHandler)(onChange),
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("hqLEh", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroup", () => $8a6c935ee2f753cd$export$4aa08d5625cb8ead);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");

var $7gpC4 = parcelRequire("7gpC4");
const $8a6c935ee2f753cd$export$4aa08d5625cb8ead = (props)=>{
    const { name: name, options: options, value: value, onChange: onChange, defaultValue: defaultValue = [], isDisabled: isDisabled = false } = props.forgeDoc.props;
    const [selectedValues, setSelectedValues] = (0, $gwFzn.useState)(value ?? defaultValue);
    (0, $gwFzn.useEffect)(()=>{
        if (value) setSelectedValues(value);
    }, [
        value
    ]);
    const notStaticCheckbox = !value || onChange;
    const onCheckboxChange = (0, $gwFzn.useCallback)((event)=>{
        if (notStaticCheckbox) {
            const newSelectedValues = selectedValues.includes(event.target.value) ? selectedValues.filter((item)=>item !== event.target.value) : [
                ...selectedValues,
                event.target.value
            ];
            setSelectedValues(newSelectedValues);
            if (onChange) onChange(newSelectedValues);
        }
    }, [
        notStaticCheckbox,
        onChange,
        selectedValues,
        setSelectedValues
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        role: "group",
        children: options.map((item, index)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                name: name,
                value: item.value,
                label: item.label,
                isChecked: selectedValues.includes(item.value),
                isDisabled: item.isDisabled ?? isDisabled,
                onChange: onCheckboxChange
            }, index);
        })
    });
};

});

parcelRegister("hmPue", function(module, exports) {

$parcel$export(module.exports, "Code", () => $d25f8a1ec16dec2a$export$52f0f02147b12c03);
// Note: codeBidi props are not exposed to prevent misuse by malicious developers

var $7UHDa = parcelRequire("7UHDa");

var $27Z0V = parcelRequire("27Z0V");
parcelRequire("gwFzn");

var $lwZHY = parcelRequire("lwZHY");
const $d25f8a1ec16dec2a$export$bf0162d825d6e13 = {
    children: {
        value: 'getTextFromForgeDocChildren(props.forgeDoc)',
        comment: 'Only render string children'
    },
    testId: true
};
const $d25f8a1ec16dec2a$export$52f0f02147b12c03 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lwZHY.default), {
        // Only render string children
        children: (0, $27Z0V.getTextFromForgeDocChildren)(props.forgeDoc),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("27Z0V", function(module, exports) {

$parcel$export(module.exports, "getTextFromForgeDocChildren", () => $7b3d0d2c6f33df23$export$550573b096470df3);
const $7b3d0d2c6f33df23$export$550573b096470df3 = (forgeDoc)=>{
    return forgeDoc.children.map((child)=>{
        if (child?.props?.text) return child.props?.text;
        else return '';
    });
};

});


parcelRegister("iULMp", function(module, exports) {

$parcel$export(module.exports, "CodeBlock", () => $df2eef1efb6606e5$export$6c415d1fdae3dfdb);
// codeBidi props are not allowed to prevent malicious developers from misusing them.

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9QfXi = parcelRequire("9QfXi");
const $df2eef1efb6606e5$export$bf0162d825d6e13 = {
    text: true,
    testId: true,
    showLineNumbers: true,
    language: true,
    highlight: true,
    highlightedStartText: true,
    highlightedEndText: true,
    shouldWrapLongLines: true
};
const $df2eef1efb6606e5$export$6c415d1fdae3dfdb = (props)=>{
    const { text: text, testId: testId, showLineNumbers: showLineNumbers, language: language, highlight: highlight, highlightedStartText: highlightedStartText, highlightedEndText: highlightedEndText, shouldWrapLongLines: shouldWrapLongLines } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9QfXi.default), {
        text: text,
        testId: testId,
        showLineNumbers: showLineNumbers,
        language: language,
        highlight: highlight,
        highlightedStartText: highlightedStartText,
        highlightedEndText: highlightedEndText,
        shouldWrapLongLines: shouldWrapLongLines
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("gU1fc", function(module, exports) {

$parcel$export(module.exports, "Comment", () => $22edd9209cc89f16$export$4d299b491347818a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9PmQV = parcelRequire("9PmQV");

var $2AuBJ = parcelRequire("2AuBJ");
var $fy6ox = parcelRequire("fy6ox");
var $9Z0wk = parcelRequire("9Z0wk");
var $fJJGs = parcelRequire("fJJGs");
var $hlzjm = parcelRequire("hlzjm");
const $22edd9209cc89f16$export$4d299b491347818a = (props)=>{
    const { actions: actions, afterContent: afterContent, author: author, edited: edited, errorActions: errorActions, errorIconLabel: errorIconLabel, headingLevel: headingLevel, highlighted: highlighted, id: id, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, time: time, type: type } = props.forgeDoc.props;
    const avatarForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'avatar') return child;
    });
    const contentForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'content') return child;
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlzjm.default), {
        actions: actions?.map((action, index)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2AuBJ.default), {
                onClick: (0, $9PmQV.adaptEventHandler)(action?.onClick),
                children: action.text
            }, index);
        }),
        afterContent: afterContent,
        author: author ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fy6ox.default), {
            onClick: (0, $9PmQV.adaptEventHandler)(author?.onClick),
            children: author.text
        }) : undefined,
        avatar: avatarForgeDoc?.children.map(props.render),
        children: props.forgeDoc.children.filter((child)=>child.type !== 'ContentWrapper').map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        content: contentForgeDoc?.children.map(props.render),
        edited: edited ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Z0wk.default), {
            children: edited
        }) : undefined,
        errorActions: errorActions?.map((action, index)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2AuBJ.default), {
                onClick: (0, $9PmQV.adaptEventHandler)(action?.onClick),
                children: action.text
            }, index);
        }),
        errorIconLabel: errorIconLabel,
        headingLevel: headingLevel,
        highlighted: highlighted,
        id: id,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        testId: testId,
        time: time ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fJJGs.default), {
            onClick: (0, $9PmQV.adaptEventHandler)(time?.onClick),
            children: time.text
        }) : undefined,
        type: type
    });
};

});
parcelRegister("2AuBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e4a1d628a071f9a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gxtzC = parcelRequire("gxtzC");

var $eEA8O = parcelRequire("eEA8O");
const $4e4a1d628a071f9a$var$ActionItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver, isDisabled: isDisabled }, ref)=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAction',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to add support for analytics instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there are no negative
     * impacts to assistive technologies.
     */ // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
            ref: ref,
            appearance: "subtle-link",
            spacing: "none",
            type: "button",
            isDisabled: isDisabled,
            children: children
        })
    }));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4e4a1d628a071f9a$export$2e2bcd8739ae039 = $4e4a1d628a071f9a$var$ActionItem;

});

parcelRegister("fy6ox", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d73e8e60584e113$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gxtzC = parcelRequire("gxtzC");

var $7tyMu = parcelRequire("7tyMu");
const $5d73e8e60584e113$var$Author = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAuthor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7tyMu.default), {
        hasAuthor: true,
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$5d73e8e60584e113$var$Author.displayName = 'CommentAuthor';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5d73e8e60584e113$export$2e2bcd8739ae039 = $5d73e8e60584e113$var$Author;

});
parcelRegister("7tyMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24e02791d90685a$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $auNCB = parcelRequire("auNCB");
const $a24e02791d90685a$var$textStyles = {
    root: "_syaz1gjq"
};
const $a24e02791d90685a$var$anchorStyles = {
    root: "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2"
};
const $a24e02791d90685a$var$noAuthorStyles = {
    root: "_k48p1kw7"
};
const $a24e02791d90685a$var$hasAuthorStyles = {
    root: "_k48p1wq8"
}; /**
    * __Field__
    *
    * A field appears in the comment header to add metadata to the comment.
    *
    * @internal
    */ 
const $a24e02791d90685a$var$Field = ({ children: children, hasAuthor: hasAuthor, href: href, onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver, testId: testId })=>{
    return href ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auNCB.default), {
        href: href,
        xcss: (0, $1Whri.cx)($a24e02791d90685a$var$textStyles.root, $a24e02791d90685a$var$anchorStyles.root, hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root),
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        /**
                     * It is not normally acceptable to add key handlers to non-interactive elements
                     * as this is an accessibility anti-pattern. However, because this instance is
                     * to add support for analytics instead of creating an inaccessible
                     * custom element, we can add role="presentation" so that there are no negative
                     * impacts to assistive technologies.
                     */ role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $a24e02791d90685a$var$textStyles.root,
            hasAuthor ? $a24e02791d90685a$var$hasAuthorStyles.root : $a24e02791d90685a$var$noAuthorStyles.root
        ]),
        children: children
    });
};
var $a24e02791d90685a$export$2e2bcd8739ae039 = $a24e02791d90685a$var$Field;

});


parcelRegister("fJJGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3930f6319807484$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gxtzC = parcelRequire("gxtzC");

var $7tyMu = parcelRequire("7tyMu");
const $d3930f6319807484$var$CommentTime = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentTime',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7tyMu.default), {
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$d3930f6319807484$var$CommentTime.displayName = 'CommentTime';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3930f6319807484$export$2e2bcd8739ae039 = $d3930f6319807484$var$CommentTime;

});

parcelRegister("hlzjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d62a86395aa94f$export$2e2bcd8739ae039);
/* comment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $bVeqx = parcelRequire("bVeqx");

var $cV7U6 = parcelRequire("cV7U6");

var $ijtAN = parcelRequire("ijtAN");
const $93d62a86395aa94f$var$textStyles = {
    root: "_syaz1fxt",
    disabled: "_syaz1lh4"
};
/**
 * __Comment__
 *
 * Comments enable discussions on an entity such as a page, blog post, work item, or pull request.
 */ const $93d62a86395aa94f$var$Comment = ({ actions: actions = [], restrictedTo: restrictedTo = '', highlighted: highlighted = false, isSaving: isSaving = false, savingText: savingText = 'Sending...', isError: isError = false, errorActions: errorActions = [], errorIconLabel: errorIconLabel = '', author: author, avatar: avatar, children: children, content: content, edited: edited, time: time, type: type, testId: testId, id: id, afterContent: afterContent, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const headerProps = {
        author: author,
        edited: edited,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        time: time,
        type: type,
        headingLevel: headingLevel,
        shouldHeaderWrap: shouldHeaderWrap
    };
    const footerProps = {
        actions: actions,
        errorActions: errorActions,
        errorIconLabel: errorIconLabel,
        isError: isError,
        isSaving: isSaving
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ijtAN.default), {
        testId: testId,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        id: id,
        avatar: avatar,
        content: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cV7U6.default), {
                            testId: testId && `${testId}-header`,
                            ...headerProps
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            testId: testId && `${testId}-content`,
                            xcss: (0, $1Whri.cx)($93d62a86395aa94f$var$textStyles.root, (isSaving || isError) && $93d62a86395aa94f$var$textStyles.disabled),
                            children: content
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bVeqx.default), {
                    testId: testId && `${testId}-footer`,
                    ...footerProps
                }),
                afterContent
            ]
        }),
        highlighted: highlighted,
        children: children
    });
};
$93d62a86395aa94f$var$Comment.displayName = 'Comment';
var $93d62a86395aa94f$export$2e2bcd8739ae039 = $93d62a86395aa94f$var$Comment;

});
parcelRegister("bVeqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2b873e75f9e4281$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6hqEj = parcelRequire("6hqEj");

var $dcJ7R = parcelRequire("dcJ7R");

var $6fnsQ = parcelRequire("6fnsQ");
/**
 * __Footer items__
 *
 * The footer items in the comment. Usually reserved for error messages.
 *
 * @internal
 */ const $d2b873e75f9e4281$var$Footer = ({ actions: actions = [], errorActions: errorActions = [], errorIconLabel: errorIconLabel, isError: isError, isSaving: isSaving, testId: testId })=>{
    if (isSaving || !(actions.length || errorActions.length)) return null;
    const items = isError ? errorActions : actions;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        space: "space.100",
        separator: "\xb7",
        children: [
            isError && /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))), {
                spacing: "spacious",
                color: `var(--ds-icon-warning, ${(0, $6fnsQ.Y500)})`,
                label: errorIconLabel ? errorIconLabel : ''
            }),
            items.map((item, key)=>Object.assign({}, item, {
                    key: key
                }))
        ]
    });
};
$d2b873e75f9e4281$var$Footer.displayName = 'CommentFooter';
var $d2b873e75f9e4281$export$2e2bcd8739ae039 = $d2b873e75f9e4281$var$Footer;

});

parcelRegister("cV7U6", function(module, exports) {

$parcel$export(module.exports, "default", () => $09aac408a5a8747f$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $9Q2dU = parcelRequire("9Q2dU");

var $17uVW = parcelRequire("17uVW");

var $aIk0I = parcelRequire("aIk0I");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");
const $09aac408a5a8747f$var$headingStyles = {
    root: "_11c82smr"
};
const $09aac408a5a8747f$var$iconWrapperStyles = {
    root: "_18zrv77o _1e0c1txw"
}; /**
    * __Header items__
    *
    * Comment header items.
    *
    * @internal
    */ 
const $09aac408a5a8747f$var$Header = ({ author: author, edited: edited, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, time: time, testId: testId, type: type, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const Heading = `h${headingLevel}`;
    const shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
    return shouldRender ? /*#__PURE__*/ (0, $7UHDa.jsx)(Heading, {
        className: (0, $35pXk.default)([
            $09aac408a5a8747f$var$headingStyles.root
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            as: "span",
            shouldWrap: (0, $dh538.fg)('platform-comment-header-wrap') && shouldHeaderWrap,
            children: [
                author,
                type && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                    testId: testId && `${testId}-type`,
                    children: type
                }),
                time && !isSaving && !isError && time,
                edited || null,
                isSaving ? savingText : null,
                restrictedTo && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.050",
                        as: "span",
                        children: [
                            "\u2022",
                            (0, $dh538.fg)('platform-visual-refresh-icons-legacy-facade') || (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                as: "span",
                                xcss: $09aac408a5a8747f$var$iconWrapperStyles.root,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                    color: "currentColor",
                                    label: "",
                                    size: "small"
                                })
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($17uVW))), {
                                size: "small",
                                label: ""
                            }),
                            restrictedTo
                        ]
                    })
                })
            ]
        })
    }) : null;
};
$09aac408a5a8747f$var$Header.displayName = 'CommentHeader';
var $09aac408a5a8747f$export$2e2bcd8739ae039 = $09aac408a5a8747f$var$Header;

});

parcelRegister("ijtAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $768cc646e91e2e58$export$2e2bcd8739ae039);
/* layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $gdv5Z = parcelRequire("gdv5Z");
var $d8SNb = parcelRequire("d8SNb");
var $eyWa4 = parcelRequire("eyWa4");

var $6JC10 = parcelRequire("6JC10");

var $lmM8h = parcelRequire("lmM8h");
const $768cc646e91e2e58$var$containerStyles = {
    root: "_kqswh2mm _yv0e5bpd _1lmc1gx3"
};
const $768cc646e91e2e58$var$inlineCommentStyles = {
    root: "_1lmc1rav"
};
const $768cc646e91e2e58$var$noChildrenStyles = {
    root: "_1lmcvpz5"
};
// if the background is appied on Box and tokens are not switched on it breaks.
// This can be safely removed (and applied on Box) when tokens are on by default
const $768cc646e91e2e58$var$highlightOverlayStyles = {
    root: "_1r04x0bf _nd5l1sux _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _kqswstnw _lcxvglyw"
};
const $768cc646e91e2e58$var$stackOverrideStyles = {
    root: "_nd5l1dav _1q511ejb"
};
/**
 * __CommentLayout__
 *
 * The base layout for the comment component.
 *
 */ const $768cc646e91e2e58$var$Layout = ({ content: content, children: children, highlighted: highlighted, id: id, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, avatar: avatar })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $d8SNb.default), {
        gap: "space.100",
        xcss: (0, $1Whri.cx)($768cc646e91e2e58$var$containerStyles.root, shouldRenderNestedCommentsInline && $768cc646e91e2e58$var$inlineCommentStyles.root, !children && $768cc646e91e2e58$var$noChildrenStyles.root),
        testId: testId,
        id: id,
        children: [
            avatar && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6JC10.default), {
                children: avatar
            }),
            content && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lmM8h.default), {
                children: content
            }),
            children && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
                xcss: $768cc646e91e2e58$var$stackOverrideStyles.root,
                space: "space.400",
                children: children
            }),
            highlighted && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $768cc646e91e2e58$var$highlightOverlayStyles.root,
                backgroundColor: "color.background.neutral",
                testId: testId && `${testId}-highlighted`
            })
        ]
    });
$768cc646e91e2e58$var$Layout.displayName = 'CommentLayout';
var $768cc646e91e2e58$export$2e2bcd8739ae039 = $768cc646e91e2e58$var$Layout;

});
parcelRegister("6JC10", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ff3474eb3a1c0a$export$2e2bcd8739ae039);
/* avatar-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $d6ff3474eb3a1c0a$var$avatarSectionStyles = {
    root: "_nd5l1ofd"
};
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */ const $d6ff3474eb3a1c0a$var$AvatarSlot = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $d6ff3474eb3a1c0a$var$avatarSectionStyles.root,
        children: children
    });
var $d6ff3474eb3a1c0a$export$2e2bcd8739ae039 = $d6ff3474eb3a1c0a$var$AvatarSlot;

});

parcelRegister("lmM8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $df8b60abd3030907$export$2e2bcd8739ae039);
/* content-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $df8b60abd3030907$var$contentSlotStyles = {
    root: "_nd5l8niw _1ul9idpf _1q51v77o _slp31hna"
};
const $df8b60abd3030907$var$ContentSlot = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $df8b60abd3030907$var$contentSlotStyles.root
        ]),
        children: children
    });
var $df8b60abd3030907$export$2e2bcd8739ae039 = $df8b60abd3030907$var$ContentSlot;

});




parcelRegister("9dr2W", function(module, exports) {

$parcel$export(module.exports, "DatePicker", () => $0c16ee99e755f906$export$5109c6dd95d8fb00);
/**
 * Type for date picker had to be defined here because the type could not be imported from the datepicker module.
 * It is being declared in typings/atlaskit.d.ts which is preventing imports. If removed, type errors are introduced in components
 * outside of this package.
 *
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $c4Cbx = parcelRequire("c4Cbx");

var $9PmQV = parcelRequire("9PmQV");
const $0c16ee99e755f906$export$bf0162d825d6e13 = {
    appearance: true,
    defaultIsOpen: true,
    autoFocus: true,
    defaultValue: true,
    disabled: true,
    disabledDateFilter: false,
    maxDate: true,
    minDate: true,
    isOpen: {
        replaceLine: true,
        value: '{...(isOpen ? { isOpen }: undefined)}',
        comment: 'undefined is evaluated as true when isOpen is being explicitly set'
    },
    nextMonthLabel: true,
    parseInputValue: false,
    formatDisplayLabel: false,
    previousMonthLabel: true,
    selectProps: true,
    spacing: true,
    dateFormat: true,
    shouldShowCalendarButton: true,
    placeholder: true,
    locale: true,
    testId: true,
    weekStartDay: true,
    onChange: true,
    value: {
        replaceLine: true,
        value: '{...(value !== undefined ? { value }: undefined)}',
        comment: 'Explicitly setting value to undefined is causing issues'
    }
};
const $0c16ee99e755f906$export$5109c6dd95d8fb00 = (props)=>{
    const { appearance: appearance, defaultIsOpen: defaultIsOpen, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, maxDate: maxDate, minDate: minDate, isOpen: isOpen, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps, spacing: spacing, dateFormat: dateFormat, shouldShowCalendarButton: shouldShowCalendarButton, placeholder: placeholder, locale: locale, testId: testId, weekStartDay: weekStartDay, onChange: onChange, value: value, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    // warning: appearance is deprecated;
    // warning: defaultIsOpen is deprecated;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4Cbx.default), {
        appearance: appearance,
        defaultIsOpen: defaultIsOpen,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: disabled,
        maxDate: maxDate,
        minDate: minDate,
        ...isOpen ? {
            isOpen: isOpen
        } : undefined,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        selectProps: selectProps,
        spacing: spacing,
        dateFormat: dateFormat,
        shouldShowCalendarButton: shouldShowCalendarButton,
        placeholder: placeholder,
        locale: locale,
        testId: testId,
        weekStartDay: weekStartDay,
        onChange: onChange,
        ...value !== undefined ? {
            value: value
        } : undefined,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("bua6O", function(module, exports) {

$parcel$export(module.exports, "DynamicTable", () => $470ecb33486442bb$export$af35fa26cfd84ce3);
// stateful version of DynamicTable from @atlaskit

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1RqgI = parcelRequire("1RqgI");

var $aeJrv = parcelRequire("aeJrv");

var $j040i = parcelRequire("j040i");
/**
 * Non working props excluded:
 * isRankingDisabled
 * onPageRowsUpdate
 * onSort
 */ const $470ecb33486442bb$var$renderCellForgeDoc = (cells, render)=>cells.filter((cell)=>cell.type === 'Cell').map((cell)=>{
        const { children: children, props: cellProps } = cell;
        const { cellKey: cellKey, ...restProps } = cellProps || {};
        return {
            ...restProps,
            key: cellKey,
            content: children.map(render).flat()
        };
    });
const $470ecb33486442bb$export$af35fa26cfd84ce3 = (props)=>{
    if (props.forgeDoc.children.length === 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j040i.DynamicTable), {
        ...props
    });
    const { caption: caption, defaultPage: defaultPage, defaultSortKey: defaultSortKey, defaultSortOrder: defaultSortOrder, emptyView: emptyView, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, isLoading: isLoading, isRankable: isRankable, label: label, loadingSpinnerSize: loadingSpinnerSize, onRankEnd: onRankEnd, onRankStart: onRankStart, onSetPage: onSetPage, page: page, paginationi18n: paginationi18n, rowsPerPage: rowsPerPage, sortKey: sortKey, sortOrder: sortOrder, testId: testId } = props.forgeDoc.props;
    const headForgeDoc = props.forgeDoc.children.find((child)=>child.type === 'ContentWrapper' && child.props?.name === 'head');
    const head = headForgeDoc ? {
        cells: $470ecb33486442bb$var$renderCellForgeDoc(headForgeDoc?.children, props.render)
    } : undefined;
    const rowsForgeDoc = props.forgeDoc.children.find((child)=>child.type === 'ContentWrapper' && child.props?.name === 'rows');
    const rows = rowsForgeDoc?.children.filter((row)=>row.type === 'Row').map((row)=>{
        const { children: children, props: rowProps } = row;
        const { rowKey: rowKey, ...restProps } = rowProps || {};
        return {
            ...restProps,
            key: rowKey,
            cells: $470ecb33486442bb$var$renderCellForgeDoc(children, props.render)
        };
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RqgI.default), {
        caption: caption,
        defaultPage: defaultPage,
        defaultSortKey: defaultSortKey,
        defaultSortOrder: defaultSortOrder,
        emptyView: emptyView ? props.render((0, $aeJrv.elementToForgeDoc)(emptyView)) : undefined,
        head: head,
        highlightedRowIndex: highlightedRowIndex,
        isFixedSize: isFixedSize,
        isLoading: isLoading,
        isRankable: isRankable,
        label: label,
        loadingSpinnerSize: loadingSpinnerSize,
        onRankEnd: onRankEnd,
        onRankStart: onRankStart,
        onSetPage: onSetPage,
        page: page,
        paginationi18n: paginationi18n,
        rowsPerPage: rowsPerPage,
        rows: rows,
        sortKey: sortKey,
        sortOrder: sortOrder,
        testId: testId
    });
};

});
parcelRegister("1RqgI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f76d2aa2a1b6bce3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");

var $iZTFQ = parcelRequire("iZTFQ");

var $gEpEw = parcelRequire("gEpEw");
class $f76d2aa2a1b6bce3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gEpEw.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $iZTFQ.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}
$f76d2aa2a1b6bce3$export$2e2bcd8739ae039.defaultProps = {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $ee7An.default),
    onSort: (0, $ee7An.default),
    rowsPerPage: Infinity
};

});

parcelRegister("aeJrv", function(module, exports) {

$parcel$export(module.exports, "elementToForgeDoc", () => $e0c91e5c3783b9b5$export$1b341f978fa5ef9a);

var $kyKWe = parcelRequire("kyKWe");
const $e0c91e5c3783b9b5$var$Fragment = 'Fragment';
// Handles the different cases of React's fragment component
const $e0c91e5c3783b9b5$var$isReactFragment = (type)=>type === 'Symbol(react.fragment)' || type === 'fragment' || type === undefined;
// Filter out any children that contain only whitespace
const $e0c91e5c3783b9b5$var$filterEmptyReactChildren = (children)=>{
    // Ensuring children is an array here as single elements will be an object
    // React.Children.toArray is not used as certain components could be passing JSX as an object to elementToForgeDoc
    const childrenAsArray = Array.isArray(children) ? children : [
        children
    ];
    return childrenAsArray.filter((child)=>!!child && (typeof child !== 'string' || child.trim() !== ''));
};
// converts react element(s) to forgeDoc(s) recursively
// and additionally prune and cleanup unnecessary empty fragments
const $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling = (elem, isRoot = false)=>{
    // Handles string child for components
    if (typeof elem === 'string' || typeof elem === 'number') return {
        type: 'String',
        props: {
            text: elem
        },
        children: []
    };
    else if (Array.isArray(elem)) return elem.flatMap((e)=>$e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling(e));
    else if (typeof elem === 'object') {
        let type = elem.type?.toString();
        const key = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        if ($e0c91e5c3783b9b5$var$isReactFragment(type)) {
            type = $e0c91e5c3783b9b5$var$Fragment;
            if (!isRoot) {
                const { children: children } = elem.props;
                return $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling($e0c91e5c3783b9b5$var$filterEmptyReactChildren(children));
            }
        }
        // Remove children from props as we handle them separately
        const { children: children, ...rest } = elem.props;
        const props = rest;
        return {
            type: type,
            key: key,
            props: props,
            children: $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling($e0c91e5c3783b9b5$var$filterEmptyReactChildren(children))
        };
    }
    throw new Error(`Can\'t create ForgeDoc from ${elem}`);
};
const $e0c91e5c3783b9b5$export$1b341f978fa5ef9a = (elem)=>{
    const forgeDoc = $e0c91e5c3783b9b5$var$elementToForgeDocConversionWithFragmentHandling(elem, true);
    if (Array.isArray(forgeDoc)) throw new Error('Multiple root fragments are not supported');
    return forgeDoc;
};

});

parcelRegister("j040i", function(module, exports) {

$parcel$export(module.exports, "DynamicTable", () => $0914fdd51a14cb6f$export$af35fa26cfd84ce3);
// stateful version of DynamicTable from @atlaskit

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aeJrv = parcelRequire("aeJrv");

var $1RqgI = parcelRequire("1RqgI");
const $0914fdd51a14cb6f$export$bf0162d825d6e13 = {
    createAnalyticsEvent: false,
    caption: true,
    defaultPage: true,
    defaultSortKey: true,
    defaultSortOrder: true,
    emptyView: {
        value: 'emptyView ? props.render(elementToForgeDoc(emptyView)) as ReactElement : undefined'
    },
    head: {
        value: 'head ? renderRow(head, props.render): undefined',
        comment: "Rendering each cell's content as one React element"
    },
    highlightedRowIndex: true,
    isFixedSize: true,
    isLoading: true,
    isRankable: true,
    label: true,
    loadingSpinnerSize: true,
    onRankEnd: true,
    onRankStart: true,
    onSetPage: true,
    page: true,
    paginationi18n: true,
    rowsPerPage: true,
    rows: {
        value: 'rows?.map((r) => renderRow(r, props.render))',
        comment: "Rendering each cell's content as one React element"
    },
    sortKey: true,
    sortOrder: true,
    testId: true
};
const $0914fdd51a14cb6f$var$renderRow = (row, render)=>{
    // not supporting onClick and onKeyPress to simplify API
    const { cells: cells, onClick: onClick, onKeyPress: onKeyPress, ...rest } = row;
    return {
        ...rest,
        cells: cells.map((cell)=>{
            const preRenderedContent = cell.content !== undefined ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
                children: render((0, $aeJrv.elementToForgeDoc)(cell.content))
            }, cell.key) : null;
            return {
                ...cell,
                content: preRenderedContent
            };
        })
    };
};
const $0914fdd51a14cb6f$export$af35fa26cfd84ce3 = (props)=>{
    const { caption: caption, defaultPage: defaultPage, defaultSortKey: defaultSortKey, defaultSortOrder: defaultSortOrder, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, isLoading: isLoading, isRankable: isRankable, label: label, loadingSpinnerSize: loadingSpinnerSize, onRankEnd: onRankEnd, onRankStart: onRankStart, onSetPage: onSetPage, page: page, paginationi18n: paginationi18n, rowsPerPage: rowsPerPage, rows: rows, sortKey: sortKey, sortOrder: sortOrder, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RqgI.default), {
        caption: caption,
        defaultPage: defaultPage,
        defaultSortKey: defaultSortKey,
        defaultSortOrder: defaultSortOrder,
        emptyView: emptyView ? props.render((0, $aeJrv.elementToForgeDoc)(emptyView)) : undefined,
        // Rendering each cell's content as one React element
        head: head ? $0914fdd51a14cb6f$var$renderRow(head, props.render) : undefined,
        highlightedRowIndex: highlightedRowIndex,
        isFixedSize: isFixedSize,
        isLoading: isLoading,
        isRankable: isRankable,
        label: label,
        loadingSpinnerSize: loadingSpinnerSize,
        onRankEnd: onRankEnd,
        onRankStart: onRankStart,
        onSetPage: onSetPage,
        page: page,
        paginationi18n: paginationi18n,
        rowsPerPage: rowsPerPage,
        // Rendering each cell's content as one React element
        rows: rows?.map((r)=>$0914fdd51a14cb6f$var$renderRow(r, props.render)),
        sortKey: sortKey,
        sortOrder: sortOrder,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});


parcelRegister("cAQ31", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $7e65a5488f15879d$export$fddf379e22a74b00);

var $7UHDa = parcelRequire("7UHDa");

var $aeJrv = parcelRequire("aeJrv");
parcelRequire("gwFzn");

var $abC4X = parcelRequire("abC4X");
const $7e65a5488f15879d$export$bf0162d825d6e13 = {
    buttonGroupLabel: true,
    description: {
        value: 'description ? props.render(elementToForgeDoc(description as ReactElement)) : undefined'
    },
    header: true,
    headingLevel: true,
    imageHeight: false,
    imageUrl: false,
    imageWidth: false,
    isLoading: true,
    maxImageHeight: false,
    maxImageWidth: false,
    primaryAction: {
        value: 'primaryAction ? props.render(elementToForgeDoc(primaryAction as ReactElement)) : undefined'
    },
    renderImage: false,
    secondaryAction: {
        value: 'secondaryAction ? props.render(elementToForgeDoc(secondaryAction as ReactElement)) : undefined'
    },
    tertiaryAction: {
        value: 'tertiaryAction ? props.render(elementToForgeDoc(tertiaryAction as ReactElement)) : undefined'
    },
    testId: true,
    width: true
};
const $7e65a5488f15879d$export$fddf379e22a74b00 = (props)=>{
    const { buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel, isLoading: isLoading, primaryAction: primaryAction, secondaryAction: secondaryAction, tertiaryAction: tertiaryAction, testId: testId, width: width } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $abC4X.default), {
        buttonGroupLabel: buttonGroupLabel,
        description: description ? props.render((0, $aeJrv.elementToForgeDoc)(description)) : undefined,
        header: header,
        headingLevel: headingLevel,
        isLoading: isLoading,
        primaryAction: primaryAction ? props.render((0, $aeJrv.elementToForgeDoc)(primaryAction)) : undefined,
        secondaryAction: secondaryAction ? props.render((0, $aeJrv.elementToForgeDoc)(secondaryAction)) : undefined,
        tertiaryAction: tertiaryAction ? props.render((0, $aeJrv.elementToForgeDoc)(tertiaryAction)) : undefined,
        testId: testId,
        width: width
    });
}; /**
 * @codegenEnd
 */  /* eslint @repo/internal/codegen/signed-source-integrity: "warn" */ 

});

parcelRegister("2Z8T6", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $03f0e1b1264f2dff$export$915e9e7bd4f0f96d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gQhRa = parcelRequire("gQhRa");
const $03f0e1b1264f2dff$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $03f0e1b1264f2dff$export$915e9e7bd4f0f96d = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("5JZv6", function(module, exports) {

$parcel$export(module.exports, "Flex", () => $1e214349972aaec0$export$f51f4c4ede09e011);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bUlM5 = parcelRequire("bUlM5");
const $1e214349972aaec0$export$bf0162d825d6e13 = {
    children: true,
    as: false,
    justifyContent: true,
    alignItems: true,
    columnGap: true,
    gap: true,
    rowGap: true,
    direction: true,
    wrap: true,
    testId: true,
    'data-testid': false,
    role: true,
    xcss: false
};
const $1e214349972aaec0$export$f51f4c4ede09e011 = (props)=>{
    const { justifyContent: justifyContent, alignItems: alignItems, columnGap: columnGap, gap: gap, rowGap: rowGap, direction: direction, wrap: wrap, testId: testId, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        justifyContent: justifyContent,
        alignItems: alignItems,
        columnGap: columnGap,
        gap: gap,
        rowGap: rowGap,
        direction: direction,
        wrap: wrap,
        testId: testId,
        role: role
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("8a4Jc", function(module, exports) {

$parcel$export(module.exports, "Form", () => $1ebfea88a67bc737$export$a7fed597f4b8afd8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $1ebfea88a67bc737$export$a7fed597f4b8afd8 = (props)=>{
    const { onSubmit: onSubmit } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit();
        },
        children: props.forgeDoc.children.map(props.render)
    });
};
const $1ebfea88a67bc737$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(null);

});

parcelRegister("48Sur", function(module, exports) {

$parcel$export(module.exports, "FormFooter", () => $05422e99a34922d5$export$e7277fd05612133d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dn4ZF = parcelRequire("dn4ZF");
const $05422e99a34922d5$export$bf0162d825d6e13 = {
    children: true,
    /**
	 * Sets the alignment of the footer contents. This is often a button. Defaults to `end`.
	 */ align: true
};
const $05422e99a34922d5$export$e7277fd05612133d = (props)=>{
    const { align: align } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dn4ZF.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        align: align
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("3VqTP", function(module, exports) {

$parcel$export(module.exports, "FormHeader", () => $8f165c1167364179$export$97ee2cbf37e5ebfe);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $brqG4 = parcelRequire("brqG4");
const $8f165c1167364179$export$bf0162d825d6e13 = {
    title: true,
    description: true,
    children: true
};
const $8f165c1167364179$export$97ee2cbf37e5ebfe = (props)=>{
    const { title: title, description: description } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $brqG4.default), {
        title: title,
        description: description,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key))
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("khMWP", function(module, exports) {

$parcel$export(module.exports, "FormSection", () => $767d61145e43c730$export$b5ff61ac8b0a660f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3eD0p = parcelRequire("3eD0p");
const $767d61145e43c730$export$bf0162d825d6e13 = {
    title: true,
    children: true,
    description: true
};
const $767d61145e43c730$export$b5ff61ac8b0a660f = (props)=>{
    const { title: title, description: description } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3eD0p.default), {
        title: title,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        description: description
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("99RJG", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $96ceb9d2478856d1$export$ef2184bd89960b14);
// Note that the prop `templateAreas` is removed as it requires child components to use `style`

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $cwkWT = parcelRequire("cwkWT");
const $96ceb9d2478856d1$export$bf0162d825d6e13 = {
    children: true,
    as: false,
    justifyContent: true,
    justifyItems: true,
    alignItems: true,
    alignContent: true,
    columnGap: true,
    gap: true,
    rowGap: true,
    autoFlow: true,
    templateRows: true,
    templateColumns: true,
    templateAreas: false,
    id: true,
    testId: true,
    'data-testid': false,
    role: true,
    xcss: false
};
const $96ceb9d2478856d1$export$ef2184bd89960b14 = (props)=>{
    const { justifyContent: justifyContent, justifyItems: justifyItems, alignItems: alignItems, alignContent: alignContent, columnGap: columnGap, gap: gap, rowGap: rowGap, autoFlow: autoFlow, templateRows: templateRows, templateColumns: templateColumns, id: id, testId: testId, role: role } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cwkWT.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        justifyContent: justifyContent,
        justifyItems: justifyItems,
        alignItems: alignItems,
        alignContent: alignContent,
        columnGap: columnGap,
        gap: gap,
        rowGap: rowGap,
        autoFlow: autoFlow,
        templateRows: templateRows,
        templateColumns: templateColumns,
        id: id,
        testId: testId,
        role: role
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("6u5lR", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $b6182902fe2166c0$export$a8a3e93435678ff9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7hXDW = parcelRequire("7hXDW");
const $b6182902fe2166c0$export$bf0162d825d6e13 = {
    size: {
        excludeFromDeconstruct: false,
        value: 'size ? size : getSize(as)'
    },
    color: true,
    as: {
        excludeFromDeconstruct: false,
        value: 'onlyAllowHeadingTag(as)'
    },
    children: true,
    id: true,
    testId: true
};
const $b6182902fe2166c0$var$onlyAllowHeadingTag = (asProp)=>{
    if (!asProp) return undefined;
    if (asProp && [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'div',
        'span'
    ].includes(asProp)) return asProp;
    throw Error(`${asProp} is an invalid heading tag. Please use one of h1, h2, h3, h4, h5, h6, div, span.`);
};
const $b6182902fe2166c0$var$getSize = (asProp)=>{
    if (!asProp) return 'xlarge';
    const sizeMap = {
        h1: 'xlarge',
        h2: 'large',
        h3: 'medium',
        h4: 'small',
        h5: 'xsmall',
        h6: 'xxsmall'
    };
    return sizeMap[asProp];
};
const $b6182902fe2166c0$export$a8a3e93435678ff9 = (props)=>{
    const { size: size, color: color, as: as, id: id, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        size: size ? size : $b6182902fe2166c0$var$getSize(as),
        color: color,
        as: $b6182902fe2166c0$var$onlyAllowHeadingTag(as),
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        id: id,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("8Tqzl", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $93789ff5869bb338$export$8fbe3c7d0ed2c683);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gQhRa = parcelRequire("gQhRa");
const $93789ff5869bb338$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $93789ff5869bb338$export$8fbe3c7d0ed2c683 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.HelperMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("64TIr", function(module, exports) {

$parcel$export(module.exports, "Image", () => $39a34e462e058bd0$export$3e431a229df88919);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kS0x0 = parcelRequire("kS0x0");

var $er4dw = parcelRequire("er4dw");
const $39a34e462e058bd0$export$baab7c95ad93ac5a = {
    xsmall: '25%',
    small: '37.5%',
    medium: '50%',
    large: '75%',
    xlarge: '100%'
};
function $39a34e462e058bd0$var$ImageInner({ forgeDoc: forgeDoc }) {
    const { src: src, alt: alt, size: size = 'xlarge', width: width, height: height } = forgeDoc.props;
    const isCustomSize = width || height;
    const fixedImageSize = $39a34e462e058bd0$export$baab7c95ad93ac5a[size] ? $39a34e462e058bd0$export$baab7c95ad93ac5a[size] : '100%';
    const maxWidth = isCustomSize ? '100%' : fixedImageSize; // the width and height props will override the size prop
    return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 'auto',
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textAlign: 'center'
        },
        src: src,
        alt: alt,
        width: width,
        height: height
    });
}
const $39a34e462e058bd0$export$3e431a229df88919 = (props)=>{
    const { src: src } = props.forgeDoc.props;
    const isValidUrl = (0, $kS0x0.useIsValidImageUrl)(src);
    if (isValidUrl) return /*#__PURE__*/ (0, $7UHDa.jsx)($39a34e462e058bd0$var$ImageInner, {
        ...props
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $er4dw.EgressErrorMessage), {
        url: src
    });
};

});

parcelRegister("cjUe4", function(module, exports) {

$parcel$export(module.exports, "Inline", () => $f76c54d59d098003$export$fbae5b5ffd8af05e);
// Grow is being excluded at the moment as it requires a Box component to have `flexGrow: 1` as a property

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dcJ7R = parcelRequire("dcJ7R");
const $f76c54d59d098003$export$bf0162d825d6e13 = {
    children: true,
    alignBlock: true,
    alignInline: true,
    spread: true,
    grow: true,
    space: true,
    shouldWrap: true,
    separator: true,
    rowSpace: true,
    testId: true
};
const $f76c54d59d098003$export$fbae5b5ffd8af05e = (props)=>{
    const { alignBlock: alignBlock, alignInline: alignInline, spread: spread, grow: grow, space: space, shouldWrap: shouldWrap, separator: separator, rowSpace: rowSpace, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        alignBlock: alignBlock,
        alignInline: alignInline,
        spread: spread,
        grow: grow,
        space: space,
        shouldWrap: shouldWrap,
        separator: separator,
        rowSpace: rowSpace,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("fMaYs", function(module, exports) {

$parcel$export(module.exports, "InlineEdit", () => $c6aec3aaf282f684$export$97bda0f90d93904c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lUjjs = parcelRequire("lUjjs");
const $c6aec3aaf282f684$var$noop = ()=>{};
const $c6aec3aaf282f684$export$97bda0f90d93904c = (props)=>{
    const { label: label, startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, onConfirm: providedOnConfirm = $c6aec3aaf282f684$var$noop, onCancel: providedOnCancel = $c6aec3aaf282f684$var$noop, onEdit: providedOnEdit = $c6aec3aaf282f684$var$noop } = props.forgeDoc.props;
    const readViewForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'readView') return child;
    });
    const editViewForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'editView') return child;
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lUjjs.default), {
        label: label,
        startWithEditViewOpen: startWithEditViewOpen,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur,
        hideActionButtons: hideActionButtons,
        isRequired: isRequired,
        readViewFitContainerWidth: readViewFitContainerWidth,
        editButtonLabel: editButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        cancelButtonLabel: cancelButtonLabel,
        defaultValue: defaultValue,
        isEditing: isEditing,
        readView: ()=>readViewForgeDoc?.children.map(props.render),
        editView: ()=>editViewForgeDoc?.children.map(props.render),
        onConfirm: providedOnConfirm,
        onCancel: providedOnCancel,
        onEdit: providedOnEdit
    });
};

});

parcelRegister("bVZ7M", function(module, exports) {

$parcel$export(module.exports, "Label", () => $2949b71a9c026983$export$b04be29aa201d4f5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bfgIy = parcelRequire("bfgIy");
const $2949b71a9c026983$export$bf0162d825d6e13 = {
    /**
	 * Content of the label.
	 */ children: true,
    /**
	 * The unique identifier to match the label to the field component `id`.
	 */ htmlFor: {
        value: 'labelFor',
        excludeFromDeconstruct: true,
        comment: 'labelFor as prop name to remove reference to HTML'
    },
    /**
	 * The unique identifier for the label.
	 */ id: true,
    testId: true
};
const $2949b71a9c026983$export$b04be29aa201d4f5 = (props)=>{
    const { id: id, testId: testId, labelFor: labelFor } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bfgIy.Label), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        // labelFor as prop name to remove reference to HTML
        htmlFor: labelFor,
        id: id,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("g1GtN", function(module, exports) {

$parcel$export(module.exports, "Link", () => $79ffaea80c8babc5$export$a6c7ac8248d6e38a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gGmck = parcelRequire("gGmck");

var $kZjf5 = parcelRequire("kZjf5");

var $clpPd = parcelRequire("clpPd");

var $dh538 = parcelRequire("dh538");
const $79ffaea80c8babc5$var$LinkOld = (props)=>{
    const { forgeDoc: forgeDoc, render: render } = props;
    const { href: href, openNewTab: openNewTab } = forgeDoc.props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        target: openNewTab ? '_blank' : undefined,
        href: (0, $clpPd.sanitizeUrl)(href),
        rel: "noopener noreferrer",
        children: forgeDoc.children.map(render)
    }));
};
const $79ffaea80c8babc5$var$LinkNew = (props)=>{
    const { egress: egress, properties: properties } = (0, $gwFzn.useContext)((0, $gGmck.RendererContext));
    const { forgeDoc: forgeDoc, render: render } = props;
    const { href: href, openNewTab: openNewTab } = forgeDoc.props;
    const extension = {
        egress: egress,
        properties: properties
    };
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: extension
    });
    const santizedUrl = (0, $clpPd.sanitizeUrl)(href);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            getModalJsx(),
            /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                target: openNewTab ? '_blank' : undefined,
                href: santizedUrl,
                onClick: (e)=>{
                    // stop the usual navigation event from anchor tags
                    e.preventDefault();
                    onNavigate({
                        type: openNewTab ? 'new-tab' : 'same-tab',
                        url: santizedUrl
                    });
                },
                rel: "noopener noreferrer",
                children: forgeDoc.children.map(render)
            })
        ]
    });
};
const $79ffaea80c8babc5$export$a6c7ac8248d6e38a = (props)=>{
    return (0, $dh538.fg)('ui-kit-link-egress-patch') ? /*#__PURE__*/ (0, $7UHDa.jsx)($79ffaea80c8babc5$var$LinkNew, {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($79ffaea80c8babc5$var$LinkOld, {
        ...props
    });
};

});

parcelRegister("gyKm3", function(module, exports) {

$parcel$export(module.exports, "LinkButton", () => $d8f17ec7cdc8b68d$export$29d11c0fe2fc51d8);
/* link-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $7p4As = parcelRequire("7p4As");

var $clpPd = parcelRequire("clpPd");

var $9PmQV = parcelRequire("9PmQV");

var $aKn4O = parcelRequire("aKn4O");
const $d8f17ec7cdc8b68d$var$defaultStyle = null;
const $d8f17ec7cdc8b68d$var$primaryStyle = null;
const $d8f17ec7cdc8b68d$var$warningStyle = null;
const $d8f17ec7cdc8b68d$var$dangerStyle = null;
const $d8f17ec7cdc8b68d$var$discoveryStyle = null;
const $d8f17ec7cdc8b68d$var$subtleStyle = null; /**
                           * Type for link button had to be defined here because the prop `href` should only take strings here
                           * and not custom RouterLinkConfigs
                           */ 
const $d8f17ec7cdc8b68d$var$mapDeprecatedAppearances = (appearance)=>appearance === 'link' || appearance === 'subtle-link' ? 'subtle' : appearance; /**
                                                                                                                                                                * Mapping the deprecated 'none' spacing to 'compact'
                                                                                                                                                                */ 
const $d8f17ec7cdc8b68d$var$mapDeprecatedSpacing = (spacing)=>spacing === 'none' ? 'compact' : spacing; /**
                                                                                                                 * Renders a link in the style of a button.
                                                                                                                 */ 
const $d8f17ec7cdc8b68d$var$BaseLinkButton = (props)=>{
    const { target: target, href: href, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, appearance: appearance } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
        target: target,
        href: (0, $clpPd.sanitizeUrl)(href),
        rel: 'noopener noreferrer',
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onClick: (0, $9PmQV.adaptEventHandler)(onClick),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        spacing: $d8f17ec7cdc8b68d$var$mapDeprecatedSpacing(spacing),
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        appearance: $d8f17ec7cdc8b68d$var$mapDeprecatedAppearances(appearance)
    });
}; /**
    * This overrides global anchor tag styling that affects link button in byline content apps
    */ 
const $d8f17ec7cdc8b68d$export$29d11c0fe2fc51d8 = (props)=>{
    const isBylineItem = (0, $aKn4O.useIsBylineItem)();
    const { appearance: appearance } = props.forgeDoc.props;
    return isBylineItem ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            appearance === undefined && "_1tjq1fxt",
            appearance === 'primary' && "_1tjq15cr",
            appearance === 'warning' && "_1tjqal3n",
            appearance === 'danger' && "_1tjq15cr",
            appearance === 'discovery' && "_1tjq15cr",
            appearance === 'subtle' && "_1tjq1fxt"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($d8f17ec7cdc8b68d$var$BaseLinkButton, {
            ...props
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($d8f17ec7cdc8b68d$var$BaseLinkButton, {
        ...props
    });
};

});
parcelRegister("aKn4O", function(module, exports) {

$parcel$export(module.exports, "useIsMacro", () => $ad0fe6534ffb7bc3$export$aabfca967ce25e7e);
$parcel$export(module.exports, "useIsBylineItem", () => $ad0fe6534ffb7bc3$export$30f7d67d7263f4a6);

var $gwFzn = parcelRequire("gwFzn");

var $gGmck = parcelRequire("gGmck");
const $ad0fe6534ffb7bc3$export$aabfca967ce25e7e = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $gGmck.RendererContext));
    return extensionType === 'xen:macro';
};
const $ad0fe6534ffb7bc3$export$30f7d67d7263f4a6 = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $gGmck.RendererContext));
    return extensionType === 'confluence:contentBylineItem';
};

});


parcelRegister("cNdyU", function(module, exports) {

$parcel$export(module.exports, "List", () => $6528e052fc61f2c8$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $aKn4O = parcelRequire("aKn4O");
const $6528e052fc61f2c8$var$defaultMarginStyle = null;
const $6528e052fc61f2c8$var$styles = {
    macroMargin: "_18u01b66 _19pku2gc"
};
const $6528e052fc61f2c8$var$defaultStyle = null; // bullet style ordering
const $6528e052fc61f2c8$var$UNORDERED_LIST_STYLES = [
    'disc',
    'circle',
    'square'
];
const $6528e052fc61f2c8$var$ORDERED_LIST_STYLES = [
    'decimal',
    'lower-alpha',
    'lower-roman'
]; // create a type ForgeDocWihData that includes an indentLevel object, to avoid exposing indentLevel prop in ListProps
const $6528e052fc61f2c8$export$54c2e3dc7acea9f5 = (props)=>{
    const { forgeDoc: forgeDoc, render: render } = props;
    const { type: type } = props.forgeDoc.props;
    const forgeDocWithData = forgeDoc; // initialise indentLevel to 0 and add to forgeDocWithData
    if (forgeDocWithData.data === undefined) forgeDocWithData.data = {
        indentLevel: 0
    };
     // the indentLevel is used to determine the list item style that should be rendered for that level
    const { indentLevel: indentLevel } = forgeDocWithData.data;
    const isMacro = (0, $aKn4O.useIsMacro)(); // set the list style according to the list type
    const listType = type === 'ordered' ? $6528e052fc61f2c8$var$ORDERED_LIST_STYLES : $6528e052fc61f2c8$var$UNORDERED_LIST_STYLES; // pass iterated indentLevel to child
    forgeDocWithData.children.forEach((child)=>{
        // This `if` block needs to be deprecated. `List` children should always be `ListItem`s, not another `List`
        // Using `List` as a child of `List` fails accessibility tests
        if (child.type === 'List') child.data = {
            ...child.data,
            indentLevel: indentLevel + 1
        };
        if (child.type === 'ListItem') // Iterate through children of `ListItem` to find any `List` children to pass indentLevel
        // This is to render the correct list style
        child.children.forEach((grandChild)=>{
            if (grandChild.type === 'List') grandChild.data = {
                ...child.data,
                indentLevel: indentLevel + 1
            };
        });
    });
    const listChildren = forgeDocWithData.children.map((child)=>render(child)); // We have to use "style" here since the value for the "list-style-type" property is dynamic (based on the indentation level).
    // Compiled does not support dynamic values and @compiled/babel-plugin would not be able to transform this code.
    // See https://atlassian.design/components/eslint-plugin-ui-styling-standard/migration-guide#dynamic-styles
    const listComponent = type === 'ordered' ? /*#__PURE__*/ (0, $7UHDa.jsx)("ol", {
        style: {
            listStyleType: listType[indentLevel % listType.length]
        },
        className: (0, $35pXk.default)([
            "_vwz41ejb _xhc01b66",
            "_18u0mgjw"
        ]),
        children: listChildren
    }, forgeDocWithData.key) : /*#__PURE__*/ (0, $7UHDa.jsx)("ul", {
        style: {
            listStyleType: listType[indentLevel % listType.length]
        },
        className: (0, $35pXk.default)([
            "_vwz41ejb _xhc01b66",
            "_18u0mgjw"
        ]),
        children: listChildren
    }, forgeDocWithData.key);
    if (isMacro && indentLevel === 0) // Applying an additional margin when used in a macro extension point as the editor contains styling that causes decimal bullets to overflow and be cut off. The additional margin shifts the List component to prevent the cut off.
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $6528e052fc61f2c8$var$styles.macroMargin,
        children: listComponent
    });
    return listComponent;
};

});

parcelRegister("8tpmm", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $fda6ba8c44d5f6e4$export$a7b06bfba60a8a78);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $fda6ba8c44d5f6e4$export$a7b06bfba60a8a78 = (props)=>{
    const { forgeDoc: forgeDoc, render: render } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
        children: forgeDoc.children.map(render)
    }, forgeDoc.key);
};

});

parcelRegister("7i4Hu", function(module, exports) {

$parcel$export(module.exports, "LoadingButton", () => $a7a849b4fabaa947$export$4ec83e90d030b2f3);
/* loading-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $aKn4O = parcelRequire("aKn4O");

var $9PmQV = parcelRequire("9PmQV");

var $gwFzn = parcelRequire("gwFzn");

var $9YwaJ = parcelRequire("9YwaJ");
const $a7a849b4fabaa947$var$buttonStyle = null;
const $a7a849b4fabaa947$export$4ec83e90d030b2f3 = (props)=>{
    const { appearance: appearance, autoFocus: autoFocus, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, spacing: spacing, testId: testId, shouldFitContainer: shouldFitContainer, type: type, isLoading: isLoading } = props.forgeDoc.props;
    const isMacro = (0, $aKn4O.useIsMacro)();
    const isBylineItem = (0, $aKn4O.useIsBylineItem)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            (isMacro || isBylineItem) && "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9YwaJ.default), {
            children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                    children: props.render(c)
                }, c.key)),
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
            onClick: (0, $9PmQV.adaptEventHandler)(onClick),
            onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
            spacing: spacing,
            testId: testId,
            shouldFitContainer: shouldFitContainer,
            type: type,
            isLoading: isLoading
        })
    });
};

});

parcelRegister("evykB", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $8e74fad470730542$export$a31cbe1bf5463979);

var $7UHDa = parcelRequire("7UHDa");

var $27Z0V = parcelRequire("27Z0V");
parcelRequire("gwFzn");

var $aIk0I = parcelRequire("aIk0I");
const $8e74fad470730542$export$bf0162d825d6e13 = {
    appearance: true,
    children: {
        value: 'getTextFromForgeDocChildren(props.forgeDoc)',
        comment: 'Lozenge should only accept plain text as children'
    },
    isBold: true,
    maxWidth: true,
    testId: true
};
const $8e74fad470730542$export$a31cbe1bf5463979 = (props)=>{
    const { appearance: appearance, isBold: isBold, maxWidth: maxWidth, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
        appearance: appearance,
        // Lozenge should only accept plain text as children
        children: (0, $27Z0V.getTextFromForgeDocChildren)(props.forgeDoc),
        isBold: isBold,
        maxWidth: maxWidth,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("gYSxw", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $f666e114719e56a0$export$2b77a92f1a5ad772);

var $7UHDa = parcelRequire("7UHDa");

var $9PmQV = parcelRequire("9PmQV");

var $gwFzn = parcelRequire("gwFzn");

var $ekolh = parcelRequire("ekolh");
const $f666e114719e56a0$export$bf0162d825d6e13 = {
    autoFocus: true,
    children: true,
    height: true,
    width: true,
    onClose: {
        value: 'adaptEventHandler(onClose) as OnCloseHandler'
    },
    onCloseComplete: false,
    onOpenComplete: false,
    onStackChange: false,
    shouldScrollInViewport: true,
    shouldCloseOnOverlayClick: false,
    shouldCloseOnEscapePress: false,
    shouldReturnFocus: false,
    isBlanketHidden: false,
    stackIndex: false,
    label: true,
    testId: true
};
const $f666e114719e56a0$export$2b77a92f1a5ad772 = (props)=>{
    const { autoFocus: autoFocus, height: height, width: width, onClose: onClose, shouldScrollInViewport: shouldScrollInViewport, label: label, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ekolh.default), {
        autoFocus: autoFocus,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        height: height,
        width: width,
        onClose: (0, $9PmQV.adaptEventHandler)(onClose),
        shouldScrollInViewport: shouldScrollInViewport,
        label: label,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("fUUXd", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $fc93215de45af324$export$cb540d8b0ef7906c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1DHa6 = parcelRequire("1DHa6");
const $fc93215de45af324$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $fc93215de45af324$export$cb540d8b0ef7906c = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("1TJ7p", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $0317a808cd1fde51$export$519437715052e656);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $8o1lj = parcelRequire("8o1lj");
const $0317a808cd1fde51$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $0317a808cd1fde51$export$519437715052e656 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8o1lj.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("FPPvd", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $9f7a43a09b6f4394$export$f50a68e3694789ee);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9ot3w = parcelRequire("9ot3w");
const $9f7a43a09b6f4394$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $9f7a43a09b6f4394$export$f50a68e3694789ee = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("fiQfD", function(module, exports) {

$parcel$export(module.exports, "ModalTitle", () => $953c31e66b49cd3a$export$b26fae16ba5468aa);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8eRd = parcelRequire("d8eRd");
const $953c31e66b49cd3a$export$bf0162d825d6e13 = {
    appearance: true,
    children: true,
    isMultiline: true,
    testId: true
};
const $953c31e66b49cd3a$export$b26fae16ba5468aa = (props)=>{
    const { appearance: appearance, isMultiline: isMultiline, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
        appearance: appearance,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        isMultiline: isMultiline,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("bKcia", function(module, exports) {

$parcel$export(module.exports, "ModalTransition", () => $e6ff594647c24f09$export$f0a3ab1cc2e7e9a6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6xdDU = parcelRequire("6xdDU");
const $e6ff594647c24f09$export$bf0162d825d6e13 = {
    children: true
};
const $e6ff594647c24f09$export$f0a3ab1cc2e7e9a6 = (props)=>{
    const {} = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key))
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("aEqpx", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $6526f160ae33ce5b$export$129a32eedafa97c5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lGgRw = parcelRequire("lGgRw");

var $gdv5Z = parcelRequire("gdv5Z");

var $1Whri = parcelRequire("1Whri");
// This is required to keep the div width wrapped around the contents of trigger instead of the full width of the parent
const $6526f160ae33ce5b$var$styles = {
    triggerContainer: "_1e0c1o8l",
    fullWidth: "_1bsb1osq"
};
const $6526f160ae33ce5b$export$129a32eedafa97c5 = (props)=>{
    const { isOpen: isOpen, id: providedId, testId: testId, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement, fallbackPlacements: fallbackPlacements, autoFocus: autoFocus, shouldRenderToParent: shouldRenderToParent, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, strategy: strategy, role: role, label: label, titleId: titleId } = props.forgeDoc.props;
    const contentForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'content') return child;
    });
    const triggerForgeDoc = props.forgeDoc.children.find((child)=>{
        if (child.type === 'ContentWrapper' && child.props?.name === 'trigger') return child;
    });
    // Trigger props need to be passed internally here because it contains a ref object which can't be passed in the runtime
    // The double span is a workaround to ensure the span is wrapped around the popup trigger component without it extending the width of the container when used within `Inline`. Otherwise, the popup trigger component will extend the width of the container.
    const TriggerComponent = ({ triggerProps: triggerProps, shouldFitContainer: shouldFitContainer })=>{
        // aria props removed as they fail accessibility tests when passed into a span
        const { 'aria-expanded': _expanded, 'aria-haspopup': _popup, ...restTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            as: "span",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: (0, $1Whri.cx)($6526f160ae33ce5b$var$styles.triggerContainer, shouldFitContainer && $6526f160ae33ce5b$var$styles.fullWidth),
                ...restTriggerProps,
                children: triggerForgeDoc?.children.map(props.render)
            })
        });
    };
    /**
   * This check is necessary because of the conditional typing for PopupProps in ADS.
   * It has a union type `type PopupProps = StandardPopupProps | ShouldFitContainerPopupProps` where combined,
   * the `shouldFitContainer` prop is actually typed `(false | undefined) OR true`.
   * However, this resolves as `boolean | undefined`, which does not match the ADS typing. Therefore we need to declare two versions -
   * where `shouldFitContainer` is explicitly true (to match `ShouldFitContainerPopupProps`), and false (to match StandardPopupProps).
   */ if (shouldFitContainer) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        content: ()=>contentForgeDoc?.children.map(props.render),
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        id: providedId,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldFitContainer: shouldFitContainer,
        shouldRenderToParent: shouldRenderToParent ? shouldRenderToParent : undefined,
        strategy: strategy ? 'absolute' : undefined,
        shouldDisableFocusLock: shouldDisableFocusLock,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)(TriggerComponent, {
                triggerProps: triggerProps,
                shouldFitContainer: true
            }),
        role: role,
        label: label,
        titleId: titleId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        content: ()=>contentForgeDoc?.children.map(props.render),
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        id: providedId,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)(TriggerComponent, {
                triggerProps: triggerProps
            }),
        strategy: strategy,
        role: role,
        label: label,
        titleId: titleId
    });
};

});

parcelRegister("oCFvm", function(module, exports) {

$parcel$export(module.exports, "Pressable", () => $594ae92b09a9e868$export$27c701ed9e449e99);
// The below lint rules are disabled because Pressable relies on building styles at runtime from in Forge apps
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ 
var $7UHDa = parcelRequire("7UHDa");

var $9PmQV = parcelRequire("9PmQV");

var $7Ytfp = parcelRequire("7Ytfp");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $gwFzn = parcelRequire("gwFzn");
const $594ae92b09a9e868$export$bf0162d825d6e13 = {
    backgroundColor: true,
    "data-testid": false,
    children: true,
    isDisabled: true,
    onClick: {
        value: 'adaptEventHandler(onClick)'
    },
    padding: true,
    paddingBlock: true,
    paddingBlockEnd: true,
    paddingBlockStart: true,
    paddingInline: true,
    paddingInlineEnd: true,
    paddingInlineStart: true,
    style: false,
    testId: true,
    xcss: {
        value: 'xcss && platformXCSS(xcssValidator(xcss) as PlatformXCSSParam)'
    }
};
const $594ae92b09a9e868$export$27c701ed9e449e99 = (props)=>{
    const { backgroundColor: backgroundColor, isDisabled: isDisabled, onClick: onClick, padding: padding, paddingBlock: paddingBlock, paddingBlockEnd: paddingBlockEnd, paddingBlockStart: paddingBlockStart, paddingInline: paddingInline, paddingInlineEnd: paddingInlineEnd, paddingInlineStart: paddingInlineStart, testId: testId, xcss: xcss } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
        backgroundColor: backgroundColor,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        isDisabled: isDisabled,
        onClick: (0, $9PmQV.adaptEventHandler)(onClick),
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockEnd: paddingBlockEnd,
        paddingBlockStart: paddingBlockStart,
        paddingInline: paddingInline,
        paddingInlineEnd: paddingInlineEnd,
        paddingInlineStart: paddingInlineStart,
        testId: testId,
        xcss: xcss && (0, $ecnYn.xcss)((0, $7Ytfp.xcssValidator)(xcss))
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("ll1X4", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $662934f2ccc55a75$export$c17561cb55d4db30);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6UBEn = parcelRequire("6UBEn");
const $662934f2ccc55a75$export$bf0162d825d6e13 = {
    appearance: true,
    ariaLabel: true,
    isIndeterminate: true,
    testId: true,
    value: true
};
const $662934f2ccc55a75$export$c17561cb55d4db30 = (props)=>{
    const { appearance: appearance, ariaLabel: ariaLabel, isIndeterminate: isIndeterminate, testId: testId, value: value } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6UBEn.default), {
        appearance: appearance,
        ariaLabel: ariaLabel,
        isIndeterminate: isIndeterminate,
        testId: testId,
        value: value
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("81Klo", function(module, exports) {

$parcel$export(module.exports, "ProgressTracker", () => $f27e71f81adf4ae0$export$50a55323bc54fb79);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $jwcwi = parcelRequire("jwcwi");
const $f27e71f81adf4ae0$export$bf0162d825d6e13 = {
    animated: true,
    items: {
        value: 'filterItems(items)'
    },
    label: true,
    spacing: true,
    testId: true
};
// Filters out href from items. @forge/bridge router must be used in onClick for in app navigation
const $f27e71f81adf4ae0$var$filterItems = (items)=>{
    return items.map((item)=>{
        // removes href and noLink props
        const { href: href, noLink: noLink, ...rest } = item;
        return {
            ...rest,
            noLink: !rest.onClick
        };
    });
};
const $f27e71f81adf4ae0$export$50a55323bc54fb79 = (props)=>{
    const { animated: animated, items: items, label: label, spacing: spacing, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jwcwi.default), {
        animated: animated,
        items: $f27e71f81adf4ae0$var$filterItems(items),
        label: label,
        spacing: spacing,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("jwcwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a8d06d25fc8b317$export$2e2bcd8739ae039);
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $cWhfY = parcelRequire("cWhfY");

var $fUSG6 = parcelRequire("fUSG6");

var $f7TWP = parcelRequire("f7TWP");
const $1a8d06d25fc8b317$var$containerStyles = null;
const $1a8d06d25fc8b317$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $1a8d06d25fc8b317$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cosy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        (0, $dh538.fg)('platform_progress_tracker_link_migration') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUSG6.default), {
            ...item
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cWhfY.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $gwFzn.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $gwFzn.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f7TWP.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $1a8d06d25fc8b317$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
var $1a8d06d25fc8b317$export$2e2bcd8739ae039 = $1a8d06d25fc8b317$var$ProgressTracker;

});
parcelRegister("cWhfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e073ee697483df67$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $e073ee697483df67$var$linkStyles = null; /**
                          * __Progress tracker link__
                          */ 
const $e073ee697483df67$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        href: href,
        onClick: onClick,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_syaz1fxt _80omtlke"
        ]),
        children: label
    });
var $e073ee697483df67$export$2e2bcd8739ae039 = $e073ee697483df67$var$Link;

});

parcelRegister("fUSG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c616bd3378eca8$export$2e2bcd8739ae039);
/* link-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $auNCB = parcelRequire("auNCB");
const $c8c616bd3378eca8$var$styles = {
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _11c81kw7 _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Progress tracker link__
 */ const $c8c616bd3378eca8$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auNCB.default), {
        xcss: $c8c616bd3378eca8$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
var $c8c616bd3378eca8$export$2e2bcd8739ae039 = $c8c616bd3378eca8$var$Link;

});

parcelRegister("f7TWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $711efba874fede10$export$2e2bcd8739ae039);
/* stage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gd5X1 = parcelRequire("gd5X1");

var $gdv5Z = parcelRequire("gdv5Z");

var $3rSKm = parcelRequire("3rSKm");

var $kEBXJ = parcelRequire("kEBXJ");
function $711efba874fede10$var$_defineProperty(e, r, t) {
    return (r = $711efba874fede10$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $711efba874fede10$var$_toPropertyKey(t) {
    var i = $711efba874fede10$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $711efba874fede10$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $711efba874fede10$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $711efba874fede10$var$textColor = {
    unvisited: "_syaz131l",
    current: "_syaz1e6v",
    visited: "_syaz1fxt",
    disabled: "_syaz1lh4"
};
const $711efba874fede10$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pmoej",
    visited: "_k48pmoej",
    disabled: "_k48pmoej"
};
const $711efba874fede10$var$getMarkerColor = ({ status: status, percentageCompleted: percentageCompleted })=>{
    switch(status){
        case 'unvisited':
            return "var(--ds-icon-subtle, #626F86)";
        case 'current':
        case 'visited':
            return "var(--ds-icon-brand, #0C66E4)";
        case 'disabled':
            if (percentageCompleted === 0) return "var(--ds-icon-disabled, #091E424F)";
             // If the percentage completed is greater than 0, we show the brand colour, so that the marker (circle) blends in with the progress bar.
            // Otherwise, the grey marker would be visible within the progress bar.
            return "var(--ds-icon-brand, #0C66E4)";
        default:
            return;
    }
};
const $711efba874fede10$var$listItemStyles = null;
const $711efba874fede10$var$titleStyles = null;
class $711efba874fede10$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    UNSAFE_componentWillReceiveProps() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing,
            ['--ds--pt--mc']: this.state.oldMarkerColor,
            ['--ds--pt--bg']: $711efba874fede10$var$getMarkerColor({
                status: item.status,
                percentageCompleted: item.percentageComplete
            }),
            listStyleType: 'none'
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
            "data-testid": testId,
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $35pXk.default)([
                "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                xcss: $711efba874fede10$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gd5X1.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefMarker,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kEBXJ.default), {
                            testId: testId && `${testId}-marker`
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gd5X1.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefBar,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3rSKm.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gd5X1.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefTitle,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            "data-testid": testId && `${testId}-title`,
                            className: (0, $35pXk.default)([
                                "_11c82smr _v564ph28 _1pfhv47k _y3gn1h6o _1t9yph28 _1ez2kb7n _1uuw17dr",
                                $711efba874fede10$var$textColor[item.status],
                                $711efba874fede10$var$fontWeight[item.status]
                            ]),
                            children: this.shouldShowLink() ? render.link({
                                item: item
                            }) : item.label
                        })
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        $711efba874fede10$var$_defineProperty(this, "nodeRefMarker", /*#__PURE__*/ (0, $gwFzn.createRef)());
        $711efba874fede10$var$_defineProperty(this, "nodeRefBar", /*#__PURE__*/ (0, $gwFzn.createRef)());
        $711efba874fede10$var$_defineProperty(this, "nodeRefTitle", /*#__PURE__*/ (0, $gwFzn.createRef)());
        $711efba874fede10$var$_defineProperty(this, "onEntered", ()=>{
            this.setState({
                transitioning: false,
                oldMarkerColor: $711efba874fede10$var$getMarkerColor({
                    status: this.props.item.status,
                    percentageCompleted: this.props.item.percentageComplete
                }),
                oldPercentageComplete: this.props.item.percentageComplete
            });
        });
        this.state = {
            transitioning: false,
            oldMarkerColor: $711efba874fede10$var$getMarkerColor({
                status: this.props.item.status,
                percentageCompleted: this.props.item.percentageComplete
            }),
            oldPercentageComplete: 0
        };
    }
}

});
parcelRegister("3rSKm", function(module, exports) {

$parcel$export(module.exports, "default", () => $99e33e8128326caf$export$2e2bcd8739ae039);
/* bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $99e33e8128326caf$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $99e33e8128326caf$var$progressBarStyles = null; /**
                                 * __Progress bar__
                                 *
                                 * A progress bar describes the horizontal tracking bar that traverses each individual step.
                                 *
                                 */ 
const $99e33e8128326caf$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$99e33e8128326caf$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $35pXk.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhkb29m _1einu2gc _5fbcu2gc _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
var $99e33e8128326caf$export$2e2bcd8739ae039 = $99e33e8128326caf$var$ProgressBar;

});

parcelRegister("kEBXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb2296c785e715e$export$2e2bcd8739ae039);
/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $abb2296c785e715e$var$progressMarkerStyles = null; /**
                                    * __Progress marker__
                                    *
                                    * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
                                    */ 
const $abb2296c785e715e$var$ProgressMarker = ({ testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_2rkou2gc _v5645rui _1bsbu2gc _4t3iu2gc _kqswstnw _bfhkr3ku _1e021ssb _t9ec157a _1lww1oqq _1uuw17dr _1ez2kb7n _1190pbrw _1ia8r3ku"
        ])
    });
var $abb2296c785e715e$export$2e2bcd8739ae039 = $abb2296c785e715e$var$ProgressMarker;

});




parcelRegister("alvzu", function(module, exports) {

$parcel$export(module.exports, "Radio", () => $c471241698e6ee4a$export$d7b12c4107be0d61);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kZ5GD = parcelRequire("kZ5GD");

var $9PmQV = parcelRequire("9PmQV");
const $c471241698e6ee4a$export$bf0162d825d6e13 = {
    label: true,
    testId: true,
    isChecked: true,
    ariaLabel: true,
    onInvalid: true
};
const $c471241698e6ee4a$export$d7b12c4107be0d61 = (props)=>{
    const { label: label, testId: testId, isChecked: isChecked, ariaLabel: ariaLabel, onInvalid: onInvalid, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kZ5GD.default), {
        label: label,
        testId: testId,
        isChecked: isChecked,
        ariaLabel: ariaLabel,
        onInvalid: onInvalid,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $9PmQV.adaptEventHandler)(onChange),
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("8XUwU", function(module, exports) {

$parcel$export(module.exports, "RadioGroup", () => $294009ff50641444$export$a98f0dcb43a68a25);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lBvGi = parcelRequire("lBvGi");

var $9PmQV = parcelRequire("9PmQV");
const $294009ff50641444$export$bf0162d825d6e13 = {
    defaultValue: true,
    options: true,
    onInvalid: true,
    testId: true
};
const $294009ff50641444$export$a98f0dcb43a68a25 = (props)=>{
    const { defaultValue: defaultValue, options: options, onInvalid: onInvalid, testId: testId, isRequired: // Field props
    isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, value: value, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lBvGi.default), {
        defaultValue: defaultValue,
        options: options,
        onInvalid: onInvalid,
        testId: testId,
        // Field props
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $9PmQV.adaptEventHandler)(onChange),
        value: value,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("aMl5L", function(module, exports) {

$parcel$export(module.exports, "Range", () => $aaf088545b88ebea$export$9a58ef0d7ad3278c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $epp7s = parcelRequire("epp7s");

var $9PmQV = parcelRequire("9PmQV");
const $aaf088545b88ebea$export$bf0162d825d6e13 = {
    defaultValue: true,
    max: true,
    min: true,
    step: true,
    testId: true,
    onChange: true
};
const $aaf088545b88ebea$export$9a58ef0d7ad3278c = (props)=>{
    const { defaultValue: defaultValue, max: max, min: min, step: step, testId: testId, onChange: onChange, id: // Field props
    id, isDisabled: isDisabled, onBlur: onBlur, onFocus: onFocus, value: value, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epp7s.default), {
        defaultValue: defaultValue,
        max: max,
        min: min,
        step: step,
        testId: testId,
        onChange: onChange,
        // Field props
        id: id,
        isDisabled: isDisabled,
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("kresT", function(module, exports) {

$parcel$export(module.exports, "RequiredAsterisk", () => $0889dc325a0feeeb$export$a4bb55a1e3b8a49f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $jVhgp = parcelRequire("jVhgp");
const $0889dc325a0feeeb$export$bf0162d825d6e13 = {};
const $0889dc325a0feeeb$export$a4bb55a1e3b8a49f = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jVhgp.default), {});
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("fOllR", function(module, exports) {

$parcel$export(module.exports, "SectionMessage", () => $e7ec2598dbaaf218$export$a36903bd214cec06);

var $7UHDa = parcelRequire("7UHDa");

var $aeJrv = parcelRequire("aeJrv");

var $gwFzn = parcelRequire("gwFzn");

var $aoVih = parcelRequire("aoVih");
const $e7ec2598dbaaf218$export$bf0162d825d6e13 = {
    children: true,
    appearance: true,
    title: true,
    actions: {
        value: 'actions ? renderActions(props.render, actions) as React.ReactElement[] : undefined',
        comment: 'pre-render actions before inserting as props'
    },
    icon: false,
    testId: true
};
const $e7ec2598dbaaf218$var$renderActions = (render, actions)=>Array.isArray(actions) ? actions.map((action)=>render((0, $aeJrv.elementToForgeDoc)(action))) : [
        render((0, $aeJrv.elementToForgeDoc)(actions))
    ];
const $e7ec2598dbaaf218$export$a36903bd214cec06 = (props)=>{
    const { appearance: appearance, title: title, actions: actions, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        appearance: appearance,
        title: title,
        // pre-render actions before inserting as props
        actions: actions ? $e7ec2598dbaaf218$var$renderActions(props.render, actions) : undefined,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("e98jd", function(module, exports) {

$parcel$export(module.exports, "SectionMessageAction", () => $3ef8d014d092b03b$export$22cf410f36f6c7c1);

var $7UHDa = parcelRequire("7UHDa");

var $clpPd = parcelRequire("clpPd");

var $9PmQV = parcelRequire("9PmQV");

var $gwFzn = parcelRequire("gwFzn");

var $iHPbg = parcelRequire("iHPbg");
const $3ef8d014d092b03b$export$bf0162d825d6e13 = {
    children: true,
    linkComponent: false,
    onClick: {
        value: 'adaptEventHandler(onClick)'
    },
    href: {
        value: 'href ? sanitizeUrl(href): undefined',
        comment: 'safety measure'
    },
    testId: true
};
const $3ef8d014d092b03b$export$22cf410f36f6c7c1 = (props)=>{
    const { onClick: onClick, href: href, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iHPbg.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        onClick: (0, $9PmQV.adaptEventHandler)(onClick),
        // safety measure
        href: href ? (0, $clpPd.sanitizeUrl)(href) : undefined,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("8zt10", function(module, exports) {

$parcel$export(module.exports, "Select", () => $7b3a4c57e538b052$export$ef9b1a59e592288f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2gD2K = parcelRequire("2gD2K");

var $9PmQV = parcelRequire("9PmQV");

var $JmaBh = parcelRequire("JmaBh");
const $7b3a4c57e538b052$export$ef9b1a59e592288f = (props)=>{
    const { spacing: spacing, appearance: appearance, testId: testId, autoFocus: autoFocus, defaultValue: defaultValue, closeMenuOnSelect: closeMenuOnSelect, inputValue: inputValue, inputId: inputId, isClearable: isClearable, isLoading: isLoading, isMulti: isMulti, isSearchable: isSearchable, menuIsOpen: menuIsOpen, openMenuOnFocus: openMenuOnFocus, onInputChange: onInputChange, options: options, placeholder: placeholder, onChange: onChange, isRequired: isRequired, id: // Field props
    id, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, value: value, name: name } = props.forgeDoc.props;
    return(// Portal is required to render the menu as a sibling of the select container so that it appears ontop of the parent when used within ModalBody
    // ModalBody is a scrollable area and the menu is hidden when rendered within it
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $JmaBh.PortalConsumer), {
        children: (portal)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gD2K.SelectWithoutAnalytics), {
                spacing: spacing,
                appearance: appearance,
                testId: testId,
                autoFocus: autoFocus,
                defaultValue: defaultValue,
                closeMenuOnSelect: closeMenuOnSelect,
                inputValue: inputValue,
                inputId: id || inputId,
                isClearable: isClearable,
                isLoading: isLoading,
                isMulti: isMulti,
                isSearchable: isSearchable,
                menuIsOpen: menuIsOpen,
                openMenuOnFocus: openMenuOnFocus,
                menuPortalTarget: portal,
                isRequired: isRequired,
                // onInputChange must return a void type for this to work
                onInputChange: (value, metaData)=>{
                    onInputChange?.(value, metaData);
                    return;
                },
                options: options,
                placeholder: placeholder,
                onChange: onChange,
                // Field props
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
                onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
                value: value,
                name: name
            })
    }));
};

});

parcelRegister("5wUBa", function(module, exports) {

$parcel$export(module.exports, "Spinner", () => $f1ce34ac4a8f6247$export$7f7cbe89f1eacd2);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");
const $f1ce34ac4a8f6247$export$bf0162d825d6e13 = {
    appearance: true,
    delay: true,
    interactionName: false,
    label: true,
    size: true,
    testId: true
};
const $f1ce34ac4a8f6247$export$7f7cbe89f1eacd2 = (props)=>{
    const { appearance: appearance, delay: delay, label: label, size: size, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
        appearance: appearance,
        delay: delay,
        label: label,
        size: size,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("hC1RA", function(module, exports) {

$parcel$export(module.exports, "Stack", () => $a571f3bae9da938e$export$694e0d28c7ffc90c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1GzhS = parcelRequire("1GzhS");
const $a571f3bae9da938e$export$bf0162d825d6e13 = {
    children: true,
    alignBlock: true,
    alignInline: true,
    grow: true,
    space: true,
    spread: true,
    testId: true
};
const $a571f3bae9da938e$export$694e0d28c7ffc90c = (props)=>{
    const { alignBlock: alignBlock, alignInline: alignInline, grow: grow, space: space, spread: spread, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        alignBlock: alignBlock,
        alignInline: alignInline,
        grow: grow,
        space: space,
        spread: spread,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("acZWu", function(module, exports) {

$parcel$export(module.exports, "Strong", () => $631299c90d3ab822$export$f301627d437cff88);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5dK2X = parcelRequire("5dK2X");

var $1nSBE = parcelRequire("1nSBE");

var $gGmck = parcelRequire("gGmck");
const $631299c90d3ab822$export$f301627d437cff88 = (props)=>{
    const { extensionType: extensionType, forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $gGmck.RendererContext));
    const isMacro = extensionType === 'xen:macro';
    const isProduction = forgeEnvironment === 'PRODUCTION';
    if (!isProduction) (0, $1nSBE.default)(`[@forge/react: Strong] Warning: The "Strong" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    return(// `p` tag in editor/page is set to 16px. The strong element is using the Text component which sets it to 14px. Resetting to large to match with the rest of the editor/page styles. In other modules, this would default to 14px to match with the rest of the typography styles.
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
        size: isMacro ? 'large' : undefined,
        as: "strong",
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key))
    }));
};

});

parcelRegister("aW047", function(module, exports) {

$parcel$export(module.exports, "Tab", () => $733f9fb8e2b38783$export$3e41faf802a29e71);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gCbPZ = parcelRequire("gCbPZ");
const $733f9fb8e2b38783$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $733f9fb8e2b38783$export$3e41faf802a29e71 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gCbPZ.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("cpYZp", function(module, exports) {

$parcel$export(module.exports, "TabList", () => $2c03a219758d0996$export$e51a686c67fdaa2d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $0DTaW = parcelRequire("0DTaW");
const $2c03a219758d0996$export$bf0162d825d6e13 = {
    children: {
        value: "props.forgeDoc.children.flatMap((c) => c.type === 'String' ? [] : props.render(c))",
        comment: 'Filter out line spacing strings as TabList should only have Tab children'
    }
};
const $2c03a219758d0996$export$e51a686c67fdaa2d = (props)=>{
    const {} = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $0DTaW.default), {
        // Filter out line spacing strings as TabList should only have Tab children
        children: props.forgeDoc.children.flatMap((c)=>c.type === 'String' ? [] : props.render(c))
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("1sb1z", function(module, exports) {

$parcel$export(module.exports, "TabPanel", () => $e11d57d02e0497c5$export$3d96ec278d3efce4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d2kvf = parcelRequire("d2kvf");
const $e11d57d02e0497c5$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $e11d57d02e0497c5$export$3d96ec278d3efce4 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d2kvf.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("4keNh", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => $c9acb431e4f41d1b$export$b2539bed5023c21c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4A7Gn = parcelRequire("4A7Gn");
const $c9acb431e4f41d1b$export$bf0162d825d6e13 = {
    id: true,
    children: {
        value: "props.forgeDoc.children.flatMap((c) => c.type === 'String' ? [] : props.render(c))",
        comment: 'Filter out line spacing strings as Tabs should only have TabList & TabPanel children'
    },
    defaultSelected: true,
    onChange: true,
    selected: true,
    shouldUnmountTabPanelOnChange: true,
    testId: true
};
const $c9acb431e4f41d1b$export$b2539bed5023c21c = (props)=>{
    const { id: id, defaultSelected: defaultSelected, onChange: onChange, selected: selected, shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4A7Gn.default), {
        id: id,
        // Filter out line spacing strings as Tabs should only have TabList & TabPanel children
        children: props.forgeDoc.children.flatMap((c)=>c.type === 'String' ? [] : props.render(c)),
        defaultSelected: defaultSelected,
        onChange: onChange,
        selected: selected,
        shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("6ewzK", function(module, exports) {

$parcel$export(module.exports, "SimpleTag", () => $a7379c399c27a504$export$774e1ef5dc84ebd4);

var $7UHDa = parcelRequire("7UHDa");

var $aeJrv = parcelRequire("aeJrv");

var $clpPd = parcelRequire("clpPd");
parcelRequire("gwFzn");

var $ho4zm = parcelRequire("ho4zm");
const $a7379c399c27a504$export$bf0162d825d6e13 = {
    text: true,
    appearance: true,
    color: true,
    elemBefore: {
        value: 'elemBefore ? props.render(elementToForgeDoc(elemBefore as React.ReactElement)): null',
        comment: 'forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here'
    },
    href: {
        value: 'href ? sanitizeUrl(href) : undefined'
    },
    linkComponent: false,
    testId: true
};
const $a7379c399c27a504$export$774e1ef5dc84ebd4 = (props)=>{
    const { text: text, appearance: appearance, color: color, elemBefore: elemBefore, href: href, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ho4zm.default), {
        text: text,
        appearance: appearance,
        color: color,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemBefore: elemBefore ? props.render((0, $aeJrv.elementToForgeDoc)(elemBefore)) : null,
        href: href ? (0, $clpPd.sanitizeUrl)(href) : undefined,
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("dgnRd", function(module, exports) {

$parcel$export(module.exports, "TagGroup", () => $42125b5a45a10feb$export$67ea30858aaf75e3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bRPo1 = parcelRequire("bRPo1");
const $42125b5a45a10feb$export$bf0162d825d6e13 = {
    children: true,
    alignment: true
};
const $42125b5a45a10feb$export$67ea30858aaf75e3 = (props)=>{
    const { alignment: alignment } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bRPo1.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        alignment: alignment
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("bUkSd", function(module, exports) {

$parcel$export(module.exports, "PatchedText", () => $f221c6e2fc122a48$export$40702e9f235b31be);
/* index.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $9UyM5 = parcelRequire("9UyM5");

var $gwFzn = parcelRequire("gwFzn");

var $iXCQx = parcelRequire("iXCQx");
const $f221c6e2fc122a48$export$bf0162d825d6e13 = {
    align: true,
    as: {
        excludeFromDeconstruct: false,
        value: 'as === "strike" ? "span" : as'
    },
    color: true,
    maxLines: true,
    size: true,
    weight: true,
    children: true,
    testId: true,
    xcss: {
        excludeFromDeconstruct: true,
        value: 'cx(styles.regular, as === "strike" && styles.lineThrough)'
    }
};
const $f221c6e2fc122a48$var$styles = {
    regular: "_1i4q4jg8",
    lineThrough: "_1hms1911"
}; // If we're displaying a paragraph, unfortunately we still need to bring back the styles to add a top margin
// (unless the wrapper is the first one) to be fully backwards compatible with the legacy component.
const $f221c6e2fc122a48$var$wrapperStyles = null;
const $f221c6e2fc122a48$export$5f1af8db9871e1d6 = (props)=>{
    const { align: align, as: as, color: color, maxLines: maxLines, size: size, weight: weight, testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
        align: align,
        as: as === "strike" ? "span" : as,
        color: color,
        maxLines: maxLines,
        size: size,
        weight: weight,
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId,
        xcss: (0, $ddbVR.cx)($f221c6e2fc122a48$var$styles.regular, as === "strike" && $f221c6e2fc122a48$var$styles.lineThrough)
    });
}; /**
    * @codegenEnd
    */ 
const $f221c6e2fc122a48$export$40702e9f235b31be = (props)=>{
    const textProps = props.forgeDoc.props;
    const componentProps = {
        ...props.forgeDoc.props
    }; // ADS Text will set value for "color" if none is provided. Since the only way to adjust the color of texts in
    // Forge UI was by using the `xcss` prop on a <Box>, we need to make sure that inheritance of that color
    // is still possible, otherwise we would not be backwards compatible.
    // We can achieve this by setting the default value for "color" to "inherit" if it is not provided.
    componentProps.color = textProps.color === undefined ? 'inherit' : textProps.color;
    const needsWrapper = componentProps.as === 'p' || componentProps.as === undefined; // If we don't have to worry about any margins (all inline elements), we can use the platform Text component directly
    if (!needsWrapper) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9UyM5.InlineContext).Provider, {
        value: {
            inline: true
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($f221c6e2fc122a48$export$5f1af8db9871e1d6, {
            render: props.render,
            dispatch: props.dispatch,
            forgeDoc: {
                children: props.forgeDoc.children,
                type: props.forgeDoc.type,
                props: componentProps
            }
        })
    });
     // Default to <p> for backwards compatibility
    if (textProps.as === undefined) componentProps.as = 'p';
     // Use the wrapper to add the margin-top for all paragraphs except the first one
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_168kutpp"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9UyM5.InlineContext).Provider, {
            value: {
                inline: true
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($f221c6e2fc122a48$export$5f1af8db9871e1d6, {
                render: props.render,
                dispatch: props.dispatch,
                forgeDoc: {
                    children: props.forgeDoc.children,
                    type: props.forgeDoc.type,
                    props: componentProps
                }
            })
        })
    });
};

});

parcelRegister("3foWe", function(module, exports) {

$parcel$export(module.exports, "TextArea", () => $1fc11daf0ad720e4$export$f5c9f3c2c4054eec);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9EtP6 = parcelRequire("9EtP6");

var $9PmQV = parcelRequire("9PmQV");

var $9yb2c = parcelRequire("9yb2c");
const $1fc11daf0ad720e4$export$f5c9f3c2c4054eec = (props)=>{
    const { appearance: appearance, defaultValue: defaultValue, isCompact: isCompact, isMonospaced: isMonospaced, isReadOnly: isReadOnly, maxHeight: maxHeight, minimumRows: minimumRows, placeholder: placeholder, resize: resize, spellCheck: spellCheck, testId: testId, maxLength: maxLength, minLength: minLength, autoFocus: autoFocus, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledby, name: name } = props.forgeDoc.props;
    const { onChangeWithCursorState: onChangeWithCursorState, inputRef: inputRef } = (0, $9yb2c.useCursorState)(value, onChange);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9EtP6.default), {
        // @ts-ignore type from ADS is missing the ref object. It is still supported
        ref: inputRef,
        appearance: appearance,
        defaultValue: defaultValue,
        isCompact: isCompact,
        isMonospaced: isMonospaced,
        isReadOnly: isReadOnly,
        maxHeight: maxHeight,
        minimumRows: minimumRows,
        placeholder: placeholder,
        resize: resize,
        spellCheck: spellCheck,
        testId: testId,
        maxLength: maxLength,
        minLength: minLength,
        autoFocus: autoFocus,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $9PmQV.adaptEventHandler)(onChangeWithCursorState),
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
};

});
parcelRegister("9yb2c", function(module, exports) {

$parcel$export(module.exports, "useCursorState", () => $8b156d7c4c07c50e$export$7dee127706cff7f2);

var $gwFzn = parcelRequire("gwFzn");
const $8b156d7c4c07c50e$export$7dee127706cff7f2 = (value, onChange)=>{
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        const input = inputRef.current;
        if (input && cursor !== null && input.selectionStart !== cursor) input.setSelectionRange(cursor, cursor);
    }, [
        inputRef,
        cursor,
        value
    ]);
    const onChangeWithCursorState = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((e)=>{
        onChange?.(e);
        if (e.target.selectionStart) setCursor(e.target?.selectionStart);
    }, [
        onChange
    ]);
    if (!onChange) return {
        onChangeWithCursorState: undefined,
        inputRef: inputRef
    };
    return {
        onChangeWithCursorState: onChangeWithCursorState,
        inputRef: inputRef
    };
};

});


parcelRegister("2FspE", function(module, exports) {

$parcel$export(module.exports, "Textfield", () => $6fe27daa4a695a9d$export$d66ddc2063fc70a7);

var $7UHDa = parcelRequire("7UHDa");

var $aeJrv = parcelRequire("aeJrv");
parcelRequire("gwFzn");

var $4noo5 = parcelRequire("4noo5");

var $9PmQV = parcelRequire("9PmQV");

var $9yb2c = parcelRequire("9yb2c");
const $6fe27daa4a695a9d$export$d66ddc2063fc70a7 = (props)=>{
    const { appearance: appearance, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact, autoFocus: autoFocus, isReadOnly: isReadOnly, isMonospaced: isMonospaced, placeholder: placeholder, testId: testId, width: width, type: type, defaultValue: defaultValue, min: min, max: max, maxLength: maxLength, minLength: minLength, pattern: pattern, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, 'aria-invalid': ariaInvalid, 'aria-labelledby': ariaLabelledby, name: name } = props.forgeDoc.props;
    const { onChangeWithCursorState: onChangeWithCursorState, inputRef: inputRef } = (0, $9yb2c.useCursorState)(value, onChange);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
        ref: inputRef,
        appearance: appearance,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemAfterInput: elemAfterInput ? props.render((0, $aeJrv.elementToForgeDoc)(elemAfterInput)) : null,
        // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
        elemBeforeInput: elemBeforeInput ? props.render((0, $aeJrv.elementToForgeDoc)(elemBeforeInput)) : null,
        isCompact: isCompact,
        autoFocus: autoFocus,
        isReadOnly: isReadOnly,
        isMonospaced: isMonospaced,
        placeholder: placeholder,
        testId: testId,
        width: width,
        type: type,
        defaultValue: defaultValue,
        min: min,
        max: max,
        maxLength: maxLength,
        minLength: minLength,
        pattern: pattern,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onChange: (0, $9PmQV.adaptEventHandler)(onChangeWithCursorState),
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        value: value,
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
};

});

parcelRegister("17tPP", function(module, exports) {

$parcel$export(module.exports, "TimePicker", () => $086ee2e19305ab97$export$5f876910ea565cd3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bIBXx = parcelRequire("bIBXx");

var $9PmQV = parcelRequire("9PmQV");
const $086ee2e19305ab97$export$bf0162d825d6e13 = {
    appearance: true,
    defaultIsOpen: true,
    autoFocus: true,
    defaultValue: true,
    formatDisplayLabel: false,
    innerProps: false,
    isOpen: true,
    label: true,
    parseInputValue: false,
    spacing: true,
    times: true,
    timeIsEditable: true,
    hideIcon: true,
    timeFormat: true,
    placeholder: true,
    locale: true,
    testId: true,
    selectProps: true,
    onChange: true,
    value: {
        replaceLine: true,
        value: '{...(value !== undefined ? { value }: undefined) }',
        comment: 'Explicitly setting value to undefined is causing issues'
    }
};
const $086ee2e19305ab97$export$5f876910ea565cd3 = (props)=>{
    const { appearance: appearance, defaultIsOpen: defaultIsOpen, autoFocus: autoFocus, defaultValue: defaultValue, isOpen: isOpen, label: label, spacing: spacing, times: times, timeIsEditable: timeIsEditable, hideIcon: hideIcon, timeFormat: timeFormat, placeholder: placeholder, locale: locale, testId: testId, selectProps: selectProps, onChange: onChange, value: value, id: // Field props
    id, isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, onBlur: onBlur, onFocus: onFocus, "aria-invalid": ariaInvalid, "aria-labelledby": ariaLabelledby, name: name } = props.forgeDoc.props;
    // warning: appearance is deprecated;
    // warning: defaultIsOpen is deprecated;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bIBXx.default), {
        appearance: appearance,
        defaultIsOpen: defaultIsOpen,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        isOpen: isOpen,
        label: label,
        spacing: spacing,
        times: times,
        timeIsEditable: timeIsEditable,
        hideIcon: hideIcon,
        timeFormat: timeFormat,
        placeholder: placeholder,
        locale: locale,
        testId: testId,
        selectProps: selectProps,
        onChange: onChange,
        ...value !== undefined ? {
            value: value
        } : undefined,
        // Field props
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledby,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("bIBXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a13142a7a4ddecd$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $62ptY = parcelRequire("62ptY");
var $4mCpo = parcelRequire("4mCpo");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $9KYtE = parcelRequire("9KYtE");

var $bS1VQ = parcelRequire("bS1VQ");
var $2gD2K = parcelRequire("2gD2K");
var $eKXGE = parcelRequire("eKXGE");

var $2oOe7 = parcelRequire("2oOe7");

var $jgNUL = parcelRequire("jgNUL");

var $6BP5H = parcelRequire("6BP5H");

var $7lMCw = parcelRequire("7lMCw");

var $cda8t = parcelRequire("cda8t");
const $6a13142a7a4ddecd$var$packageName = "platform-pkg";
const $6a13142a7a4ddecd$var$packageVersion = "0.0.0-use.local";
const $6a13142a7a4ddecd$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $6a13142a7a4ddecd$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $6a13142a7a4ddecd$var$packageName,
    packageVersion: $6a13142a7a4ddecd$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $6a13142a7a4ddecd$var$TimePicker = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $ee7An.default), onChange: providedOnChange = (0, $ee7An.default), onFocus: providedOnFocus = (0, $ee7An.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $6BP5H.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $2oOe7.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $gwFzn.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $gwFzn.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $gwFzn.useState)(false);
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(defaultIsOpen);
    const [value, setValue] = (0, $gwFzn.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $gwFzn.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$6a13142a7a4ddecd$var$analyticsAttributes
    });
    (0, $gwFzn.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $gwFzn.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $2oOe7.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $62ptY.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $9KYtE.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $bS1VQ.default) : (0, $2gD2K.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $2oOe7.defaultTimeFormat));
        const date = (0, $6BP5H.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $4mCpo.default)(date)) return time;
        if (timeFormat) return (0, $62ptY.default)(date, (0, $7lMCw.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $cda8t.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $2oOe7.EmptyComponent),
        Menu: (0, $jgNUL.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $2oOe7.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$6a13142a7a4ddecd$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $2oOe7.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $6a13142a7a4ddecd$export$2e2bcd8739ae039 = $6a13142a7a4ddecd$var$TimePicker;

});
parcelRegister("jgNUL", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $234f598d19f6cd6a$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $3hOY6 = parcelRequire("3hOY6");

var $hq1yX = parcelRequire("hq1yX");
const $234f598d19f6cd6a$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hq1yX.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3hOY6.components).Menu // We have to have this because `getClassNames` is missing. Can't define
        , {
            ...rest,
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("6BP5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $8831c39f93c6811b$export$2e2bcd8739ae039);
const $8831c39f93c6811b$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $8831c39f93c6811b$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $8831c39f93c6811b$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $8831c39f93c6811b$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $8831c39f93c6811b$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $8831c39f93c6811b$var$map24[hour];
    return hour;
}
function $8831c39f93c6811b$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $8831c39f93c6811b$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $8831c39f93c6811b$var$formatSemi24(timeArray[0].trim());
    const hour = $8831c39f93c6811b$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $8831c39f93c6811b$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $8831c39f93c6811b$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$8831c39f93c6811b$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $8831c39f93c6811b$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $8831c39f93c6811b$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $8831c39f93c6811b$var$assignToDate(time2);
}

});



parcelRegister("avzTi", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $f4c002d535c36bd6$export$bea8ebba691c5813);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $82gXq = parcelRequire("82gXq");

var $9PmQV = parcelRequire("9PmQV");
const $f4c002d535c36bd6$export$bf0162d825d6e13 = {
    size: true,
    testId: true,
    defaultChecked: true,
    isChecked: true,
    label: true
};
const $f4c002d535c36bd6$export$bea8ebba691c5813 = (props)=>{
    const { size: size, testId: testId, defaultChecked: defaultChecked, isChecked: isChecked, label: label, id: // Field props
    id, isDisabled: isDisabled, onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value, name: name } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $82gXq.default), {
        size: size,
        testId: testId,
        defaultChecked: defaultChecked,
        isChecked: isChecked,
        label: label,
        // Field props
        id: id,
        isDisabled: isDisabled,
        onChange: (0, $9PmQV.adaptEventHandler)(onChange),
        onBlur: (0, $9PmQV.adaptEventHandler)(onBlur),
        onFocus: (0, $9PmQV.adaptEventHandler)(onFocus),
        value: value,
        name: name
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("hBDWA", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $16e7c2be5df3039d$export$28c660c63b792dea);
/**
 * Excluded props to simplify API:
 * - strategy
 * - hideTooltipOnClick
 * - hideTooltipOnMouseDown
 * - onHide
 * - onShow
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");
const $16e7c2be5df3039d$export$bf0162d825d6e13 = {
    children: true,
    position: true,
    mousePosition: true,
    content: true,
    truncate: true,
    testId: true,
    delay: true,
    onShow: false,
    onHide: false,
    hideTooltipOnClick: false,
    hideTooltipOnMouseDown: false,
    strategy: false
};
const $16e7c2be5df3039d$export$28c660c63b792dea = (props)=>{
    const { position: position, mousePosition: mousePosition, content: content, truncate: truncate, testId: testId, delay: delay } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        position: position,
        mousePosition: mousePosition,
        content: content,
        truncate: truncate,
        testId: testId,
        delay: delay
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("5u7Ds", function(module, exports) {

$parcel$export(module.exports, "ValidMessage", () => $580da07d63cfd038$export$5505afb209a532c8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gQhRa = parcelRequire("gQhRa");
const $580da07d63cfd038$export$bf0162d825d6e13 = {
    children: true,
    testId: true
};
const $580da07d63cfd038$export$5505afb209a532c8 = (props)=>{
    const { testId: testId } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ValidMessage), {
        children: props.forgeDoc.children.map((c)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: props.render(c)
            }, c.key)),
        testId: testId
    });
}; /**
 * @codegenEnd
 */ 

});

parcelRegister("g7rOD", function(module, exports) {

$parcel$export(module.exports, "forgePropsAreEqual", () => $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f);
/**
 * this function assume the inputs are not same object, and hence
 * it doesn't check for reference equality.
 *
 * Additionally, it check keys of the object and then check the values
 * for better performance.
 */ const $9678c1c47c1b0bc2$var$objectValuesAreEqual = (prev, next, valuesAreEqual)=>{
    const keys = Object.keys(prev);
    const length = keys.length;
    if (length !== Object.keys(next).length) return false;
    // there are two small optimization techniques used in this file:
    // 1. using decrementing for loop instead of incrementing for loop,
    //    to reduce 1 instruction per iteration.
    // 2. for object equality check, we check the key match first and then
    //    the value match. This is to identify the inequality as soon as possible.
    for(let i = length; i-- !== 0;){
        if (!(keys[i] in next)) return false;
    }
    for(let i = length; i-- !== 0;){
        const key = keys[i];
        if (!valuesAreEqual(prev[key], next[key])) return false;
    }
    return true;
};
/**
 * Some of the ideas are based on https://github.com/FormidableLabs/react-fast-compare
 */ const $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    else if (typeof prev === 'function' && typeof next === 'function') // if the function is a crossDomainFunctionWrapper (i.e. post-bot),
    // then we can check if the function is the same by looking at the
    // __id__ property.
    return prev.__id__ === next.__id__;
    else if (typeof prev === 'object' && typeof next === 'object') {
        if (prev.constructor !== next.constructor) return false;
        else if (Array.isArray(prev)) {
            const length = prev.length;
            if (length !== next.length) return false;
            for(let i = length; i-- !== 0;){
                if (!$9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual(prev[i], next[i])) return false;
            }
            return true;
        } else if (prev.valueOf !== Object.prototype.valueOf && typeof prev.valueOf === 'function' && typeof next.valueOf === 'function') return prev.valueOf() === next.valueOf();
        else if (prev.toString !== Object.prototype.toString && typeof prev.toString === 'function' && typeof next.toString === 'function') return prev.toString() === next.toString();
        return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
    }
    return false;
};
const $9678c1c47c1b0bc2$var$forgeDocPropsAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
};
/**
 * the function is used to cache the hasChanged value in the ForgeDoc.
 * Please note, the cached result need to be stored in the next prop not the prev prop.
 * This is because react internally caches the props, and the cache become stale
 * at every render, if the calculation depends on the prev prop, the stale cache
 * will impact the accuracy of the result.
 */ const $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged = (nextDoc, hasChanged)=>{
    nextDoc.hasChanged = hasChanged;
    return !hasChanged;
};
const $9678c1c47c1b0bc2$var$forgeDocsAreEqual = (prev, next)=>{
    if (next.hasChanged !== undefined) return !next.hasChanged;
    else if (prev === next) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, false);
    else if (!prev || !next) return next ? $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true) : false;
    if (prev.type !== next.type || prev.key !== next.key) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
    else if (prev.children !== next.children) {
        if (prev.children?.length !== next.children?.length) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        const length = prev.children?.length ?? 0;
        for(let i = length; i-- !== 0;){
            if (!$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.children[i], next.children[i])) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        }
    }
    return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, !$9678c1c47c1b0bc2$var$forgeDocPropsAreEqual(prev.props, next.props));
};
const $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f = (prev, next)=>$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.forgeDoc, next.forgeDoc);

});


parcelRegister("3tbBB", function(module, exports) {

$parcel$export(module.exports, "importMapChartsMemo", () => $2f0fd47f1e034052$export$534226a750271d58);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aUU3X = parcelRequire("aUU3X");
var $hWQ6L = parcelRequire("hWQ6L");
var $l6wTu = parcelRequire("l6wTu");
var $fnQjp = parcelRequire("fnQjp");
var $cwRjg = parcelRequire("cwRjg");
var $5E7S0 = parcelRequire("5E7S0");
var $7Opz3 = parcelRequire("7Opz3");

var $g7rOD = parcelRequire("g7rOD");
const $2f0fd47f1e034052$export$7cbf6225478f6479 = {
    BarChart: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)($aUU3X.BarChart, {
            ...args
        }),
    StackBarChart: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)($7Opz3.StackBarChart, {
            ...args
        }),
    HorizontalStackBarChart: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)($fnQjp.HorizontalStackBarChart, {
            ...args
        }),
    HorizontalBarChart: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)($l6wTu.HorizontalBarChart, {
            ...args
        }),
    LineChart: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)($cwRjg.LineChart, {
            ...args
        }),
    PieChart: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)($5E7S0.PieChart, {
            ...args
        }),
    DonutChart: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)($hWQ6L.DonutChart, {
            ...args
        })
};
const $2f0fd47f1e034052$export$534226a750271d58 = Object.entries($2f0fd47f1e034052$export$7cbf6225478f6479).reduce((agg, [key, Component])=>{
    agg[key] = /*#__PURE__*/ (0, $gwFzn.memo)(Component, (0, $g7rOD.forgePropsAreEqual));
    return agg;
}, {});

});
parcelRegister("aUU3X", function(module, exports) {

$parcel$export(module.exports, "BarChart", () => $d14c84df0f3e2985$export$94aefc399ef206a9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3zb7V = parcelRequire("3zb7V");

const $d14c84df0f3e2985$var$PlatformBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.BarChart
        })));

const $d14c84df0f3e2985$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.BarChart.elements.Title
        })));

const $d14c84df0f3e2985$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.BarChart.elements.SubTitle
        })));
const $d14c84df0f3e2985$var$BaseBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($d14c84df0f3e2985$var$PlatformBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $7UHDa.jsx)($d14c84df0f3e2985$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7UHDa.jsx)($d14c84df0f3e2985$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $d14c84df0f3e2985$export$94aefc399ef206a9 = (0, $3zb7V.withConfluenceStyleWrapper)($d14c84df0f3e2985$var$BaseBarChart);

});
parcelRegister("3zb7V", function(module, exports) {

$parcel$export(module.exports, "withConfluenceStyleWrapper", () => $284faf76aab47fa0$export$579859975dfcad56);
/* confluenceStyleWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $9owLH = parcelRequire("9owLH");

var $k8vKD = parcelRequire("k8vKD");
const $284faf76aab47fa0$var$chartStyle = null; // Styling override in Safari for UI Kit chart y-axis (axis-left) label that gets overlapped by chart plot.
// (See https://ecosystem-platform.atlassian.net/browse/EXT-3078)
const $284faf76aab47fa0$var$safariChartStyle = null;
const $284faf76aab47fa0$export$579859975dfcad56 = (ChartComponent)=>{
    return function ConfluenceStyleWrapper(props) {
        const isConfluenceModule = (0, $k8vKD.useIsConfluenceModule)();
        return isConfluenceModule ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            className: (0, $35pXk.default)([
                "_1hur1o8v _15ywze3t _xlx2ze3t _ohs2131l _v8kv1o8v _1t4h131l _12r8nbxd _tc2g1gjq _1prk2smr _1x821gjq _59ea1vhk _9y82ze3t _7ve0ze3t _zi1a131l _125ipxbi",
                (0, $9owLH.isSafari)() && "_15xdc38t"
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(ChartComponent, {
                ...props
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)(ChartComponent, {
            ...props
        });
    };
};

});
parcelRegister("9owLH", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $c9e454fe83f0fb0f$export$95df08bae54cb4df);
const $c9e454fe83f0fb0f$export$95df08bae54cb4df = ()=>{
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
};

});

parcelRegister("k8vKD", function(module, exports) {

$parcel$export(module.exports, "useIsConfluenceModule", () => $a1933e587948ea63$export$ad87aa198ab86978);

var $gwFzn = parcelRequire("gwFzn");

var $gGmck = parcelRequire("gGmck");
const $a1933e587948ea63$export$ad87aa198ab86978 = ()=>{
    const { extensionType: extensionType } = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $gGmck.RendererContext));
    return extensionType === 'xen:macro' || !!extensionType?.startsWith('confluence');
};

});


parcelRegister("78i2u", function(module, exports) {

let $531745fb1f77f266$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $531745fb1f77f266$var$load("MrUJ0"),
    $531745fb1f77f266$var$load("e08m0"),
    $531745fb1f77f266$var$load("hXFaG"),
    $531745fb1f77f266$var$load("5hFEw"),
    $531745fb1f77f266$var$load("7Q0UC"),
    $531745fb1f77f266$var$load("6vOHT")
]).then(()=>parcelRequire('diitp'));

});


parcelRegister("hWQ6L", function(module, exports) {

$parcel$export(module.exports, "DonutChart", () => $d7cc4faea5385b92$export$533707e2f61b59ec);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3zb7V = parcelRequire("3zb7V");

const $d7cc4faea5385b92$var$PlatformDonutChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.DonutChart
        })));

const $d7cc4faea5385b92$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.DonutChart.elements.Title
        })));

const $d7cc4faea5385b92$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.DonutChart.elements.SubTitle
        })));

const $d7cc4faea5385b92$var$MarkLabels = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.DonutChart.elements.MarkLabels
        })));
const $d7cc4faea5385b92$var$BaseDonutChart = (props)=>{
    const { width: width, height: height, data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, title: title, subtitle: subtitle, showMarkLabels: showMarkLabels, innerRadius: innerRadius, outerRadius: outerRadius } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($d7cc4faea5385b92$var$PlatformDonutChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        colorAccessor: colorAccessor,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($d7cc4faea5385b92$var$MarkLabels, {
                hide: !showMarkLabels
            }),
            title && /*#__PURE__*/ (0, $7UHDa.jsx)($d7cc4faea5385b92$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7UHDa.jsx)($d7cc4faea5385b92$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $d7cc4faea5385b92$export$533707e2f61b59ec = (0, $3zb7V.withConfluenceStyleWrapper)($d7cc4faea5385b92$var$BaseDonutChart);

});

parcelRegister("l6wTu", function(module, exports) {

$parcel$export(module.exports, "HorizontalBarChart", () => $ed05019de36d5f33$export$2d84115b1316e023);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3zb7V = parcelRequire("3zb7V");

const $ed05019de36d5f33$var$PlatformHorizontalBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.HorizontalBarChart
        })));

const $ed05019de36d5f33$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.HorizontalBarChart.elements.Title
        })));

const $ed05019de36d5f33$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.HorizontalBarChart.elements.SubTitle
        })));
const $ed05019de36d5f33$var$BaseHorizontalBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($ed05019de36d5f33$var$PlatformHorizontalBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $7UHDa.jsx)($ed05019de36d5f33$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7UHDa.jsx)($ed05019de36d5f33$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $ed05019de36d5f33$export$2d84115b1316e023 = (0, $3zb7V.withConfluenceStyleWrapper)($ed05019de36d5f33$var$BaseHorizontalBarChart);

});

parcelRegister("fnQjp", function(module, exports) {

$parcel$export(module.exports, "HorizontalStackBarChart", () => $00efd03eaf86ffe9$export$68d163a36b4f8e7c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3zb7V = parcelRequire("3zb7V");

const $00efd03eaf86ffe9$var$PlatformHorizontalStackBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.HorizontalStackBarChart
        })));

const $00efd03eaf86ffe9$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.Title
        })));

const $00efd03eaf86ffe9$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.HorizontalStackBarChart.elements.SubTitle
        })));
const $00efd03eaf86ffe9$var$BaseHorizontalStackBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($00efd03eaf86ffe9$var$PlatformHorizontalStackBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $7UHDa.jsx)($00efd03eaf86ffe9$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7UHDa.jsx)($00efd03eaf86ffe9$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $00efd03eaf86ffe9$export$68d163a36b4f8e7c = (0, $3zb7V.withConfluenceStyleWrapper)($00efd03eaf86ffe9$var$BaseHorizontalStackBarChart);

});

parcelRegister("cwRjg", function(module, exports) {

$parcel$export(module.exports, "LineChart", () => $ae664695ea96b65e$export$54d0e8420ac838ac);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3zb7V = parcelRequire("3zb7V");

const $ae664695ea96b65e$var$PlatformLineChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.LineChart
        })));

const $ae664695ea96b65e$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.LineChart.elements.Title
        })));

const $ae664695ea96b65e$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.LineChart.elements.SubTitle
        })));
const $ae664695ea96b65e$var$BaseLineChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($ae664695ea96b65e$var$PlatformLineChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $7UHDa.jsx)($ae664695ea96b65e$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7UHDa.jsx)($ae664695ea96b65e$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $ae664695ea96b65e$export$54d0e8420ac838ac = (0, $3zb7V.withConfluenceStyleWrapper)($ae664695ea96b65e$var$BaseLineChart);

});

parcelRegister("5E7S0", function(module, exports) {

$parcel$export(module.exports, "PieChart", () => $eed44d9ffe8c9ca9$export$b99d3348f709c998);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3zb7V = parcelRequire("3zb7V");

const $eed44d9ffe8c9ca9$var$PlatformPieChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.PieChart
        })));

const $eed44d9ffe8c9ca9$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.PieChart.elements.Title
        })));

const $eed44d9ffe8c9ca9$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.PieChart.elements.SubTitle
        })));

const $eed44d9ffe8c9ca9$var$MarkLabels = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.PieChart.elements.MarkLabels
        })));
const $eed44d9ffe8c9ca9$var$BasePieChart = (props)=>{
    const { width: width, height: height, data: data, colorAccessor: colorAccessor, labelAccessor: labelAccessor, valueAccessor: valueAccessor, title: title, subtitle: subtitle, showMarkLabels: showMarkLabels } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($eed44d9ffe8c9ca9$var$PlatformPieChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        colorAccessor: colorAccessor,
        valueAccessor: valueAccessor,
        labelAccessor: labelAccessor,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($eed44d9ffe8c9ca9$var$MarkLabels, {
                hide: !showMarkLabels
            }),
            title && /*#__PURE__*/ (0, $7UHDa.jsx)($eed44d9ffe8c9ca9$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7UHDa.jsx)($eed44d9ffe8c9ca9$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $eed44d9ffe8c9ca9$export$b99d3348f709c998 = (0, $3zb7V.withConfluenceStyleWrapper)($eed44d9ffe8c9ca9$var$BasePieChart);

});

parcelRegister("7Opz3", function(module, exports) {

$parcel$export(module.exports, "StackBarChart", () => $ecdecb5af3a80cf9$export$a0048b2d4c7b0c89);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3zb7V = parcelRequire("3zb7V");

const $ecdecb5af3a80cf9$var$PlatformStackBarChart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.StackBarChart
        })));

const $ecdecb5af3a80cf9$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.StackBarChart.elements.Title
        })));

const $ecdecb5af3a80cf9$var$SubTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("78i2u")).then((module)=>({
            default: module.StackBarChart.elements.SubTitle
        })));
const $ecdecb5af3a80cf9$var$BaseStackBarChart = (props)=>{
    const { width: width, height: height, data: data, xAccessor: xAccessor, yAccessor: yAccessor, colorAccessor: colorAccessor, title: title, subtitle: subtitle } = props.forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($ecdecb5af3a80cf9$var$PlatformStackBarChart, {
        width: width,
        height: height ? height : 400,
        data: data,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        colorAccessor: colorAccessor,
        children: [
            title && /*#__PURE__*/ (0, $7UHDa.jsx)($ecdecb5af3a80cf9$var$Title, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7UHDa.jsx)($ecdecb5af3a80cf9$var$SubTitle, {
                children: subtitle
            })
        ]
    });
};
const $ecdecb5af3a80cf9$export$a0048b2d4c7b0c89 = (0, $3zb7V.withConfluenceStyleWrapper)($ecdecb5af3a80cf9$var$BaseStackBarChart);

});



parcelRegister("69400", function(module, exports) {

$parcel$export(module.exports, "FrameCount", () => $6b91a44b41ae4f33$export$61945ff869c3ddb);
$parcel$export(module.exports, "default", () => $6b91a44b41ae4f33$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $6b91a44b41ae4f33$export$61945ff869c3ddb = /*#__PURE__*/ (0, $gwFzn.createContext)({
    frameCount: 0,
    setFrameCount: ()=>{}
});
const $6b91a44b41ae4f33$var$FrameCountProvider = ({ children: children })=>{
    const [frameCount, setFrameCount] = (0, $gwFzn.useState)(0);
    const value = {
        frameCount: frameCount,
        setFrameCount: setFrameCount
    };
    (0, $gwFzn.useEffect)(()=>{
        if (frameCount > 1) throw new Error('Max limit of one frame component per module.');
    }, [
        frameCount
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($6b91a44b41ae4f33$export$61945ff869c3ddb.Provider, {
        value: value,
        children: children
    });
};
var $6b91a44b41ae4f33$export$2e2bcd8739ae039 = $6b91a44b41ae4f33$var$FrameCountProvider;

});

parcelRegister("iGprk", function(module, exports) {

$parcel$export(module.exports, "privateAppExtensionList", () => $7423a1f215cace36$export$3fb152bd1221f9f9);
const $7423a1f215cace36$export$3fb152bd1221f9f9 = {
    '57f0f0f6-c4bd-46df-93b1-a090332de70a': {
        app_name: 'nexus-components',
        site_name: 'MSCI',
        marketplace_type: 'Private',
        appid: '57f0f0f6-c4bd-46df-93b1-a090332de70a'
    },
    'cd3b7a85-32e7-4910-8fb4-e1604ff35b95': {
        app_name: 'nexus-systems',
        site_name: 'MSCI',
        marketplace_type: 'Private',
        appid: 'cd3b7a85-32e7-4910-8fb4-e1604ff35b95'
    },
    '725684c4-3375-4431-818f-7697fb1ec3c5': {
        site_name: 'billcom',
        marketplace_type: 'Private',
        appid: '725684c4-3375-4431-818f-7697fb1ec3c5'
    },
    '411935c8-e985-43e1-a91c-df4a1399f3a1': {
        app_name: 'jira-assets-client-sync',
        site_name: 'Interactio.io',
        marketplace_type: 'Private',
        appid: '411935c8-e985-43e1-a91c-df4a1399f3a1'
    },
    '40e0dfd8-0e8e-4b92-9700-bfd00ec77ca8': {
        app_name: 'slack-send-v2',
        site_name: 'Interactio.io',
        marketplace_type: 'Private',
        appid: '40e0dfd8-0e8e-4b92-9700-bfd00ec77ca8'
    },
    '27e1630b-7796-4c1c-8431-d3dacd0b0a65': {
        site_name: 'FusionSpan',
        marketplace_type: 'Private',
        appid: '27e1630b-7796-4c1c-8431-d3dacd0b0a65'
    },
    'cf02163e-b400-4e6e-902b-049492d4675c': {
        site_name: 'dalet',
        marketplace_type: 'Private',
        appid: 'cf02163e-b400-4e6e-902b-049492d4675c'
    }
};

});

parcelRegister("hoVr8", function(module, exports) {

$parcel$export(module.exports, "useSendRendererRenderedAnalytics", () => $fbc50d5752c05105$export$1e4237f96323a8a1);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $6oQb1 = parcelRequire("6oQb1");

var $5U2YR = parcelRequire("5U2YR");
const $fbc50d5752c05105$export$1e4237f96323a8a1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    (0, $gwFzn.useEffect)(()=>{
        (0, $6oQb1.trackRendererRendered)(createAnalyticsEvent, {
            source: source,
            target: 'renderer'
        });
    });
};

});


parcelRegister("hEvav", function(module, exports) {

$parcel$export(module.exports, "makeUser", () => $556ea5977eff619b$export$4e4c41e4152a9f8a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6vnrx = parcelRequire("6vnrx");

var $9UyM5 = parcelRequire("9UyM5");

var $kpdGL = parcelRequire("kpdGL");
var $esRft = parcelRequire("esRft");

var $c4sKh = parcelRequire("c4sKh");
const $556ea5977eff619b$var$containerStyle = null;
const $556ea5977eff619b$var$messages = (0, $2nPZH.defineMessages)({
    unknownUser: {
        id: "confluence.user.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
const $556ea5977eff619b$var$Avatar = ({ name: name, picture: picture, hideDisplayName: hideDisplayName })=>{
    if (hideDisplayName) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
        name: name,
        src: picture
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // Reduce Atlaskit padding to vertically-align with other components
    , {
        className: (0, $35pXk.default)([
            "_1gzjidpf _1plv18uv _1r3373ad"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpdGL.default), {
            avatar: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                name: name,
                src: picture
            }),
            primaryText: name
        })
    });
};
function $556ea5977eff619b$var$UserInline({ name: name }) {
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
        appearance: "primary",
        children: name || intl.formatMessage($556ea5977eff619b$var$messages.unknownUser)
    });
}
const $556ea5977eff619b$var$User = ({ accountId: accountId, client: client, hideDisplayName: hideDisplayName })=>{
    const { picture: picture, name: name } = (0, $6vnrx.useUser)(accountId, client);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) return /*#__PURE__*/ (0, $7UHDa.jsx)($556ea5977eff619b$var$UserInline, {
        name: name
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($556ea5977eff619b$var$Avatar, {
        name: name,
        picture: picture,
        hideDisplayName: hideDisplayName
    });
};
const $556ea5977eff619b$export$4e4c41e4152a9f8a = ({ client: client })=>{
    return function UserFnNext({ forgeDoc: { props: props } }) {
        const { accountId: accountId, hideDisplayName: hideDisplayName } = props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($556ea5977eff619b$var$User, {
            accountId: accountId,
            client: client,
            hideDisplayName: hideDisplayName
        });
    };
};

});
parcelRegister("6vnrx", function(module, exports) {

$parcel$export(module.exports, "useUsers", () => $d67925c3490b4618$export$90f4370c54dd43c9);
$parcel$export(module.exports, "useUser", () => $d67925c3490b4618$export$23bbbc4533528f03);

var $xQxzY = parcelRequire("xQxzY");

var $d2LG0 = parcelRequire("d2LG0");

var $dh538 = parcelRequire("dh538");

var $1Igmn = parcelRequire("1Igmn");
const $d67925c3490b4618$export$25f4d46d5dabadfc = (0, $d2LG0.default)`query forge_ui_userQuery($accountId:ID!){user(accountId:$accountId){name picture}}`;
const $d67925c3490b4618$export$ef7fb495aeba8901 = (0, $d2LG0.default)`query forge_ui_usersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){name accountId picture}}`;
const $d67925c3490b4618$export$90f4370c54dd43c9 = (accountIds, client)=>{
    const nonEmptyAccountIds = accountIds.filter((id)=>!(id === ''));
    const headers = {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) headers['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)();
    const { data: data } = (0, $xQxzY.useQuery)($d67925c3490b4618$export$ef7fb495aeba8901, {
        variables: {
            accountIds: nonEmptyAccountIds
        },
        client: client,
        context: {
            headers: headers
        }
    });
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    return users;
};
const $d67925c3490b4618$export$23bbbc4533528f03 = (accountId, client)=>{
    const headers = {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) headers['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)();
    const { data: data } = (0, $xQxzY.useQuery)($d67925c3490b4618$export$25f4d46d5dabadfc, {
        variables: {
            accountId: accountId
        },
        skip: !accountId,
        client: client,
        context: {
            headers: headers
        }
    });
    if (data && data.user) {
        const { picture: picture, name: name } = data.user;
        return {
            name: name,
            picture: picture
        };
    }
    return {
        name: '',
        picture: ''
    };
};

});


parcelRegister("cAcwV", function(module, exports) {

$parcel$export(module.exports, "makeUserGroup", () => $ac41127a79653400$export$30420ba0b3cd13e0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6vnrx = parcelRequire("6vnrx");

var $9UyM5 = parcelRequire("9UyM5");

const $ac41127a79653400$var$AKAvatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("4PNeW")));

const $ac41127a79653400$var$AKBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("1htSM")));
function $ac41127a79653400$export$a2cdaa6af5c46e54(users, accountIds, intl) {
    // order should match accountIds
    return accountIds.map((key)=>{
        const { name: name = intl.formatMessage($ac41127a79653400$var$messages.unknownUserMessage), picture: picture = '' } = users[key] || {};
        return {
            key: key,
            name: name,
            src: picture
        };
    });
}
function $ac41127a79653400$export$7962e827ea8ac95f({ data: data }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$var$AKAvatarGroup, {
        appearance: "stack",
        data: data
    });
}
function $ac41127a79653400$var$More({ data: data }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$var$AKBadge, {
        children: `+${data.length}`
    });
}
function $ac41127a79653400$export$82c3b28526691c79({ data: data }) {
    const end = Math.max(Math.min(8, data.length), 0); // 4 would be the same as AvatarStack
    const shown = data.slice(0, end);
    const more = data.slice(end);
    const hasMore = more.length > 0;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
        children: [
            shown.map(({ name: name }, i)=>{
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$var$AKBadge, {
                            appearance: "primary",
                            children: name
                        }),
                        hasMore || i !== end - 1 ? ' ' : null
                    ]
                });
            }),
            hasMore ? /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$var$More, {
                data: more
            }) : null
        ]
    });
}
// @ts-ignore setting z index to 0 so that the avatars do not overlap other components
const $ac41127a79653400$var$avatarStackWrapper = (0, $ecnYn.xcss)({
    zIndex: 0,
    position: 'relative'
});
function $ac41127a79653400$export$2e2bcd8739ae039({ accountIds: accountIds, client: client }) {
    const users = (0, $6vnrx.useUsers)(accountIds, client);
    const intl = (0, $dBxQj.default)();
    const data = $ac41127a79653400$export$a2cdaa6af5c46e54(users, accountIds, intl);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (inline) return /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$export$82c3b28526691c79, {
        data: data
    });
    return(// Each avatar in an avatar stack has a z index value applied.
    // Setting a container with a z index here to 0 so that the avatars do no overlap other components such as the Select menu
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $ac41127a79653400$var$avatarStackWrapper,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$export$7962e827ea8ac95f, {
            data: data
        })
    }));
}
function $ac41127a79653400$export$63abfa3ed5832db7({ children: children }) {
    const accountIds = children.map((child)=>{
        if (child.type !== 'User' && child.type !== 'Avatar') return '';
        const { props: props } = child;
        const { accountId: accountId } = props;
        return accountId;
    }).filter((x)=>x);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$export$2e2bcd8739ae039, {
        accountIds: accountIds,
        client: undefined
    });
}
function $ac41127a79653400$export$30420ba0b3cd13e0({ client: client }) {
    return function avatarStackNext({ forgeDoc: { children: children } }) {
        const accountIds = children.map((child)=>{
            if (child.type !== 'User' && child.type !== 'Avatar') return '';
            const { props: props } = child;
            const { accountId: accountId } = props;
            return accountId;
        }).filter((x)=>x);
        return /*#__PURE__*/ (0, $7UHDa.jsx)($ac41127a79653400$export$2e2bcd8739ae039, {
            accountIds: accountIds,
            client: client
        });
    };
}
const $ac41127a79653400$var$messages = (0, $2nPZH.defineMessages)({
    unknownUserMessage: {
        id: "confluence.user.group.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});

});
parcelRegister("4PNeW", function(module, exports) {

let $38521ee3d09f906c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $38521ee3d09f906c$var$load("7Q0UC"),
    $38521ee3d09f906c$var$load("dTsOE"),
    $38521ee3d09f906c$var$load("19qJC")
]).then(()=>parcelRequire('jl3SG'));

});


parcelRegister("durRy", function(module, exports) {

$parcel$export(module.exports, "makeNativeUserPicker", () => $482c9d0ed1050096$export$57fb7dc1c2438e62);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6vnrx = parcelRequire("6vnrx");

var $cWPLt = parcelRequire("cWPLt");

var $iamDk = parcelRequire("iamDk");

// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
const $482c9d0ed1050096$var$hydrateDefaultValue = (users, isMulti = false)=>{
    const defaultValues = [];
    for(const userId in users){
        const { name: name, picture: picture } = users[userId];
        // Only grabbing the values where user name exist
        if (name) defaultValues.push({
            name: name,
            avatarUrl: picture,
            id: userId,
            type: 'user'
        });
    }
    return isMulti ? defaultValues : defaultValues[0];
};
const $482c9d0ed1050096$var$UserPickerFn = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props })=>{
    const { name: name, label: label, placeholder: placeholder, description: description, // Warning: Smart user picker ONLY supports default value hydration
    // of *users*, not groups!
    defaultValue: defaultUserValue = '', isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const query = (0, $cWPLt.useMentionResource)(mentionProvider);
    const accountIds = Array.isArray(defaultUserValue) ? defaultUserValue : [
        defaultUserValue
    ];
    const usersData = (0, $6vnrx.useUsers)(accountIds, client);
    // Hydrate the default value ourselves, since we are controlling value from <Field>
    // component value. It will get passed into the user picker as simply `value`.
    const hydratedDefaultValue = $482c9d0ed1050096$var$hydrateDefaultValue(usersData, isMulti);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iamDk.UserPicker), {
        accountId: accountId,
        cloudId: cloudId,
        productAttributes: productAttributes,
        productKey: productKey,
        mentionProvider: mentionProvider,
        name: name,
        label: label,
        placeholder: placeholder,
        description: description,
        defaultValue: hydratedDefaultValue,
        isRequired: isRequired,
        isMulti: isMulti,
        includeUsers: includeUsers,
        includeGroups: includeGroups,
        baseUrl: baseUrl,
        onChange: onChange,
        query: query
    });
};
const $482c9d0ed1050096$export$89c0f5a165dc562a = ({ query: query, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        const { name: name, label: label, placeholder: placeholder, description: description, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange, defaultValue: defaultUserId } = props;
        const [defaultValueLoaded, setDefaultValueLoaded] = (0, $gwFzn.useState)(!defaultUserId);
        const [defaultValue, setDefaultValue] = (0, $gwFzn.useState)();
        (0, $gwFzn.useEffect)(()=>{
            if (defaultUserId && !defaultValueLoaded) query().then((users)=>{
                const targetUsers = users.filter(({ id: id })=>Array.isArray(defaultUserId) ? defaultUserId.includes(id) : defaultUserId === id);
                if (targetUsers.length === 0) setDefaultValue(undefined);
                else if (isMulti) setDefaultValue(targetUsers);
                else setDefaultValue(targetUsers[0]);
                setDefaultValueLoaded(true);
            });
        }, [
            isMulti,
            defaultUserId,
            defaultValueLoaded,
            setDefaultValue,
            setDefaultValueLoaded
        ]);
        if (!defaultValueLoaded) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: null
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iamDk.UserPicker), {
            accountId: accountId,
            cloudId: cloudId,
            productKey: productKey,
            baseUrl: baseUrl,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            onChange: onChange,
            query: query,
            defaultValue: defaultValue
        });
    };
};
const $482c9d0ed1050096$export$57fb7dc1c2438e62 = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl, productAttributes: productAttributes })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        return /*#__PURE__*/ (0, $7UHDa.jsx)($482c9d0ed1050096$var$UserPickerFn, {
            props: props,
            client: client,
            mentionProvider: mentionProvider,
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            baseUrl: baseUrl
        });
    };
};

});
parcelRegister("cWPLt", function(module, exports) {

$parcel$export(module.exports, "useMentionResource", () => $d0f49770ff4f5279$export$f4d09562dcb13ab);

var $gwFzn = parcelRequire("gwFzn");
// Key for registering and unregistering the subscriber
const $d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY = 'forge-ui-user-select';
const $d0f49770ff4f5279$var$mentionResultsToUsers = (results)=>{
    return results.map((result)=>({
            id: result.id,
            name: result.name,
            avatarUrl: result.avatarUrl || '',
            type: 'user'
        })).filter((user)=>typeof user.name !== 'undefined');
};
const $d0f49770ff4f5279$export$f4d09562dcb13ab = (mentionProvider)=>{
    const query = (0, $gwFzn.useCallback)(async (search)=>{
        const provider = await mentionProvider;
        if (provider && search) return new Promise((resolve)=>{
            provider.filter(search);
            provider.subscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve($d0f49770ff4f5279$var$mentionResultsToUsers(results));
            }, ()=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve([]);
            });
        });
        return Promise.resolve([]);
    }, [
        mentionProvider
    ]);
    if (mentionProvider) return query;
};

});

parcelRegister("iamDk", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $a8c4b840c9ca4704$export$83e0c73b09b3a9cd);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kRbf2 = parcelRequire("kRbf2");

var $dh538 = parcelRequire("dh538");

var $kSKAi = parcelRequire("kSKAi");

var $7rus4 = parcelRequire("7rus4");

var $gQhRa = parcelRequire("gQhRa");

var $JmaBh = parcelRequire("JmaBh");

var $7LZ4R = parcelRequire("7LZ4R");
const $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';
// the value prop in UserPicker component can only take undefined for empty value.
// null is not allowed and will resulted in unexpected behavior.
const $a8c4b840c9ca4704$var$ensureUserPickerValue = (value)=>{
    if (!value || Array.isArray(value) && value.length === 0) return undefined;
    return value;
};
// by forcing a key update when defaultValue is present, we force the SmartUserPicker to re-render.
// this is because the SmartUserPicker does not re-render when the defaultValue changes in its
// current implementation.
const $a8c4b840c9ca4704$var$makeUserPickerKey = (id, defaultValue)=>{
    if (!defaultValue || Array.isArray(defaultValue) && defaultValue.length === 0) return id;
    return `${id}-with-default`;
};
const $a8c4b840c9ca4704$var$RawUserPicker = ({ id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: includeUsers = true, includeGroups: includeGroups = false, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes })=>{
    const [value, setValue] = (0, $gwFzn.useState)(defaultValue);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $JmaBh.PortalConsumer), {
        children: (portal)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    suppliedCloudId && productKey ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7rus4.default), {
                        value: (0, $dh538.fg)('platform_fix_userpicker_clear_values') ? undefined : $a8c4b840c9ca4704$var$ensureUserPickerValue(providedValue ?? value),
                        onChange: (user)=>{
                            if ((0, $dh538.fg)('platform_fix_userpicker_clear_values')) onChange?.(user);
                            else {
                                setValue(user);
                                onChange?.(user);
                            }
                        },
                        isMulti: isMulti,
                        menuPortalTarget: portal || undefined,
                        noOptionsMessage: ()=>null,
                        placeholder: placeholder,
                        width: width,
                        fieldId: // Bitbucket User Recommendations does not support generic contextType
                        productKey === 'bitbucket' ? $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID : id,
                        debounceTime: 400,
                        includeUsers: includeUsers,
                        includeGroups: includeGroups,
                        siteId: suppliedCloudId,
                        productAttributes: productAttributes,
                        // If principalId === 'Context', upstream attempts to use other context
                        // to discover the principal ID
                        principalId: currentAccountId ?? 'Context',
                        productKey: productKey,
                        baseUrl: baseUrl,
                        inputId: name || id,
                        defaultValue: defaultValue
                    }, $a8c4b840c9ca4704$var$makeUserPickerKey(id, defaultValue)) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kSKAi.UserPicker), {
                        value: $a8c4b840c9ca4704$var$ensureUserPickerValue(providedValue ?? value),
                        onChange: (user)=>{
                            setValue(user);
                            onChange?.(user);
                        },
                        isMulti: isMulti,
                        menuPortalTarget: portal || undefined,
                        noOptionsMessage: ()=>null,
                        placeholder: placeholder,
                        width: width,
                        loadOptions: query,
                        fieldId: null,
                        inputId: id,
                        defaultValue: defaultValue
                    }),
                    description && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.HelperMessage), {
                        children: description
                    })
                ]
            })
    });
};
const $a8c4b840c9ca4704$export$83e0c73b09b3a9cd = (props)=>{
    const uid = (0, $kRbf2.useUID)();
    const { name: name, isRequired: isRequired, label: label } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7LZ4R.Label), {
                name: name,
                isRequired: isRequired,
                label: label
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($a8c4b840c9ca4704$var$RawUserPicker, {
                id: name || uid,
                width: "100%",
                ...props
            })
        ]
    });
};

});
parcelRegister("7LZ4R", function(module, exports) {

$parcel$export(module.exports, "Label", () => $4dadbd8988869e85$export$b04be29aa201d4f5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");

const $4dadbd8988869e85$var$AKLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.Label
        })));
const $4dadbd8988869e85$export$b04be29aa201d4f5 = ({ isRequired: isRequired, label: label, name: name })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($4dadbd8988869e85$var$AKLabel, {
        htmlFor: name,
        id: `${name}-label`,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            space: "space.025",
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                    as: "strong",
                    color: "color.text.danger",
                    size: "UNSAFE_small",
                    children: "*"
                })
            ]
        })
    });
};

});



parcelRegister("d0USC", function(module, exports) {

$parcel$export(module.exports, "WebRuntime", () => $6f2f66284b5f7b02$export$c9565324b088e0b8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $h6bEF = parcelRequire("h6bEF");

var $dh538 = parcelRequire("dh538");

var $76I1K = parcelRequire("76I1K");
const $6f2f66284b5f7b02$export$c9565324b088e0b8 = ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, apolloClient: apolloClient, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, ...restProps })=>{
    const forgeReactMajorVersion = (0, $gwFzn.useRef)(null);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const macroConfigUpdateImprovementEnabled = (0, $dh538.fg)('forge-ui-macro-config-update-improvement');
    const combinedBridge = {
        onError: ({ error: error })=>{
            if (setError) setError(error);
        },
        ...bridge,
        reconcile: ({ forgeDoc: forgeDoc })=>{
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (macroConfigUpdateImprovementEnabled && forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        }
    };
    const getCurrentForgeReactMajorVersion = (0, $76I1K.useCallbackOne)(()=>{
        return forgeReactMajorVersion.current;
    }, [
        forgeReactMajorVersion
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6bEF.Iframe), {
        accountId: accountId,
        apolloClient: apolloClient,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        isHidden: true,
        getCurrentForgeReactMajorVersion: macroConfigUpdateImprovementEnabled ? getCurrentForgeReactMajorVersion : undefined,
        ...restProps,
        onError: (err)=>setError && setError(new Error(err))
    });
};

});

parcelRegister("gwUcI", function(module, exports) {

$parcel$export(module.exports, "uncurlyUuid", () => $388fc69d2d887761$export$3a1a8bfb58a690be);
const $388fc69d2d887761$var$uuidRe = new RegExp('^{([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})}$');
const $388fc69d2d887761$export$3a1a8bfb58a690be = (uuid)=>{
    const match = $388fc69d2d887761$var$uuidRe.exec(uuid);
    if (!match) return '';
    return match[1];
};

});


parcelRegister("4hOVE", function(module, exports) {

$parcel$export(module.exports, "makeFrame", () => $acc8ad845a033cd1$export$1f1ebfe6da5b177c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $69400 = parcelRequire("69400");

var $g7rOD = parcelRequire("g7rOD");
const $acc8ad845a033cd1$var$Frame = ({ forgeDoc: forgeDoc, IframeRenderer: IframeRenderer })=>{
    const { setFrameCount: setFrameCount } = (0, $gwFzn.useContext)((0, $69400.FrameCount));
    (0, $gwFzn.useEffect)(()=>{
        setFrameCount((prevCount)=>prevCount + 1);
        return ()=>setFrameCount((prevCount)=>prevCount - 1);
    }, [
        setFrameCount
    ]);
    const { resource: resource, frameId: frameId } = forgeDoc.props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(IframeRenderer, {
        resource: resource,
        frameId: frameId
    });
};
const $acc8ad845a033cd1$var$FrameMemo = /*#__PURE__*/ (0, $gwFzn.memo)($acc8ad845a033cd1$var$Frame, (0, $g7rOD.forgePropsAreEqual));
const $acc8ad845a033cd1$export$1f1ebfe6da5b177c = (IframeRenderer)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($acc8ad845a033cd1$var$FrameMemo, {
            ...props,
            IframeRenderer: IframeRenderer
        });
};

});

parcelRegister("iqcSr", function(module, exports) {

$parcel$export(module.exports, "isCustomUI", () => $017ffa7c15d62dd2$export$4c5241daa4566af8);
const $017ffa7c15d62dd2$export$4c5241daa4566af8 = (extension, entryPoint)=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        return entryPointResource != null && entryPointRender !== 'native';
    }
    return resource != null && render !== 'native';
};

});


parcelRegister("8z3oB", function(module, exports) {

$parcel$export(module.exports, "getFlagProvider", () => $0ffa514f9611729c$export$723a1497b2536563);
$parcel$export(module.exports, "FlagProvider", () => $0ffa514f9611729c$export$b0063bae72b769ca);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $aD1SW = parcelRequire("aD1SW");

var $gqqjz = parcelRequire("gqqjz");
const $0ffa514f9611729c$export$723a1497b2536563 = ({ showFlag: showFlag, hideFlag: hideFlag })=>{
    const createFlag = (flagOptions)=>{
        const { isAutoDismiss: isAutoDismiss, ...restOptions } = flagOptions;
        const { type: type, appearance: appearance, actions: actions } = flagOptions;
        const shouldAutoDismiss = isAutoDismiss ?? (appearance === 'info' || appearance === 'success');
        showFlag({
            ...restOptions,
            type: appearance ?? type,
            actions: actions?.map(({ text: content, onClick: onClick })=>({
                    onClick: ()=>onClick(),
                    content: content
                })),
            customComponent: shouldAutoDismiss ? (0, $aD1SW.default) : undefined
        });
        return true;
    };
    const closeFlag = ({ id: id })=>{
        hideFlag(id);
        return true;
    };
    return {
        showFlag: createFlag,
        closeFlag: closeFlag
    };
};
const $0ffa514f9611729c$export$b0063bae72b769ca = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, children);

});

parcelRegister("i6tJx", function(module, exports) {

$parcel$export(module.exports, "makeUserPicker", () => $87e7d50457aeae86$export$c34ed2223cde96e2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kRbf2 = parcelRequire("kRbf2");

var $cWPLt = parcelRequire("cWPLt");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $JmaBh = parcelRequire("JmaBh");

var $dTk3A = parcelRequire("dTk3A");

var $6vnrx = parcelRequire("6vnrx");

var $2Hm46 = parcelRequire("2Hm46");
const $87e7d50457aeae86$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';

const $87e7d50457aeae86$var$AKFormField = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("aJB4a")));

const $87e7d50457aeae86$var$AKUserPicker = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jRkeq")));

const $87e7d50457aeae86$var$AKSmartUserPicker = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jmd46")));

const $87e7d50457aeae86$var$AKHelperMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.HelperMessage
        })));

const $87e7d50457aeae86$var$AKErrorMessage = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fmuWr")).then((module)=>({
            default: module.ErrorMessage
        })));
const $87e7d50457aeae86$export$2a41a819c1db85b1 = (productKey)=>{
    return productKey === 'confluence' || productKey === 'jira' || productKey === 'people' || productKey === 'compass' || productKey === 'bitbucket';
};
const $87e7d50457aeae86$var$validate = (value)=>!value || Array.isArray(value) && value.length === 0 ? 'EMPTY' : undefined;
// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
const $87e7d50457aeae86$var$hydrateDefaultValue = (users, isMulti = false)=>{
    const defaultValues = [];
    for(const userId in users){
        const { name: name, picture: picture } = users[userId];
        // Only grabbing the values where user name exist
        if (name) defaultValues.push({
            name: name,
            avatarUrl: picture,
            id: userId,
            type: 'user'
        });
    }
    return isMulti ? defaultValues : defaultValues[0];
};
const $87e7d50457aeae86$var$UserPicker = ({ name: name, label: label, description: description, placeholder: placeholder, isRequired: isRequired, isMulti: isMulti, // Warning: Smart user picker ONLY supports default value hydration
// of *users*, not groups!
defaultValue: defaultUsersValue = '', includeUsers: includeUsers = true, includeGroups: includeGroups = false, client: client, mentionProvider: mentionProvider, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl })=>{
    const query = (0, $cWPLt.useMentionResource)(mentionProvider);
    const uid = (0, $kRbf2.useUID)();
    // Hydrate the default value ourselves, since we are controlling value from <Field>
    // component value. It will get passed into the user picker as simply `value`.
    const accountIds = Array.isArray(defaultUsersValue) ? defaultUsersValue : [
        defaultUsersValue
    ];
    const usersData = (0, $6vnrx.useUsers)(accountIds, client);
    const hydratedDefaultValue = $87e7d50457aeae86$var$hydrateDefaultValue(usersData, isMulti);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $JmaBh.PortalConsumer), {
        children: (portal)=>/*#__PURE__*/ (0, $7UHDa.jsx)($87e7d50457aeae86$var$AKFormField, {
                id: `${uid}-forge-${suppliedCloudId && productKey ? 'smart-user-picker' : 'user-picker'}`,
                name: name,
                label: label,
                defaultValue: hydratedDefaultValue,
                validate: isRequired ? $87e7d50457aeae86$var$validate : undefined,
                isRequired: isRequired,
                children: ({ fieldProps: fieldProps, error: error })=>{
                    const userPickerProps = {
                        ...fieldProps,
                        isMulti: isMulti,
                        menuPortalTarget: portal || undefined,
                        noOptionsMessage: ()=>null,
                        placeholder: placeholder,
                        width: `${(0, $dTk3A.gridSize)() * 40}px`
                    };
                    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Hm46.FormStateChangeNotifier), {
                                name: name,
                                value: fieldProps.value
                            }),
                            suppliedCloudId && productKey ? /*#__PURE__*/ (0, $7UHDa.jsx)($87e7d50457aeae86$var$AKSmartUserPicker, {
                                ...userPickerProps,
                                fieldId: // Bitbucket User Recommendations does not support generic contextType
                                productKey === 'bitbucket' ? $87e7d50457aeae86$var$BITBUCKET_FIELD_ID : uid,
                                debounceTime: 400,
                                includeUsers: includeUsers,
                                includeGroups: includeGroups,
                                siteId: suppliedCloudId,
                                // If principalId === 'Context', upstream attempts to use other context
                                // to discover the principal ID
                                principalId: currentAccountId || 'Context',
                                productKey: productKey,
                                baseUrl: baseUrl,
                                inputId: userPickerProps.id
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)($87e7d50457aeae86$var$AKUserPicker, {
                                ...userPickerProps,
                                loadOptions: query,
                                fieldId: null,
                                inputId: userPickerProps.id
                            }),
                            error === 'EMPTY' && /*#__PURE__*/ (0, $7UHDa.jsx)($87e7d50457aeae86$var$AKErrorMessage, {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...$87e7d50457aeae86$var$messages.emptyFieldErrorMessage
                                })
                            }),
                            description && /*#__PURE__*/ (0, $7UHDa.jsx)($87e7d50457aeae86$var$AKHelperMessage, {
                                children: description
                            })
                        ]
                    });
                }
            })
    });
};
var $87e7d50457aeae86$export$2e2bcd8739ae039 = $87e7d50457aeae86$var$UserPicker;
const $87e7d50457aeae86$export$36317cb13bddb31a = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl, props: props })=>{
    const { name: name, label: label, placeholder: placeholder, description: description, defaultValue: defaultValue, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($87e7d50457aeae86$var$UserPicker, {
        client: client,
        accountId: accountId,
        cloudId: cloudId,
        productKey: productKey,
        mentionProvider: mentionProvider,
        name: name,
        label: label,
        placeholder: placeholder,
        description: description,
        defaultValue: defaultValue,
        isRequired: isRequired,
        isMulti: isMulti,
        includeUsers: includeUsers,
        includeGroups: includeGroups,
        baseUrl: baseUrl
    });
};
const $87e7d50457aeae86$export$c34ed2223cde96e2 = ({ client: client, mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        return /*#__PURE__*/ (0, $7UHDa.jsx)($87e7d50457aeae86$export$36317cb13bddb31a, {
            props: props,
            client: client,
            mentionProvider: mentionProvider,
            accountId: accountId,
            cloudId: cloudId,
            productKey: productKey,
            baseUrl: baseUrl
        });
    };
};
const $87e7d50457aeae86$var$messages = (0, $2nPZH.defineMessages)({
    emptyFieldErrorMessage: {
        id: "confluence.user.picker.empty.field.error.message",
        defaultMessage: "This field is required."
    }
});

});
parcelRegister("jRkeq", function(module, exports) {

let $e752a925537e7dfb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e752a925537e7dfb$var$load("9VhGp").then(()=>parcelRequire('l1GSg'));

});

parcelRegister("jmd46", function(module, exports) {

let $e17a34d752707875$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e17a34d752707875$var$load("6nr9L"),
    $e17a34d752707875$var$load("7ofLD"),
    $e17a34d752707875$var$load("9FBaW"),
    $e17a34d752707875$var$load("jjAxo")
]).then(()=>parcelRequire('7HssB'));

});


parcelRegister("79spt", function(module, exports) {

$parcel$export(module.exports, "useWebRuntime", () => $01f3df308a04e9e4$export$104ed22ca3b5f013);

var $gwFzn = parcelRequire("gwFzn");

var $76I1K = parcelRequire("76I1K");

var $eH9u1 = parcelRequire("eH9u1");

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $3Spjc = parcelRequire("3Spjc");

var $kMV4U = parcelRequire("kMV4U");

var $ijfiP = parcelRequire("ijfiP");
function $01f3df308a04e9e4$var$isRenderEffect(effect) {
    return effect.type === 'render' && !!effect.aux && !!effect.state;
}
function $01f3df308a04e9e4$var$isResultEffect(effect) {
    return effect.type === 'result' && !!effect.forgeDoc && !!effect.state;
}
function $01f3df308a04e9e4$export$e1cc320ad208a904(effect) {
    return $01f3df308a04e9e4$var$isRenderEffect(effect) || $01f3df308a04e9e4$var$isResultEffect(effect);
}
function $01f3df308a04e9e4$export$d8d6c2eccfad5495(effects) {
    return effects.every($01f3df308a04e9e4$export$e1cc320ad208a904);
}
function $01f3df308a04e9e4$var$isGQLInvokeAuxEffectsNetworkFailure(response) {
    return typeof response.success === 'undefined';
}
function $01f3df308a04e9e4$var$isGQLInvokeAuxEffectsResponseSucceeded(response) {
    return response.success;
}
const $01f3df308a04e9e4$var$downgradeEffect = (effect)=>{
    if (effect.type === 'render') return {
        type: 'initialize'
    };
    else if (effect.type === 'event') return {
        type: 'event',
        handler: effect.handler,
        args: effect.args
    };
};
const $01f3df308a04e9e4$var$getRuntimeStateError = (response)=>{
    const { result: result, errors: errors } = response;
    if ($01f3df308a04e9e4$var$isGQLInvokeAuxEffectsNetworkFailure(response)) return 'Unexpected error occurred. Try refreshing your browser.';
    else if (!$01f3df308a04e9e4$var$isGQLInvokeAuxEffectsResponseSucceeded(response)) {
        const error = errors?.[0];
        const statusCode = error?.extensions.statusCode;
        const message = error?.message;
        if (statusCode === 400 || statusCode === 500) {
            if (!result?.effects) return message;
            else if (!$01f3df308a04e9e4$export$d8d6c2eccfad5495(result.effects)) return 'received a non-client effect';
            return undefined;
        }
        return message;
    } else if (!!result && !$01f3df308a04e9e4$export$d8d6c2eccfad5495(result.effects)) return 'received a non-client effect';
    return undefined;
};
function $01f3df308a04e9e4$var$useIsUnmountedRef() {
    const isUnmountedRef = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            isUnmountedRef.current = true;
        };
    }, []);
    return isUnmountedRef;
}
const $01f3df308a04e9e4$export$104ed22ca3b5f013 = ({ apolloClient: apolloClient, contextIds: contextIds, extensionId: extensionId, coreData: coreData, entryPoint: entryPoint, getContextToken: getContextToken, resetStateOnExtensionDataChange: resetStateOnExtensionDataChange })=>{
    const [{ forgeDoc: forgeDoc, appTime: appTime, error: error, loading: loading }, setRuntimeState] = (0, $gwFzn.useState)({
        forgeDoc: undefined,
        appTime: 0,
        error: undefined,
        loading: false
    });
    const previousProps = (0, $gwFzn.useRef)({
        extensionId: extensionId,
        entryPoint: entryPoint
    });
    const extensionData = (0, $gwFzn.useRef)({});
    const appState = (0, $gwFzn.useRef)({});
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(previousProps.current, {
        extensionId: extensionId,
        entryPoint: entryPoint
    })) {
        appState.current = {};
        previousProps.current = {
            extensionId: extensionId,
            entryPoint: entryPoint
        };
    }
    const contextToken = (0, $gwFzn.useRef)(undefined);
    const isUnmountedRef = $01f3df308a04e9e4$var$useIsUnmountedRef();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // TODO: remove this event once we have switched over to the new event schema
    // https://ecosystem-platform.atlassian.net/browse/EXT-2196
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            data: {
                action: 'viewed',
                actionSubject: 'forgeUIExtension',
                actionSubjectId: 'editorMacro'
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    /* eslint-disable */ /* prettier-ignore */ // Disabled to prevent eslint auto-fixing these hooks.
    // The autofix breaks usages like: useWebRuntime({ coreData: { localId, cloudId } })
    const memoedContextIds = (0, $76I1K.useMemoOne)(()=>contextIds, [
        contextIds.sort().join()
    ]);
    const { moduleKey: moduleKey } = (0, $ijfiP.parseExtensionId)(extensionId);
    const siteUrl = window.location.origin;
    const memoedCoreData = (0, $76I1K.useMemoOne)(()=>({
            ...coreData,
            moduleKey: moduleKey,
            siteUrl: siteUrl
        }), [
        coreData.localId,
        coreData.cloudId,
        moduleKey,
        siteUrl
    ]);
    /* eslint-enable */ const dispatch = (0, $76I1K.useCallbackOne)(async (effect)=>{
        performance.mark(`forge-ui.fe.render-start-${memoedCoreData.localId}`);
        switch(effect.type){
            case 'event':
            /* eslint-disable-line no-fallthrough */ case 'render':
                if (resetStateOnExtensionDataChange) {
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(effect.extensionData, extensionData.current)) appState.current = {};
                }
                extensionData.current = effect.extensionData;
                setRuntimeState(({ forgeDoc: forgeDoc, appTime: appTime, error: error })=>({
                        forgeDoc: forgeDoc,
                        appTime: appTime,
                        error: error,
                        loading: true
                    }));
                try {
                    const mutationResult = await apolloClient.mutate({
                        mutation: (0, $kMV4U.invokeAuxEffectsMutation),
                        variables: {
                            input: {
                                contextIds: memoedContextIds,
                                extensionId: extensionId,
                                entryPoint: entryPoint,
                                payload: {
                                    state: appState.current,
                                    context: {
                                        ...memoedCoreData,
                                        extensionData: effect.extensionData
                                    },
                                    extensionPayload: effect.extensionPayload,
                                    contextToken: getContextToken ? await getContextToken() : contextToken.current?.jwt,
                                    effects: [
                                        $01f3df308a04e9e4$var$downgradeEffect(effect)
                                    ],
                                    config: effect.extensionData?.config
                                }
                            }
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const response = mutationResult.data.invokeAuxEffects || {};
                    const { result: result } = response;
                    contextToken.current = result?.contextToken;
                    setRuntimeState(({ forgeDoc: forgeDoc })=>({
                            forgeDoc: (()=>{
                                if (!result || !result.effects[0]) return forgeDoc;
                                const resultEffect = result.effects[0];
                                appState.current = resultEffect.state;
                                return resultEffect.aux;
                            })(),
                            appTime: result?.metrics?.appTimeMs || 0,
                            error: $01f3df308a04e9e4$var$getRuntimeStateError(response),
                            loading: false
                        }));
                    if (!isUnmountedRef.current) {
                        requestAnimationFrame(()=>{
                            setTimeout(()=>{
                                performance.mark(`forge-ui.fe.render-end-${memoedCoreData.localId}`);
                                performance.measure('forge-ui.fe.render', `forge-ui.fe.render-start-${memoedCoreData.localId}`, `forge-ui.fe.render-end-${memoedCoreData.localId}`);
                            });
                        });
                        // this tracks every time an app is rendered
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                            data: {
                                action: 'rendered',
                                actionSubject: 'forge.ui.renderer',
                                attributes: {
                                    target: 'useWebRuntime'
                                },
                                tags: [
                                    'forge'
                                ]
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                    }
                } catch (error) {
                    setRuntimeState(({ forgeDoc: forgeDoc, appTime: appTime })=>({
                            forgeDoc: forgeDoc,
                            appTime: appTime,
                            error: error && error.message,
                            loading: false
                        }));
                }
                return;
            default:
                setRuntimeState(({ forgeDoc: forgeDoc, appTime: appTime, loading: loading })=>({
                        forgeDoc: forgeDoc,
                        appTime: appTime,
                        error: `Internal Error: Don't know how to handle effect ${effect}.`,
                        loading: loading
                    }));
        }
    }, [
        apolloClient,
        memoedContextIds,
        extensionId,
        appState,
        memoedCoreData,
        isUnmountedRef,
        entryPoint,
        getContextToken,
        resetStateOnExtensionDataChange,
        createAnalyticsEvent
    ]);
    Object.freeze(forgeDoc);
    return [
        dispatch,
        {
            forgeDoc: forgeDoc,
            appTime: appTime,
            loading: loading,
            error: error
        }
    ];
};

});
parcelRegister("kMV4U", function(module, exports) {

$parcel$export(module.exports, "invokeAuxEffectsMutation", () => $3a02e5f9ae610962$export$fc98ec826c78a30a);
$parcel$export(module.exports, "APIError", () => $3a02e5f9ae610962$export$3e5b797e39668f84);

var $d2LG0 = parcelRequire("d2LG0");
const $3a02e5f9ae610962$export$fc98ec826c78a30a = (0, $d2LG0.default)`mutation forge_ui_invokeAuxEffects($input:InvokeAuxEffectsInput!){invokeAuxEffects(input:$input){success errors{message extensions{errorType statusCode}}result{effects contextToken{jwt expiresAt}metrics{appTimeMs}}}}`;
class $3a02e5f9ae610962$export$3e5b797e39668f84 extends Error {
    constructor(message){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $3a02e5f9ae610962$export$3e5b797e39668f84.prototype);
    }
}

});



//# sourceMappingURL=HelpPanel.9a9cfb90.js.map
